/* tslint:disable */
/* eslint-disable */
/**
 * 
 * @export
 * @interface AcceptAgencyInviteRequest
 */
export interface AcceptAgencyInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptAgencyInviteRequest
     */
    agencyId: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptAgencyInviteRequest
     */
    inviteId: string;
    /**
     * The `t` token from the invite email's link.
     * @type {string}
     * @memberof AcceptAgencyInviteRequest
     */
    token: string;
}
/**
 * 
 * @export
 * @interface AcceptAgencyInviteResponse
 */
export interface AcceptAgencyInviteResponse {
    /**
     * 
     * @type {string}
     * @memberof AcceptAgencyInviteResponse
     */
    state: AcceptAgencyInviteResponseStateEnum;
    /**
     * 
     * @type {string}
     * @memberof AcceptAgencyInviteResponse
     */
    agencyName?: string | null;
    /**
     * Bonus credits granted by joining (0 if none).
     * @type {number}
     * @memberof AcceptAgencyInviteResponse
     */
    bonusTokens: number;
}


/**
 * @export
 */
export const AcceptAgencyInviteResponseStateEnum = {
    Ready: 'ready',
    Invalid: 'invalid',
    Revoked: 'revoked',
    Accepted: 'accepted',
    WrongAccount: 'wrong_account',
    AlreadyInAgency: 'already_in_agency',
    InOtherAgency: 'in_other_agency',
    SeatsFull: 'seats_full'
} as const;
export type AcceptAgencyInviteResponseStateEnum = typeof AcceptAgencyInviteResponseStateEnum[keyof typeof AcceptAgencyInviteResponseStateEnum];

/**
 * 
 * @export
 * @interface AccountItem
 */
export interface AccountItem {
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    userType?: AccountItemUserTypeEnum;
}


/**
 * @export
 */
export const AccountItemUserTypeEnum = {
    Guest: 'guest',
    Normal: 'normal',
    Seller: 'seller',
    VerifiedSeller: 'verifiedSeller'
} as const;
export type AccountItemUserTypeEnum = typeof AccountItemUserTypeEnum[keyof typeof AccountItemUserTypeEnum];

/**
 * 
 * @export
 * @interface AccountsPageRows
 */
export interface AccountsPageRows {
    /**
     * 
     * @type {Array<AccountItem>}
     * @memberof AccountsPageRows
     */
    rows: Array<AccountItem>;
}
/**
 * 
 * @export
 * @interface AddCommunityChannelMessageReportRequest
 */
export interface AddCommunityChannelMessageReportRequest {
    /**
     * 
     * @type {ReportReasonEnumItem}
     * @memberof AddCommunityChannelMessageReportRequest
     */
    reason: ReportReasonEnumItem;
}


/**
 * 
 * @export
 * @interface AddCommunityChannelMessageRequest
 */
export interface AddCommunityChannelMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof AddCommunityChannelMessageRequest
     */
    parentMessageId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddCommunityChannelMessageRequest
     */
    clientMessageId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddCommunityChannelMessageRequest
     */
    mentions?: Array<string>;
    /**
     * 
     * @type {CommunityChannelMessageContentRequest}
     * @memberof AddCommunityChannelMessageRequest
     */
    content: CommunityChannelMessageContentRequest;
}
/**
 * 
 * @export
 * @interface AddGroupEventRequest
 */
export interface AddGroupEventRequest {
    /**
     * 
     * @type {string}
     * @memberof AddGroupEventRequest
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof AddGroupEventRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddGroupEventRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AddGroupEventRequest
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof AddGroupEventRequest
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof AddGroupEventRequest
     */
    endDate: string;
    /**
     * 
     * @type {number}
     * @memberof AddGroupEventRequest
     */
    inviteeLimit: number;
    /**
     * 
     * @type {GroupEventLocationTypeEnumItem}
     * @memberof AddGroupEventRequest
     */
    locationType: GroupEventLocationTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AddGroupEventRequest
     */
    address?: string;
}


/**
 * 
 * @export
 * @interface AddListingsToLiveStreamInBatchDto
 */
export interface AddListingsToLiveStreamInBatchDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddListingsToLiveStreamInBatchDto
     */
    listingIds: Array<string>;
}
/**
 * 
 * @export
 * @interface AddListingsToLiveStreamInBatchResponse
 */
export interface AddListingsToLiveStreamInBatchResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddListingsToLiveStreamInBatchResponse
     */
    successfulListingIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddListingsToLiveStreamInBatchResponse
     */
    nonexistentListingIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddListingsToLiveStreamInBatchResponse
     */
    autoRemovedListingIdsOnSoldOut: Array<string>;
}
/**
 * 
 * @export
 * @interface AddMemberToCommunityChannelRequest
 */
export interface AddMemberToCommunityChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof AddMemberToCommunityChannelRequest
     */
    userId: string;
}
/**
 * 
 * @export
 * @interface AddPaymentMethodRequestV2
 */
export interface AddPaymentMethodRequestV2 {
    /**
     * 
     * @type {BillingAddressDto}
     * @memberof AddPaymentMethodRequestV2
     */
    billingAddress: BillingAddressDto;
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodRequestV2
     */
    stripeToken?: string;
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodRequestV2
     */
    nonce?: string;
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodRequestV2
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddPaymentMethodRequestV2
     */
    isSubscriptionPayment?: boolean;
}
/**
 * 
 * @export
 * @interface AddPaymentMethodResponse
 */
export interface AddPaymentMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodResponse
     */
    paymentMethodId: string;
}
/**
 * 
 * @export
 * @interface AddSeriesPopClipDto
 */
export interface AddSeriesPopClipDto {
    /**
     * 
     * @type {string}
     * @memberof AddSeriesPopClipDto
     */
    popClipId: string;
    /**
     * 
     * @type {string}
     * @memberof AddSeriesPopClipDto
     */
    contentType?: AddSeriesPopClipDtoContentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AddSeriesPopClipDto
     */
    sort?: number;
}


/**
 * @export
 */
export const AddSeriesPopClipDtoContentTypeEnum = {
    Feed: 'FEED',
    Episode: 'EPISODE',
    Teaser: 'TEASER',
    Promo: 'PROMO',
    Sponsored: 'SPONSORED'
} as const;
export type AddSeriesPopClipDtoContentTypeEnum = typeof AddSeriesPopClipDtoContentTypeEnum[keyof typeof AddSeriesPopClipDtoContentTypeEnum];

/**
 * 
 * @export
 * @interface AddTippingGoalRequest
 */
export interface AddTippingGoalRequest {
    /**
     * 
     * @type {string}
     * @memberof AddTippingGoalRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddTippingGoalRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AddTippingGoalRequest
     */
    buttonText: string;
    /**
     * 
     * @type {number}
     * @memberof AddTippingGoalRequest
     */
    minimumTipAmount: number;
    /**
     * 
     * @type {number}
     * @memberof AddTippingGoalRequest
     */
    targetAmount: number;
    /**
     * 
     * @type {string}
     * @memberof AddTippingGoalRequest
     */
    dueAt: string;
}
/**
 * 
 * @export
 * @interface AddUserBonusTokenBalanceTokenRequest
 */
export interface AddUserBonusTokenBalanceTokenRequest {
    /**
     * 
     * @type {BonusTokenActionEnumItem}
     * @memberof AddUserBonusTokenBalanceTokenRequest
     */
    action: BonusTokenActionEnumItem;
}


/**
 * 
 * @export
 * @interface AddUserToLiveStreamCommentDenylist
 */
export interface AddUserToLiveStreamCommentDenylist {
    /**
     * 
     * @type {string}
     * @memberof AddUserToLiveStreamCommentDenylist
     */
    reason: AddUserToLiveStreamCommentDenylistReasonEnum;
}


/**
 * @export
 */
export const AddUserToLiveStreamCommentDenylistReasonEnum = {
    Spam: 'spam',
    Inappropriate: 'inappropriate',
    Aggressive: 'aggressive'
} as const;
export type AddUserToLiveStreamCommentDenylistReasonEnum = typeof AddUserToLiveStreamCommentDenylistReasonEnum[keyof typeof AddUserToLiveStreamCommentDenylistReasonEnum];

/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    compareHash?: string;
}
/**
 * 
 * @export
 * @interface AddressItem
 */
export interface AddressItem {
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    compareHash?: string;
}
/**
 * 
 * @export
 * @interface AdvanceNoticeRequest
 */
export interface AdvanceNoticeRequest {
    /**
     * 
     * @type {AdvanceNoticeUnitEnumItem}
     * @memberof AdvanceNoticeRequest
     */
    unit: AdvanceNoticeUnitEnumItem;
    /**
     * 
     * @type {number}
     * @memberof AdvanceNoticeRequest
     */
    value: number;
}



/**
 * 
 * @export
 */
export const AdvanceNoticeUnitEnumItem = {
    Minutes: 'MINUTES',
    Hours: 'HOURS',
    Days: 'DAYS'
} as const;
export type AdvanceNoticeUnitEnumItem = typeof AdvanceNoticeUnitEnumItem[keyof typeof AdvanceNoticeUnitEnumItem];

/**
 * 
 * @export
 * @interface AgencyAddressItem
 */
export interface AgencyAddressItem {
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    postalCode: string;
}
/**
 * 
 * @export
 * @interface AgencyInviteAgency
 */
export interface AgencyInviteAgency {
    /**
     * 
     * @type {string}
     * @memberof AgencyInviteAgency
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyInviteAgency
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyInviteAgency
     */
    logoUrl?: string | null;
    /**
     * Credited on joining; 0 when this agency already paid it once.
     * @type {number}
     * @memberof AgencyInviteAgency
     */
    bonusTokens: number;
}
/**
 * 
 * @export
 * @interface AgencyInvitePaidPlan
 */
export interface AgencyInvitePaidPlan {
    /**
     * 
     * @type {string}
     * @memberof AgencyInvitePaidPlan
     */
    name: string;
    /**
     * Epoch milliseconds the paid period ends.
     * @type {number}
     * @memberof AgencyInvitePaidPlan
     */
    periodEndsAt: number;
}
/**
 * 
 * @export
 * @interface AgencyInvitePreviewResponse
 */
export interface AgencyInvitePreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof AgencyInvitePreviewResponse
     */
    state: AgencyInvitePreviewResponseStateEnum;
    /**
     * 
     * @type {AgencyInviteAgency}
     * @memberof AgencyInvitePreviewResponse
     */
    agency?: AgencyInviteAgency | null;
    /**
     * The invited address, masked, when `wrong_account`.
     * @type {string}
     * @memberof AgencyInvitePreviewResponse
     */
    invitedEmailHint?: string | null;
    /**
     * Their own paid plan, which stops renewing when they join (it ends at the period end).
     * @type {AgencyInvitePaidPlan}
     * @memberof AgencyInvitePreviewResponse
     */
    paidPlan?: AgencyInvitePaidPlan | null;
}


/**
 * @export
 */
export const AgencyInvitePreviewResponseStateEnum = {
    Ready: 'ready',
    Invalid: 'invalid',
    Revoked: 'revoked',
    Accepted: 'accepted',
    WrongAccount: 'wrong_account',
    AlreadyInAgency: 'already_in_agency',
    InOtherAgency: 'in_other_agency',
    SeatsFull: 'seats_full'
} as const;
export type AgencyInvitePreviewResponseStateEnum = typeof AgencyInvitePreviewResponseStateEnum[keyof typeof AgencyInvitePreviewResponseStateEnum];

/**
 * 
 * @export
 * @interface AgencyItemWithId
 */
export interface AgencyItemWithId {
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    status: AgencyItemWithIdStatusEnum;
    /**
     * 
     * @type {AgencyAddressItem}
     * @memberof AgencyItemWithId
     */
    address: AgencyAddressItem;
    /**
     * The `?utm_agency=<slug>` identifier. Immutable once set — live campaign links carry it.
     * @type {string}
     * @memberof AgencyItemWithId
     */
    slug?: string;
    /**
     * Vestigial: no longer gates anything. Every agency is UTM-tagged, so `false` does NOT block public utm_agency tagging. Stored only because the field is on the model and in the search mapping.
     * @type {boolean}
     * @memberof AgencyItemWithId
     */
    utmTaggingEnabled?: boolean;
    /**
     * Creators this agency may have. Absent means unlimited.
     * @type {number}
     * @memberof AgencyItemWithId
     */
    creatorSeatLimit?: number;
    /**
     * Creators currently tagged (the seat counter). Absent means never counted.
     * @type {number}
     * @memberof AgencyItemWithId
     */
    creatorSeatsUsed?: number;
    /**
     * Credits each creator gets once on signing up through the link. Absent means 500.
     * @type {number}
     * @memberof AgencyItemWithId
     */
    signupBonusTokens?: number;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    id: string;
}


/**
 * @export
 */
export const AgencyItemWithIdStatusEnum = {
    Active: 'active',
    Disabled: 'disabled'
} as const;
export type AgencyItemWithIdStatusEnum = typeof AgencyItemWithIdStatusEnum[keyof typeof AgencyItemWithIdStatusEnum];

/**
 * 
 * @export
 * @interface AiGeneratedPdfAiAssistedRequest
 */
export interface AiGeneratedPdfAiAssistedRequest {
    /**
     * 
     * @type {AiGeneratedPdfAiAssistedRequestVariantSkuEnumItem}
     * @memberof AiGeneratedPdfAiAssistedRequest
     */
    variantSku: AiGeneratedPdfAiAssistedRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const AiGeneratedPdfAiAssistedRequestVariantSkuEnumItem = {
    AiAssisted: 'com.popstore.ai_generated_pdf.ai_assisted'
} as const;
export type AiGeneratedPdfAiAssistedRequestVariantSkuEnumItem = typeof AiGeneratedPdfAiAssistedRequestVariantSkuEnumItem[keyof typeof AiGeneratedPdfAiAssistedRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AiGeneratedPdfEditPdfRequest
 */
export interface AiGeneratedPdfEditPdfRequest {
    /**
     * 
     * @type {AiGeneratedPdfEditPdfRequestVariantSkuEnumItem}
     * @memberof AiGeneratedPdfEditPdfRequest
     */
    variantSku: AiGeneratedPdfEditPdfRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const AiGeneratedPdfEditPdfRequestVariantSkuEnumItem = {
    EditPdf: 'com.popstore.ai_generated_pdf.edit_pdf'
} as const;
export type AiGeneratedPdfEditPdfRequestVariantSkuEnumItem = typeof AiGeneratedPdfEditPdfRequestVariantSkuEnumItem[keyof typeof AiGeneratedPdfEditPdfRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AiGeneratedPdfFullyAutoRequest
 */
export interface AiGeneratedPdfFullyAutoRequest {
    /**
     * 
     * @type {AiGeneratedPdfFullyAutoRequestVariantSkuEnumItem}
     * @memberof AiGeneratedPdfFullyAutoRequest
     */
    variantSku: AiGeneratedPdfFullyAutoRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const AiGeneratedPdfFullyAutoRequestVariantSkuEnumItem = {
    FullyAuto: 'com.popstore.ai_generated_pdf.fully_auto'
} as const;
export type AiGeneratedPdfFullyAutoRequestVariantSkuEnumItem = typeof AiGeneratedPdfFullyAutoRequestVariantSkuEnumItem[keyof typeof AiGeneratedPdfFullyAutoRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AnlsSellerItem
 */
export interface AnlsSellerItem {
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerItem
     */
    sellerId: string;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    subscriptions: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    subscriberSubscriptions: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    fanSubscriptions: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    vipSubscriptions: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    activeSubscribers: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    bioPv: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    bioPvT30d: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    bioPvT60dToT31d: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    newVisitorsT30d: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    newVisitorsT60dToT31d: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    gmvT30d: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    gmvT60dToT31d: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    customerCount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    viewerCount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    followerCount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    referralCount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    gmv: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    initializedShowCount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    totalNewShippingRevenue?: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    totalNewShippingCost?: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    maxNewShippingCost?: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    minNewShippingCost?: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    averageShippingCostT60d?: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    averageNewShippingCost?: number;
}
/**
 * 
 * @export
 * @interface AnsweredLeadFormMultipleChoiceQuestionItem
 */
export interface AnsweredLeadFormMultipleChoiceQuestionItem {
    /**
     * 
     * @type {string}
     * @memberof AnsweredLeadFormMultipleChoiceQuestionItem
     */
    id: string;
    /**
     * 
     * @type {AnsweredLeadFormMultipleChoiceQuestionItemTypeEnumItem}
     * @memberof AnsweredLeadFormMultipleChoiceQuestionItem
     */
    type: AnsweredLeadFormMultipleChoiceQuestionItemTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AnsweredLeadFormMultipleChoiceQuestionItem
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AnsweredLeadFormMultipleChoiceQuestionItem
     */
    sort: number;
    /**
     * 
     * @type {Array<SelectedLeadFormQuestionOptionItem>}
     * @memberof AnsweredLeadFormMultipleChoiceQuestionItem
     */
    options: Array<SelectedLeadFormQuestionOptionItem>;
}



/**
 * 
 * @export
 */
export const AnsweredLeadFormMultipleChoiceQuestionItemTypeEnumItem = {
    MultipleChoice: 'MULTIPLE_CHOICE'
} as const;
export type AnsweredLeadFormMultipleChoiceQuestionItemTypeEnumItem = typeof AnsweredLeadFormMultipleChoiceQuestionItemTypeEnumItem[keyof typeof AnsweredLeadFormMultipleChoiceQuestionItemTypeEnumItem];

/**
 * 
 * @export
 * @interface AnsweredLeadFormSingleChoiceQuestionItem
 */
export interface AnsweredLeadFormSingleChoiceQuestionItem {
    /**
     * 
     * @type {string}
     * @memberof AnsweredLeadFormSingleChoiceQuestionItem
     */
    id: string;
    /**
     * 
     * @type {AnsweredLeadFormSingleChoiceQuestionItemTypeEnumItem}
     * @memberof AnsweredLeadFormSingleChoiceQuestionItem
     */
    type: AnsweredLeadFormSingleChoiceQuestionItemTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AnsweredLeadFormSingleChoiceQuestionItem
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AnsweredLeadFormSingleChoiceQuestionItem
     */
    sort: number;
    /**
     * 
     * @type {Array<SelectedLeadFormQuestionOptionItem>}
     * @memberof AnsweredLeadFormSingleChoiceQuestionItem
     */
    options: Array<SelectedLeadFormQuestionOptionItem>;
}



/**
 * 
 * @export
 */
export const AnsweredLeadFormSingleChoiceQuestionItemTypeEnumItem = {
    SingleChoice: 'SINGLE_CHOICE'
} as const;
export type AnsweredLeadFormSingleChoiceQuestionItemTypeEnumItem = typeof AnsweredLeadFormSingleChoiceQuestionItemTypeEnumItem[keyof typeof AnsweredLeadFormSingleChoiceQuestionItemTypeEnumItem];

/**
 * 
 * @export
 * @interface AnsweredLeadFormTextQuestionItem
 */
export interface AnsweredLeadFormTextQuestionItem {
    /**
     * 
     * @type {string}
     * @memberof AnsweredLeadFormTextQuestionItem
     */
    id: string;
    /**
     * 
     * @type {AnsweredLeadFormTextQuestionItemTypeEnumItem}
     * @memberof AnsweredLeadFormTextQuestionItem
     */
    type: AnsweredLeadFormTextQuestionItemTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AnsweredLeadFormTextQuestionItem
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AnsweredLeadFormTextQuestionItem
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof AnsweredLeadFormTextQuestionItem
     */
    text?: string;
}



/**
 * 
 * @export
 */
export const AnsweredLeadFormTextQuestionItemTypeEnumItem = {
    Text: 'TEXT'
} as const;
export type AnsweredLeadFormTextQuestionItemTypeEnumItem = typeof AnsweredLeadFormTextQuestionItemTypeEnumItem[keyof typeof AnsweredLeadFormTextQuestionItemTypeEnumItem];

/**
 * 
 * @export
 * @interface ApplyRetentionOfferRequest
 */
export interface ApplyRetentionOfferRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplyRetentionOfferRequest
     */
    couponCode: string;
}
/**
 * 
 * @export
 * @interface ApplyRetentionOfferResponse
 */
export interface ApplyRetentionOfferResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ApplyRetentionOfferResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplyRetentionOfferResponse
     */
    message: string;
    /**
     * 
     * @type {SaasSubscriptionRetentionOfferEnumItem}
     * @memberof ApplyRetentionOfferResponse
     */
    offer?: SaasSubscriptionRetentionOfferEnumItem;
    /**
     * True when the coupon is queued for the end of the trial rather than on the subscription already
     * @type {boolean}
     * @memberof ApplyRetentionOfferResponse
     */
    scheduled?: boolean;
    /**
     * Credits granted by this call, for the free-month offer
     * @type {number}
     * @memberof ApplyRetentionOfferResponse
     */
    bonusCredits?: number;
}


/**
 * 
 * @export
 * @interface AuthTokenResponse
 */
export interface AuthTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponse
     */
    token: string;
}
/**
 * 
 * @export
 * @interface AuthUrlResponse
 */
export interface AuthUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthUrlResponse
     */
    authUrl: string;
}
/**
 * 
 * @export
 * @interface AvailableMeetingDateItemResponse
 */
export interface AvailableMeetingDateItemResponse {
    /**
     * 
     * @type {string}
     * @memberof AvailableMeetingDateItemResponse
     */
    date: string;
}
/**
 * 
 * @export
 * @interface AvailableMeetingTypeItemResponse
 */
export interface AvailableMeetingTypeItemResponse {
    /**
     * 
     * @type {string}
     * @memberof AvailableMeetingTypeItemResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableMeetingTypeItemResponse
     */
    topic: string;
    /**
     * 
     * @type {number}
     * @memberof AvailableMeetingTypeItemResponse
     */
    duration: number;
    /**
     * 
     * @type {number}
     * @memberof AvailableMeetingTypeItemResponse
     */
    price: number;
    /**
     * 
     * @type {Array<MeetingSlotItem>}
     * @memberof AvailableMeetingTypeItemResponse
     */
    slots: Array<MeetingSlotItem>;
}
/**
 * 
 * @export
 * @interface AvatarMeBuyerProfileItem
 */
export interface AvatarMeBuyerProfileItem {
    /**
     * 
     * @type {string}
     * @memberof AvatarMeBuyerProfileItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeBuyerProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeBuyerProfileItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeBuyerProfileItem
     */
    username?: string;
}
/**
 * 
 * @export
 * @interface AvatarMeGamifiedLipSyncVideoRequest
 */
export interface AvatarMeGamifiedLipSyncVideoRequest {
    /**
     * 
     * @type {AvatarMeGamifiedLipSyncVideoRequestVariantSkuEnumItem}
     * @memberof AvatarMeGamifiedLipSyncVideoRequest
     */
    variantSku: AvatarMeGamifiedLipSyncVideoRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeGamifiedLipSyncVideoRequest
     */
    videoProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeGamifiedLipSyncVideoRequest
     */
    audioUrl: string;
}


/**
 * 
 * @export
 * @interface AvatarMeGamifiedLipSyncVideoRequestItem
 */
export interface AvatarMeGamifiedLipSyncVideoRequestItem {
    /**
     * 
     * @type {AvatarMeGamifiedLipSyncVideoRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeGamifiedLipSyncVideoRequestItem
     */
    variantSku: AvatarMeGamifiedLipSyncVideoRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeGamifiedLipSyncVideoRequestItem
     */
    videoProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeGamifiedLipSyncVideoRequestItem
     */
    audioUrl: string;
}



/**
 * 
 * @export
 */
export const AvatarMeGamifiedLipSyncVideoRequestItemVariantSkuEnumItem = {
    VideoLipSync: 'com.popstore.avatar_me.video.lip_sync'
} as const;
export type AvatarMeGamifiedLipSyncVideoRequestItemVariantSkuEnumItem = typeof AvatarMeGamifiedLipSyncVideoRequestItemVariantSkuEnumItem[keyof typeof AvatarMeGamifiedLipSyncVideoRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeGamifiedLipSyncVideoRequestVariantSkuEnumItem = {
    VideoLipSync: 'com.popstore.avatar_me.video.lip_sync'
} as const;
export type AvatarMeGamifiedLipSyncVideoRequestVariantSkuEnumItem = typeof AvatarMeGamifiedLipSyncVideoRequestVariantSkuEnumItem[keyof typeof AvatarMeGamifiedLipSyncVideoRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeGamifiedVideoRequestItem
 */
export interface AvatarMeGamifiedVideoRequestItem {
    /**
     * 
     * @type {AvatarMeGamifiedVideoRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeGamifiedVideoRequestItem
     */
    variantSku: AvatarMeGamifiedVideoRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeGamifiedVideoRequestItem
     */
    videoProcessId: string;
}



/**
 * 
 * @export
 */
export const AvatarMeGamifiedVideoRequestItemVariantSkuEnumItem = {
    VideoHdUpgrade: 'com.popstore.avatar_me.video.hd_upgrade',
    VideoFacePerfect: 'com.popstore.avatar_me.video.face_perfect'
} as const;
export type AvatarMeGamifiedVideoRequestItemVariantSkuEnumItem = typeof AvatarMeGamifiedVideoRequestItemVariantSkuEnumItem[keyof typeof AvatarMeGamifiedVideoRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeImageLocationSourceEnumItem = {
    Location: 'LOCATION',
    SceneLibrary: 'SCENE_LIBRARY',
    MySavedScene: 'MY_SAVED_SCENE',
    MyUnsavedScene: 'MY_UNSAVED_SCENE'
} as const;
export type AvatarMeImageLocationSourceEnumItem = typeof AvatarMeImageLocationSourceEnumItem[keyof typeof AvatarMeImageLocationSourceEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeImageRequest
 */
export interface AvatarMeImageRequest {
    /**
     * 
     * @type {AvatarMeImageRequestVariantSkuEnumItem}
     * @memberof AvatarMeImageRequest
     */
    variantSku: AvatarMeImageRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeImageRequest
     */
    location: string;
    /**
     * 
     * @type {AvatarMeImageLocationSourceEnumItem}
     * @memberof AvatarMeImageRequest
     */
    locationSource?: AvatarMeImageLocationSourceEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeImageRequest
     */
    atmosphere?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeImageRequest
     */
    outfitId?: string;
    /**
     * s3 url of creator uploaded image
     * @type {string}
     * @memberof AvatarMeImageRequest
     */
    outfitUrl?: string;
}


/**
 * 
 * @export
 * @interface AvatarMeImageRequestItem
 */
export interface AvatarMeImageRequestItem {
    /**
     * 
     * @type {AvatarMeImageRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeImageRequestItem
     */
    variantSku: AvatarMeImageRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeImageRequestItem
     */
    location: string;
    /**
     * 
     * @type {AvatarMeImageLocationSourceEnumItem}
     * @memberof AvatarMeImageRequestItem
     */
    locationSource?: AvatarMeImageLocationSourceEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeImageRequestItem
     */
    atmosphere?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeImageRequestItem
     */
    outfitId?: string;
    /**
     * s3 url of creator uploaded image
     * @type {string}
     * @memberof AvatarMeImageRequestItem
     */
    outfitUrl?: string;
}



/**
 * 
 * @export
 */
export const AvatarMeImageRequestItemVariantSkuEnumItem = {
    Image: 'com.popstore.avatar_me.image'
} as const;
export type AvatarMeImageRequestItemVariantSkuEnumItem = typeof AvatarMeImageRequestItemVariantSkuEnumItem[keyof typeof AvatarMeImageRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeImageRequestVariantSkuEnumItem = {
    Image: 'com.popstore.avatar_me.image'
} as const;
export type AvatarMeImageRequestVariantSkuEnumItem = typeof AvatarMeImageRequestVariantSkuEnumItem[keyof typeof AvatarMeImageRequestVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeListingVariantSkuEnumItem = {
    ComPopstoreAvatarMeImage: 'com.popstore.avatar_me.image',
    ComPopstoreAvatarMePhotoshoot: 'com.popstore.avatar_me.photoshoot',
    ComPopstoreAvatarMeVideo5s: 'com.popstore.avatar_me.video.5s',
    ComPopstoreAvatarMeVideo10s: 'com.popstore.avatar_me.video.10s',
    ComPopstoreAvatarMeVideoHdUpgrade: 'com.popstore.avatar_me.video.hd_upgrade',
    ComPopstoreAvatarMeVideoSoundFx: 'com.popstore.avatar_me.video.sound_fx',
    ComPopstoreAvatarMeVideoFacePerfect: 'com.popstore.avatar_me.video.face_perfect',
    ComPopstoreAvatarMeVideoLipSync: 'com.popstore.avatar_me.video.lip_sync',
    ComPopstoreAvatarMeStudioFreeImage: 'com.popstore.avatar_me.studio_free_image',
    ComPopstoreAvatarMeStudioImage: 'com.popstore.avatar_me.studio_image',
    ComPopstoreAvatarMeStudioPhotoshoot: 'com.popstore.avatar_me.studio_photoshoot',
    ComPopstoreAvatarMeStudioVideo5s: 'com.popstore.avatar_me.studio_video.5s',
    ComPopstoreAvatarMeStudioVideo10s: 'com.popstore.avatar_me.studio_video.10s',
    ComPopstoreAvatarMeStudioVideoXs: 'com.popstore.avatar_me.studio_video.xs',
    ComPopstoreAvatarMeStudioVideoPrompt: 'com.popstore.avatar_me.studio_video.prompt',
    ComPopstoreAvatarMeStudioVideoLipSync: 'com.popstore.avatar_me.studio_video.lip_sync'
} as const;
export type AvatarMeListingVariantSkuEnumItem = typeof AvatarMeListingVariantSkuEnumItem[keyof typeof AvatarMeListingVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeOrientationEnumItem = {
    Portrait: 'PORTRAIT',
    Landscape: 'LANDSCAPE'
} as const;
export type AvatarMeOrientationEnumItem = typeof AvatarMeOrientationEnumItem[keyof typeof AvatarMeOrientationEnumItem];

/**
 * 
 * @export
 * @interface AvatarMePhotoshootRequest
 */
export interface AvatarMePhotoshootRequest {
    /**
     * 
     * @type {AvatarMePhotoshootRequestVariantSkuEnumItem}
     * @memberof AvatarMePhotoshootRequest
     */
    variantSku: AvatarMePhotoshootRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMePhotoshootRequest
     */
    location: string;
    /**
     * 
     * @type {AvatarMeImageLocationSourceEnumItem}
     * @memberof AvatarMePhotoshootRequest
     */
    locationSource?: AvatarMeImageLocationSourceEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMePhotoshootRequest
     */
    atmosphere?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMePhotoshootRequest
     */
    outfitId?: string;
    /**
     * s3 url of creator uploaded image
     * @type {string}
     * @memberof AvatarMePhotoshootRequest
     */
    outfitUrl?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AvatarMePhotoshootRequest
     */
    poseIds: Array<number>;
}


/**
 * 
 * @export
 * @interface AvatarMePhotoshootRequestItem
 */
export interface AvatarMePhotoshootRequestItem {
    /**
     * 
     * @type {AvatarMePhotoshootRequestItemVariantSkuEnumItem}
     * @memberof AvatarMePhotoshootRequestItem
     */
    variantSku: AvatarMePhotoshootRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMePhotoshootRequestItem
     */
    location: string;
    /**
     * 
     * @type {AvatarMeImageLocationSourceEnumItem}
     * @memberof AvatarMePhotoshootRequestItem
     */
    locationSource?: AvatarMeImageLocationSourceEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMePhotoshootRequestItem
     */
    atmosphere?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMePhotoshootRequestItem
     */
    outfitId?: string;
    /**
     * s3 url of creator uploaded image
     * @type {string}
     * @memberof AvatarMePhotoshootRequestItem
     */
    outfitUrl?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AvatarMePhotoshootRequestItem
     */
    poseIds: Array<number>;
}



/**
 * 
 * @export
 */
export const AvatarMePhotoshootRequestItemVariantSkuEnumItem = {
    Photoshoot: 'com.popstore.avatar_me.photoshoot'
} as const;
export type AvatarMePhotoshootRequestItemVariantSkuEnumItem = typeof AvatarMePhotoshootRequestItemVariantSkuEnumItem[keyof typeof AvatarMePhotoshootRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMePhotoshootRequestVariantSkuEnumItem = {
    Photoshoot: 'com.popstore.avatar_me.photoshoot'
} as const;
export type AvatarMePhotoshootRequestVariantSkuEnumItem = typeof AvatarMePhotoshootRequestVariantSkuEnumItem[keyof typeof AvatarMePhotoshootRequestVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeProcessStatusEnumItem = {
    Initialized: 'INITIALIZED',
    Triggered: 'TRIGGERED',
    Completed: 'COMPLETED',
    PartiallyCompleted: 'PARTIALLY_COMPLETED',
    Failed: 'FAILED'
} as const;
export type AvatarMeProcessStatusEnumItem = typeof AvatarMeProcessStatusEnumItem[keyof typeof AvatarMeProcessStatusEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeStudioFreeImageRequest
 */
export interface AvatarMeStudioFreeImageRequest {
    /**
     * 
     * @type {AvatarMeStudioFreeImageRequestVariantSkuEnumItem}
     * @memberof AvatarMeStudioFreeImageRequest
     */
    variantSku: AvatarMeStudioFreeImageRequestVariantSkuEnumItem;
    /**
     * up-to 5 free outfits
     * @type {Array<string>}
     * @memberof AvatarMeStudioFreeImageRequest
     */
    outfitIds: Array<string>;
    /**
     * required for wear with ai
     * @type {WearWithAiDto}
     * @memberof AvatarMeStudioFreeImageRequest
     */
    wearWithAi?: WearWithAiDto;
    /**
     * the personal look to be used, the default one will be used when it is not provided
     * @type {string}
     * @memberof AvatarMeStudioFreeImageRequest
     */
    personalLookId?: string;
}


/**
 * 
 * @export
 * @interface AvatarMeStudioFreeImageRequestItem
 */
export interface AvatarMeStudioFreeImageRequestItem {
    /**
     * 
     * @type {AvatarMeStudioFreeImageRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeStudioFreeImageRequestItem
     */
    variantSku: AvatarMeStudioFreeImageRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvatarMeStudioFreeImageRequestItem
     */
    outfitIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioFreeImageRequestItem
     */
    personalLookId?: string;
}



/**
 * 
 * @export
 */
export const AvatarMeStudioFreeImageRequestItemVariantSkuEnumItem = {
    StudioFreeImage: 'com.popstore.avatar_me.studio_free_image'
} as const;
export type AvatarMeStudioFreeImageRequestItemVariantSkuEnumItem = typeof AvatarMeStudioFreeImageRequestItemVariantSkuEnumItem[keyof typeof AvatarMeStudioFreeImageRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeStudioFreeImageRequestVariantSkuEnumItem = {
    StudioFreeImage: 'com.popstore.avatar_me.studio_free_image'
} as const;
export type AvatarMeStudioFreeImageRequestVariantSkuEnumItem = typeof AvatarMeStudioFreeImageRequestVariantSkuEnumItem[keyof typeof AvatarMeStudioFreeImageRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeStudioGamifiedLipSyncVideoRequest
 */
export interface AvatarMeStudioGamifiedLipSyncVideoRequest {
    /**
     * 
     * @type {AvatarMeStudioGamifiedLipSyncVideoRequestVariantSkuEnumItem}
     * @memberof AvatarMeStudioGamifiedLipSyncVideoRequest
     */
    variantSku: AvatarMeStudioGamifiedLipSyncVideoRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioGamifiedLipSyncVideoRequest
     */
    videoProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioGamifiedLipSyncVideoRequest
     */
    audioUrl: string;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioGamifiedLipSyncVideoRequest
     */
    orientation?: AvatarMeOrientationEnumItem;
}


/**
 * 
 * @export
 * @interface AvatarMeStudioGamifiedLipSyncVideoRequestItem
 */
export interface AvatarMeStudioGamifiedLipSyncVideoRequestItem {
    /**
     * 
     * @type {AvatarMeStudioGamifiedLipSyncVideoRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeStudioGamifiedLipSyncVideoRequestItem
     */
    variantSku: AvatarMeStudioGamifiedLipSyncVideoRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioGamifiedLipSyncVideoRequestItem
     */
    videoProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioGamifiedLipSyncVideoRequestItem
     */
    audioUrl: string;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioGamifiedLipSyncVideoRequestItem
     */
    orientation?: AvatarMeOrientationEnumItem;
}



/**
 * 
 * @export
 */
export const AvatarMeStudioGamifiedLipSyncVideoRequestItemVariantSkuEnumItem = {
    StudioVideoLipSync: 'com.popstore.avatar_me.studio_video.lip_sync'
} as const;
export type AvatarMeStudioGamifiedLipSyncVideoRequestItemVariantSkuEnumItem = typeof AvatarMeStudioGamifiedLipSyncVideoRequestItemVariantSkuEnumItem[keyof typeof AvatarMeStudioGamifiedLipSyncVideoRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeStudioGamifiedLipSyncVideoRequestVariantSkuEnumItem = {
    StudioVideoLipSync: 'com.popstore.avatar_me.studio_video.lip_sync'
} as const;
export type AvatarMeStudioGamifiedLipSyncVideoRequestVariantSkuEnumItem = typeof AvatarMeStudioGamifiedLipSyncVideoRequestVariantSkuEnumItem[keyof typeof AvatarMeStudioGamifiedLipSyncVideoRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeStudioImageRequest
 */
export interface AvatarMeStudioImageRequest {
    /**
     * 
     * @type {AvatarMeStudioImageRequestVariantSkuEnumItem}
     * @memberof AvatarMeStudioImageRequest
     */
    variantSku: AvatarMeStudioImageRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioImageRequest
     */
    location: string;
    /**
     * 
     * @type {AvatarMeImageLocationSourceEnumItem}
     * @memberof AvatarMeStudioImageRequest
     */
    locationSource?: AvatarMeImageLocationSourceEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioImageRequest
     */
    atmosphere?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioImageRequest
     */
    outfitId?: string;
    /**
     * s3 url of creator uploaded image
     * @type {string}
     * @memberof AvatarMeStudioImageRequest
     */
    outfitUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof AvatarMeStudioImageRequest
     */
    poseId?: number;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioImageRequest
     */
    orientation?: AvatarMeOrientationEnumItem;
    /**
     * required for wear with ai
     * @type {WearWithAiDto}
     * @memberof AvatarMeStudioImageRequest
     */
    wearWithAi?: WearWithAiDto;
    /**
     * the personal look to be used, the default one will be used when it is not provided
     * @type {string}
     * @memberof AvatarMeStudioImageRequest
     */
    personalLookId?: string;
}


/**
 * 
 * @export
 * @interface AvatarMeStudioImageRequestItem
 */
export interface AvatarMeStudioImageRequestItem {
    /**
     * 
     * @type {AvatarMeStudioImageRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeStudioImageRequestItem
     */
    variantSku: AvatarMeStudioImageRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioImageRequestItem
     */
    location: string;
    /**
     * 
     * @type {AvatarMeImageLocationSourceEnumItem}
     * @memberof AvatarMeStudioImageRequestItem
     */
    locationSource?: AvatarMeImageLocationSourceEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioImageRequestItem
     */
    atmosphere?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioImageRequestItem
     */
    outfitId?: string;
    /**
     * s3 url of creator uploaded image
     * @type {string}
     * @memberof AvatarMeStudioImageRequestItem
     */
    outfitUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof AvatarMeStudioImageRequestItem
     */
    poseId?: number;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioImageRequestItem
     */
    orientation?: AvatarMeOrientationEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioImageRequestItem
     */
    personalLookId?: string;
}



/**
 * 
 * @export
 */
export const AvatarMeStudioImageRequestItemVariantSkuEnumItem = {
    StudioImage: 'com.popstore.avatar_me.studio_image'
} as const;
export type AvatarMeStudioImageRequestItemVariantSkuEnumItem = typeof AvatarMeStudioImageRequestItemVariantSkuEnumItem[keyof typeof AvatarMeStudioImageRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeStudioImageRequestVariantSkuEnumItem = {
    StudioImage: 'com.popstore.avatar_me.studio_image'
} as const;
export type AvatarMeStudioImageRequestVariantSkuEnumItem = typeof AvatarMeStudioImageRequestVariantSkuEnumItem[keyof typeof AvatarMeStudioImageRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeStudioPhotoshootRequest
 */
export interface AvatarMeStudioPhotoshootRequest {
    /**
     * 
     * @type {AvatarMeStudioPhotoshootRequestVariantSkuEnumItem}
     * @memberof AvatarMeStudioPhotoshootRequest
     */
    variantSku: AvatarMeStudioPhotoshootRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioPhotoshootRequest
     */
    location: string;
    /**
     * 
     * @type {AvatarMeImageLocationSourceEnumItem}
     * @memberof AvatarMeStudioPhotoshootRequest
     */
    locationSource?: AvatarMeImageLocationSourceEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioPhotoshootRequest
     */
    atmosphere?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioPhotoshootRequest
     */
    outfitId?: string;
    /**
     * s3 url of creator uploaded image
     * @type {string}
     * @memberof AvatarMeStudioPhotoshootRequest
     */
    outfitUrl?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AvatarMeStudioPhotoshootRequest
     */
    poseIds: Array<number>;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioPhotoshootRequest
     */
    orientation?: AvatarMeOrientationEnumItem;
    /**
     * the personal look to be used, the default one will be used when it is not provided
     * @type {string}
     * @memberof AvatarMeStudioPhotoshootRequest
     */
    personalLookId?: string;
}


/**
 * 
 * @export
 * @interface AvatarMeStudioPhotoshootRequestItem
 */
export interface AvatarMeStudioPhotoshootRequestItem {
    /**
     * 
     * @type {AvatarMeStudioPhotoshootRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeStudioPhotoshootRequestItem
     */
    variantSku: AvatarMeStudioPhotoshootRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioPhotoshootRequestItem
     */
    location: string;
    /**
     * 
     * @type {AvatarMeImageLocationSourceEnumItem}
     * @memberof AvatarMeStudioPhotoshootRequestItem
     */
    locationSource?: AvatarMeImageLocationSourceEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioPhotoshootRequestItem
     */
    atmosphere?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioPhotoshootRequestItem
     */
    outfitId?: string;
    /**
     * s3 url of creator uploaded image
     * @type {string}
     * @memberof AvatarMeStudioPhotoshootRequestItem
     */
    outfitUrl?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AvatarMeStudioPhotoshootRequestItem
     */
    poseIds: Array<number>;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioPhotoshootRequestItem
     */
    orientation?: AvatarMeOrientationEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioPhotoshootRequestItem
     */
    personalLookId?: string;
}



/**
 * 
 * @export
 */
export const AvatarMeStudioPhotoshootRequestItemVariantSkuEnumItem = {
    StudioPhotoshoot: 'com.popstore.avatar_me.studio_photoshoot'
} as const;
export type AvatarMeStudioPhotoshootRequestItemVariantSkuEnumItem = typeof AvatarMeStudioPhotoshootRequestItemVariantSkuEnumItem[keyof typeof AvatarMeStudioPhotoshootRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeStudioPhotoshootRequestVariantSkuEnumItem = {
    StudioPhotoshoot: 'com.popstore.avatar_me.studio_photoshoot'
} as const;
export type AvatarMeStudioPhotoshootRequestVariantSkuEnumItem = typeof AvatarMeStudioPhotoshootRequestVariantSkuEnumItem[keyof typeof AvatarMeStudioPhotoshootRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeStudioVideo10sRequest
 */
export interface AvatarMeStudioVideo10sRequest {
    /**
     * 
     * @type {AvatarMeStudioVideo10sRequestVariantSkuEnumItem}
     * @memberof AvatarMeStudioVideo10sRequest
     */
    variantSku: AvatarMeStudioVideo10sRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideo10sRequest
     */
    imageProcessId: string;
    /**
     * one of images if it is from StudioFreeImage or StudioPhotoshoot
     * @type {string}
     * @memberof AvatarMeStudioVideo10sRequest
     */
    imageUrl?: string;
    /**
     * text-type prompt
     * @type {string}
     * @memberof AvatarMeStudioVideo10sRequest
     */
    videoPrompt: string;
    /**
     * required for wear with ai
     * @type {WearWithAiDto}
     * @memberof AvatarMeStudioVideo10sRequest
     */
    wearWithAi?: WearWithAiDto;
}


/**
 * 
 * @export
 * @interface AvatarMeStudioVideo10sRequestItem
 */
export interface AvatarMeStudioVideo10sRequestItem {
    /**
     * 
     * @type {AvatarMeStudioVideo10sRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeStudioVideo10sRequestItem
     */
    variantSku: AvatarMeStudioVideo10sRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideo10sRequestItem
     */
    imageProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideo10sRequestItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideo10sRequestItem
     */
    videoPrompt: string;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioVideo10sRequestItem
     */
    orientation?: AvatarMeOrientationEnumItem;
}



/**
 * 
 * @export
 */
export const AvatarMeStudioVideo10sRequestItemVariantSkuEnumItem = {
    StudioVideo10s: 'com.popstore.avatar_me.studio_video.10s'
} as const;
export type AvatarMeStudioVideo10sRequestItemVariantSkuEnumItem = typeof AvatarMeStudioVideo10sRequestItemVariantSkuEnumItem[keyof typeof AvatarMeStudioVideo10sRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeStudioVideo10sRequestVariantSkuEnumItem = {
    StudioVideo10s: 'com.popstore.avatar_me.studio_video.10s'
} as const;
export type AvatarMeStudioVideo10sRequestVariantSkuEnumItem = typeof AvatarMeStudioVideo10sRequestVariantSkuEnumItem[keyof typeof AvatarMeStudioVideo10sRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeStudioVideo5sRequest
 */
export interface AvatarMeStudioVideo5sRequest {
    /**
     * 
     * @type {AvatarMeStudioVideo5sRequestVariantSkuEnumItem}
     * @memberof AvatarMeStudioVideo5sRequest
     */
    variantSku: AvatarMeStudioVideo5sRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideo5sRequest
     */
    imageProcessId: string;
    /**
     * one of images if it is from StudioFreeImage or StudioPhotoshoot
     * @type {string}
     * @memberof AvatarMeStudioVideo5sRequest
     */
    imageUrl?: string;
    /**
     * text-type prompt
     * @type {string}
     * @memberof AvatarMeStudioVideo5sRequest
     */
    videoPrompt: string;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioVideo5sRequest
     */
    orientation?: AvatarMeOrientationEnumItem;
    /**
     * required for wear with ai
     * @type {WearWithAiDto}
     * @memberof AvatarMeStudioVideo5sRequest
     */
    wearWithAi?: WearWithAiDto;
}


/**
 * 
 * @export
 * @interface AvatarMeStudioVideo5sRequestItem
 */
export interface AvatarMeStudioVideo5sRequestItem {
    /**
     * 
     * @type {AvatarMeStudioVideo5sRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeStudioVideo5sRequestItem
     */
    variantSku: AvatarMeStudioVideo5sRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideo5sRequestItem
     */
    imageProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideo5sRequestItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideo5sRequestItem
     */
    videoPrompt: string;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioVideo5sRequestItem
     */
    orientation?: AvatarMeOrientationEnumItem;
}



/**
 * 
 * @export
 */
export const AvatarMeStudioVideo5sRequestItemVariantSkuEnumItem = {
    StudioVideo5s: 'com.popstore.avatar_me.studio_video.5s'
} as const;
export type AvatarMeStudioVideo5sRequestItemVariantSkuEnumItem = typeof AvatarMeStudioVideo5sRequestItemVariantSkuEnumItem[keyof typeof AvatarMeStudioVideo5sRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeStudioVideo5sRequestVariantSkuEnumItem = {
    StudioVideo5s: 'com.popstore.avatar_me.studio_video.5s'
} as const;
export type AvatarMeStudioVideo5sRequestVariantSkuEnumItem = typeof AvatarMeStudioVideo5sRequestVariantSkuEnumItem[keyof typeof AvatarMeStudioVideo5sRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeStudioVideoPromptRequest
 */
export interface AvatarMeStudioVideoPromptRequest {
    /**
     * 
     * @type {AvatarMeStudioVideoPromptRequestVariantSkuEnumItem}
     * @memberof AvatarMeStudioVideoPromptRequest
     */
    variantSku: AvatarMeStudioVideoPromptRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoPromptRequest
     */
    imageProcessId: string;
    /**
     * one of images if it is from StudioFreeImage or StudioPhotoshoot
     * @type {string}
     * @memberof AvatarMeStudioVideoPromptRequest
     */
    imageUrl?: string;
    /**
     * video-type prompt, s3 url of creator uploaded video
     * @type {string}
     * @memberof AvatarMeStudioVideoPromptRequest
     */
    videoPrompt: string;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioVideoPromptRequest
     */
    orientation?: AvatarMeOrientationEnumItem;
    /**
     * required for wear with ai
     * @type {WearWithAiDto}
     * @memberof AvatarMeStudioVideoPromptRequest
     */
    wearWithAi?: WearWithAiDto;
}


/**
 * 
 * @export
 * @interface AvatarMeStudioVideoPromptRequestItem
 */
export interface AvatarMeStudioVideoPromptRequestItem {
    /**
     * 
     * @type {AvatarMeStudioVideoPromptRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeStudioVideoPromptRequestItem
     */
    variantSku: AvatarMeStudioVideoPromptRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoPromptRequestItem
     */
    imageProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoPromptRequestItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoPromptRequestItem
     */
    videoPrompt: string;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioVideoPromptRequestItem
     */
    orientation?: AvatarMeOrientationEnumItem;
}



/**
 * 
 * @export
 */
export const AvatarMeStudioVideoPromptRequestItemVariantSkuEnumItem = {
    StudioVideoPrompt: 'com.popstore.avatar_me.studio_video.prompt'
} as const;
export type AvatarMeStudioVideoPromptRequestItemVariantSkuEnumItem = typeof AvatarMeStudioVideoPromptRequestItemVariantSkuEnumItem[keyof typeof AvatarMeStudioVideoPromptRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeStudioVideoPromptRequestVariantSkuEnumItem = {
    StudioVideoPrompt: 'com.popstore.avatar_me.studio_video.prompt'
} as const;
export type AvatarMeStudioVideoPromptRequestVariantSkuEnumItem = typeof AvatarMeStudioVideoPromptRequestVariantSkuEnumItem[keyof typeof AvatarMeStudioVideoPromptRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeStudioVideoRequestItem
 */
export interface AvatarMeStudioVideoRequestItem {
    /**
     * 
     * @type {AvatarMeStudioVideoRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeStudioVideoRequestItem
     */
    variantSku: AvatarMeStudioVideoRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoRequestItem
     */
    imageProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoRequestItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoRequestItem
     */
    videoPrompt: string;
}



/**
 * 
 * @export
 */
export const AvatarMeStudioVideoRequestItemVariantSkuEnumItem = {
    StudioVideo5s: 'com.popstore.avatar_me.studio_video.5s',
    StudioVideo10s: 'com.popstore.avatar_me.studio_video.10s'
} as const;
export type AvatarMeStudioVideoRequestItemVariantSkuEnumItem = typeof AvatarMeStudioVideoRequestItemVariantSkuEnumItem[keyof typeof AvatarMeStudioVideoRequestItemVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeStudioVideoXsRequest
 */
export interface AvatarMeStudioVideoXsRequest {
    /**
     * 
     * @type {AvatarMeStudioVideoXsRequestVariantSkuEnumItem}
     * @memberof AvatarMeStudioVideoXsRequest
     */
    variantSku: AvatarMeStudioVideoXsRequestVariantSkuEnumItem;
    /**
     * video length in whole seconds; charged per second
     * @type {number}
     * @memberof AvatarMeStudioVideoXsRequest
     */
    durationSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoXsRequest
     */
    imageProcessId?: string;
    /**
     * one of images if it is from StudioFreeImage or StudioPhotoshoot
     * @type {string}
     * @memberof AvatarMeStudioVideoXsRequest
     */
    imageUrl?: string;
    /**
     * text-type prompt
     * @type {string}
     * @memberof AvatarMeStudioVideoXsRequest
     */
    videoPrompt: string;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioVideoXsRequest
     */
    orientation?: AvatarMeOrientationEnumItem;
    /**
     * required for wear with ai
     * @type {WearWithAiDto}
     * @memberof AvatarMeStudioVideoXsRequest
     */
    wearWithAi?: WearWithAiDto;
}


/**
 * 
 * @export
 * @interface AvatarMeStudioVideoXsRequestItem
 */
export interface AvatarMeStudioVideoXsRequestItem {
    /**
     * 
     * @type {AvatarMeStudioVideoXsRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeStudioVideoXsRequestItem
     */
    variantSku: AvatarMeStudioVideoXsRequestItemVariantSkuEnumItem;
    /**
     * video length in whole seconds
     * @type {number}
     * @memberof AvatarMeStudioVideoXsRequestItem
     */
    durationSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoXsRequestItem
     */
    imageProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoXsRequestItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeStudioVideoXsRequestItem
     */
    videoPrompt: string;
    /**
     * 
     * @type {AvatarMeOrientationEnumItem}
     * @memberof AvatarMeStudioVideoXsRequestItem
     */
    orientation?: AvatarMeOrientationEnumItem;
}



/**
 * 
 * @export
 */
export const AvatarMeStudioVideoXsRequestItemVariantSkuEnumItem = {
    StudioVideoXs: 'com.popstore.avatar_me.studio_video.xs'
} as const;
export type AvatarMeStudioVideoXsRequestItemVariantSkuEnumItem = typeof AvatarMeStudioVideoXsRequestItemVariantSkuEnumItem[keyof typeof AvatarMeStudioVideoXsRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeStudioVideoXsRequestVariantSkuEnumItem = {
    StudioVideoXs: 'com.popstore.avatar_me.studio_video.xs'
} as const;
export type AvatarMeStudioVideoXsRequestVariantSkuEnumItem = typeof AvatarMeStudioVideoXsRequestVariantSkuEnumItem[keyof typeof AvatarMeStudioVideoXsRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeVideo10sRequest
 */
export interface AvatarMeVideo10sRequest {
    /**
     * 
     * @type {AvatarMeVideo10sRequestVariantSkuEnumItem}
     * @memberof AvatarMeVideo10sRequest
     */
    variantSku: AvatarMeVideo10sRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideo10sRequest
     */
    imageProcessId: string;
    /**
     * text-type prompt
     * @type {string}
     * @memberof AvatarMeVideo10sRequest
     */
    videoPrompt: string;
    /**
     * aws s3(not cdn) url if imageProcessId points to a AvatarMePhotoshootRequest
     * @type {string}
     * @memberof AvatarMeVideo10sRequest
     */
    poseUrl?: string;
}


/**
 * 
 * @export
 * @interface AvatarMeVideo10sRequestItem
 */
export interface AvatarMeVideo10sRequestItem {
    /**
     * 
     * @type {AvatarMeVideo10sRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeVideo10sRequestItem
     */
    variantSku: AvatarMeVideo10sRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideo10sRequestItem
     */
    imageProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideo10sRequestItem
     */
    videoPrompt: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideo10sRequestItem
     */
    poseUrl?: string;
}



/**
 * 
 * @export
 */
export const AvatarMeVideo10sRequestItemVariantSkuEnumItem = {
    Video10s: 'com.popstore.avatar_me.video.10s'
} as const;
export type AvatarMeVideo10sRequestItemVariantSkuEnumItem = typeof AvatarMeVideo10sRequestItemVariantSkuEnumItem[keyof typeof AvatarMeVideo10sRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeVideo10sRequestVariantSkuEnumItem = {
    Video10s: 'com.popstore.avatar_me.video.10s'
} as const;
export type AvatarMeVideo10sRequestVariantSkuEnumItem = typeof AvatarMeVideo10sRequestVariantSkuEnumItem[keyof typeof AvatarMeVideo10sRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeVideo5sRequest
 */
export interface AvatarMeVideo5sRequest {
    /**
     * 
     * @type {AvatarMeVideo5sRequestVariantSkuEnumItem}
     * @memberof AvatarMeVideo5sRequest
     */
    variantSku: AvatarMeVideo5sRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideo5sRequest
     */
    imageProcessId: string;
    /**
     * text-type prompt
     * @type {string}
     * @memberof AvatarMeVideo5sRequest
     */
    videoPrompt: string;
    /**
     * aws s3(not cdn) url if imageProcessId points to a AvatarMePhotoshootRequest
     * @type {string}
     * @memberof AvatarMeVideo5sRequest
     */
    poseUrl?: string;
}


/**
 * 
 * @export
 * @interface AvatarMeVideo5sRequestItem
 */
export interface AvatarMeVideo5sRequestItem {
    /**
     * 
     * @type {AvatarMeVideo5sRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeVideo5sRequestItem
     */
    variantSku: AvatarMeVideo5sRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideo5sRequestItem
     */
    imageProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideo5sRequestItem
     */
    videoPrompt: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideo5sRequestItem
     */
    poseUrl?: string;
}



/**
 * 
 * @export
 */
export const AvatarMeVideo5sRequestItemVariantSkuEnumItem = {
    Video5s: 'com.popstore.avatar_me.video.5s'
} as const;
export type AvatarMeVideo5sRequestItemVariantSkuEnumItem = typeof AvatarMeVideo5sRequestItemVariantSkuEnumItem[keyof typeof AvatarMeVideo5sRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeVideo5sRequestVariantSkuEnumItem = {
    Video5s: 'com.popstore.avatar_me.video.5s'
} as const;
export type AvatarMeVideo5sRequestVariantSkuEnumItem = typeof AvatarMeVideo5sRequestVariantSkuEnumItem[keyof typeof AvatarMeVideo5sRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeVideoFacePerfectRequest
 */
export interface AvatarMeVideoFacePerfectRequest {
    /**
     * 
     * @type {AvatarMeVideoFacePerfectRequestVariantSkuEnumItem}
     * @memberof AvatarMeVideoFacePerfectRequest
     */
    variantSku: AvatarMeVideoFacePerfectRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideoFacePerfectRequest
     */
    videoProcessId: string;
}


/**
 * 
 * @export
 * @interface AvatarMeVideoFacePerfectRequestItem
 */
export interface AvatarMeVideoFacePerfectRequestItem {
    /**
     * 
     * @type {AvatarMeVideoFacePerfectRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeVideoFacePerfectRequestItem
     */
    variantSku: AvatarMeVideoFacePerfectRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideoFacePerfectRequestItem
     */
    videoProcessId: string;
}



/**
 * 
 * @export
 */
export const AvatarMeVideoFacePerfectRequestItemVariantSkuEnumItem = {
    VideoFacePerfect: 'com.popstore.avatar_me.video.face_perfect'
} as const;
export type AvatarMeVideoFacePerfectRequestItemVariantSkuEnumItem = typeof AvatarMeVideoFacePerfectRequestItemVariantSkuEnumItem[keyof typeof AvatarMeVideoFacePerfectRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeVideoFacePerfectRequestVariantSkuEnumItem = {
    VideoFacePerfect: 'com.popstore.avatar_me.video.face_perfect'
} as const;
export type AvatarMeVideoFacePerfectRequestVariantSkuEnumItem = typeof AvatarMeVideoFacePerfectRequestVariantSkuEnumItem[keyof typeof AvatarMeVideoFacePerfectRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeVideoHdUpgradeRequest
 */
export interface AvatarMeVideoHdUpgradeRequest {
    /**
     * 
     * @type {AvatarMeVideoHdUpgradeRequestVariantSkuEnumItem}
     * @memberof AvatarMeVideoHdUpgradeRequest
     */
    variantSku: AvatarMeVideoHdUpgradeRequestVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideoHdUpgradeRequest
     */
    videoProcessId: string;
}


/**
 * 
 * @export
 * @interface AvatarMeVideoHdUpgradeRequestItem
 */
export interface AvatarMeVideoHdUpgradeRequestItem {
    /**
     * 
     * @type {AvatarMeVideoHdUpgradeRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeVideoHdUpgradeRequestItem
     */
    variantSku: AvatarMeVideoHdUpgradeRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideoHdUpgradeRequestItem
     */
    videoProcessId: string;
}



/**
 * 
 * @export
 */
export const AvatarMeVideoHdUpgradeRequestItemVariantSkuEnumItem = {
    VideoHdUpgrade: 'com.popstore.avatar_me.video.hd_upgrade'
} as const;
export type AvatarMeVideoHdUpgradeRequestItemVariantSkuEnumItem = typeof AvatarMeVideoHdUpgradeRequestItemVariantSkuEnumItem[keyof typeof AvatarMeVideoHdUpgradeRequestItemVariantSkuEnumItem];


/**
 * 
 * @export
 */
export const AvatarMeVideoHdUpgradeRequestVariantSkuEnumItem = {
    VideoHdUpgrade: 'com.popstore.avatar_me.video.hd_upgrade'
} as const;
export type AvatarMeVideoHdUpgradeRequestVariantSkuEnumItem = typeof AvatarMeVideoHdUpgradeRequestVariantSkuEnumItem[keyof typeof AvatarMeVideoHdUpgradeRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarMeVideoRequestItem
 */
export interface AvatarMeVideoRequestItem {
    /**
     * 
     * @type {AvatarMeVideoRequestItemVariantSkuEnumItem}
     * @memberof AvatarMeVideoRequestItem
     */
    variantSku: AvatarMeVideoRequestItemVariantSkuEnumItem;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideoRequestItem
     */
    imageProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideoRequestItem
     */
    videoPrompt: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMeVideoRequestItem
     */
    poseUrl?: string;
}



/**
 * 
 * @export
 */
export const AvatarMeVideoRequestItemVariantSkuEnumItem = {
    Video5s: 'com.popstore.avatar_me.video.5s',
    Video10s: 'com.popstore.avatar_me.video.10s'
} as const;
export type AvatarMeVideoRequestItemVariantSkuEnumItem = typeof AvatarMeVideoRequestItemVariantSkuEnumItem[keyof typeof AvatarMeVideoRequestItemVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface AvatarType
 */
export interface AvatarType {
    /**
     * 
     * @type {string}
     * @memberof AvatarType
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarType
     */
    thumbnail: string;
}
/**
 * 
 * @export
 * @interface BaseProfileItem
 */
export interface BaseProfileItem {
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     * @deprecated
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BaseProfileItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    storeType?: BaseProfileItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof BaseProfileItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof BaseProfileItem
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {PopStoreCreatorBusinessTypeEnumItem}
     * @memberof BaseProfileItem
     */
    businessType?: PopStoreCreatorBusinessTypeEnumItem;
}


/**
 * @export
 */
export const BaseProfileItemStoreTypeEnum = {
    Business: 'Business',
    Creator: 'Creator',
    CommentChat: 'CommentChat',
    Vfs: 'VFS'
} as const;
export type BaseProfileItemStoreTypeEnum = typeof BaseProfileItemStoreTypeEnum[keyof typeof BaseProfileItemStoreTypeEnum];

/**
 * 
 * @export
 * @interface BaseUpcomingShowItem
 */
export interface BaseUpcomingShowItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseUpcomingShowItem
     */
    badges: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    title: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof BaseUpcomingShowItem
     */
    user: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    originalCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    shareVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseUpcomingShowItem
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    visibility?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    permission?: BaseUpcomingShowItemPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseUpcomingShowItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseUpcomingShowItem
     */
    disableComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseUpcomingShowItem
     */
    notificationSent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseUpcomingShowItem
     */
    historyLiveStreamIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    transcodeStatus?: BaseUpcomingShowItemTranscodeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    accessLevel?: BaseUpcomingShowItemAccessLevelEnum;
    /**
     * 
     * @type {ShowTippingItem}
     * @memberof BaseUpcomingShowItem
     */
    tipping?: ShowTippingItem;
}


/**
 * @export
 */
export const BaseUpcomingShowItemPermissionEnum = {
    All: 'all',
    Follower: 'follower',
    Subscriber: 'subscriber',
    NoOne: 'no-one'
} as const;
export type BaseUpcomingShowItemPermissionEnum = typeof BaseUpcomingShowItemPermissionEnum[keyof typeof BaseUpcomingShowItemPermissionEnum];

/**
 * @export
 */
export const BaseUpcomingShowItemTranscodeStatusEnum = {
    Initial: 'initial',
    Processing: 'processing',
    TranscodeOriginal: 'transcode-original',
    TranscodeOriginalShare: 'transcode-original-share',
    RequestRetranscode: 'request-retranscode'
} as const;
export type BaseUpcomingShowItemTranscodeStatusEnum = typeof BaseUpcomingShowItemTranscodeStatusEnum[keyof typeof BaseUpcomingShowItemTranscodeStatusEnum];

/**
 * @export
 */
export const BaseUpcomingShowItemAccessLevelEnum = {
    All: 'all',
    Subscriber: 'subscriber',
    Fan: 'fan',
    Vip: 'vip'
} as const;
export type BaseUpcomingShowItemAccessLevelEnum = typeof BaseUpcomingShowItemAccessLevelEnum[keyof typeof BaseUpcomingShowItemAccessLevelEnum];

/**
 * 
 * @export
 * @interface BasicGoogleCategoryItem
 */
export interface BasicGoogleCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof BasicGoogleCategoryItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BasicGoogleCategoryItem
     */
    name: string;
}
/**
 * 
 * @export
 * @interface BasicProductCategoryItem
 */
export interface BasicProductCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof BasicProductCategoryItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BasicProductCategoryItem
     */
    name: string;
}
/**
 * 
 * @export
 * @interface BasicProfileDto
 */
export interface BasicProfileDto {
    /**
     * First name
     * @type {string}
     * @memberof BasicProfileDto
     */
    firstName: string;
    /**
     * Last name
     * @type {string}
     * @memberof BasicProfileDto
     */
    lastName: string;
    /**
     * Username
     * @type {string}
     * @memberof BasicProfileDto
     */
    username: string;
    /**
     * Avatar URL
     * @type {string}
     * @memberof BasicProfileDto
     */
    avatar: string;
}
/**
 * 
 * @export
 * @interface BatchAddStorePublicListingRequest
 */
export interface BatchAddStorePublicListingRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchAddStorePublicListingRequest
     */
    listingIds: Array<string>;
}
/**
 * 
 * @export
 * @interface BatchGetSellerCustomersRequest
 */
export interface BatchGetSellerCustomersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchGetSellerCustomersRequest
     */
    userIds: Array<string>;
}
/**
 * 
 * @export
 * @interface BatchGetSellerCustomersResponse
 */
export interface BatchGetSellerCustomersResponse {
    /**
     * 
     * @type {Array<SellerCustomerItem>}
     * @memberof BatchGetSellerCustomersResponse
     */
    data: Array<SellerCustomerItem>;
    /**
     * Number of rows in `data`. Equals the requested id count once duplicates are collapsed; there is no paging.
     * @type {number}
     * @memberof BatchGetSellerCustomersResponse
     */
    total: number;
}
/**
 * 
 * @export
 * @interface BillingAddressDto
 */
export interface BillingAddressDto {
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    postalCode: string;
}
/**
 * 
 * @export
 * @interface BillingAddressItem
 */
export interface BillingAddressItem {
    /**
     * For shipping addresses, id will be undefined while for billing addresses, id will be defined
     * @type {string}
     * @memberof BillingAddressItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    postalCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillingAddressItem
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    compareHash?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface BodyImageAwsS3UrlsV2
 */
export interface BodyImageAwsS3UrlsV2 {
    /**
     * aws s3 url for front
     * @type {string}
     * @memberof BodyImageAwsS3UrlsV2
     */
    front: string;
    /**
     * aws s3 url for back
     * @type {string}
     * @memberof BodyImageAwsS3UrlsV2
     */
    back: string;
    /**
     * aws s3 url for profile
     * @type {string}
     * @memberof BodyImageAwsS3UrlsV2
     */
    profile: string;
}
/**
 * 
 * @export
 * @interface BodyImageAwsS3UrlsV2Item
 */
export interface BodyImageAwsS3UrlsV2Item {
    /**
     * 
     * @type {string}
     * @memberof BodyImageAwsS3UrlsV2Item
     */
    front: string;
    /**
     * 
     * @type {string}
     * @memberof BodyImageAwsS3UrlsV2Item
     */
    back: string;
    /**
     * 
     * @type {string}
     * @memberof BodyImageAwsS3UrlsV2Item
     */
    profile: string;
}

/**
 * 
 * @export
 */
export const BodyTypeEnumItem = {
    Lean: 'Lean',
    Normal: 'Normal',
    Bbw: 'BBW',
    Toned: 'Toned',
    Muscular: 'Muscular',
    BodyBuilder: 'Body Builder'
} as const;
export type BodyTypeEnumItem = typeof BodyTypeEnumItem[keyof typeof BodyTypeEnumItem];


/**
 * 
 * @export
 */
export const BonusTokenActionEnumItem = {
    AddSocials: 'ADD_SOCIALS'
} as const;
export type BonusTokenActionEnumItem = typeof BonusTokenActionEnumItem[keyof typeof BonusTokenActionEnumItem];

/**
 * 
 * @export
 * @interface BraintreeDisbursementDetailsItem
 */
export interface BraintreeDisbursementDetailsItem {
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisbursementDetailsItem
     */
    disbursementDate: string;
    /**
     * 
     * @type {boolean}
     * @memberof BraintreeDisbursementDetailsItem
     */
    fundsHeld: boolean;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisbursementDetailsItem
     */
    settlementAmount: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisbursementDetailsItem
     */
    settlementCurrencyExchangeRate: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisbursementDetailsItem
     */
    settlementCurrencyIsoCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof BraintreeDisbursementDetailsItem
     */
    success: boolean;
}
/**
 * 
 * @export
 * @interface BraintreeDisputeItem
 */
export interface BraintreeDisputeItem {
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    amountDisputed: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    amountWon: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    caseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    currencyIsoCode: string;
    /**
     * 
     * @type {EvidenceItem}
     * @memberof BraintreeDisputeItem
     */
    evidence: EvidenceItem;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    kind: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    merchantAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    originalDisputeId: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    processorComments: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    reasonCode: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    reasonDescription: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    receivedDate: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    referenceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    replyByDate: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    status: BraintreeDisputeItemStatusEnum;
    /**
     * 
     * @type {Array<DisputeStatusHistoryItem>}
     * @memberof BraintreeDisputeItem
     */
    statusHistory: Array<DisputeStatusHistoryItem>;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    updatedAt: string;
}


/**
 * @export
 */
export const BraintreeDisputeItemStatusEnum = {
    Accepted: 'Accepted',
    Disputed: 'Disputed',
    Expired: 'Expired',
    Lost: 'Lost',
    Won: 'Won',
    Open: 'Open'
} as const;
export type BraintreeDisputeItemStatusEnum = typeof BraintreeDisputeItemStatusEnum[keyof typeof BraintreeDisputeItemStatusEnum];

/**
 * 
 * @export
 * @interface BraintreeTransactionItem
 */
export interface BraintreeTransactionItem {
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    amount: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BraintreeTransactionItem
     */
    refundIds: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof BraintreeTransactionItem
     */
    refundedTransactionId?: object;
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    updatedAt: string;
    /**
     * 
     * @type {Array<BraintreeDisputeItem>}
     * @memberof BraintreeTransactionItem
     */
    disputes?: Array<BraintreeDisputeItem>;
    /**
     * 
     * @type {BraintreeDisbursementDetailsItem}
     * @memberof BraintreeTransactionItem
     */
    disbursementDetails?: BraintreeDisbursementDetailsItem;
}

/**
 * 
 * @export
 */
export const BreastImplantsEnumItem = {
    Normal: 'Normal',
    Large: 'Large',
    ExtraLarge: 'Extra Large'
} as const;
export type BreastImplantsEnumItem = typeof BreastImplantsEnumItem[keyof typeof BreastImplantsEnumItem];

/**
 * 
 * @export
 * @interface BuyerEarningsPart
 */
export interface BuyerEarningsPart {
    /**
     * Credited to the seller balance
     * @type {number}
     * @memberof BuyerEarningsPart
     */
    earned: number;
    /**
     * Sales tax taken out of what the buyer paid
     * @type {number}
     * @memberof BuyerEarningsPart
     */
    tax: number;
    /**
     * Orders, or subscription charges, counted
     * @type {number}
     * @memberof BuyerEarningsPart
     */
    count: number;
}
/**
 * 
 * @export
 * @interface BuyerStats
 */
export interface BuyerStats {
    /**
     * 
     * @type {number}
     * @memberof BuyerStats
     */
    orders: number;
    /**
     * 
     * @type {number}
     * @memberof BuyerStats
     */
    badges: number;
    /**
     * 
     * @type {number}
     * @memberof BuyerStats
     */
    viewedShows: number;
}

/**
 * 
 * @export
 */
export const BwhUnitEnumItem = {
    Cm: 'cm',
    In: 'in'
} as const;
export type BwhUnitEnumItem = typeof BwhUnitEnumItem[keyof typeof BwhUnitEnumItem];

/**
 * 
 * @export
 * @interface CalculateSaasSubscriptionActualChargeRequest
 */
export interface CalculateSaasSubscriptionActualChargeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CalculateSaasSubscriptionActualChargeRequest
     */
    priceIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CalculateSaasSubscriptionActualChargeRequest
     */
    couponCode?: string;
    /**
     * 
     * @type {TaxCalculationAddress}
     * @memberof CalculateSaasSubscriptionActualChargeRequest
     */
    address?: TaxCalculationAddress;
}
/**
 * 
 * @export
 * @interface CalculateSaasSubscriptionActualChargeResponse
 */
export interface CalculateSaasSubscriptionActualChargeResponse {
    /**
     * 
     * @type {number}
     * @memberof CalculateSaasSubscriptionActualChargeResponse
     */
    totalAmount: number;
    /**
     * Tax on the charged item alone (new plan on upgrade, add-on on add-on purchase)
     * @type {number}
     * @memberof CalculateSaasSubscriptionActualChargeResponse
     */
    taxAmount: number;
}
/**
 * 
 * @export
 * @interface CancelOrderRequest
 */
export interface CancelOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CancelOrderRequest
     */
    reason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CancelOrderRequest
     */
    shouldRestock?: boolean;
    /**
     * only admin can use
     * @type {string}
     * @memberof CancelOrderRequest
     */
    processingFeePayer?: CancelOrderRequestProcessingFeePayerEnum;
}


/**
 * @export
 */
export const CancelOrderRequestProcessingFeePayerEnum = {
    Seller: 'SELLER',
    Popshop: 'POPSHOP'
} as const;
export type CancelOrderRequestProcessingFeePayerEnum = typeof CancelOrderRequestProcessingFeePayerEnum[keyof typeof CancelOrderRequestProcessingFeePayerEnum];

/**
 * 
 * @export
 * @interface CancelSubscriptionRequest
 */
export interface CancelSubscriptionRequest {
    /**
     * 
     * @type {CancellationFeedbackBody}
     * @memberof CancelSubscriptionRequest
     */
    cancellationFeedback?: CancellationFeedbackBody;
    /**
     * 
     * @type {SaasSubscriptionCancelIntentEnumItem}
     * @memberof CancelSubscriptionRequest
     */
    cancelIntent?: SaasSubscriptionCancelIntentEnumItem;
}
/**
 * 
 * @export
 * @interface CancellationFeedbackBody
 */
export interface CancellationFeedbackBody {
    /**
     * 
     * @type {Array<object>}
     * @memberof CancellationFeedbackBody
     */
    answers: Array<object>;
}
/**
 * 
 * @export
 * @interface CancellationQuestionOptionResponse
 */
export interface CancellationQuestionOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof CancellationQuestionOptionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CancellationQuestionOptionResponse
     */
    title: string;
    /**
     * The save screen to open when this option is chosen; absent means none
     * @type {SurveyRetentionModalEnumItem}
     * @memberof CancellationQuestionOptionResponse
     */
    retentionModal?: SurveyRetentionModalEnumItem;
}


/**
 * 
 * @export
 * @interface CancellationQuestionResponse
 */
export interface CancellationQuestionResponse {
    /**
     * 
     * @type {string}
     * @memberof CancellationQuestionResponse
     */
    id: string;
    /**
     * 
     * @type {SurveyQuestionTypeEnumItem}
     * @memberof CancellationQuestionResponse
     */
    type: SurveyQuestionTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CancellationQuestionResponse
     */
    title: string;
    /**
     * 
     * @type {boolean}
     * @memberof CancellationQuestionResponse
     */
    required: boolean;
    /**
     * 
     * @type {number}
     * @memberof CancellationQuestionResponse
     */
    sort: number;
    /**
     * 
     * @type {Array<CancellationQuestionOptionResponse>}
     * @memberof CancellationQuestionResponse
     */
    options?: Array<CancellationQuestionOptionResponse>;
    /**
     * 
     * @type {number}
     * @memberof CancellationQuestionResponse
     */
    minChoices?: number;
    /**
     * 
     * @type {number}
     * @memberof CancellationQuestionResponse
     */
    maxChoices?: number;
    /**
     * 
     * @type {SurveyChoiceDisplayEnumItem}
     * @memberof CancellationQuestionResponse
     */
    display?: SurveyChoiceDisplayEnumItem;
    /**
     * 
     * @type {number}
     * @memberof CancellationQuestionResponse
     */
    step?: number;
    /**
     * 
     * @type {string}
     * @memberof CancellationQuestionResponse
     */
    stepLabel?: string;
    /**
     * 
     * @type {SurveyVisibilityRuleResponse}
     * @memberof CancellationQuestionResponse
     */
    visibleIf?: SurveyVisibilityRuleResponse;
}


/**
 * 
 * @export
 * @interface CardThreeDSecureUsage
 */
export interface CardThreeDSecureUsage {
    /**
     * 
     * @type {boolean}
     * @memberof CardThreeDSecureUsage
     */
    supported: boolean;
}
/**
 * 
 * @export
 * @interface CardWallet
 */
export interface CardWallet {
    /**
     * 
     * @type {string}
     * @memberof CardWallet
     */
    type: CardWalletTypeEnum;
}


/**
 * @export
 */
export const CardWalletTypeEnum = {
    AmexExpressCheckout: 'amex_express_checkout',
    ApplePay: 'apple_pay',
    GooglePay: 'google_pay',
    Masterpass: 'masterpass',
    SamsungPay: 'samsung_pay',
    VisaCheckout: 'visa_checkout'
} as const;
export type CardWalletTypeEnum = typeof CardWalletTypeEnum[keyof typeof CardWalletTypeEnum];

/**
 * 
 * @export
 * @interface ChatMentionDto
 */
export interface ChatMentionDto {
    /**
     * 
     * @type {number}
     * @memberof ChatMentionDto
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMentionDto
     */
    length: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMentionDto
     */
    userId: string;
}
/**
 * 
 * @export
 * @interface ChatMessageData
 */
export interface ChatMessageData {
    /**
     * 
     * @type {number}
     * @memberof ChatMessageData
     */
    messageId: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    clientId: string;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageData
     */
    messageType: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageData
     */
    sessionType: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageData
     */
    chatSessionId: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    sessionId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    fromUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    fromAvatar: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    fromNickname: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    toAvatar: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    toNickname: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    ext: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    quoteMsg: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    createdAt: string;
}
/**
 * 
 * @export
 * @interface ChatMessageDto
 */
export interface ChatMessageDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    chatSessionId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    fromUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    toUserId: string;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageDto
     */
    messageType: ChatMessageDtoMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    ext: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    pictureUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    quoteMsg: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    updatedAt: string;
}


/**
 * @export
 */
export const ChatMessageDtoMessageTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7
} as const;
export type ChatMessageDtoMessageTypeEnum = typeof ChatMessageDtoMessageTypeEnum[keyof typeof ChatMessageDtoMessageTypeEnum];

/**
 * 
 * @export
 * @interface CheckGroupEventDateRangeAvailabilityRequest
 */
export interface CheckGroupEventDateRangeAvailabilityRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckGroupEventDateRangeAvailabilityRequest
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof CheckGroupEventDateRangeAvailabilityRequest
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof CheckGroupEventDateRangeAvailabilityRequest
     */
    groupEventId?: string;
}
/**
 * 
 * @export
 * @interface CheckGroupEventDateRangeAvailabilityResponse
 */
export interface CheckGroupEventDateRangeAvailabilityResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckGroupEventDateRangeAvailabilityResponse
     */
    overlapWithBookedSlots: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckGroupEventDateRangeAvailabilityResponse
     */
    overlapWithAvailableSlots?: boolean;
}
/**
 * 
 * @export
 * @interface CheckLeadFormTriggerActionRequest
 */
export interface CheckLeadFormTriggerActionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckLeadFormTriggerActionRequest
     */
    triggerActionKeys: Array<string>;
}
/**
 * 
 * @export
 * @interface CheckLeadFormTriggerActionResponse
 */
export interface CheckLeadFormTriggerActionResponse {
    /**
     * a list of trigger action key that have been used
     * @type {Array<string>}
     * @memberof CheckLeadFormTriggerActionResponse
     */
    data: Array<string>;
}
/**
 * 
 * @export
 * @interface CheckPayoutMethodUpdateStatusResponse
 */
export interface CheckPayoutMethodUpdateStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    canWithdraw: boolean;
    /**
     * it means status is approved or reject.
     * @type {boolean}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    hasCompleteApply: boolean;
    /**
     * it means status is pending. can not withdraw.
     * @type {boolean}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    hasPendingApply: boolean;
    /**
     * it means whether the last request is within 24 hours. if hasCompleteApply && isInLimitHours && !firstCreate, can not withdraw 
     * @type {boolean}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    isInLimitHours?: boolean;
    /**
     * no status means seller never submits update request
     * @type {string}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    status?: CheckPayoutMethodUpdateStatusResponseStatusEnum;
    /**
     * first create payout method can be withdraw
     * @type {boolean}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    firstCreate?: boolean;
    /**
     * The last four digits of latest update bank account number when status is pending
     * @type {string}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    latestAccountNumber?: string;
}


/**
 * @export
 */
export const CheckPayoutMethodUpdateStatusResponseStatusEnum = {
    Approved: 'approved',
    Pending: 'pending',
    Rejected: 'rejected',
    Canceled: 'canceled'
} as const;
export type CheckPayoutMethodUpdateStatusResponseStatusEnum = typeof CheckPayoutMethodUpdateStatusResponseStatusEnum[keyof typeof CheckPayoutMethodUpdateStatusResponseStatusEnum];

/**
 * 
 * @export
 * @interface CheckUserBonusTokenBalanceTokenRequest
 */
export interface CheckUserBonusTokenBalanceTokenRequest {
    /**
     * 
     * @type {BonusTokenActionEnumItem}
     * @memberof CheckUserBonusTokenBalanceTokenRequest
     */
    action: BonusTokenActionEnumItem;
}


/**
 * 
 * @export
 * @interface CheckUserBonusTokenBalanceTokenResponse
 */
export interface CheckUserBonusTokenBalanceTokenResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckUserBonusTokenBalanceTokenResponse
     */
    data: boolean;
}
/**
 * 
 * @export
 * @interface ClaimSaasSubscriptionCouponCampaignOfferResponse
 */
export interface ClaimSaasSubscriptionCouponCampaignOfferResponse {
    /**
     * 
     * @type {ClaimedSaasSubscriptionCouponCampaignOffer}
     * @memberof ClaimSaasSubscriptionCouponCampaignOfferResponse
     */
    data: ClaimedSaasSubscriptionCouponCampaignOffer;
}
/**
 * 
 * @export
 * @interface ClaimedSaasSubscriptionCouponCampaignOffer
 */
export interface ClaimedSaasSubscriptionCouponCampaignOffer {
    /**
     * 
     * @type {PublicSaasSubscriptionCouponCampaignItem}
     * @memberof ClaimedSaasSubscriptionCouponCampaignOffer
     */
    campaign: PublicSaasSubscriptionCouponCampaignItem;
    /**
     * the stage the token was minted for
     * @type {string}
     * @memberof ClaimedSaasSubscriptionCouponCampaignOffer
     */
    stageKey: string;
    /**
     * when the offer lapses; absent when the stage set no expiry. Re-claiming never extends it.
     * @type {string}
     * @memberof ClaimedSaasSubscriptionCouponCampaignOffer
     */
    expiresAt?: string;
}

/**
 * 
 * @export
 */
export const CollectionLayoutTypeEnumItem = {
    Racks: 'racks',
    Stacks: 'stacks'
} as const;
export type CollectionLayoutTypeEnumItem = typeof CollectionLayoutTypeEnumItem[keyof typeof CollectionLayoutTypeEnumItem];

/**
 * 
 * @export
 * @interface CommentChatSource
 */
export interface CommentChatSource {
    /**
     * 
     * @type {string}
     * @memberof CommentChatSource
     */
    type: CommentChatSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentChatSource
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentChatSource
     */
    postLinkId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentChatSource
     */
    channelId?: string;
}


/**
 * @export
 */
export const CommentChatSourceTypeEnum = {
    CommentChat: 'COMMENT_CHAT'
} as const;
export type CommentChatSourceTypeEnum = typeof CommentChatSourceTypeEnum[keyof typeof CommentChatSourceTypeEnum];

/**
 * 
 * @export
 * @interface CommentSoldOrderItem
 */
export interface CommentSoldOrderItem {
    /**
     * 
     * @type {string}
     * @memberof CommentSoldOrderItem
     */
    shopId?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentSoldOrderItem
     */
    orderId?: number;
    /**
     * 
     * @type {string}
     * @memberof CommentSoldOrderItem
     */
    syncAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommentSoldOrderItem
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommentSoldOrderItem
     */
    subtotalAdjusted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommentSoldOrderItem
     */
    error?: string;
}

/**
 * 
 * @export
 */
export const CommissionFeeTypeEnumItem = {
    Rate: 'RATE',
    Fixed: 'FIXED'
} as const;
export type CommissionFeeTypeEnumItem = typeof CommissionFeeTypeEnumItem[keyof typeof CommissionFeeTypeEnumItem];

/**
 * 
 * @export
 * @interface CommunityChannelMemberNotificationSettingsItem
 */
export interface CommunityChannelMemberNotificationSettingsItem {
    /**
     * 
     * @type {boolean}
     * @memberof CommunityChannelMemberNotificationSettingsItem
     */
    muted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityChannelMemberNotificationSettingsItem
     */
    subscribedToUpdatesOfCreator: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommunityChannelMemberNotificationSettingsItem
     */
    subscribedToUpdatesOfMessages: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityChannelMemberNotificationSettingsItem
     */
    subscribedToMentions: boolean;
}
/**
 * 
 * @export
 * @interface CommunityChannelMemberPageRows
 */
export interface CommunityChannelMemberPageRows {
    /**
     * 
     * @type {Array<CommunityChannelMemberSearchItem>}
     * @memberof CommunityChannelMemberPageRows
     */
    rows: Array<CommunityChannelMemberSearchItem>;
}
/**
 * 
 * @export
 * @interface CommunityChannelMemberProfileItem
 */
export interface CommunityChannelMemberProfileItem {
    /**
     * First name
     * @type {string}
     * @memberof CommunityChannelMemberProfileItem
     */
    firstName: string;
    /**
     * Last name
     * @type {string}
     * @memberof CommunityChannelMemberProfileItem
     */
    lastName: string;
    /**
     * Username
     * @type {string}
     * @memberof CommunityChannelMemberProfileItem
     */
    username: string;
    /**
     * Avatar URL
     * @type {string}
     * @memberof CommunityChannelMemberProfileItem
     */
    avatar: string;
    /**
     * 
     * @type {ProfileUserTypeEnumItem}
     * @memberof CommunityChannelMemberProfileItem
     */
    userType?: ProfileUserTypeEnumItem;
    /**
     * 
     * @type {StoreTypeEnumItem}
     * @memberof CommunityChannelMemberProfileItem
     */
    storeType?: StoreTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberProfileItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberProfileItem
     */
    urlCode?: string;
}


/**
 * 
 * @export
 * @interface CommunityChannelMemberSearchItem
 */
export interface CommunityChannelMemberSearchItem {
    /**
     * 
     * @type {CommunityChannelMemberProfileItem}
     * @memberof CommunityChannelMemberSearchItem
     */
    profile: CommunityChannelMemberProfileItem;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof CommunityChannelMemberSearchItem
     */
    subscriptionLevel: PopStoreExtendedSubscriptionLevelEnumItem;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof CommunityChannelMemberSearchItem
     */
    minimumRequiredSubscriptionLevel: PopStoreExtendedSubscriptionLevelEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberSearchItem
     */
    lastReadAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberSearchItem
     */
    lastDeleteAt?: string;
    /**
     * 
     * @type {CommunityChannelMemberStatusEnumItem}
     * @memberof CommunityChannelMemberSearchItem
     */
    status: CommunityChannelMemberStatusEnumItem;
    /**
     * 
     * @type {CommunityMemberPresenceStatusEnumItem}
     * @memberof CommunityChannelMemberSearchItem
     */
    presenceStatus: CommunityMemberPresenceStatusEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberSearchItem
     */
    onlineLastUpdatedAt?: string;
    /**
     * 
     * @type {CommunityChannelMemberNotificationSettingsItem}
     * @memberof CommunityChannelMemberSearchItem
     */
    notificationSettings: CommunityChannelMemberNotificationSettingsItem;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityChannelMemberSearchItem
     */
    blocked: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberSearchItem
     */
    blockedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberSearchItem
     */
    leftAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof CommunityChannelMemberSearchItem
     */
    relations: Relations;
}


/**
 * 
 * @export
 * @interface CommunityChannelMemberSearchResponse
 */
export interface CommunityChannelMemberSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof CommunityChannelMemberSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof CommunityChannelMemberSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {CommunityChannelMemberPageRows}
     * @memberof CommunityChannelMemberSearchResponse
     */
    data: CommunityChannelMemberPageRows;
}

/**
 * 
 * @export
 */
export const CommunityChannelMemberStatusEnumItem = {
    Active: 'active',
    Left: 'left'
} as const;
export type CommunityChannelMemberStatusEnumItem = typeof CommunityChannelMemberStatusEnumItem[keyof typeof CommunityChannelMemberStatusEnumItem];

/**
 * 
 * @export
 * @interface CommunityChannelMemberTypingItem
 */
export interface CommunityChannelMemberTypingItem {
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberTypingItem
     */
    userId: string;
    /**
     * 
     * @type {BasicProfileDto}
     * @memberof CommunityChannelMemberTypingItem
     */
    profile: BasicProfileDto;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMemberTypingItem
     */
    lastUpdatedAt: string;
}
/**
 * 
 * @export
 * @interface CommunityChannelMessageAttachmentItem
 */
export interface CommunityChannelMessageAttachmentItem {
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentItem
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentItem
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentItem
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentItem
     */
    objectId?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentItem
     */
    caption?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentItem
     */
    processedUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentItem
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentItem
     */
    thumbnailVideoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentItem
     */
    blurhash?: string;
    /**
     * 
     * @type {ContentModerationInfoItem}
     * @memberof CommunityChannelMessageAttachmentItem
     */
    moderation?: ContentModerationInfoItem;
}
/**
 * 
 * @export
 * @interface CommunityChannelMessageAttachmentRequest
 */
export interface CommunityChannelMessageAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentRequest
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentRequest
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentRequest
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentRequest
     */
    objectId?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentRequest
     */
    caption?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentRequest
     */
    processedUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentRequest
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageAttachmentRequest
     */
    blurhash?: string;
}
/**
 * 
 * @export
 * @interface CommunityChannelMessageContentItem
 */
export interface CommunityChannelMessageContentItem {
    /**
     * 
     * @type {CommunityChannelMessageTextContentItem}
     * @memberof CommunityChannelMessageContentItem
     */
    textContent: CommunityChannelMessageTextContentItem;
    /**
     * 
     * @type {Array<CommunityChannelMessageAttachmentItem>}
     * @memberof CommunityChannelMessageContentItem
     */
    attachments?: Array<CommunityChannelMessageAttachmentItem>;
    /**
     * 
     * @type {Array<object>}
     * @memberof CommunityChannelMessageContentItem
     */
    links?: Array<object>;
}
/**
 * 
 * @export
 * @interface CommunityChannelMessageContentRequest
 */
export interface CommunityChannelMessageContentRequest {
    /**
     * 
     * @type {CommunityChannelMessageTextContentRequest}
     * @memberof CommunityChannelMessageContentRequest
     */
    textContent: CommunityChannelMessageTextContentRequest;
    /**
     * 
     * @type {Array<CommunityChannelMessageAttachmentRequest>}
     * @memberof CommunityChannelMessageContentRequest
     */
    attachments?: Array<CommunityChannelMessageAttachmentRequest>;
    /**
     * 
     * @type {Array<object>}
     * @memberof CommunityChannelMessageContentRequest
     */
    links?: Array<object>;
}
/**
 * 
 * @export
 * @interface CommunityChannelMessageMentionItem
 */
export interface CommunityChannelMessageMentionItem {
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageMentionItem
     */
    userId: string;
    /**
     * 
     * @type {BasicProfileDto}
     * @memberof CommunityChannelMessageMentionItem
     */
    profile: BasicProfileDto;
}
/**
 * 
 * @export
 * @interface CommunityChannelMessagePageRows
 */
export interface CommunityChannelMessagePageRows {
    /**
     * 
     * @type {Array<CommunityChannelMessageSearchItem>}
     * @memberof CommunityChannelMessagePageRows
     */
    rows: Array<CommunityChannelMessageSearchItem>;
}

/**
 * 
 * @export
 */
export const CommunityChannelMessagePredefinedReactionNameEnumItem = {
    Like: 'like'
} as const;
export type CommunityChannelMessagePredefinedReactionNameEnumItem = typeof CommunityChannelMessagePredefinedReactionNameEnumItem[keyof typeof CommunityChannelMessagePredefinedReactionNameEnumItem];

/**
 * 
 * @export
 * @interface CommunityChannelMessageReactionStatItem
 */
export interface CommunityChannelMessageReactionStatItem {
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageReactionStatItem
     */
    emoji: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageReactionStatItem
     */
    emojiCode: string;
    /**
     * 
     * @type {number}
     * @memberof CommunityChannelMessageReactionStatItem
     */
    count: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommunityChannelMessageReactionStatItem
     */
    usernames: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityChannelMessageReactionStatItem
     */
    meClicked?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityChannelMessageSearchItem
 */
export interface CommunityChannelMessageSearchItem {
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    rootMessageId: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    userId: string;
    /**
     * 
     * @type {CommunityChannelMemberProfileItem}
     * @memberof CommunityChannelMessageSearchItem
     */
    profile: CommunityChannelMemberProfileItem;
    /**
     * 
     * @type {CommunityChannelMessageContentItem}
     * @memberof CommunityChannelMessageSearchItem
     */
    content: CommunityChannelMessageContentItem;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof CommunityChannelMessageSearchItem
     */
    level: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    parentMessageId?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    clientMessageId: string;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof CommunityChannelMessageSearchItem
     */
    subscriptionLevel?: PopStoreExtendedSubscriptionLevelEnumItem;
    /**
     * 
     * @type {Array<CommunityChannelMessageMentionItem>}
     * @memberof CommunityChannelMessageSearchItem
     */
    mentions?: Array<CommunityChannelMessageMentionItem>;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityChannelMessageSearchItem
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    deletedByUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    deletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    lastRepliedAt?: string;
    /**
     * 
     * @type {Array<RecentRepliedProfileDto>}
     * @memberof CommunityChannelMessageSearchItem
     */
    recentRepliedProfiles: Array<RecentRepliedProfileDto>;
    /**
     * 
     * @type {{ [key: string]: CommunityChannelMessageReactionStatItem; }}
     * @memberof CommunityChannelMessageSearchItem
     */
    reactions: { [key: string]: CommunityChannelMessageReactionStatItem; };
    /**
     * 
     * @type {number}
     * @memberof CommunityChannelMessageSearchItem
     */
    replyCount: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    pinnedAt?: string;
    /**
     * 
     * @type {ContentModerationInfoItem}
     * @memberof CommunityChannelMessageSearchItem
     */
    moderation?: ContentModerationInfoItem;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof CommunityChannelMessageSearchItem
     */
    relations: Relations;
}


/**
 * 
 * @export
 * @interface CommunityChannelMessageSearchResponse
 */
export interface CommunityChannelMessageSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof CommunityChannelMessageSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof CommunityChannelMessageSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {CommunityChannelMessagePageRows}
     * @memberof CommunityChannelMessageSearchResponse
     */
    data: CommunityChannelMessagePageRows;
}
/**
 * 
 * @export
 * @interface CommunityChannelMessageTextContentItem
 */
export interface CommunityChannelMessageTextContentItem {
    /**
     * 
     * @type {CommunityChannelMessageTextContentTypeEnumItem}
     * @memberof CommunityChannelMessageTextContentItem
     */
    type: CommunityChannelMessageTextContentTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageTextContentItem
     */
    content: string;
}


/**
 * 
 * @export
 * @interface CommunityChannelMessageTextContentRequest
 */
export interface CommunityChannelMessageTextContentRequest {
    /**
     * 
     * @type {CommunityChannelMessageTextContentTypeEnumItem}
     * @memberof CommunityChannelMessageTextContentRequest
     */
    type: CommunityChannelMessageTextContentTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelMessageTextContentRequest
     */
    content: string;
}



/**
 * 
 * @export
 */
export const CommunityChannelMessageTextContentTypeEnumItem = {
    PlainText: 'plain-text',
    Markdown: 'markdown',
    SlatejsDom: 'slatejs-dom'
} as const;
export type CommunityChannelMessageTextContentTypeEnumItem = typeof CommunityChannelMessageTextContentTypeEnumItem[keyof typeof CommunityChannelMessageTextContentTypeEnumItem];

/**
 * 
 * @export
 * @interface CommunityChannelMyDetailItem
 */
export interface CommunityChannelMyDetailItem {
    /**
     * 
     * @type {number}
     * @memberof CommunityChannelMyDetailItem
     */
    unreadMessageCount: number;
}
/**
 * 
 * @export
 * @interface CommunityChannelPageRows
 */
export interface CommunityChannelPageRows {
    /**
     * 
     * @type {Array<CommunityChannelSearchItem>}
     * @memberof CommunityChannelPageRows
     */
    rows: Array<CommunityChannelSearchItem>;
}
/**
 * 
 * @export
 * @interface CommunityChannelSearchItem
 */
export interface CommunityChannelSearchItem {
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelSearchItem
     */
    icon: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelSearchItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelSearchItem
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelSearchItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelSearchItem
     */
    announcement?: string;
    /**
     * 
     * @type {CommunityChannelVisibilityEnumItem}
     * @memberof CommunityChannelSearchItem
     */
    visibility: CommunityChannelVisibilityEnumItem;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof CommunityChannelSearchItem
     */
    minimumSubscriptionLevel: PopStoreExtendedSubscriptionLevelEnumItem;
    /**
     * 
     * @type {SaasSubscriptionBasePlanTypeEnumItem}
     * @memberof CommunityChannelSearchItem
     */
    seedBasePlanType: SaasSubscriptionBasePlanTypeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof CommunityChannelSearchItem
     */
    messageCount: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityChannelSearchItem
     */
    memberCount: number;
    /**
     * 
     * @type {Array<CommunityChannelMemberTypingItem>}
     * @memberof CommunityChannelSearchItem
     */
    membersTyping: Array<CommunityChannelMemberTypingItem>;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {LatestCommunityChannelMessageItem}
     * @memberof CommunityChannelSearchItem
     */
    lastMessage?: LatestCommunityChannelMessageItem;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityChannelSearchItem
     */
    isBroadcastChannel?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof CommunityChannelSearchItem
     */
    relations: Relations;
    /**
     * 
     * @type {CommunityChannelMyDetailItem}
     * @memberof CommunityChannelSearchItem
     */
    me?: CommunityChannelMyDetailItem;
}


/**
 * 
 * @export
 * @interface CommunityChannelSearchResponse
 */
export interface CommunityChannelSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof CommunityChannelSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof CommunityChannelSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityChannelSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {CommunityChannelPageRows}
     * @memberof CommunityChannelSearchResponse
     */
    data: CommunityChannelPageRows;
}

/**
 * 
 * @export
 */
export const CommunityChannelVisibilityEnumItem = {
    Public: 'public',
    Private: 'private'
} as const;
export type CommunityChannelVisibilityEnumItem = typeof CommunityChannelVisibilityEnumItem[keyof typeof CommunityChannelVisibilityEnumItem];


/**
 * 
 * @export
 */
export const CommunityMemberPresenceStatusEnumItem = {
    Online: 'online',
    Offline: 'offline',
    Away: 'away'
} as const;
export type CommunityMemberPresenceStatusEnumItem = typeof CommunityMemberPresenceStatusEnumItem[keyof typeof CommunityMemberPresenceStatusEnumItem];

/**
 * 
 * @export
 * @interface ConciergeAckResponse
 */
export interface ConciergeAckResponse {
    /**
     * 
     * @type {string}
     * @memberof ConciergeAckResponse
     */
    conversation_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConciergeAckResponse
     */
    ok: boolean;
}
/**
 * 
 * @export
 * @interface ConciergeAnswer
 */
export interface ConciergeAnswer {
    /**
     * 
     * @type {string}
     * @memberof ConciergeAnswer
     */
    text: string;
}
/**
 * 
 * @export
 * @interface ConciergeProactiveActionRequest
 */
export interface ConciergeProactiveActionRequest {
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveActionRequest
     */
    store_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveActionRequest
     */
    listing_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveActionRequest
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveActionRequest
     */
    session_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveActionRequest
     */
    conversation_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveActionRequest
     */
    conv_token: string;
    /**
     * 
     * @type {number}
     * @memberof ConciergeProactiveActionRequest
     */
    conv_token_issued_at: number;
    /**
     * 
     * @type {ConciergeSelfEngagementAction}
     * @memberof ConciergeProactiveActionRequest
     */
    action: ConciergeSelfEngagementAction;
}
/**
 * 
 * @export
 * @interface ConciergeProactiveMessage
 */
export interface ConciergeProactiveMessage {
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveMessage
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveMessage
     */
    category_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveMessage
     */
    type: string;
}
/**
 * 
 * @export
 * @interface ConciergeProactiveNextRequest
 */
export interface ConciergeProactiveNextRequest {
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveNextRequest
     */
    store_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveNextRequest
     */
    listing_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveNextRequest
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveNextRequest
     */
    session_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveNextRequest
     */
    conversation_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveNextRequest
     */
    conv_token: string;
    /**
     * 
     * @type {number}
     * @memberof ConciergeProactiveNextRequest
     */
    conv_token_issued_at: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConciergeProactiveNextRequest
     */
    cool_down_completed?: boolean;
}
/**
 * 
 * @export
 * @interface ConciergeProactiveNextResponse
 */
export interface ConciergeProactiveNextResponse {
    /**
     * 
     * @type {string}
     * @memberof ConciergeProactiveNextResponse
     */
    conversation_id: string;
    /**
     * 
     * @type {ConciergeProactiveMessage}
     * @memberof ConciergeProactiveNextResponse
     */
    response: ConciergeProactiveMessage;
}
/**
 * 
 * @export
 * @interface ConciergeReactiveQueryRequest
 */
export interface ConciergeReactiveQueryRequest {
    /**
     * 
     * @type {string}
     * @memberof ConciergeReactiveQueryRequest
     */
    store_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeReactiveQueryRequest
     */
    listing_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeReactiveQueryRequest
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeReactiveQueryRequest
     */
    session_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeReactiveQueryRequest
     */
    conversation_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeReactiveQueryRequest
     */
    conv_token: string;
    /**
     * 
     * @type {number}
     * @memberof ConciergeReactiveQueryRequest
     */
    conv_token_issued_at: number;
    /**
     * 
     * @type {string}
     * @memberof ConciergeReactiveQueryRequest
     */
    query?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConciergeReactiveQueryRequest
     */
    triggered_by_suggestion?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConciergeReactiveQueryRequest
     */
    action?: string;
}
/**
 * 
 * @export
 * @interface ConciergeReactiveQueryResponse
 */
export interface ConciergeReactiveQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof ConciergeReactiveQueryResponse
     */
    conversation_id: string;
    /**
     * 
     * @type {ConciergeAnswer}
     * @memberof ConciergeReactiveQueryResponse
     */
    response?: ConciergeAnswer;
    /**
     * 
     * @type {boolean}
     * @memberof ConciergeReactiveQueryResponse
     */
    ok?: boolean;
}
/**
 * 
 * @export
 * @interface ConciergeSelfEngagementAction
 */
export interface ConciergeSelfEngagementAction {
    /**
     * 
     * @type {string}
     * @memberof ConciergeSelfEngagementAction
     */
    type: ConciergeSelfEngagementActionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConciergeSelfEngagementAction
     */
    event_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeSelfEngagementAction
     */
    event_title?: string;
}


/**
 * @export
 */
export const ConciergeSelfEngagementActionTypeEnum = {
    PrivateTouringDeclined: 'private-touring-declined',
    OpenHouseRsvp: 'open-house-rsvp'
} as const;
export type ConciergeSelfEngagementActionTypeEnum = typeof ConciergeSelfEngagementActionTypeEnum[keyof typeof ConciergeSelfEngagementActionTypeEnum];

/**
 * 
 * @export
 * @interface ConciergeSessionRequest
 */
export interface ConciergeSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof ConciergeSessionRequest
     */
    store_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeSessionRequest
     */
    listing_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeSessionRequest
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeSessionRequest
     */
    conversation_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeSessionRequest
     */
    conv_id_proof?: string;
}
/**
 * 
 * @export
 * @interface ConciergeSessionResponse
 */
export interface ConciergeSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof ConciergeSessionResponse
     */
    session_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeSessionResponse
     */
    conversation_id: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeSessionResponse
     */
    conv_id_proof: string;
    /**
     * 
     * @type {string}
     * @memberof ConciergeSessionResponse
     */
    conv_token: string;
    /**
     * 
     * @type {number}
     * @memberof ConciergeSessionResponse
     */
    conv_token_issued_at: number;
    /**
     * 
     * @type {number}
     * @memberof ConciergeSessionResponse
     */
    conv_token_expires_at: number;
}
/**
 * 
 * @export
 * @interface ConfirmSetupCreatorSubscriptionPaymentMethodRequest
 */
export interface ConfirmSetupCreatorSubscriptionPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodRequest
     */
    stripeConfirmationToken?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodRequest
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodRequest
     */
    returnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodRequest
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface ConfirmSetupCreatorSubscriptionPaymentMethodResponse
 */
export interface ConfirmSetupCreatorSubscriptionPaymentMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    status: string;
    /**
     * 
     * @type {object}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    nextAction?: object;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    addressId?: string;
}
/**
 * 
 * @export
 * @interface ConfirmSetupSaasSubscriptionPaymentMethodRequest
 */
export interface ConfirmSetupSaasSubscriptionPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodRequest
     */
    stripeConfirmationToken?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodRequest
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodRequest
     */
    returnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodRequest
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodRequest
     */
    isSetAsDefault?: boolean;
}
/**
 * 
 * @export
 * @interface ConfirmSetupSaasSubscriptionPaymentMethodResponse
 */
export interface ConfirmSetupSaasSubscriptionPaymentMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    status: string;
    /**
     * 
     * @type {object}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    nextAction?: object;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    addressId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    becameDefaultPaymentMethod?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    outstandingInvoicePaid?: boolean;
}
/**
 * 
 * @export
 * @interface ContentModerationInfoItem
 */
export interface ContentModerationInfoItem {
    /**
     * 
     * @type {ModerationStatusEnumItem}
     * @memberof ContentModerationInfoItem
     */
    moderationStatus?: ModerationStatusEnumItem;
    /**
     * 
     * @type {string}
     * @memberof ContentModerationInfoItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof ContentModerationInfoItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof ContentModerationInfoItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentModerationInfoItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentModerationInfoItem
     */
    aiModerationReason?: string;
}


/**
 * 
 * @export
 * @interface ConvertTrialRequest
 */
export interface ConvertTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof ConvertTrialRequest
     */
    type: ConvertTrialRequestTypeEnum;
}


/**
 * @export
 */
export const ConvertTrialRequestTypeEnum = {
    PdfWatermarkRemoval: 'pdf-watermark-removal'
} as const;
export type ConvertTrialRequestTypeEnum = typeof ConvertTrialRequestTypeEnum[keyof typeof ConvertTrialRequestTypeEnum];

/**
 * 
 * @export
 * @interface ConvertTrialResponse
 */
export interface ConvertTrialResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ConvertTrialResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConvertTrialResponse
     */
    subscriptionId?: string;
    /**
     * 
     * @type {SubscriptionStatusEnumItem}
     * @memberof ConvertTrialResponse
     */
    status?: SubscriptionStatusEnumItem;
    /**
     * 
     * @type {string}
     * @memberof ConvertTrialResponse
     */
    message?: string;
}


/**
 * 
 * @export
 * @interface CouponCampaignReachDto
 */
export interface CouponCampaignReachDto {
    /**
     * 
     * @type {SaasSubscriptionCouponCampaignReachMethodEnumItem}
     * @memberof CouponCampaignReachDto
     */
    method: SaasSubscriptionCouponCampaignReachMethodEnumItem;
    /**
     * `inline` only — absent = the scene default slot
     * @type {string}
     * @memberof CouponCampaignReachDto
     */
    slot?: string;
    /**
     * `popup` only
     * @type {boolean}
     * @memberof CouponCampaignReachDto
     */
    dismissible?: boolean;
    /**
     * `popup` only
     * @type {boolean}
     * @memberof CouponCampaignReachDto
     */
    reshowOnDismiss?: boolean;
    /**
     * `email` only, and required there — a doc id in the `emailTemplates` collection
     * @type {string}
     * @memberof CouponCampaignReachDto
     */
    emailTemplateId?: string;
    /**
     * `email` only — delay before sending
     * @type {number}
     * @memberof CouponCampaignReachDto
     */
    sendAfterSeconds?: number;
    /**
     * `email_flow` only, and required there — an `EmailFlow.flowId` owned by the ai-service
     * @type {string}
     * @memberof CouponCampaignReachDto
     */
    emailFlowId?: string;
}


/**
 * 
 * @export
 * @interface CouponCampaignTriggerDto
 */
export interface CouponCampaignTriggerDto {
    /**
     * 
     * @type {SaasSubscriptionCouponCampaignTriggerTypeEnumItem}
     * @memberof CouponCampaignTriggerDto
     */
    type: SaasSubscriptionCouponCampaignTriggerTypeEnumItem;
    /**
     * `landed` only — grace period after landing
     * @type {number}
     * @memberof CouponCampaignTriggerDto
     */
    delaySeconds?: number;
    /**
     * `idled` only, and required there
     * @type {number}
     * @memberof CouponCampaignTriggerDto
     */
    idleSeconds?: number;
    /**
     * `action_taken` only, and required there — the client-emitted action name, e.g. `plan_card_clicked`
     * @type {string}
     * @memberof CouponCampaignTriggerDto
     */
    actionKey?: string;
    /**
     * `left` only — absent = any departure signal fires the stage
     * @type {Array<SaasSubscriptionCouponCampaignExitSignalEnumItem>}
     * @memberof CouponCampaignTriggerDto
     */
    signals?: Array<SaasSubscriptionCouponCampaignExitSignalEnumItem>;
}


/**
 * 
 * @export
 * @interface CouponCreatedByItem
 */
export interface CouponCreatedByItem {
    /**
     * 
     * @type {string}
     * @memberof CouponCreatedByItem
     */
    profileId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof CouponCreatedByItem
     */
    profile?: ProfileItem;
}
/**
 * 
 * @export
 * @interface CouponDetailItem
 */
export interface CouponDetailItem {
    /**
     * 
     * @type {string}
     * @memberof CouponDetailItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CouponDetailItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CouponDetailItem
     */
    type: CouponDetailItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CouponDetailItem
     */
    source?: CouponDetailItemSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof CouponDetailItem
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponDetailItem
     */
    percentage?: number;
}


/**
 * @export
 */
export const CouponDetailItemTypeEnum = {
    PercentOff: 'percent_off',
    AmountOff: 'amount_off',
    Trial: 'trial'
} as const;
export type CouponDetailItemTypeEnum = typeof CouponDetailItemTypeEnum[keyof typeof CouponDetailItemTypeEnum];

/**
 * @export
 */
export const CouponDetailItemSourceEnum = {
    Manual: 'manual',
    Retention: 'retention',
    PlanCoupon: 'plan_coupon',
    Campaign: 'campaign',
    WinBack: 'win_back'
} as const;
export type CouponDetailItemSourceEnum = typeof CouponDetailItemSourceEnum[keyof typeof CouponDetailItemSourceEnum];

/**
 * 
 * @export
 * @interface CouponDetails
 */
export interface CouponDetails {
    /**
     * 
     * @type {string}
     * @memberof CouponDetails
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CouponDetails
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CouponDetails
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof CouponDetails
     */
    type: CouponDetailsTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CouponDetails
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponDetails
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponDetails
     */
    maxRedemptions?: number;
    /**
     * 
     * @type {string}
     * @memberof CouponDetails
     */
    expireTime: string;
    /**
     * 
     * @type {string}
     * @memberof CouponDetails
     */
    createdBy: string;
    /**
     * 
     * @type {string}
     * @memberof CouponDetails
     */
    createdAt: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponDetails
     */
    applyToUsers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponDetails
     */
    applyToSubscriptions?: Array<string>;
    /**
     * 
     * @type {SaasSubscriptionPromotionDetails}
     * @memberof CouponDetails
     */
    promotion?: SaasSubscriptionPromotionDetails;
    /**
     * 
     * @type {number}
     * @memberof CouponDetails
     */
    trialPeriodDays?: number;
    /**
     * 
     * @type {CouponDurationDetails}
     * @memberof CouponDetails
     */
    duration?: CouponDurationDetails;
    /**
     * 
     * @type {SaasSubscriptionCouponFrequencyEnumItem}
     * @memberof CouponDetails
     */
    couponFrequency?: SaasSubscriptionCouponFrequencyEnumItem;
}


/**
 * @export
 */
export const CouponDetailsTypeEnum = {
    PercentOff: 'percent_off',
    AmountOff: 'amount_off',
    Trial: 'trial'
} as const;
export type CouponDetailsTypeEnum = typeof CouponDetailsTypeEnum[keyof typeof CouponDetailsTypeEnum];

/**
 * 
 * @export
 * @interface CouponDurationDetails
 */
export interface CouponDurationDetails {
    /**
     * 
     * @type {SassSubscriptionCouponDurationTypeEnumItem}
     * @memberof CouponDurationDetails
     */
    type: SassSubscriptionCouponDurationTypeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof CouponDurationDetails
     */
    durationInMonths?: number;
}


/**
 * 
 * @export
 * @interface CouponItem
 */
export interface CouponItem {
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    pagUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    visible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    exclusive: boolean;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    quantityLimit: boolean;
    /**
     * 
     * @type {number}
     * @memberof CouponItem
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponItem
     */
    redeemedQuantity: number;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    expiredAt: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItem
     */
    storeIds?: Array<string>;
    /**
     * 
     * @type {StoreItem}
     * @memberof CouponItem
     */
    store?: StoreItem;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    couponCreateMethod?: CouponItemCouponCreateMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    type: CouponItemTypeEnum;
    /**
     * belong to type discountPercent and non-nullable.
     * @type {number}
     * @memberof CouponItem
     */
    discountPercent?: number;
    /**
     * belong to type discountPercent and nullable.
     * @type {number}
     * @memberof CouponItem
     */
    maximumDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponItem
     */
    maximumFreeShippingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponItem
     */
    sellerShippingPriceSubsidy?: number;
    /**
     * belong to type discountAmount and non-nullable.
     * @type {number}
     * @memberof CouponItem
     */
    discountAmount?: number;
    /**
     * belong to type discountAmount and nullable.
     * @type {number}
     * @memberof CouponItem
     */
    minimalPurchase?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyPurchasedUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyNewUserPerStore?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyReactivatedUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyNewUser?: boolean;
    /**
     * 
     * @type {OnlyAssignToUserItem}
     * @memberof CouponItem
     */
    onlyAssignToUser?: OnlyAssignToUserItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    oncePerStore?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItem
     */
    sellerGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    followSelectedSellers?: boolean;
    /**
     * 
     * @type {CouponCreatedByItem}
     * @memberof CouponItem
     */
    createdBy?: CouponCreatedByItem;
    /**
     * 
     * @type {CouponCreatedByItem}
     * @memberof CouponItem
     */
    lastUpdatedBy?: CouponCreatedByItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItem
     */
    liveStreamIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyPopshopShipping?: boolean;
    /**
     * 
     * @type {OnlyApplyToListingsItem}
     * @memberof CouponItem
     */
    onlyApplyToListings?: OnlyApplyToListingsItem;
    /**
     * 
     * @type {PlatformEnumItem}
     * @memberof CouponItem
     */
    platform?: PlatformEnumItem;
    /**
     * 
     * @type {Array<number>}
     * @memberof CouponItem
     */
    excludedDropshipPartnerIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    applicableOrderType?: CouponItemApplicableOrderTypeEnum;
}


/**
 * @export
 */
export const CouponItemCouponCreateMethodEnum = {
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide'
} as const;
export type CouponItemCouponCreateMethodEnum = typeof CouponItemCouponCreateMethodEnum[keyof typeof CouponItemCouponCreateMethodEnum];

/**
 * @export
 */
export const CouponItemTypeEnum = {
    DiscountPercent: 'discountPercent',
    DiscountAmount: 'discountAmount',
    FreeShipping: 'freeShipping'
} as const;
export type CouponItemTypeEnum = typeof CouponItemTypeEnum[keyof typeof CouponItemTypeEnum];

/**
 * @export
 */
export const CouponItemApplicableOrderTypeEnum = {
    OrderGroup: 'OrderGroup',
    ChildOrder: 'ChildOrder'
} as const;
export type CouponItemApplicableOrderTypeEnum = typeof CouponItemApplicableOrderTypeEnum[keyof typeof CouponItemApplicableOrderTypeEnum];

/**
 * 
 * @export
 * @interface CreateAccountSessionRequest
 */
export interface CreateAccountSessionRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccountSessionRequest
     */
    enableExternalAccountCollection?: boolean;
}
/**
 * 
 * @export
 * @interface CreateAccountSessionResponse
 */
export interface CreateAccountSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountSessionResponse
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountSessionResponse
     */
    expireAt: string;
    /**
     * 
     * @type {object}
     * @memberof CreateAccountSessionResponse
     */
    account?: object;
}
/**
 * 
 * @export
 * @interface CreateCommunityChannelRequest
 */
export interface CreateCommunityChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCommunityChannelRequest
     */
    icon: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCommunityChannelRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCommunityChannelRequest
     */
    description?: string;
    /**
     * 
     * @type {CommunityChannelVisibilityEnumItem}
     * @memberof CreateCommunityChannelRequest
     */
    visibility: CommunityChannelVisibilityEnumItem;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof CreateCommunityChannelRequest
     */
    minimumSubscriptionLevel: PopStoreExtendedSubscriptionLevelEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCommunityChannelRequest
     */
    isBroadcastChannel?: boolean;
}


/**
 * 
 * @export
 * @interface CreateCustomerAccountRequest
 */
export interface CreateCustomerAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerAccountRequest
     */
    usage?: CreateCustomerAccountRequestUsageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCustomerAccountRequest
     */
    removable?: boolean;
}


/**
 * @export
 */
export const CreateCustomerAccountRequestUsageEnum = {
    OnSession: 'on_session',
    OffSession: 'off_session'
} as const;
export type CreateCustomerAccountRequestUsageEnum = typeof CreateCustomerAccountRequestUsageEnum[keyof typeof CreateCustomerAccountRequestUsageEnum];

/**
 * 
 * @export
 * @interface CreateFollowerDto
 */
export interface CreateFollowerDto {
    /**
     * 
     * @type {CreateFollowerSource}
     * @memberof CreateFollowerDto
     */
    source?: CreateFollowerSource;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFollowerDto
     */
    receivePromotionalOffers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFollowerDto
     */
    sharePhoneNumber?: boolean;
}
/**
 * 
 * @export
 * @interface CreateFollowerSource
 */
export interface CreateFollowerSource {
    /**
     * 
     * @type {string}
     * @memberof CreateFollowerSource
     */
    type: CreateFollowerSourceTypeEnum;
    /**
     * belong type upcoming show
     * @type {string}
     * @memberof CreateFollowerSource
     */
    upcomingShowId?: string;
    /**
     * belong type live stream
     * @type {string}
     * @memberof CreateFollowerSource
     */
    liveStreamId?: string;
}


/**
 * @export
 */
export const CreateFollowerSourceTypeEnum = {
    LiveStream: 'LIVE_STREAM',
    UpcomingShow: 'UPCOMING_SHOW'
} as const;
export type CreateFollowerSourceTypeEnum = typeof CreateFollowerSourceTypeEnum[keyof typeof CreateFollowerSourceTypeEnum];

/**
 * 
 * @export
 * @interface CreateGuestUserRequest
 */
export interface CreateGuestUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGuestUserRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGuestUserRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGuestUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGuestUserRequest
     */
    recaptchaToken?: string;
}
/**
 * 
 * @export
 * @interface CreateLeadFormRequest
 */
export interface CreateLeadFormRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadFormRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadFormRequest
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLeadFormRequest
     */
    active: boolean;
    /**
     * 
     * @type {Array<CreateLeadFormRequestQuestionsInner>}
     * @memberof CreateLeadFormRequest
     */
    questions: Array<CreateLeadFormRequestQuestionsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLeadFormRequest
     */
    showQuestionsInSequence?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLeadFormRequest
     */
    autoQualify?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateLeadFormRequest
     */
    minIdealAnswersRequired?: number;
    /**
     * 
     * @type {LeadFormActionOnQualifiedEnumItem}
     * @memberof CreateLeadFormRequest
     */
    actionOnQualified?: LeadFormActionOnQualifiedEnumItem;
    /**
     * 
     * @type {LeadFormActionOnUnqualifiedEnumItem}
     * @memberof CreateLeadFormRequest
     */
    actionOnUnqualified?: LeadFormActionOnUnqualifiedEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadFormRequest
     */
    redirectLink?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadFormRequest
     */
    politeMessageTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadFormRequest
     */
    politeMessageHtml?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadFormRequest
     */
    politeMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadFormRequest
     */
    differentLink?: string;
    /**
     * 
     * @type {Array<LeadFormTriggerActionDto>}
     * @memberof CreateLeadFormRequest
     */
    triggerActions?: Array<LeadFormTriggerActionDto>;
}


/**
 * @type CreateLeadFormRequestQuestionsInner
 * 
 * @export
 */
export type CreateLeadFormRequestQuestionsInner = LeadFormMultipleChoiceQuestionDto | LeadFormSingleChoiceQuestionDto | LeadFormTextQuestionDto;
/**
 * 
 * @export
 * @interface CreateLeadsContactRequest
 */
export interface CreateLeadsContactRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsContactRequest
     */
    creatorId: string;
    /**
     * 
     * @type {CreateLeadsContactRequestSourceTypeEnumItem}
     * @memberof CreateLeadsContactRequest
     */
    sourceType: CreateLeadsContactRequestSourceTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsContactRequest
     */
    sourceId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsContactRequest
     */
    source?: string;
    /**
     * context
     * @type {{ [key: string]: any; }}
     * @memberof CreateLeadsContactRequest
     */
    context?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsContactRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsContactRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsContactRequest
     */
    phoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLeadsContactRequest
     */
    sharePhoneConsent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLeadsContactRequest
     */
    offerConsent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsContactRequest
     */
    recaptchaToken?: string;
}



/**
 * 
 * @export
 */
export const CreateLeadsContactRequestSourceTypeEnumItem = {
    RealEstateListing: 'REAL_ESTATE_LISTING',
    DigitalProduct: 'DIGITAL_PRODUCT',
    Calendar: 'CALENDAR',
    LinkButton: 'LINK_BUTTON',
    SimpleLead: 'SIMPLE_LEAD'
} as const;
export type CreateLeadsContactRequestSourceTypeEnumItem = typeof CreateLeadsContactRequestSourceTypeEnumItem[keyof typeof CreateLeadsContactRequestSourceTypeEnumItem];

/**
 * 
 * @export
 * @interface CreateLiveStreamRequest
 */
export interface CreateLiveStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    device: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    versionTag?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    showEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    showEventTemplateId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    permission: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLiveStreamRequest
     */
    shippingMode?: Array<CreateLiveStreamRequestShippingModeEnum>;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    addressId?: string;
    /**
     * prerequisite: nftGatedShows feature enabled for this seller
     * @type {boolean}
     * @memberof CreateLiveStreamRequest
     */
    isNftGated?: boolean;
    /**
     * prerequisite: patreonGatedShows feature enabled for this seller
     * @type {boolean}
     * @memberof CreateLiveStreamRequest
     */
    isPatreonGated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    accessLevel?: CreateLiveStreamRequestAccessLevelEnum;
    /**
     * 
     * @type {ShowTippingRequest}
     * @memberof CreateLiveStreamRequest
     */
    tipping?: ShowTippingRequest;
}


/**
 * @export
 */
export const CreateLiveStreamRequestShippingModeEnum = {
    Shipping: 'shipping',
    Pickup: 'pickup'
} as const;
export type CreateLiveStreamRequestShippingModeEnum = typeof CreateLiveStreamRequestShippingModeEnum[keyof typeof CreateLiveStreamRequestShippingModeEnum];

/**
 * @export
 */
export const CreateLiveStreamRequestAccessLevelEnum = {
    All: 'all',
    Subscriber: 'subscriber',
    Fan: 'fan',
    Vip: 'vip'
} as const;
export type CreateLiveStreamRequestAccessLevelEnum = typeof CreateLiveStreamRequestAccessLevelEnum[keyof typeof CreateLiveStreamRequestAccessLevelEnum];

/**
 * 
 * @export
 * @interface CreateLiveStreamResponse
 */
export interface CreateLiveStreamResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamResponse
     */
    id: string;
}
/**
 * 
 * @export
 * @interface CreateOrderDtoV3
 */
export interface CreateOrderDtoV3 {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    stripePaymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    stripeApplePayNonce?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    listingId?: string;
    /**
     * listing info for virtual listings
     * @type {ListingDto}
     * @memberof CreateOrderDtoV3
     */
    listing?: ListingDto;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    sellerId: string;
    /**
     * The recipient of this gift order
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    recipientId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    sendItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    sentReferralGiftId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    variantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    shippingMethod?: CreateOrderDtoV3ShippingMethodEnum;
    /**
     * Optional for gifting orders or digital products
     * @type {AddressDto}
     * @memberof CreateOrderDtoV3
     */
    shippingAddress?: AddressDto;
    /**
     * 
     * @type {PickupAddressDto}
     * @memberof CreateOrderDtoV3
     */
    pickupAddress?: PickupAddressDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrderDtoV3
     */
    redeemedCouponIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderDtoV3
     */
    quantity: number;
    /**
     * 
     * @type {PreviewOrderDtoSource}
     * @memberof CreateOrderDtoV3
     */
    source?: PreviewOrderDtoSource;
    /**
     * 
     * @type {PaymentAddressDto}
     * @memberof CreateOrderDtoV3
     */
    paymentBillingAddress?: PaymentAddressDto;
    /**
     * 
     * @type {TippingDto}
     * @memberof CreateOrderDtoV3
     */
    tipping?: TippingDto;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    fxQuoteId?: string;
    /**
     * 
     * @type {PreviewOrderDtoAvatarMe}
     * @memberof CreateOrderDtoV3
     */
    avatarMe?: PreviewOrderDtoAvatarMe;
    /**
     * 
     * @type {OrderMeetingSlotDto}
     * @memberof CreateOrderDtoV3
     */
    meeting?: OrderMeetingSlotDto;
    /**
     * 
     * @type {OrderGroupEventDto}
     * @memberof CreateOrderDtoV3
     */
    groupEvent?: OrderGroupEventDto;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    paymentType: CreateOrderDtoV3PaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    buyerName: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderDtoV3
     */
    useBonus?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    requestTrackingID: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    userAgent?: string;
    /**
     * 
     * @type {GiftPackageDto}
     * @memberof CreateOrderDtoV3
     */
    giftPackage?: GiftPackageDto;
    /**
     * 
     * @type {object}
     * @memberof CreateOrderDtoV3
     */
    utmParameters?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    braintreeToken?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    braintreeApplePayNonce?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    stripeConfirmationToken?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    returnUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderDtoV3
     */
    savePaymentMethodForFutureOnSessionPayment?: boolean;
}


/**
 * @export
 */
export const CreateOrderDtoV3ShippingMethodEnum = {
    DropshipSupplierProvide: 'dropshipSupplierProvide',
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide',
    Pickup: 'pickup'
} as const;
export type CreateOrderDtoV3ShippingMethodEnum = typeof CreateOrderDtoV3ShippingMethodEnum[keyof typeof CreateOrderDtoV3ShippingMethodEnum];

/**
 * @export
 */
export const CreateOrderDtoV3PaymentTypeEnum = {
    Applepay: 'applepay',
    Credit: 'credit',
    Empty: 'empty'
} as const;
export type CreateOrderDtoV3PaymentTypeEnum = typeof CreateOrderDtoV3PaymentTypeEnum[keyof typeof CreateOrderDtoV3PaymentTypeEnum];

/**
 * 
 * @export
 * @interface CreateOrderResponse
 */
export interface CreateOrderResponse {
    /**
     * 
     * @type {CommentSoldOrderItem}
     * @memberof CreateOrderResponse
     */
    commentSold?: CommentSoldOrderItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     * @deprecated
     */
    buyerName: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    shippingFeeAdjusted: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderResponse
     */
    braintreeShippingFeeRefunded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    buyerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof CreateOrderResponse
     */
    buyer: OrderProfileItem;
    /**
     * 
     * @type {OrderGiftingItem}
     * @memberof CreateOrderResponse
     */
    gifting?: OrderGiftingItem;
    /**
     * 
     * @type {OrderGiftPackageItem}
     * @memberof CreateOrderResponse
     */
    giftPackage?: OrderGiftPackageItem;
    /**
     * 
     * @type {ShipmentItem}
     * @memberof CreateOrderResponse
     */
    shipment?: ShipmentItem;
    /**
     * 
     * @type {PackingSlipItem}
     * @memberof CreateOrderResponse
     */
    packingSlip?: PackingSlipItem;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    refund?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    userAgent?: string;
    /**
     * 
     * @type {OrderPaymentItem}
     * @memberof CreateOrderResponse
     */
    orderPayment?: OrderPaymentItem;
    /**
     * 
     * @type {PaymentItem}
     * @memberof CreateOrderResponse
     */
    payment?: PaymentItem;
    /**
     * 
     * @type {Array<RedeemedCouponItem>}
     * @memberof CreateOrderResponse
     */
    coupons?: Array<RedeemedCouponItem>;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    couponDiscountProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    couponDiscountShippingFeeAmount?: number;
    /**
     * 
     * @type {SellerTrackingInfoItem}
     * @memberof CreateOrderResponse
     */
    sellerTrackingInfo?: SellerTrackingInfoItem;
    /**
     * 
     * @type {Array<SellerTrackingInfoItem>}
     * @memberof CreateOrderResponse
     */
    sellerTrackingInfoHistory?: Array<SellerTrackingInfoItem>;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    bonus?: number;
    /**
     * 
     * @type {AddressItem}
     * @memberof CreateOrderResponse
     */
    shippingAddress: AddressItem;
    /**
     * 
     * @type {PickupAddressItem}
     * @memberof CreateOrderResponse
     */
    pickupAddress?: PickupAddressItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof CreateOrderResponse
     */
    listingSnapshot: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    sendItemId?: string;
    /**
     * 
     * @type {CreateOrderResponseSendItem}
     * @memberof CreateOrderResponse
     */
    sendItem?: CreateOrderResponseSendItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    sellerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof CreateOrderResponse
     */
    seller: OrderProfileItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    status: CreateOrderResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderGroupStatus: CreateOrderResponseOrderGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    pickupStatus?: CreateOrderResponsePickupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    cancelStatus?: CreateOrderResponseCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderGroupCancelStatus?: CreateOrderResponseOrderGroupCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderRefundStatus?: CreateOrderResponseOrderRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderGroupRefundStatus?: CreateOrderResponseOrderGroupRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    shippingMethod: CreateOrderResponseShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    shippoOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    variantId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof CreateOrderResponse
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {OrderShipmentGroupStatus}
     * @memberof CreateOrderResponse
     */
    orderShipmentGroupStatus: OrderShipmentGroupStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof CreateOrderResponse
     */
    shippingLabelStatus: ShippingLabelStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof CreateOrderResponse
     */
    packingSlipStatus: ShippingLabelStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    masterOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    planTimeOfShippingLabelGeneration?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    totalQuantitiesIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    totalPriceIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    totalPriceIncludeSlaveOrdersWithProductCoupon: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    totalRefundIncludeSlaveOrders?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderResponse
     */
    newCustomer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    firstPurchaseAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    updatedAt?: string;
    /**
     * 
     * @type {OrderCompositionCancellationStatus}
     * @memberof CreateOrderResponse
     */
    orderCompositionCancellationStatus?: OrderCompositionCancellationStatus;
    /**
     * 
     * @type {OrderChargeDistributionItem}
     * @memberof CreateOrderResponse
     */
    orderChargeDistribution?: OrderChargeDistributionItem;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderResponse
     */
    packed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    pickupNotifiedAt?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof CreateOrderResponse
     */
    source?: OrderSource;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof CreateOrderResponse
     */
    shipmentParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof CreateOrderResponse
     */
    shipmentOriginalParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    shipmentOriginalParcelSource?: CreateOrderResponseShipmentOriginalParcelSourceEnum;
    /**
     * 
     * @type {OrderItemPriceComponents}
     * @memberof CreateOrderResponse
     */
    priceComponents?: OrderItemPriceComponents;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof CreateOrderResponse
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    packageTemplateId?: string;
    /**
     * 
     * @type {OrderItemPackageTemplate}
     * @memberof CreateOrderResponse
     */
    packageTemplate?: OrderItemPackageTemplate;
    /**
     * 
     * @type {OrderItemPresetShippingCost}
     * @memberof CreateOrderResponse
     */
    presetShippingCost?: OrderItemPresetShippingCost;
    /**
     * 
     * @type {OrderItemDropshipDetails}
     * @memberof CreateOrderResponse
     */
    dropshipDetails?: OrderItemDropshipDetails;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    fundAvailableDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    fundAvailableDate2?: string;
    /**
     * 
     * @type {LabelShippingCost}
     * @memberof CreateOrderResponse
     */
    labelShippingCost?: LabelShippingCost;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    totalRefundedSalesTax?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    paymentExpireAt?: string;
    /**
     * 
     * @type {MultiCurrencyOrderItem}
     * @memberof CreateOrderResponse
     */
    buyerCurrencyOrderDetails?: MultiCurrencyOrderItem;
    /**
     * 
     * @type {OrderCalendarEventItem}
     * @memberof CreateOrderResponse
     */
    calendarEvent?: OrderCalendarEventItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderResponse
     */
    isFirstPurchaseFromSeller: boolean;
}


/**
 * @export
 */
export const CreateOrderResponseStatusEnum = {
    Created: 'created',
    Completed: 'completed',
    Canceled: 'canceled',
    PendingPayment: 'pendingPayment',
    ProcessingPayment: 'processingPayment',
    Closed: 'closed'
} as const;
export type CreateOrderResponseStatusEnum = typeof CreateOrderResponseStatusEnum[keyof typeof CreateOrderResponseStatusEnum];

/**
 * @export
 */
export const CreateOrderResponseOrderGroupStatusEnum = {
    Open: 'open',
    Processing: 'processing',
    Fulfilling: 'fulfilling',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type CreateOrderResponseOrderGroupStatusEnum = typeof CreateOrderResponseOrderGroupStatusEnum[keyof typeof CreateOrderResponseOrderGroupStatusEnum];

/**
 * @export
 */
export const CreateOrderResponsePickupStatusEnum = {
    Open: 'open',
    New: 'new',
    Processing: 'processing',
    Pending: 'pending',
    Packed: 'packed',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type CreateOrderResponsePickupStatusEnum = typeof CreateOrderResponsePickupStatusEnum[keyof typeof CreateOrderResponsePickupStatusEnum];

/**
 * @export
 */
export const CreateOrderResponseCancelStatusEnum = {
    SellerApplied: 'seller_applied',
    AdminApproved: 'admin_approved'
} as const;
export type CreateOrderResponseCancelStatusEnum = typeof CreateOrderResponseCancelStatusEnum[keyof typeof CreateOrderResponseCancelStatusEnum];

/**
 * @export
 */
export const CreateOrderResponseOrderGroupCancelStatusEnum = {
    PartialCanceled: 'PARTIAL_CANCELED',
    FullyCanceled: 'FULLY_CANCELED'
} as const;
export type CreateOrderResponseOrderGroupCancelStatusEnum = typeof CreateOrderResponseOrderGroupCancelStatusEnum[keyof typeof CreateOrderResponseOrderGroupCancelStatusEnum];

/**
 * @export
 */
export const CreateOrderResponseOrderRefundStatusEnum = {
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED'
} as const;
export type CreateOrderResponseOrderRefundStatusEnum = typeof CreateOrderResponseOrderRefundStatusEnum[keyof typeof CreateOrderResponseOrderRefundStatusEnum];

/**
 * @export
 */
export const CreateOrderResponseOrderGroupRefundStatusEnum = {
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED'
} as const;
export type CreateOrderResponseOrderGroupRefundStatusEnum = typeof CreateOrderResponseOrderGroupRefundStatusEnum[keyof typeof CreateOrderResponseOrderGroupRefundStatusEnum];

/**
 * @export
 */
export const CreateOrderResponseShippingMethodEnum = {
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide',
    Pickup: 'pickup',
    DropshipSupplierProvide: 'dropshipSupplierProvide'
} as const;
export type CreateOrderResponseShippingMethodEnum = typeof CreateOrderResponseShippingMethodEnum[keyof typeof CreateOrderResponseShippingMethodEnum];

/**
 * @export
 */
export const CreateOrderResponseShipmentOriginalParcelSourceEnum = {
    Default: 'DEFAULT',
    ShowEvent: 'SHOW_EVENT'
} as const;
export type CreateOrderResponseShipmentOriginalParcelSourceEnum = typeof CreateOrderResponseShipmentOriginalParcelSourceEnum[keyof typeof CreateOrderResponseShipmentOriginalParcelSourceEnum];

/**
 * @type CreateOrderResponseSendItem
 * 
 * @export
 */
export type CreateOrderResponseSendItem = GiveawaySendItemItem | LiveStreamAuctionSendItemItem | NormalSendItemItem;
/**
 * 
 * @export
 * @interface CreateOrderV3Response
 */
export interface CreateOrderV3Response {
    /**
     * 
     * @type {CreateOrderResponse}
     * @memberof CreateOrderV3Response
     */
    order: CreateOrderResponse;
    /**
     * 
     * @type {object}
     * @memberof CreateOrderV3Response
     */
    nextAction?: object;
}
/**
 * 
 * @export
 * @interface CreatePollRequest
 */
export interface CreatePollRequest {
    /**
     * 
     * @type {PollTypeEnumItem}
     * @memberof CreatePollRequest
     */
    type: PollTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CreatePollRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePollRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePollRequest
     */
    dueAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePollRequest
     */
    isAnonymousVotingAllowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePollRequest
     */
    isMultiChoice: boolean;
    /**
     * 
     * @type {PollStatusEnumItem}
     * @memberof CreatePollRequest
     */
    status: PollStatusEnumItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePollRequest
     */
    options: Array<string>;
}


/**
 * 
 * @export
 * @interface CreatePopStoreCreatorRequest
 */
export interface CreatePopStoreCreatorRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    storeName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    country: string;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof CreatePopStoreCreatorRequest
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {Array<SocialLinkRequest>}
     * @memberof CreatePopStoreCreatorRequest
     */
    socialLinks?: Array<SocialLinkRequest>;
    /**
     * Business Or Creator Application
     * @type {StoreTypeEnumItem}
     * @memberof CreatePopStoreCreatorRequest
     */
    storeType: StoreTypeEnumItem;
    /**
     * store url
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    billingCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    birthday?: string;
    /**
     * 
     * @type {object}
     * @memberof CreatePopStoreCreatorRequest
     */
    utmParameters?: object;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    referralCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePopStoreCreatorRequest
     */
    allowSMS?: boolean;
    /**
     * 
     * @type {CreatorRegTypeEnumItem}
     * @memberof CreatePopStoreCreatorRequest
     */
    creatorRegType?: CreatorRegTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopStoreCreatorRequest
     */
    avatar?: string;
    /**
     * 
     * @type {PopStoreCreatorBusinessTypeEnumItem}
     * @memberof CreatePopStoreCreatorRequest
     */
    businessType?: PopStoreCreatorBusinessTypeEnumItem;
}


/**
 * 
 * @export
 * @interface CreatePopStoreCreatorResponse
 */
export interface CreatePopStoreCreatorResponse {
    /**
     * The agency the creator was tagged to, or null (no link, unknown or disabled agency).
     * @type {string}
     * @memberof CreatePopStoreCreatorResponse
     */
    agencyId?: string | null;
    /**
     * True when an agency sponsors this creator: no plan picker, straight to the dashboard.
     * @type {boolean}
     * @memberof CreatePopStoreCreatorResponse
     */
    sponsored: boolean;
}
/**
 * 
 * @export
 * @interface CreatePostCommentRequest
 */
export interface CreatePostCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePostCommentRequest
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePostCommentRequest
     */
    text: string;
}
/**
 * 
 * @export
 * @interface CreatePostRequest
 */
export interface CreatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePostRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePostRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePostRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePostRequest
     */
    allowComments: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePostRequest
     */
    saveAsDraft?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePostRequest
     */
    scheduledReleaseTime?: string;
    /**
     * 
     * @type {PayToViewOnlyModeDto}
     * @memberof CreatePostRequest
     */
    payToViewOnlyMode?: PayToViewOnlyModeDto;
    /**
     * 
     * @type {SubscribeToViewDto}
     * @memberof CreatePostRequest
     */
    subscribeToView?: SubscribeToViewDto;
    /**
     * 
     * @type {PayToViewDto}
     * @memberof CreatePostRequest
     */
    payToView?: PayToViewDto;
    /**
     * 
     * @type {CrowdTippingToViewDto}
     * @memberof CreatePostRequest
     */
    crowdTippingToView?: CrowdTippingToViewDto;
    /**
     * 
     * @type {TipToViewDto}
     * @memberof CreatePostRequest
     */
    tipToView?: TipToViewDto;
    /**
     * 
     * @type {Array<TippingAmountDto>}
     * @memberof CreatePostRequest
     */
    tippingAmounts?: Array<TippingAmountDto>;
    /**
     * 
     * @type {DmDto}
     * @memberof CreatePostRequest
     */
    dm?: DmDto;
    /**
     * 
     * @type {PostContentTypeEnumItem}
     * @memberof CreatePostRequest
     */
    postType: PostContentTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CreatePostRequest
     */
    textContent?: string;
    /**
     * 
     * @type {Array<PostMediaDto>}
     * @memberof CreatePostRequest
     */
    medias?: Array<PostMediaDto>;
    /**
     * 
     * @type {number}
     * @memberof CreatePostRequest
     */
    unrestrictedLeadingMediaCount?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePostRequest
     */
    cid: string;
}


/**
 * 
 * @export
 * @interface CreateProductCollectionRequest
 */
export interface CreateProductCollectionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateProductCollectionRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductCollectionRequest
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCollectionRequest
     */
    strategy: CreateProductCollectionRequestStrategyEnum;
    /**
     * valid when strategy is BY_CATEGORY
     * @type {Array<string>}
     * @memberof CreateProductCollectionRequest
     */
    productCategoryIds: Array<string>;
    /**
     * 
     * @type {CollectionLayoutTypeEnumItem}
     * @memberof CreateProductCollectionRequest
     */
    layoutType?: CollectionLayoutTypeEnumItem;
}


/**
 * @export
 */
export const CreateProductCollectionRequestStrategyEnum = {
    ByCategory: 'BY_CATEGORY',
    ManualSelection: 'MANUAL_SELECTION'
} as const;
export type CreateProductCollectionRequestStrategyEnum = typeof CreateProductCollectionRequestStrategyEnum[keyof typeof CreateProductCollectionRequestStrategyEnum];

/**
 * 
 * @export
 * @interface CreateReferralRequest
 */
export interface CreateReferralRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateReferralRequest
     */
    passcode: string;
}
/**
 * 
 * @export
 * @interface CreateSeriesRequest
 */
export interface CreateSeriesRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    labelFormat?: CreateSeriesRequestLabelFormatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeriesRequest
     */
    showLabel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeriesRequest
     */
    hasChapter?: boolean;
    /**
     * 
     * @type {SeriesChapterLabelFormatEnumItem}
     * @memberof CreateSeriesRequest
     */
    chapterLabelFormat?: SeriesChapterLabelFormatEnumItem;
    /**
     * 
     * @type {number}
     * @memberof CreateSeriesRequest
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    elementSortingStrategy?: CreateSeriesRequestElementSortingStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    mobileBannerImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    desktopBannerImage?: string;
    /**
     * 
     * @type {Array<AddSeriesPopClipDto>}
     * @memberof CreateSeriesRequest
     */
    popClips?: Array<AddSeriesPopClipDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeriesRequest
     */
    standaloneSale?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateSeriesRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSeriesRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeriesRequest
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    discountEndDate?: string;
    /**
     * 
     * @type {PopStoreUserAccessLevelEnumItem}
     * @memberof CreateSeriesRequest
     */
    accessLevel?: PopStoreUserAccessLevelEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    description?: string;
    /**
     * 
     * @type {SeriesTypeEnumItem}
     * @memberof CreateSeriesRequest
     */
    type?: SeriesTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    parentId?: string;
}


/**
 * @export
 */
export const CreateSeriesRequestLabelFormatEnum = {
    Short: 'SHORT',
    Long: 'LONG'
} as const;
export type CreateSeriesRequestLabelFormatEnum = typeof CreateSeriesRequestLabelFormatEnum[keyof typeof CreateSeriesRequestLabelFormatEnum];

/**
 * @export
 */
export const CreateSeriesRequestElementSortingStrategyEnum = {
    MostRecentFirst: 'MOST_RECENT_FIRST',
    MostRecentLast: 'MOST_RECENT_LAST',
    Custom: 'CUSTOM'
} as const;
export type CreateSeriesRequestElementSortingStrategyEnum = typeof CreateSeriesRequestElementSortingStrategyEnum[keyof typeof CreateSeriesRequestElementSortingStrategyEnum];

/**
 * 
 * @export
 * @interface CreateStoreListingRequest
 */
export interface CreateStoreListingRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    defaultImage: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateStoreListingRequest
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {Array<StoreControllerStoreListingVariant>}
     * @memberof CreateStoreListingRequest
     */
    variants?: Array<StoreControllerStoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    shippingFee?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateStoreListingRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof CreateStoreListingRequest
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    externalId?: string;
    /**
     * 
     * @type {DimsInfo}
     * @memberof CreateStoreListingRequest
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {CreateStoreListingRequestWeight}
     * @memberof CreateStoreListingRequest
     */
    weight?: CreateStoreListingRequestWeight;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof CreateStoreListingRequest
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStoreListingRequest
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStoreListingRequest
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStoreListingRequest
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileDto}
     * @memberof CreateStoreListingRequest
     */
    uploadedFile?: UploadedFileDto;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingDto}
     * @memberof CreateStoreListingRequest
     */
    meeting?: ListingMeetingDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStoreListingRequest
     */
    isLandingEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStoreListingRequest
     */
    isEligibleForWearMe?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    externalProductCtaText?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    type?: CreateStoreListingRequestTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof CreateStoreListingRequest
     */
    extra?: object;
}


/**
 * @export
 */
export const CreateStoreListingRequestTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type CreateStoreListingRequestTypeEnum = typeof CreateStoreListingRequestTypeEnum[keyof typeof CreateStoreListingRequestTypeEnum];

/**
 * @type CreateStoreListingRequestWeight
 * 
 * @export
 */
export type CreateStoreListingRequestWeight = PoundWithOunceWeightInfo | SingleUnitWeightInfo;
/**
 * 
 * @export
 * @interface CreateStoreListingResponse
 */
export interface CreateStoreListingResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingResponse
     */
    id: string;
    /**
     * when creating repeating slots, this is all the listings that are created
     * @type {Array<string>}
     * @memberof CreateStoreListingResponse
     */
    listingIds: Array<string>;
    /**
     * URL-safe slug of the main listing (the returned id)
     * @type {string}
     * @memberof CreateStoreListingResponse
     */
    slug?: string;
}
/**
 * 
 * @export
 * @interface CreateStorePersonalLookRequest
 */
export interface CreateStorePersonalLookRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateStorePersonalLookRequest
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateStorePersonalLookRequest
     */
    name: string;
    /**
     * at least default 1 face image aws s3 urls
     * @type {Array<string>}
     * @memberof CreateStorePersonalLookRequest
     */
    faceImageAwsS3Urls: Array<string>;
    /**
     * 
     * @type {FaceImageAwsS3UrlsV2}
     * @memberof CreateStorePersonalLookRequest
     */
    faceImageAwsS3UrlsV2?: FaceImageAwsS3UrlsV2;
    /**
     * 
     * @type {BodyImageAwsS3UrlsV2}
     * @memberof CreateStorePersonalLookRequest
     */
    bodyImageAwsS3UrlsV2: BodyImageAwsS3UrlsV2;
    /**
     * 
     * @type {BodyTypeEnumItem}
     * @memberof CreateStorePersonalLookRequest
     */
    bodyType: BodyTypeEnumItem;
    /**
     * 
     * @type {SkinComplexionEnumItem}
     * @memberof CreateStorePersonalLookRequest
     */
    skinComplexion: SkinComplexionEnumItem;
    /**
     * 
     * @type {EyeColorEnumItem}
     * @memberof CreateStorePersonalLookRequest
     */
    eyeColor: EyeColorEnumItem;
    /**
     * 
     * @type {GenderEnumItem}
     * @memberof CreateStorePersonalLookRequest
     */
    gender: GenderEnumItem;
    /**
     * 
     * @type {TattooImageAwsS3Urls}
     * @memberof CreateStorePersonalLookRequest
     */
    tattooImageAwsS3Urls?: TattooImageAwsS3Urls;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStorePersonalLookRequest
     */
    brazilianButtLift?: boolean;
    /**
     * 
     * @type {BreastImplantsEnumItem}
     * @memberof CreateStorePersonalLookRequest
     */
    breastImplants?: BreastImplantsEnumItem;
}


/**
 * 
 * @export
 * @interface CreateStripeCustomerSessionResponse
 */
export interface CreateStripeCustomerSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateStripeCustomerSessionResponse
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStripeCustomerSessionResponse
     */
    expireAt: string;
}
/**
 * 
 * @export
 * @interface CreateSubscriptionRequest
 */
export interface CreateSubscriptionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSubscriptionRequest
     */
    priceIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    couponCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSubscriptionRequest
     */
    usePaidTrial?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSubscriptionRequest
     */
    isNoCreditCardTrial?: boolean;
}
/**
 * 
 * @export
 * @interface CreateSubscriptionResponse
 */
export interface CreateSubscriptionResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    status: CreateSubscriptionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    collectionMethod: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSubscriptionResponse
     */
    discountedPrice: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    initialStartDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    currentPeriodStart: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    currentPeriodEnd: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    cancelledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    cancellationAppliedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    lastInvoiceId: string;
    /**
     * 
     * @type {Array<SubscriptionPlan>}
     * @memberof CreateSubscriptionResponse
     */
    plans: Array<SubscriptionPlan>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSubscriptionResponse
     */
    isNoCreditCardTrial?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSubscriptionResponse
     */
    isFreePlan?: boolean;
    /**
     * Credits granted on upgrade (delta)
     * @type {number}
     * @memberof CreateSubscriptionResponse
     */
    upgradeDeltaCredits?: number;
}


/**
 * @export
 */
export const CreateSubscriptionResponseStatusEnum = {
    Active: 'active',
    Canceled: 'canceled',
    Incomplete: 'incomplete',
    IncompleteExpired: 'incomplete_expired',
    Trialing: 'trialing',
    PastDue: 'past_due',
    Unpaid: 'unpaid',
    Paused: 'paused'
} as const;
export type CreateSubscriptionResponseStatusEnum = typeof CreateSubscriptionResponseStatusEnum[keyof typeof CreateSubscriptionResponseStatusEnum];

/**
 * 
 * @export
 * @interface CreateTokenOrderDto
 */
export interface CreateTokenOrderDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTokenOrderDto
     */
    sellerId: string;
    /**
     * 
     * @type {TokenListingDto}
     * @memberof CreateTokenOrderDto
     */
    listing: TokenListingDto;
    /**
     * 
     * @type {number}
     * @memberof CreateTokenOrderDto
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTokenOrderDto
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTokenOrderDto
     */
    requestTrackingID: string;
}
/**
 * 
 * @export
 * @interface CreateUpcomingShowBySellerDto
 */
export interface CreateUpcomingShowBySellerDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    permission?: CreateUpcomingShowBySellerDtoPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpcomingShowBySellerDto
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    accessLevel?: CreateUpcomingShowBySellerDtoAccessLevelEnum;
    /**
     * 
     * @type {ShowTippingRequest}
     * @memberof CreateUpcomingShowBySellerDto
     */
    tipping?: ShowTippingRequest;
}


/**
 * @export
 */
export const CreateUpcomingShowBySellerDtoPermissionEnum = {
    All: 'all',
    Follower: 'follower',
    Subscriber: 'subscriber',
    NoOne: 'no-one'
} as const;
export type CreateUpcomingShowBySellerDtoPermissionEnum = typeof CreateUpcomingShowBySellerDtoPermissionEnum[keyof typeof CreateUpcomingShowBySellerDtoPermissionEnum];

/**
 * @export
 */
export const CreateUpcomingShowBySellerDtoAccessLevelEnum = {
    All: 'all',
    Subscriber: 'subscriber',
    Fan: 'fan',
    Vip: 'vip'
} as const;
export type CreateUpcomingShowBySellerDtoAccessLevelEnum = typeof CreateUpcomingShowBySellerDtoAccessLevelEnum[keyof typeof CreateUpcomingShowBySellerDtoAccessLevelEnum];

/**
 * 
 * @export
 * @interface CreateUserParamsV2
 */
export interface CreateUserParamsV2 {
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    bio?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    avatar?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserParamsV2
     */
    popStore?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    billingCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    birthday?: string;
}
/**
 * 
 * @export
 * @interface CreateWithdrawDto
 */
export interface CreateWithdrawDto {
    /**
     * 
     * @type {number}
     * @memberof CreateWithdrawDto
     */
    withdrawableAmount: number;
    /**
     * 
     * @type {string}
     * @memberof CreateWithdrawDto
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWithdrawDto
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWithdrawDto
     */
    note?: string;
}

/**
 * 
 * @export
 */
export const CreatorRegTypeEnumItem = {
    Individual: 'individual',
    Business: 'business'
} as const;
export type CreatorRegTypeEnumItem = typeof CreatorRegTypeEnumItem[keyof typeof CreatorRegTypeEnumItem];

/**
 * 
 * @export
 * @interface CrowdTippingToViewDto
 */
export interface CrowdTippingToViewDto {
    /**
     * 
     * @type {boolean}
     * @memberof CrowdTippingToViewDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CrowdTippingToViewDto
     */
    targetAmount: number;
    /**
     * currently only USD is supported
     * @type {string}
     * @memberof CrowdTippingToViewDto
     */
    currency: string;
}
/**
 * 
 * @export
 * @interface CrowdTippingToViewItem
 */
export interface CrowdTippingToViewItem {
    /**
     * 
     * @type {boolean}
     * @memberof CrowdTippingToViewItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CrowdTippingToViewItem
     */
    targetAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CrowdTippingToViewItem
     */
    currentAmount: number;
    /**
     * currently only USD is supported
     * @type {string}
     * @memberof CrowdTippingToViewItem
     */
    currency: string;
}
/**
 * 
 * @export
 * @interface CustomScheduleRequest
 */
export interface CustomScheduleRequest {
    /**
     * 0=Sunday, 6=Saturday
     * @type {number}
     * @memberof CustomScheduleRequest
     */
    dayOfWeek: number;
    /**
     * 
     * @type {string}
     * @memberof CustomScheduleRequest
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof CustomScheduleRequest
     */
    endTime: string;
}

/**
 * 
 * @export
 */
export const CustomerPaidAmountOperatorEnumItem = {
    Eq: 'eq',
    Gt: 'gt',
    Gte: 'gte',
    Lt: 'lt',
    Lte: 'lte'
} as const;
export type CustomerPaidAmountOperatorEnumItem = typeof CustomerPaidAmountOperatorEnumItem[keyof typeof CustomerPaidAmountOperatorEnumItem];

/**
 * 
 * @export
 * @interface DataPoint
 */
export interface DataPoint {
    /**
     * 
     * @type {string}
     * @memberof DataPoint
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof DataPoint
     */
    count: number;
    /**
     * percentage, e.g. 34%
     * @type {string}
     * @memberof DataPoint
     */
    percentage: string;
}
/**
 * 
 * @export
 * @interface DimsInfo
 */
export interface DimsInfo {
    /**
     * 
     * @type {number}
     * @memberof DimsInfo
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof DimsInfo
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof DimsInfo
     */
    depth?: number;
    /**
     * 
     * @type {string}
     * @memberof DimsInfo
     */
    unit: DimsInfoUnitEnum;
}


/**
 * @export
 */
export const DimsInfoUnitEnum = {
    Cm: 'cm',
    In: 'in',
    Ft: 'ft',
    M: 'm',
    Mm: 'mm',
    Yd: 'yd'
} as const;
export type DimsInfoUnitEnum = typeof DimsInfoUnitEnum[keyof typeof DimsInfoUnitEnum];

/**
 * 
 * @export
 * @interface DisputeStatusHistoryItem
 */
export interface DisputeStatusHistoryItem {
    /**
     * 
     * @type {string}
     * @memberof DisputeStatusHistoryItem
     */
    disbursementDate: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeStatusHistoryItem
     */
    effectiveDate: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeStatusHistoryItem
     */
    status: DisputeStatusHistoryItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DisputeStatusHistoryItem
     */
    timestamp: string;
}


/**
 * @export
 */
export const DisputeStatusHistoryItemStatusEnum = {
    Accepted: 'Accepted',
    Disputed: 'Disputed',
    Expired: 'Expired',
    Lost: 'Lost',
    Won: 'Won',
    Open: 'Open'
} as const;
export type DisputeStatusHistoryItemStatusEnum = typeof DisputeStatusHistoryItemStatusEnum[keyof typeof DisputeStatusHistoryItemStatusEnum];

/**
 * 
 * @export
 * @interface DmDto
 */
export interface DmDto {
    /**
     * 
     * @type {boolean}
     * @memberof DmDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DmDto
     */
    dmOnly: boolean;
    /**
     * 
     * @type {string}
     * @memberof DmDto
     */
    message?: string;
    /**
     * 
     * @type {Array<PopStoreExtendedSubscriptionLevelEnumItem>}
     * @memberof DmDto
     */
    recipients: Array<PopStoreExtendedSubscriptionLevelEnumItem>;
}
/**
 * 
 * @export
 * @interface DmItem
 */
export interface DmItem {
    /**
     * 
     * @type {boolean}
     * @memberof DmItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DmItem
     */
    dmOnly: boolean;
    /**
     * 
     * @type {string}
     * @memberof DmItem
     */
    message?: string;
    /**
     * 
     * @type {Array<PopStoreExtendedSubscriptionLevelEnumItem>}
     * @memberof DmItem
     */
    recipients: Array<PopStoreExtendedSubscriptionLevelEnumItem>;
    /**
     * 
     * @type {string}
     * @memberof DmItem
     */
    sentAt?: string;
}

/**
 * 
 * @export
 */
export const DressSizeEnumItem = {
    Xs: 'XS',
    S: 'S',
    M: 'M',
    L: 'L',
    Xl: 'XL',
    Xxl: 'XXL+'
} as const;
export type DressSizeEnumItem = typeof DressSizeEnumItem[keyof typeof DressSizeEnumItem];

/**
 * 
 * @export
 * @interface DropdownOption
 */
export interface DropdownOption {
    /**
     * 
     * @type {string}
     * @memberof DropdownOption
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof DropdownOption
     */
    value: string;
}
/**
 * 
 * @export
 * @interface DropshipAmountsItem
 */
export interface DropshipAmountsItem {
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    costAmount: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    soldAmount: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    subtotalPaidByPopshop?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    subtotalPaidBySeller?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    managementRate: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    managementFee: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    cumulativeListingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    cumulativeBuyerPaidShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    cumulativeBuyerPaidShippingSalesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    freeShippingThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    freeShippingDiff?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    freeShippingDiscountAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DropshipAmountsItem
     */
    qualifiedFreeShipping?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    shippingFeePaidByPopshop?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    shippingFeePaidBySeller?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    supplierWithdrawableAmount: number;
}
/**
 * 
 * @export
 * @interface DropshipSupplierItem
 */
export interface DropshipSupplierItem {
    /**
     * 
     * @type {string}
     * @memberof DropshipSupplierItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropshipSupplierItem
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof DropshipSupplierItem
     */
    acceptReturn?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DropshipSupplierItem
     */
    freeShippingThreshold?: number;
}
/**
 * 
 * @export
 * @interface EarningsBySource
 */
export interface EarningsBySource {
    /**
     * 
     * @type {number}
     * @memberof EarningsBySource
     */
    last30d: number;
    /**
     * 
     * @type {number}
     * @memberof EarningsBySource
     */
    last60d: number;
    /**
     * 
     * @type {number}
     * @memberof EarningsBySource
     */
    last90d: number;
    /**
     * 
     * @type {number}
     * @memberof EarningsBySource
     */
    last12m: number;
    /**
     * 
     * @type {number}
     * @memberof EarningsBySource
     */
    allTime: number;
    /**
     * Credit rows counted in allTime
     * @type {number}
     * @memberof EarningsBySource
     */
    credits: number;
    /**
     * 
     * @type {string}
     * @memberof EarningsBySource
     */
    sourceType: EarningsBySourceSourceTypeEnum | null;
}


/**
 * @export
 */
export const EarningsBySourceSourceTypeEnum = {
    Withdraw: 'WITHDRAW',
    Order: 'ORDER',
    ShippingLabel: 'SHIPPING_LABEL',
    TippingOrder: 'TIPPING_ORDER',
    User: 'USER',
    PopStoreCreatorSubscription: 'POP_STORE_CREATOR_SUBSCRIPTION',
    PopStoreCreatorSubscriptionSubscriber: 'POP_STORE_CREATOR_SUBSCRIPTION_SUBSCRIBER',
    PopStoreCreatorSubscriptionFan: 'POP_STORE_CREATOR_SUBSCRIPTION_FAN',
    PopStoreCreatorSubscriptionVip: 'POP_STORE_CREATOR_SUBSCRIPTION_VIP',
    PopStoreCreatorDigitalProduct: 'POP_STORE_CREATOR_DIGITAL_PRODUCT'
} as const;
export type EarningsBySourceSourceTypeEnum = typeof EarningsBySourceSourceTypeEnum[keyof typeof EarningsBySourceSourceTypeEnum];

/**
 * 
 * @export
 * @interface EarningsWindowTotals
 */
export interface EarningsWindowTotals {
    /**
     * 
     * @type {number}
     * @memberof EarningsWindowTotals
     */
    last30d: number;
    /**
     * 
     * @type {number}
     * @memberof EarningsWindowTotals
     */
    last60d: number;
    /**
     * 
     * @type {number}
     * @memberof EarningsWindowTotals
     */
    last90d: number;
    /**
     * 
     * @type {number}
     * @memberof EarningsWindowTotals
     */
    last12m: number;
    /**
     * 
     * @type {number}
     * @memberof EarningsWindowTotals
     */
    allTime: number;
    /**
     * Credit rows counted in allTime
     * @type {number}
     * @memberof EarningsWindowTotals
     */
    credits: number;
}
/**
 * 
 * @export
 * @interface EchoForCommentchatAiCommentAnalysisRequest
 */
export interface EchoForCommentchatAiCommentAnalysisRequest {
    /**
     * 
     * @type {EchoForCommentchatAiCommentAnalysisRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatAiCommentAnalysisRequest
     */
    variantSku: EchoForCommentchatAiCommentAnalysisRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatAiCommentAnalysisRequestVariantSkuEnumItem = {
    AiCommentAnalysis: 'com.popstore.echo_for_commentchat.ai_comment_analysis'
} as const;
export type EchoForCommentchatAiCommentAnalysisRequestVariantSkuEnumItem = typeof EchoForCommentchatAiCommentAnalysisRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatAiCommentAnalysisRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatAiCommentIntentOfferMatchingRequest
 */
export interface EchoForCommentchatAiCommentIntentOfferMatchingRequest {
    /**
     * 
     * @type {EchoForCommentchatAiCommentIntentOfferMatchingRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatAiCommentIntentOfferMatchingRequest
     */
    variantSku: EchoForCommentchatAiCommentIntentOfferMatchingRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatAiCommentIntentOfferMatchingRequestVariantSkuEnumItem = {
    AiCommentIntentOfferMatching: 'com.popstore.echo_for_commentchat.ai_comment_intent_offer_matching'
} as const;
export type EchoForCommentchatAiCommentIntentOfferMatchingRequestVariantSkuEnumItem = typeof EchoForCommentchatAiCommentIntentOfferMatchingRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatAiCommentIntentOfferMatchingRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatAiCommentResponseRequest
 */
export interface EchoForCommentchatAiCommentResponseRequest {
    /**
     * 
     * @type {EchoForCommentchatAiCommentResponseRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatAiCommentResponseRequest
     */
    variantSku: EchoForCommentchatAiCommentResponseRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatAiCommentResponseRequestVariantSkuEnumItem = {
    AiCommentResponse: 'com.popstore.echo_for_commentchat.ai_comment_response'
} as const;
export type EchoForCommentchatAiCommentResponseRequestVariantSkuEnumItem = typeof EchoForCommentchatAiCommentResponseRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatAiCommentResponseRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatAiDmResponseRequest
 */
export interface EchoForCommentchatAiDmResponseRequest {
    /**
     * 
     * @type {EchoForCommentchatAiDmResponseRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatAiDmResponseRequest
     */
    variantSku: EchoForCommentchatAiDmResponseRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatAiDmResponseRequestVariantSkuEnumItem = {
    AiDmResponse: 'com.popstore.echo_for_commentchat.ai_dm_response'
} as const;
export type EchoForCommentchatAiDmResponseRequestVariantSkuEnumItem = typeof EchoForCommentchatAiDmResponseRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatAiDmResponseRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatAiPostAnalysisRequest
 */
export interface EchoForCommentchatAiPostAnalysisRequest {
    /**
     * 
     * @type {EchoForCommentchatAiPostAnalysisRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatAiPostAnalysisRequest
     */
    variantSku: EchoForCommentchatAiPostAnalysisRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatAiPostAnalysisRequestVariantSkuEnumItem = {
    AiPostAnalysis: 'com.popstore.echo_for_commentchat.ai_post_analysis'
} as const;
export type EchoForCommentchatAiPostAnalysisRequestVariantSkuEnumItem = typeof EchoForCommentchatAiPostAnalysisRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatAiPostAnalysisRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatCollabPostCommentScrapeRequest
 */
export interface EchoForCommentchatCollabPostCommentScrapeRequest {
    /**
     * 
     * @type {EchoForCommentchatCollabPostCommentScrapeRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatCollabPostCommentScrapeRequest
     */
    variantSku: EchoForCommentchatCollabPostCommentScrapeRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatCollabPostCommentScrapeRequestVariantSkuEnumItem = {
    CollabPostCommentScrape: 'com.popstore.echo_for_commentchat.collab_post_comment_scrape'
} as const;
export type EchoForCommentchatCollabPostCommentScrapeRequestVariantSkuEnumItem = typeof EchoForCommentchatCollabPostCommentScrapeRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatCollabPostCommentScrapeRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatDmOfferAnalysisRequest
 */
export interface EchoForCommentchatDmOfferAnalysisRequest {
    /**
     * 
     * @type {EchoForCommentchatDmOfferAnalysisRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatDmOfferAnalysisRequest
     */
    variantSku: EchoForCommentchatDmOfferAnalysisRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatDmOfferAnalysisRequestVariantSkuEnumItem = {
    DmOfferAnalysis: 'com.popstore.echo_for_commentchat.dm_offer_analysis'
} as const;
export type EchoForCommentchatDmOfferAnalysisRequestVariantSkuEnumItem = typeof EchoForCommentchatDmOfferAnalysisRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatDmOfferAnalysisRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatEchoCommentGenerationRequest
 */
export interface EchoForCommentchatEchoCommentGenerationRequest {
    /**
     * 
     * @type {EchoForCommentchatEchoCommentGenerationRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatEchoCommentGenerationRequest
     */
    variantSku: EchoForCommentchatEchoCommentGenerationRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatEchoCommentGenerationRequestVariantSkuEnumItem = {
    EchoCommentGeneration: 'com.popstore.echo_for_commentchat.echo_comment_generation'
} as const;
export type EchoForCommentchatEchoCommentGenerationRequestVariantSkuEnumItem = typeof EchoForCommentchatEchoCommentGenerationRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatEchoCommentGenerationRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatFollowerProfileScrapeRequest
 */
export interface EchoForCommentchatFollowerProfileScrapeRequest {
    /**
     * 
     * @type {EchoForCommentchatFollowerProfileScrapeRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatFollowerProfileScrapeRequest
     */
    variantSku: EchoForCommentchatFollowerProfileScrapeRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatFollowerProfileScrapeRequestVariantSkuEnumItem = {
    FollowerProfileScrape: 'com.popstore.echo_for_commentchat.follower_profile_scrape'
} as const;
export type EchoForCommentchatFollowerProfileScrapeRequestVariantSkuEnumItem = typeof EchoForCommentchatFollowerProfileScrapeRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatFollowerProfileScrapeRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatGrowthRxDiagnosticRequest
 */
export interface EchoForCommentchatGrowthRxDiagnosticRequest {
    /**
     * 
     * @type {EchoForCommentchatGrowthRxDiagnosticRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatGrowthRxDiagnosticRequest
     */
    variantSku: EchoForCommentchatGrowthRxDiagnosticRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatGrowthRxDiagnosticRequestVariantSkuEnumItem = {
    GrowthRxDiagnostic: 'com.popstore.growth_rx.diagnostic_run'
} as const;
export type EchoForCommentchatGrowthRxDiagnosticRequestVariantSkuEnumItem = typeof EchoForCommentchatGrowthRxDiagnosticRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatGrowthRxDiagnosticRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatGrowthRxPostScoreRequest
 */
export interface EchoForCommentchatGrowthRxPostScoreRequest {
    /**
     * 
     * @type {EchoForCommentchatGrowthRxPostScoreRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatGrowthRxPostScoreRequest
     */
    variantSku: EchoForCommentchatGrowthRxPostScoreRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatGrowthRxPostScoreRequestVariantSkuEnumItem = {
    GrowthRxPostScore: 'com.popstore.growth_rx.post_score'
} as const;
export type EchoForCommentchatGrowthRxPostScoreRequestVariantSkuEnumItem = typeof EchoForCommentchatGrowthRxPostScoreRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatGrowthRxPostScoreRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EchoForCommentchatGrowthRxScriptRequest
 */
export interface EchoForCommentchatGrowthRxScriptRequest {
    /**
     * 
     * @type {EchoForCommentchatGrowthRxScriptRequestVariantSkuEnumItem}
     * @memberof EchoForCommentchatGrowthRxScriptRequest
     */
    variantSku: EchoForCommentchatGrowthRxScriptRequestVariantSkuEnumItem;
}



/**
 * 
 * @export
 */
export const EchoForCommentchatGrowthRxScriptRequestVariantSkuEnumItem = {
    GrowthRxScript: 'com.popstore.growth_rx.script_generation'
} as const;
export type EchoForCommentchatGrowthRxScriptRequestVariantSkuEnumItem = typeof EchoForCommentchatGrowthRxScriptRequestVariantSkuEnumItem[keyof typeof EchoForCommentchatGrowthRxScriptRequestVariantSkuEnumItem];

/**
 * 
 * @export
 * @interface EditProductCollectionRequest
 */
export interface EditProductCollectionRequest {
    /**
     * 
     * @type {string}
     * @memberof EditProductCollectionRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof EditProductCollectionRequest
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof EditProductCollectionRequest
     */
    strategy: EditProductCollectionRequestStrategyEnum;
    /**
     * valid when strategy is BY_CATEGORY
     * @type {Array<string>}
     * @memberof EditProductCollectionRequest
     */
    productCategoryIds: Array<string>;
    /**
     * 
     * @type {CollectionLayoutTypeEnumItem}
     * @memberof EditProductCollectionRequest
     */
    layoutType?: CollectionLayoutTypeEnumItem;
}


/**
 * @export
 */
export const EditProductCollectionRequestStrategyEnum = {
    ByCategory: 'BY_CATEGORY',
    ManualSelection: 'MANUAL_SELECTION'
} as const;
export type EditProductCollectionRequestStrategyEnum = typeof EditProductCollectionRequestStrategyEnum[keyof typeof EditProductCollectionRequestStrategyEnum];

/**
 * 
 * @export
 * @interface EditSeriesRequest
 */
export interface EditSeriesRequest {
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    labelFormat?: EditSeriesRequestLabelFormatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EditSeriesRequest
     */
    showLabel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditSeriesRequest
     */
    hasChapter?: boolean;
    /**
     * 
     * @type {SeriesChapterLabelFormatEnumItem}
     * @memberof EditSeriesRequest
     */
    chapterLabelFormat?: SeriesChapterLabelFormatEnumItem;
    /**
     * 
     * @type {number}
     * @memberof EditSeriesRequest
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    elementSortingStrategy?: EditSeriesRequestElementSortingStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    mobileBannerImage?: string;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    desktopBannerImage?: string;
    /**
     * 
     * @type {Array<AddSeriesPopClipDto>}
     * @memberof EditSeriesRequest
     */
    popClips?: Array<AddSeriesPopClipDto>;
    /**
     * 
     * @type {boolean}
     * @memberof EditSeriesRequest
     */
    standaloneSale?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EditSeriesRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof EditSeriesRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditSeriesRequest
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    discountEndDate?: string;
    /**
     * 
     * @type {PopStoreUserAccessLevelEnumItem}
     * @memberof EditSeriesRequest
     */
    accessLevel?: PopStoreUserAccessLevelEnumItem;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    description?: string;
}


/**
 * @export
 */
export const EditSeriesRequestLabelFormatEnum = {
    Short: 'SHORT',
    Long: 'LONG'
} as const;
export type EditSeriesRequestLabelFormatEnum = typeof EditSeriesRequestLabelFormatEnum[keyof typeof EditSeriesRequestLabelFormatEnum];

/**
 * @export
 */
export const EditSeriesRequestElementSortingStrategyEnum = {
    MostRecentFirst: 'MOST_RECENT_FIRST',
    MostRecentLast: 'MOST_RECENT_LAST',
    Custom: 'CUSTOM'
} as const;
export type EditSeriesRequestElementSortingStrategyEnum = typeof EditSeriesRequestElementSortingStrategyEnum[keyof typeof EditSeriesRequestElementSortingStrategyEnum];

/**
 * 
 * @export
 * @interface EditStoreListingRequest
 */
export interface EditStoreListingRequest {
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    defaultImage: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditStoreListingRequest
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {Array<StoreControllerStoreListingVariant>}
     * @memberof EditStoreListingRequest
     */
    variants?: Array<StoreControllerStoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    shippingFee?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditStoreListingRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof EditStoreListingRequest
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    externalId?: string;
    /**
     * 
     * @type {DimsInfo}
     * @memberof EditStoreListingRequest
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {CreateStoreListingRequestWeight}
     * @memberof EditStoreListingRequest
     */
    weight?: CreateStoreListingRequestWeight;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof EditStoreListingRequest
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditStoreListingRequest
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditStoreListingRequest
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditStoreListingRequest
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileDto}
     * @memberof EditStoreListingRequest
     */
    uploadedFile?: UploadedFileDto;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingDto}
     * @memberof EditStoreListingRequest
     */
    meeting?: ListingMeetingDto;
    /**
     * 
     * @type {boolean}
     * @memberof EditStoreListingRequest
     */
    isLandingEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditStoreListingRequest
     */
    isEligibleForWearMe?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    externalProductCtaText?: string;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    currentQuantity: number;
    /**
     * 
     * @type {Array<StoreControllerStoreListingVariant>}
     * @memberof EditStoreListingRequest
     */
    currentVariants?: Array<StoreControllerStoreListingVariant>;
    /**
     * 
     * @type {object}
     * @memberof EditStoreListingRequest
     */
    extra?: object;
}
/**
 * 
 * @export
 * @interface EnterRoomParam
 */
export interface EnterRoomParam {
    /**
     * 
     * @type {number}
     * @memberof EnterRoomParam
     */
    sessionType?: number;
    /**
     * 
     * @type {string}
     * @memberof EnterRoomParam
     */
    targetUserId: string;
}

/**
 * 
 * @export
 */
export const EthnicityEnumItem = {
    Asian: 'Asian',
    Caucasian: 'Caucasian',
    European: 'European',
    MiddleEastern: 'Middle Eastern',
    Indian: 'Indian',
    Hispanic: 'Hispanic',
    African: 'African',
    Brazilian: 'Brazilian'
} as const;
export type EthnicityEnumItem = typeof EthnicityEnumItem[keyof typeof EthnicityEnumItem];

/**
 * 
 * @export
 * @interface EvergreenVideoItem
 */
export interface EvergreenVideoItem {
    /**
     * 
     * @type {string}
     * @memberof EvergreenVideoItem
     */
    videoURL: string;
    /**
     * 
     * @type {string}
     * @memberof EvergreenVideoItem
     */
    previewImageURL: string;
    /**
     * 
     * @type {VideoResolution}
     * @memberof EvergreenVideoItem
     */
    size: VideoResolution;
}
/**
 * 
 * @export
 * @interface EvidenceItem
 */
export interface EvidenceItem {
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    sendToProcessorAt: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    url?: string;
}

/**
 * 
 * @export
 */
export const EyeColorEnumItem = {
    Brown: 'Brown',
    Blue: 'Blue',
    Hazel: 'Hazel',
    Green: 'Green'
} as const;
export type EyeColorEnumItem = typeof EyeColorEnumItem[keyof typeof EyeColorEnumItem];

/**
 * 
 * @export
 * @interface FaceImageAwsS3UrlsV2
 */
export interface FaceImageAwsS3UrlsV2 {
    /**
     * aws s3 url for front
     * @type {string}
     * @memberof FaceImageAwsS3UrlsV2
     */
    front: string;
    /**
     * aws s3 url for left
     * @type {string}
     * @memberof FaceImageAwsS3UrlsV2
     */
    left?: string;
    /**
     * aws s3 url for right
     * @type {string}
     * @memberof FaceImageAwsS3UrlsV2
     */
    right?: string;
}
/**
 * 
 * @export
 * @interface FaceImageAwsS3UrlsV2Item
 */
export interface FaceImageAwsS3UrlsV2Item {
    /**
     * 
     * @type {string}
     * @memberof FaceImageAwsS3UrlsV2Item
     */
    front: string;
    /**
     * 
     * @type {string}
     * @memberof FaceImageAwsS3UrlsV2Item
     */
    left?: string;
    /**
     * 
     * @type {string}
     * @memberof FaceImageAwsS3UrlsV2Item
     */
    right?: string;
}
/**
 * 
 * @export
 * @interface FetchUserSubscriptionLevelRequest
 */
export interface FetchUserSubscriptionLevelRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchUserSubscriptionLevelRequest
     */
    userIds: Array<string>;
}
/**
 * 
 * @export
 * @interface FetchUserSubscriptionLevelResponse
 */
export interface FetchUserSubscriptionLevelResponse {
    /**
     * 
     * @type {string}
     * @memberof FetchUserSubscriptionLevelResponse
     */
    userId: string;
    /**
     * null if not subscribed
     * @type {number}
     * @memberof FetchUserSubscriptionLevelResponse
     */
    levelId?: number;
}
/**
 * 
 * @export
 * @interface FinishAuthorizationRequest
 */
export interface FinishAuthorizationRequest {
    /**
     * ID token from authentication provider (Firebase ID token)
     * @type {string}
     * @memberof FinishAuthorizationRequest
     */
    idToken: string;
    /**
     * OAuth2 client ID
     * @type {string}
     * @memberof FinishAuthorizationRequest
     */
    clientId: string;
    /**
     * Redirect URI
     * @type {string}
     * @memberof FinishAuthorizationRequest
     */
    redirectUri: string;
    /**
     * OAuth2 state parameter
     * @type {string}
     * @memberof FinishAuthorizationRequest
     */
    state?: string;
    /**
     * OAuth2 scope parameter (space-separated)
     * @type {Array<string>}
     * @memberof FinishAuthorizationRequest
     */
    scope?: Array<string>;
}
/**
 * 
 * @export
 * @interface FinishAuthorizationResponse
 */
export interface FinishAuthorizationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FinishAuthorizationResponse
     */
    ok: boolean;
    /**
     * 
     * @type {string}
     * @memberof FinishAuthorizationResponse
     */
    redirect: string;
}
/**
 * 
 * @export
 * @interface FutureScheduleConditionAnytimeRequest
 */
export interface FutureScheduleConditionAnytimeRequest {
    /**
     * 
     * @type {FutureScheduleConditionTypeEnumItem}
     * @memberof FutureScheduleConditionAnytimeRequest
     */
    type: FutureScheduleConditionTypeEnumItem;
}


/**
 * 
 * @export
 * @interface FutureScheduleConditionDateRangeRequest
 */
export interface FutureScheduleConditionDateRangeRequest {
    /**
     * 
     * @type {FutureScheduleConditionTypeEnumItem}
     * @memberof FutureScheduleConditionDateRangeRequest
     */
    type: FutureScheduleConditionTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof FutureScheduleConditionDateRangeRequest
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof FutureScheduleConditionDateRangeRequest
     */
    endDate: string;
}


/**
 * 
 * @export
 * @interface FutureScheduleConditionDaysRequest
 */
export interface FutureScheduleConditionDaysRequest {
    /**
     * 
     * @type {FutureScheduleConditionTypeEnumItem}
     * @memberof FutureScheduleConditionDaysRequest
     */
    type: FutureScheduleConditionTypeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof FutureScheduleConditionDaysRequest
     */
    days: number;
    /**
     * 
     * @type {boolean}
     * @memberof FutureScheduleConditionDaysRequest
     */
    includeWeekends: boolean;
}



/**
 * 
 * @export
 */
export const FutureScheduleConditionTypeEnumItem = {
    Days: 'DAYS',
    DateRange: 'DATE_RANGE',
    Anytime: 'ANYTIME'
} as const;
export type FutureScheduleConditionTypeEnumItem = typeof FutureScheduleConditionTypeEnumItem[keyof typeof FutureScheduleConditionTypeEnumItem];


/**
 * 
 * @export
 */
export const GenderEnumItem = {
    Male: 'male',
    Female: 'female'
} as const;
export type GenderEnumItem = typeof GenderEnumItem[keyof typeof GenderEnumItem];


/**
 * 
 * @export
 */
export const GenderV2EnumItem = {
    M: 'm',
    F: 'f'
} as const;
export type GenderV2EnumItem = typeof GenderV2EnumItem[keyof typeof GenderV2EnumItem];

/**
 * 
 * @export
 * @interface GenerateFreeAvatarMeRequest
 */
export interface GenerateFreeAvatarMeRequest {
    /**
     * 
     * @type {AvatarMeStudioFreeImageRequest}
     * @memberof GenerateFreeAvatarMeRequest
     */
    avatarMe?: AvatarMeStudioFreeImageRequest;
}
/**
 * 
 * @export
 * @interface GenerateFreeAvatarMeResponse
 */
export interface GenerateFreeAvatarMeResponse {
    /**
     * 
     * @type {string}
     * @memberof GenerateFreeAvatarMeResponse
     */
    processId: string;
}
/**
 * 
 * @export
 * @interface GenerateTokenRequest
 */
export interface GenerateTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateTokenRequest
     */
    deviceId: string;
    /**
     * used by host only
     * @type {boolean}
     * @memberof GenerateTokenRequest
     */
    publish?: boolean;
}
/**
 * 
 * @export
 * @interface GetAvailableMeetingDatesResponse
 */
export interface GetAvailableMeetingDatesResponse {
    /**
     * 
     * @type {Array<AvailableMeetingDateItemResponse>}
     * @memberof GetAvailableMeetingDatesResponse
     */
    items: Array<AvailableMeetingDateItemResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof GetAvailableMeetingDatesResponse
     */
    calendarAuthorized: boolean;
}
/**
 * 
 * @export
 * @interface GetAvailableMeetingTypesResponse
 */
export interface GetAvailableMeetingTypesResponse {
    /**
     * 
     * @type {Array<AvailableMeetingTypeItemResponse>}
     * @memberof GetAvailableMeetingTypesResponse
     */
    items: Array<AvailableMeetingTypeItemResponse>;
}
/**
 * 
 * @export
 * @interface GetAvatarMeAllOutfitsResponse
 */
export interface GetAvatarMeAllOutfitsResponse {
    /**
     * 
     * @type {Array<Outfit>}
     * @memberof GetAvatarMeAllOutfitsResponse
     */
    outfits: Array<Outfit>;
}
/**
 * 
 * @export
 * @interface GetAvatarMeAllPosesResponse
 */
export interface GetAvatarMeAllPosesResponse {
    /**
     * 
     * @type {Array<Pose>}
     * @memberof GetAvatarMeAllPosesResponse
     */
    data: Array<Pose>;
}
/**
 * 
 * @export
 * @interface GetAvatarMeDefaultPersonalLookResponse
 */
export interface GetAvatarMeDefaultPersonalLookResponse {
    /**
     * 
     * @type {PersonalLookItem}
     * @memberof GetAvatarMeDefaultPersonalLookResponse
     */
    data?: PersonalLookItem;
}
/**
 * 
 * @export
 * @interface GetAvatarMeDropdownOptionsResponse
 */
export interface GetAvatarMeDropdownOptionsResponse {
    /**
     * 
     * @type {Array<DropdownOption>}
     * @memberof GetAvatarMeDropdownOptionsResponse
     */
    locations: Array<DropdownOption>;
    /**
     * 
     * @type {Array<DropdownOption>}
     * @memberof GetAvatarMeDropdownOptionsResponse
     */
    atmospheres: Array<DropdownOption>;
    /**
     * 
     * @type {Array<DropdownOption>}
     * @memberof GetAvatarMeDropdownOptionsResponse
     */
    sceneLibrary: Array<DropdownOption>;
    /**
     * 
     * @type {Array<DropdownOption>}
     * @memberof GetAvatarMeDropdownOptionsResponse
     */
    customLocations: Array<DropdownOption>;
    /**
     * 
     * @type {Array<DropdownOption>}
     * @memberof GetAvatarMeDropdownOptionsResponse
     */
    customVideoPrompts: Array<DropdownOption>;
}
/**
 * 
 * @export
 * @interface GetAvatarMeOutfitFilterResponse
 */
export interface GetAvatarMeOutfitFilterResponse {
    /**
     * 
     * @type {Array<AvatarType>}
     * @memberof GetAvatarMeOutfitFilterResponse
     */
    avatarTypes: Array<AvatarType>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAvatarMeOutfitFilterResponse
     */
    skinLevels: Array<string>;
}
/**
 * 
 * @export
 * @interface GetAvatarMePersonalLookResponse
 */
export interface GetAvatarMePersonalLookResponse {
    /**
     * 
     * @type {PersonalLookItem}
     * @memberof GetAvatarMePersonalLookResponse
     */
    data: PersonalLookItem;
}
/**
 * 
 * @export
 * @interface GetAvatarMeStoreOutfitsResponse
 */
export interface GetAvatarMeStoreOutfitsResponse {
    /**
     * 
     * @type {Array<OutfitV2>}
     * @memberof GetAvatarMeStoreOutfitsResponse
     */
    outfits: Array<OutfitV2>;
}
/**
 * 
 * @export
 * @interface GetBuyerEarningsResponse
 */
export interface GetBuyerEarningsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetBuyerEarningsResponse
     */
    earned: number;
    /**
     * 
     * @type {number}
     * @memberof GetBuyerEarningsResponse
     */
    tax: number;
    /**
     * 
     * @type {BuyerEarningsPart}
     * @memberof GetBuyerEarningsResponse
     */
    products: BuyerEarningsPart;
    /**
     * 
     * @type {BuyerEarningsPart}
     * @memberof GetBuyerEarningsResponse
     */
    subscriptions: BuyerEarningsPart;
}
/**
 * 
 * @export
 * @interface GetCancellationQuestionsResponse
 */
export interface GetCancellationQuestionsResponse {
    /**
     * 
     * @type {PopStoreCreatorBusinessTypeEnumItem}
     * @memberof GetCancellationQuestionsResponse
     */
    category: PopStoreCreatorBusinessTypeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof GetCancellationQuestionsResponse
     */
    templateVersion: number;
    /**
     * 
     * @type {Array<CancellationQuestionResponse>}
     * @memberof GetCancellationQuestionsResponse
     */
    questions: Array<CancellationQuestionResponse>;
}


/**
 * 
 * @export
 * @interface GetCouponResponse
 */
export interface GetCouponResponse {
    /**
     * 
     * @type {CouponDetails}
     * @memberof GetCouponResponse
     */
    data?: CouponDetails;
}

/**
 * 
 * @export
 * @interface GetIcsResponse
 */
export interface GetIcsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetIcsResponse
     */
    ics: string;
}
/**
 * 
 * @export
 * @interface GetLeadFormResponse
 */
export interface GetLeadFormResponse {
    /**
     * 
     * @type {LeadFormItem}
     * @memberof GetLeadFormResponse
     */
    data?: LeadFormItem;
}
/**
 * 
 * @export
 * @interface GetListingCouponByCodeResponse
 */
export interface GetListingCouponByCodeResponse {
    /**
     * 
     * @type {CouponItem}
     * @memberof GetListingCouponByCodeResponse
     */
    data?: CouponItem | null;
    /**
     * true when the coupon does not stack on the listing's own sale price: the buyer pays the lower of the sale price and (list price - coupon)
     * @type {boolean}
     * @memberof GetListingCouponByCodeResponse
     */
    nonStackingWithListingDiscount?: boolean;
}
/**
 * 
 * @export
 * @interface GetMyEarningsBreakdownResponse
 */
export interface GetMyEarningsBreakdownResponse {
    /**
     * 
     * @type {Array<EarningsBySource>}
     * @memberof GetMyEarningsBreakdownResponse
     */
    bySource: Array<EarningsBySource>;
    /**
     * 
     * @type {EarningsWindowTotals}
     * @memberof GetMyEarningsBreakdownResponse
     */
    total: EarningsWindowTotals;
}
/**
 * 
 * @export
 * @interface GetMyEarningsResponse
 */
export interface GetMyEarningsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMyEarningsResponse
     */
    payableEarnings: number;
    /**
     * 
     * @type {number}
     * @memberof GetMyEarningsResponse
     */
    last6MonthsEarnings: number;
    /**
     * 
     * @type {number}
     * @memberof GetMyEarningsResponse
     */
    activeSubscribers: number;
    /**
     * 
     * @type {number}
     * @memberof GetMyEarningsResponse
     */
    lifetimeEarnings: number;
    /**
     * 
     * @type {Array<MyPayout>}
     * @memberof GetMyEarningsResponse
     */
    payouts: Array<MyPayout>;
    /**
     * 
     * @type {Array<MyMonthEarning>}
     * @memberof GetMyEarningsResponse
     */
    monthlyEarnings: Array<MyMonthEarning>;
}
/**
 * 
 * @export
 * @interface GetMySubscriptionDetailsResponse
 */
export interface GetMySubscriptionDetailsResponse {
    /**
     * 
     * @type {MySubscriptionDetails}
     * @memberof GetMySubscriptionDetailsResponse
     */
    data?: MySubscriptionDetails;
}
/**
 * 
 * @export
 * @interface GetOrderDigitalProductResponse
 */
export interface GetOrderDigitalProductResponse {
    /**
     * 
     * @type {string}
     * @memberof GetOrderDigitalProductResponse
     */
    filename: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDigitalProductResponse
     */
    downloadedCount: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDigitalProductResponse
     */
    downloadLimitCount?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDigitalProductResponse
     */
    downloadEndAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDigitalProductResponse
     */
    downloadUrl: string;
}
/**
 * 
 * @export
 * @interface GetPaymentMethodsResponse
 */
export interface GetPaymentMethodsResponse {
    /**
     * 
     * @type {Array<PaymentMethodItem>}
     * @memberof GetPaymentMethodsResponse
     */
    data: Array<PaymentMethodItem>;
}
/**
 * 
 * @export
 * @interface GetPhoneResponse
 */
export interface GetPhoneResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetPhoneResponse
     */
    exist: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPhoneResponse
     */
    isCreator?: boolean;
}
/**
 * 
 * @export
 * @interface GetProductEarningsResponse
 */
export interface GetProductEarningsResponse {
    /**
     * What buyers paid for this product
     * @type {number}
     * @memberof GetProductEarningsResponse
     */
    totalSales: number;
    /**
     * Orders counted
     * @type {number}
     * @memberof GetProductEarningsResponse
     */
    totalSaleCount: number;
    /**
     * Credited to the seller balance
     * @type {number}
     * @memberof GetProductEarningsResponse
     */
    totalEarning: number;
    /**
     * Sales tax taken out of what buyers paid
     * @type {number}
     * @memberof GetProductEarningsResponse
     */
    totalTax: number;
}
/**
 * 
 * @export
 * @interface GetPurchasedAvatarMeMediaResponse
 */
export interface GetPurchasedAvatarMeMediaResponse {
    /**
     * 
     * @type {PurchasedAvatarMeMediaItem}
     * @memberof GetPurchasedAvatarMeMediaResponse
     */
    data: PurchasedAvatarMeMediaItem;
}
/**
 * 
 * @export
 * @interface GetPurchasedDigitalAssetResponse
 */
export interface GetPurchasedDigitalAssetResponse {
    /**
     * 
     * @type {GetOrderDigitalProductResponse}
     * @memberof GetPurchasedDigitalAssetResponse
     */
    asset?: GetOrderDigitalProductResponse;
}
/**
 * 
 * @export
 * @interface GetSaasSubscriptionResponse
 */
export interface GetSaasSubscriptionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetSaasSubscriptionResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {SaasSubscriptionBasePlanTypeEnumItem}
     * @memberof GetSaasSubscriptionResponse
     */
    basePlanType?: SaasSubscriptionBasePlanTypeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof GetSaasSubscriptionResponse
     */
    planLevel?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetSaasSubscriptionResponse
     */
    isFreePlan?: boolean;
}


/**
 * 
 * @export
 * @interface GetSellerMetricsResponse
 */
export interface GetSellerMetricsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    shippingSpeedOfDayMin: number;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    shippingSpeedOfDayMax: number;
    /**
     * 
     * @type {string}
     * @memberof GetSellerMetricsResponse
     */
    hoursViewed: string;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    hoursViewedNumeric: number;
    /**
     * 
     * @type {string}
     * @memberof GetSellerMetricsResponse
     */
    productsSold: string;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    productsSoldNumeric: number;
    /**
     * 
     * @type {string}
     * @memberof GetSellerMetricsResponse
     */
    revenue: string;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    followerCnt: number;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    followingCnt: number;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    bioPv: number;
}
/**
 * 
 * @export
 * @interface GetSellerPollMetricsResponse
 */
export interface GetSellerPollMetricsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSellerPollMetricsResponse
     */
    voterCount: number;
    /**
     * 
     * @type {Array<DataPoint>}
     * @memberof GetSellerPollMetricsResponse
     */
    voterDistByCountry: Array<DataPoint>;
    /**
     * 
     * @type {Array<DataPoint>}
     * @memberof GetSellerPollMetricsResponse
     */
    voterDistByAge: Array<DataPoint>;
}
/**
 * 
 * @export
 * @interface GetSessionsResponse
 */
export interface GetSessionsResponse {
    /**
     * 
     * @type {Array<GetSessionsResponseItem>}
     * @memberof GetSessionsResponse
     */
    data: Array<GetSessionsResponseItem>;
}
/**
 * 
 * @export
 * @interface GetSessionsResponseItem
 */
export interface GetSessionsResponseItem {
    /**
     * 
     * @type {number}
     * @memberof GetSessionsResponseItem
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    sessionId: string;
    /**
     * 
     * @type {number}
     * @memberof GetSessionsResponseItem
     */
    type: number;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    avatar: string;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    targetUserId: string;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    targetUserName: string;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    targetAvatar: string;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    lastMessageTime: string;
    /**
     * 
     * @type {ChatMessageDto}
     * @memberof GetSessionsResponseItem
     */
    lastMessage?: ChatMessageDto;
    /**
     * 
     * @type {number}
     * @memberof GetSessionsResponseItem
     */
    unreadCount: number;
}
/**
 * 
 * @export
 * @interface GetSessionsUnreadMessageCountResponse
 */
export interface GetSessionsUnreadMessageCountResponse {
    /**
     * 
     * @type {Array<SessionUnreadMessageCountItem>}
     * @memberof GetSessionsUnreadMessageCountResponse
     */
    data: Array<SessionUnreadMessageCountItem>;
}
/**
 * 
 * @export
 * @interface GetSignedUrlToUploadAvatarMeMediaRequest
 */
export interface GetSignedUrlToUploadAvatarMeMediaRequest {
    /**
     * 
     * @type {UploadAvatarMeMediaPurposeEnumItem}
     * @memberof GetSignedUrlToUploadAvatarMeMediaRequest
     */
    purpose: UploadAvatarMeMediaPurposeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof GetSignedUrlToUploadAvatarMeMediaRequest
     */
    fileExt: string;
}


/**
 * 
 * @export
 * @interface GetSignedUrlToUploadAvatarMeMediaResponse
 */
export interface GetSignedUrlToUploadAvatarMeMediaResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSignedUrlToUploadAvatarMeMediaResponse
     */
    awsS3SignedUrl: string;
    /**
     * 
     * @type {string}
     * @memberof GetSignedUrlToUploadAvatarMeMediaResponse
     */
    awsS3CdnUrl: string;
}
/**
 * 
 * @export
 * @interface GetSignedUrlToUploadModelMeImageRequest
 */
export interface GetSignedUrlToUploadModelMeImageRequest {
    /**
     * 
     * @type {string}
     * @memberof GetSignedUrlToUploadModelMeImageRequest
     */
    imageType: GetSignedUrlToUploadModelMeImageRequestImageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSignedUrlToUploadModelMeImageRequest
     */
    imageExt: GetSignedUrlToUploadModelMeImageRequestImageExtEnum;
}


/**
 * @export
 */
export const GetSignedUrlToUploadModelMeImageRequestImageTypeEnum = {
    Face: 'face',
    Body: 'body',
    Tattoo: 'tattoo'
} as const;
export type GetSignedUrlToUploadModelMeImageRequestImageTypeEnum = typeof GetSignedUrlToUploadModelMeImageRequestImageTypeEnum[keyof typeof GetSignedUrlToUploadModelMeImageRequestImageTypeEnum];

/**
 * @export
 */
export const GetSignedUrlToUploadModelMeImageRequestImageExtEnum = {
    Jpeg: 'jpeg',
    Jpg: 'jpg',
    Png: 'png'
} as const;
export type GetSignedUrlToUploadModelMeImageRequestImageExtEnum = typeof GetSignedUrlToUploadModelMeImageRequestImageExtEnum[keyof typeof GetSignedUrlToUploadModelMeImageRequestImageExtEnum];

/**
 * 
 * @export
 * @interface GetSignedUrlToUploadModelMeImageResponse
 */
export interface GetSignedUrlToUploadModelMeImageResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSignedUrlToUploadModelMeImageResponse
     */
    awsS3SignedUrl: string;
}
/**
 * 
 * @export
 * @interface GetStripeAccountInfoResponse
 */
export interface GetStripeAccountInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof GetStripeAccountInfoResponse
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof GetStripeAccountInfoResponse
     */
    billingCountry: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetStripeAccountInfoResponse
     */
    onBehalfOfChargeModeEnabled: boolean;
}
/**
 * 
 * @export
 * @interface GetStripeConnectedAccountResponse
 */
export interface GetStripeConnectedAccountResponse {
    /**
     * 
     * @type {object}
     * @memberof GetStripeConnectedAccountResponse
     */
    account: object;
}
/**
 * 
 * @export
 * @interface GetSubscriptionDefaultPaymentMethodResponse
 */
export interface GetSubscriptionDefaultPaymentMethodResponse {
    /**
     * 
     * @type {PaymentMethodDetailItem}
     * @memberof GetSubscriptionDefaultPaymentMethodResponse
     */
    data?: PaymentMethodDetailItem;
}
/**
 * 
 * @export
 * @interface GetSubscriptionPaymentMethodsResponse
 */
export interface GetSubscriptionPaymentMethodsResponse {
    /**
     * 
     * @type {Array<SubscriptionPaymentMethod>}
     * @memberof GetSubscriptionPaymentMethodsResponse
     */
    data: Array<SubscriptionPaymentMethod>;
    /**
     * 
     * @type {SubscriptionLastChargeFailure}
     * @memberof GetSubscriptionPaymentMethodsResponse
     */
    lastChargeFailure?: SubscriptionLastChargeFailure;
}
/**
 * 
 * @export
 * @interface GetSubscriptionPlansResponse
 */
export interface GetSubscriptionPlansResponse {
    /**
     * 
     * @type {Array<SubscriptionPlan>}
     * @memberof GetSubscriptionPlansResponse
     */
    data: Array<SubscriptionPlan>;
}
/**
 * 
 * @export
 * @interface GetSubscriptionPremiumStatusResponse
 */
export interface GetSubscriptionPremiumStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetSubscriptionPremiumStatusResponse
     */
    canAccessPremium: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSubscriptionPremiumStatusResponse
     */
    isTrialing: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionPremiumStatusResponse
     */
    planName?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionPremiumStatusResponse
     */
    planCost?: number;
    /**
     * 
     * @type {SubscriptionPlanIntervalEnumItem}
     * @memberof GetSubscriptionPremiumStatusResponse
     */
    interval?: SubscriptionPlanIntervalEnumItem;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionPremiumStatusResponse
     */
    trialEndDate?: string;
}


/**
 * 
 * @export
 * @interface GetSubscriptionTaxRequest
 */
export interface GetSubscriptionTaxRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSubscriptionTaxRequest
     */
    priceIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionTaxRequest
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {TaxCalculationAddress}
     * @memberof GetSubscriptionTaxRequest
     */
    address?: TaxCalculationAddress;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionTaxRequest
     */
    couponCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSubscriptionTaxRequest
     */
    usePaidTrial?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSubscriptionTaxRequest
     */
    allowEmptyBillingAddress?: boolean;
}
/**
 * 
 * @export
 * @interface GetSubscriptionTaxResponse
 */
export interface GetSubscriptionTaxResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionTaxResponse
     */
    totalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionTaxResponse
     */
    taxAmount: number;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionTaxResponse
     */
    taxCode: string;
    /**
     * 
     * @type {PaidTrialTax}
     * @memberof GetSubscriptionTaxResponse
     */
    paidTrial?: PaidTrialTax;
}
/**
 * 
 * @export
 * @interface GetTokenCostResponse
 */
export interface GetTokenCostResponse {
    /**
     * 
     * @type {TokenCostItem}
     * @memberof GetTokenCostResponse
     */
    data?: TokenCostItem;
}
/**
 * 
 * @export
 * @interface GetTrialAvailabilityResponse
 */
export interface GetTrialAvailabilityResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetTrialAvailabilityResponse
     */
    isTrialAvailable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTrialAvailabilityResponse
     */
    isPaidTrialAvailable: boolean;
    /**
     * 
     * @type {TrialAvailabilityCouponItem}
     * @memberof GetTrialAvailabilityResponse
     */
    coupon?: TrialAvailabilityCouponItem;
}
/**
 * 
 * @export
 * @interface GiftPackageDto
 */
export interface GiftPackageDto {
    /**
     * 
     * @type {boolean}
     * @memberof GiftPackageDto
     */
    isGiftPackage: boolean;
    /**
     * 
     * @type {string}
     * @memberof GiftPackageDto
     */
    giftMessage?: string;
}
/**
 * 
 * @export
 * @interface GiveawaySendItemItem
 */
export interface GiveawaySendItemItem {
    /**
     * 
     * @type {ProfileItem}
     * @memberof GiveawaySendItemItem
     */
    fromUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    fromUserId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof GiveawaySendItemItem
     */
    toUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof GiveawaySendItemItem
     */
    listing: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    variantId?: string;
    /**
     * 
     * @type {number}
     * @memberof GiveawaySendItemItem
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    status: GiveawaySendItemItemStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GiveawaySendItemItem
     */
    needShippingFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof GiveawaySendItemItem
     */
    quantity: number;
    /**
     * 
     * @type {LiveStreamAuctionItem}
     * @memberof GiveawaySendItemItem
     */
    liveStreamAuction: LiveStreamAuctionItem;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    type: GiveawaySendItemItemTypeEnum;
}


/**
 * @export
 */
export const GiveawaySendItemItemStatusEnum = {
    Processing: 'PROCESSING',
    Canceled: 'CANCELED',
    Confirmed: 'CONFIRMED',
    Rejected: ' REJECTED'
} as const;
export type GiveawaySendItemItemStatusEnum = typeof GiveawaySendItemItemStatusEnum[keyof typeof GiveawaySendItemItemStatusEnum];

/**
 * @export
 */
export const GiveawaySendItemItemTypeEnum = {
    Giveaway: 'giveaway'
} as const;
export type GiveawaySendItemItemTypeEnum = typeof GiveawaySendItemItemTypeEnum[keyof typeof GiveawaySendItemItemTypeEnum];


/**
 * 
 * @export
 */
export const GroupEventLocationTypeEnumItem = {
    InPerson: 'InPerson',
    GoogleMeet: 'GoogleMeet'
} as const;
export type GroupEventLocationTypeEnumItem = typeof GroupEventLocationTypeEnumItem[keyof typeof GroupEventLocationTypeEnumItem];

/**
 * 
 * @export
 * @interface GroupEventPageRows
 */
export interface GroupEventPageRows {
    /**
     * 
     * @type {Array<GroupEventSearchItem>}
     * @memberof GroupEventPageRows
     */
    rows: Array<GroupEventSearchItem>;
}
/**
 * 
 * @export
 * @interface GroupEventSearchItem
 */
export interface GroupEventSearchItem {
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchItem
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchItem
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchItem
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchItem
     */
    endDate: string;
    /**
     * 
     * @type {number}
     * @memberof GroupEventSearchItem
     */
    inviteeLimit: number;
    /**
     * 
     * @type {GroupEventLocationTypeEnumItem}
     * @memberof GroupEventSearchItem
     */
    locationType: GroupEventLocationTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchItem
     */
    address?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupEventSearchItem
     */
    totalBooked: number;
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof GroupEventSearchItem
     */
    relations: Relations;
}


/**
 * 
 * @export
 * @interface GroupEventSearchResponse
 */
export interface GroupEventSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof GroupEventSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof GroupEventSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupEventSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {GroupEventPageRows}
     * @memberof GroupEventSearchResponse
     */
    data: GroupEventPageRows;
}

/**
 * 
 * @export
 */
export const HairColorEnumItem = {
    Blonde: 'Blonde',
    Brunette: 'Brunette',
    RedHead: 'Red Head',
    BlackHair: 'Black hair',
    WhiteHair: 'White hair'
} as const;
export type HairColorEnumItem = typeof HairColorEnumItem[keyof typeof HairColorEnumItem];


/**
 * 
 * @export
 */
export const HairLengthEnumItem = {
    Short: 'Short',
    Medium: 'Medium',
    Long: 'Long',
    VeryLong: 'Very Long'
} as const;
export type HairLengthEnumItem = typeof HairLengthEnumItem[keyof typeof HairLengthEnumItem];


/**
 * 
 * @export
 */
export const HairStyleEnumItem = {
    Straight: 'Straight',
    Braided: 'Braided',
    Dreadlocks: 'Dreadlocks',
    Curly: 'Curly',
    WavyHair: 'Wavy Hair'
} as const;
export type HairStyleEnumItem = typeof HairStyleEnumItem[keyof typeof HairStyleEnumItem];


/**
 * 
 * @export
 */
export const HeightUnitEnumItem = {
    Cm: 'cm',
    In: 'in',
    Ft: 'ft',
    M: 'm'
} as const;
export type HeightUnitEnumItem = typeof HeightUnitEnumItem[keyof typeof HeightUnitEnumItem];

/**
 * 
 * @export
 * @interface IdResponse
 */
export interface IdResponse {
    /**
     * 
     * @type {string}
     * @memberof IdResponse
     */
    id: string;
}
/**
 * 
 * @export
 * @interface ImportListingFromUrlRequest
 */
export interface ImportListingFromUrlRequest {
    /**
     * Listing detail URL on a supported source (Compass, Zillow, or Redfin).
     * @type {string}
     * @memberof ImportListingFromUrlRequest
     */
    url: string;
}
/**
 * 
 * @export
 * @interface IsAllowedToGenerateFreeAvatarMeResponse
 */
export interface IsAllowedToGenerateFreeAvatarMeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof IsAllowedToGenerateFreeAvatarMeResponse
     */
    data: boolean;
}
/**
 * 
 * @export
 * @interface LabelShippingCost
 */
export interface LabelShippingCost {
    /**
     * 
     * @type {number}
     * @memberof LabelShippingCost
     */
    initialCost: number;
    /**
     * 
     * @type {string}
     * @memberof LabelShippingCost
     */
    initialDate: string;
    /**
     * 
     * @type {number}
     * @memberof LabelShippingCost
     */
    totalCost: number;
    /**
     * 
     * @type {string}
     * @memberof LabelShippingCost
     */
    lastUpdatedAt: string;
}
/**
 * 
 * @export
 * @interface LatestCommunityChannelMessageItem
 */
export interface LatestCommunityChannelMessageItem {
    /**
     * 
     * @type {string}
     * @memberof LatestCommunityChannelMessageItem
     */
    rootMessageId: string;
    /**
     * 
     * @type {string}
     * @memberof LatestCommunityChannelMessageItem
     */
    userId: string;
    /**
     * 
     * @type {CommunityChannelMemberProfileItem}
     * @memberof LatestCommunityChannelMessageItem
     */
    profile: CommunityChannelMemberProfileItem;
    /**
     * 
     * @type {CommunityChannelMessageContentItem}
     * @memberof LatestCommunityChannelMessageItem
     */
    content: CommunityChannelMessageContentItem;
    /**
     * 
     * @type {string}
     * @memberof LatestCommunityChannelMessageItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LatestCommunityChannelMessageItem
     */
    messageId: string;
}

/**
 * 
 * @export
 */
export const LeadFormActionOnQualifiedEnumItem = {
    UnlockRegistration: 'UNLOCK_REGISTRATION',
    UnlockItem: 'UNLOCK_ITEM',
    RedirectToLink: 'REDIRECT_TO_LINK',
    TriggerAutomation: 'TRIGGER_AUTOMATION'
} as const;
export type LeadFormActionOnQualifiedEnumItem = typeof LeadFormActionOnQualifiedEnumItem[keyof typeof LeadFormActionOnQualifiedEnumItem];


/**
 * 
 * @export
 */
export const LeadFormActionOnUnqualifiedEnumItem = {
    ShowPoliteMessage: 'SHOW_POLITE_MESSAGE',
    SuggestDifferentLink: 'SUGGEST_DIFFERENT_LINK'
} as const;
export type LeadFormActionOnUnqualifiedEnumItem = typeof LeadFormActionOnUnqualifiedEnumItem[keyof typeof LeadFormActionOnUnqualifiedEnumItem];

/**
 * 
 * @export
 * @interface LeadFormAnsweredQuestionDto
 */
export interface LeadFormAnsweredQuestionDto {
    /**
     * id of answered question
     * @type {string}
     * @memberof LeadFormAnsweredQuestionDto
     */
    id: string;
    /**
     * for choice question
     * @type {Array<LeadFormAnsweredQuestionOptionDto>}
     * @memberof LeadFormAnsweredQuestionDto
     */
    options?: Array<LeadFormAnsweredQuestionOptionDto>;
    /**
     * for text question
     * @type {string}
     * @memberof LeadFormAnsweredQuestionDto
     */
    text?: string;
}
/**
 * 
 * @export
 * @interface LeadFormAnsweredQuestionOptionDto
 */
export interface LeadFormAnsweredQuestionOptionDto {
    /**
     * id of selected option
     * @type {string}
     * @memberof LeadFormAnsweredQuestionOptionDto
     */
    id: string;
}
/**
 * 
 * @export
 * @interface LeadFormContactItem
 */
export interface LeadFormContactItem {
    /**
     * 
     * @type {string}
     * @memberof LeadFormContactItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormContactItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormContactItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormContactItem
     */
    userId?: string;
    /**
     * 
     * @type {BasicProfileDto}
     * @memberof LeadFormContactItem
     */
    userProfile?: BasicProfileDto;
    /**
     * 
     * @type {string}
     * @memberof LeadFormContactItem
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormContactItem
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof LeadFormContactItem
     */
    consent: boolean;
    /**
     * 
     * @type {Relations}
     * @memberof LeadFormContactItem
     */
    relations: Relations;
}
/**
 * 
 * @export
 * @interface LeadFormContactPageRows
 */
export interface LeadFormContactPageRows {
    /**
     * 
     * @type {Array<LeadFormContactItem>}
     * @memberof LeadFormContactPageRows
     */
    rows: Array<LeadFormContactItem>;
}
/**
 * 
 * @export
 * @interface LeadFormItem
 */
export interface LeadFormItem {
    /**
     * 
     * @type {string}
     * @memberof LeadFormItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormItem
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LeadFormItem
     */
    active: boolean;
    /**
     * 
     * @type {Array<LeadFormItemQuestionsInner>}
     * @memberof LeadFormItem
     */
    questions: Array<LeadFormItemQuestionsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof LeadFormItem
     */
    showQuestionsInSequence?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeadFormItem
     */
    autoQualify?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LeadFormItem
     */
    minIdealAnswersRequired?: number;
    /**
     * 
     * @type {LeadFormActionOnQualifiedEnumItem}
     * @memberof LeadFormItem
     */
    actionOnQualified?: LeadFormActionOnQualifiedEnumItem;
    /**
     * 
     * @type {LeadFormActionOnUnqualifiedEnumItem}
     * @memberof LeadFormItem
     */
    actionOnUnqualified?: LeadFormActionOnUnqualifiedEnumItem;
    /**
     * 
     * @type {string}
     * @memberof LeadFormItem
     */
    redirectLink?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormItem
     */
    politeMessageTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormItem
     */
    politeMessageHtml?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormItem
     */
    politeMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormItem
     */
    differentLink?: string;
    /**
     * 
     * @type {Array<LeadFormTriggerActionItem>}
     * @memberof LeadFormItem
     */
    triggerActions?: Array<LeadFormTriggerActionItem>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LeadFormItem
     */
    triggerActionKeys?: Array<string>;
}


/**
 * @type LeadFormItemQuestionsInner
 * 
 * @export
 */
export type LeadFormItemQuestionsInner = LeadFormMultipleChoiceQuestionItem | LeadFormSingleChoiceQuestionItem | LeadFormTextQuestionItem;
/**
 * 
 * @export
 * @interface LeadFormMultipleChoiceQuestionDto
 */
export interface LeadFormMultipleChoiceQuestionDto {
    /**
     * 
     * @type {string}
     * @memberof LeadFormMultipleChoiceQuestionDto
     */
    id: string;
    /**
     * 
     * @type {LeadFormMultipleChoiceQuestionDtoTypeEnumItem}
     * @memberof LeadFormMultipleChoiceQuestionDto
     */
    type: LeadFormMultipleChoiceQuestionDtoTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof LeadFormMultipleChoiceQuestionDto
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof LeadFormMultipleChoiceQuestionDto
     */
    sort: number;
    /**
     * 
     * @type {Array<LeadFormQuestionOptionDto>}
     * @memberof LeadFormMultipleChoiceQuestionDto
     */
    options: Array<LeadFormQuestionOptionDto>;
}



/**
 * 
 * @export
 */
export const LeadFormMultipleChoiceQuestionDtoTypeEnumItem = {
    MultipleChoice: 'MULTIPLE_CHOICE'
} as const;
export type LeadFormMultipleChoiceQuestionDtoTypeEnumItem = typeof LeadFormMultipleChoiceQuestionDtoTypeEnumItem[keyof typeof LeadFormMultipleChoiceQuestionDtoTypeEnumItem];

/**
 * 
 * @export
 * @interface LeadFormMultipleChoiceQuestionItem
 */
export interface LeadFormMultipleChoiceQuestionItem {
    /**
     * 
     * @type {string}
     * @memberof LeadFormMultipleChoiceQuestionItem
     */
    id: string;
    /**
     * 
     * @type {LeadFormMultipleChoiceQuestionItemTypeEnumItem}
     * @memberof LeadFormMultipleChoiceQuestionItem
     */
    type: LeadFormMultipleChoiceQuestionItemTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof LeadFormMultipleChoiceQuestionItem
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof LeadFormMultipleChoiceQuestionItem
     */
    sort: number;
    /**
     * 
     * @type {Array<LeadFormQuestionOptionItem>}
     * @memberof LeadFormMultipleChoiceQuestionItem
     */
    options: Array<LeadFormQuestionOptionItem>;
}



/**
 * 
 * @export
 */
export const LeadFormMultipleChoiceQuestionItemTypeEnumItem = {
    MultipleChoice: 'MULTIPLE_CHOICE'
} as const;
export type LeadFormMultipleChoiceQuestionItemTypeEnumItem = typeof LeadFormMultipleChoiceQuestionItemTypeEnumItem[keyof typeof LeadFormMultipleChoiceQuestionItemTypeEnumItem];

/**
 * 
 * @export
 * @interface LeadFormPageRows
 */
export interface LeadFormPageRows {
    /**
     * 
     * @type {Array<LeadFormItem>}
     * @memberof LeadFormPageRows
     */
    rows: Array<LeadFormItem>;
}
/**
 * 
 * @export
 * @interface LeadFormQuestionOptionDto
 */
export interface LeadFormQuestionOptionDto {
    /**
     * 
     * @type {string}
     * @memberof LeadFormQuestionOptionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormQuestionOptionDto
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof LeadFormQuestionOptionDto
     */
    sort: number;
    /**
     * 
     * @type {boolean}
     * @memberof LeadFormQuestionOptionDto
     */
    ideal?: boolean;
}
/**
 * 
 * @export
 * @interface LeadFormQuestionOptionItem
 */
export interface LeadFormQuestionOptionItem {
    /**
     * 
     * @type {string}
     * @memberof LeadFormQuestionOptionItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormQuestionOptionItem
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof LeadFormQuestionOptionItem
     */
    sort: number;
    /**
     * 
     * @type {boolean}
     * @memberof LeadFormQuestionOptionItem
     */
    ideal?: boolean;
}
/**
 * 
 * @export
 * @interface LeadFormSingleChoiceQuestionDto
 */
export interface LeadFormSingleChoiceQuestionDto {
    /**
     * 
     * @type {string}
     * @memberof LeadFormSingleChoiceQuestionDto
     */
    id: string;
    /**
     * 
     * @type {LeadFormSingleChoiceQuestionDtoTypeEnumItem}
     * @memberof LeadFormSingleChoiceQuestionDto
     */
    type: LeadFormSingleChoiceQuestionDtoTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSingleChoiceQuestionDto
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof LeadFormSingleChoiceQuestionDto
     */
    sort: number;
    /**
     * 
     * @type {Array<LeadFormQuestionOptionDto>}
     * @memberof LeadFormSingleChoiceQuestionDto
     */
    options: Array<LeadFormQuestionOptionDto>;
}



/**
 * 
 * @export
 */
export const LeadFormSingleChoiceQuestionDtoTypeEnumItem = {
    SingleChoice: 'SINGLE_CHOICE'
} as const;
export type LeadFormSingleChoiceQuestionDtoTypeEnumItem = typeof LeadFormSingleChoiceQuestionDtoTypeEnumItem[keyof typeof LeadFormSingleChoiceQuestionDtoTypeEnumItem];

/**
 * 
 * @export
 * @interface LeadFormSingleChoiceQuestionItem
 */
export interface LeadFormSingleChoiceQuestionItem {
    /**
     * 
     * @type {string}
     * @memberof LeadFormSingleChoiceQuestionItem
     */
    id: string;
    /**
     * 
     * @type {LeadFormSingleChoiceQuestionItemTypeEnumItem}
     * @memberof LeadFormSingleChoiceQuestionItem
     */
    type: LeadFormSingleChoiceQuestionItemTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSingleChoiceQuestionItem
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof LeadFormSingleChoiceQuestionItem
     */
    sort: number;
    /**
     * 
     * @type {Array<LeadFormQuestionOptionItem>}
     * @memberof LeadFormSingleChoiceQuestionItem
     */
    options: Array<LeadFormQuestionOptionItem>;
}



/**
 * 
 * @export
 */
export const LeadFormSingleChoiceQuestionItemTypeEnumItem = {
    SingleChoice: 'SINGLE_CHOICE'
} as const;
export type LeadFormSingleChoiceQuestionItemTypeEnumItem = typeof LeadFormSingleChoiceQuestionItemTypeEnumItem[keyof typeof LeadFormSingleChoiceQuestionItemTypeEnumItem];

/**
 * 
 * @export
 * @interface LeadFormSubmissionContactDto
 */
export interface LeadFormSubmissionContactDto {
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionContactDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionContactDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionContactDto
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface LeadFormSubmissionContactItem
 */
export interface LeadFormSubmissionContactItem {
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionContactItem
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionContactItem
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionContactItem
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface LeadFormSubmissionItem
 */
export interface LeadFormSubmissionItem {
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionItem
     */
    id: string;
    /**
     * 
     * @type {Array<LeadFormSubmissionItemAnswersInner>}
     * @memberof LeadFormSubmissionItem
     */
    answers: Array<LeadFormSubmissionItemAnswersInner>;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionItem
     */
    userId?: string;
    /**
     * 
     * @type {LeadFormSubmissionUserProfileItem}
     * @memberof LeadFormSubmissionItem
     */
    userProfile?: LeadFormSubmissionUserProfileItem;
    /**
     * 
     * @type {LeadFormSubmissionContactItem}
     * @memberof LeadFormSubmissionItem
     */
    contact?: LeadFormSubmissionContactItem;
    /**
     * 
     * @type {boolean}
     * @memberof LeadFormSubmissionItem
     */
    consent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeadFormSubmissionItem
     */
    offerConsent?: boolean;
    /**
     * 
     * @type {Relations}
     * @memberof LeadFormSubmissionItem
     */
    relations: Relations;
}
/**
 * @type LeadFormSubmissionItemAnswersInner
 * 
 * @export
 */
export type LeadFormSubmissionItemAnswersInner = AnsweredLeadFormMultipleChoiceQuestionItem | AnsweredLeadFormSingleChoiceQuestionItem | AnsweredLeadFormTextQuestionItem;
/**
 * 
 * @export
 * @interface LeadFormSubmissionPageRows
 */
export interface LeadFormSubmissionPageRows {
    /**
     * 
     * @type {Array<LeadFormSubmissionItem>}
     * @memberof LeadFormSubmissionPageRows
     */
    rows: Array<LeadFormSubmissionItem>;
}
/**
 * 
 * @export
 * @interface LeadFormSubmissionUserProfileItem
 */
export interface LeadFormSubmissionUserProfileItem {
    /**
     * First name
     * @type {string}
     * @memberof LeadFormSubmissionUserProfileItem
     */
    firstName: string;
    /**
     * Last name
     * @type {string}
     * @memberof LeadFormSubmissionUserProfileItem
     */
    lastName: string;
    /**
     * Username
     * @type {string}
     * @memberof LeadFormSubmissionUserProfileItem
     */
    username?: string;
    /**
     * Avatar URL
     * @type {string}
     * @memberof LeadFormSubmissionUserProfileItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionUserProfileItem
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFormSubmissionUserProfileItem
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface LeadFormTextQuestionDto
 */
export interface LeadFormTextQuestionDto {
    /**
     * 
     * @type {string}
     * @memberof LeadFormTextQuestionDto
     */
    id: string;
    /**
     * 
     * @type {LeadFormTextQuestionDtoTypeEnumItem}
     * @memberof LeadFormTextQuestionDto
     */
    type: LeadFormTextQuestionDtoTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof LeadFormTextQuestionDto
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof LeadFormTextQuestionDto
     */
    sort: number;
}



/**
 * 
 * @export
 */
export const LeadFormTextQuestionDtoTypeEnumItem = {
    Text: 'TEXT'
} as const;
export type LeadFormTextQuestionDtoTypeEnumItem = typeof LeadFormTextQuestionDtoTypeEnumItem[keyof typeof LeadFormTextQuestionDtoTypeEnumItem];

/**
 * 
 * @export
 * @interface LeadFormTextQuestionItem
 */
export interface LeadFormTextQuestionItem {
    /**
     * 
     * @type {string}
     * @memberof LeadFormTextQuestionItem
     */
    id: string;
    /**
     * 
     * @type {LeadFormTextQuestionItemTypeEnumItem}
     * @memberof LeadFormTextQuestionItem
     */
    type: LeadFormTextQuestionItemTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof LeadFormTextQuestionItem
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof LeadFormTextQuestionItem
     */
    sort: number;
}



/**
 * 
 * @export
 */
export const LeadFormTextQuestionItemTypeEnumItem = {
    Text: 'TEXT'
} as const;
export type LeadFormTextQuestionItemTypeEnumItem = typeof LeadFormTextQuestionItemTypeEnumItem[keyof typeof LeadFormTextQuestionItemTypeEnumItem];

/**
 * 
 * @export
 * @interface LeadFormTriggerActionDto
 */
export interface LeadFormTriggerActionDto {
    /**
     * 
     * @type {LeadFormTriggerActionTypeEnumItem}
     * @memberof LeadFormTriggerActionDto
     */
    type: LeadFormTriggerActionTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof LeadFormTriggerActionDto
     */
    id: string;
}


/**
 * 
 * @export
 * @interface LeadFormTriggerActionItem
 */
export interface LeadFormTriggerActionItem {
    /**
     * 
     * @type {LeadFormTriggerActionTypeEnumItem}
     * @memberof LeadFormTriggerActionItem
     */
    type: LeadFormTriggerActionTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof LeadFormTriggerActionItem
     */
    id: string;
}



/**
 * 
 * @export
 */
export const LeadFormTriggerActionTypeEnumItem = {
    Button: 'BUTTON',
    MessageMe: 'MESSAGE_ME',
    ContactCard: 'CONTACT_CARD',
    DigitalProduct: 'DIGITAL_PRODUCT',
    Course: 'COURSE',
    Calendar: 'CALENDAR',
    MeetingType: 'MEETING_TYPE',
    RealEstateListing: 'REAL_ESTATE_LISTING'
} as const;
export type LeadFormTriggerActionTypeEnumItem = typeof LeadFormTriggerActionTypeEnumItem[keyof typeof LeadFormTriggerActionTypeEnumItem];

/**
 * 
 * @export
 * @interface LeadSsourceDetailsItem
 */
export interface LeadSsourceDetailsItem {
    /**
     * 
     * @type {string}
     * @memberof LeadSsourceDetailsItem
     */
    title: string;
}

/**
 * 
 * @export
 */
export const LeadsContactSearchTypeEnumItem = {
    Lead: 'LEAD',
    Follower: 'FOLLOWER'
} as const;
export type LeadsContactSearchTypeEnumItem = typeof LeadsContactSearchTypeEnumItem[keyof typeof LeadsContactSearchTypeEnumItem];

/**
 * 
 * @export
 * @interface LeadsContactV2Item
 */
export interface LeadsContactV2Item {
    /**
     * 
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    creatorId: string;
    /**
     * 
     * @type {BasicProfileDto}
     * @memberof LeadsContactV2Item
     */
    creatorProfile?: BasicProfileDto;
    /**
     * 
     * @type {LeadsSourceTypeEnumItem}
     * @memberof LeadsContactV2Item
     */
    sourceType?: LeadsSourceTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    source?: string;
    /**
     * 
     * @type {object}
     * @memberof LeadsContactV2Item
     */
    context?: object;
    /**
     * 
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    phoneNumber?: string;
    /**
     * 
     * @type {LeadsSharePhoneConsentItem}
     * @memberof LeadsContactV2Item
     */
    sharePhoneConsent?: LeadsSharePhoneConsentItem;
    /**
     * 
     * @type {LeadsOfferConsentItem}
     * @memberof LeadsContactV2Item
     */
    offerConsent?: LeadsOfferConsentItem;
    /**
     * 
     * @type {LeadSsourceDetailsItem}
     * @memberof LeadsContactV2Item
     */
    sourceDetails?: LeadSsourceDetailsItem;
    /**
     * 
     * @type {Array<LeadFormSubmissionItemAnswersInner>}
     * @memberof LeadsContactV2Item
     */
    leadFormAnswers?: Array<LeadFormSubmissionItemAnswersInner>;
    /**
     * 
     * @type {Relations}
     * @memberof LeadsContactV2Item
     */
    relations: Relations;
    /**
     * 
     * @type {LeadsContactSearchTypeEnumItem}
     * @memberof LeadsContactV2Item
     */
    type: LeadsContactSearchTypeEnumItem;
    /**
     * 
     * @type {PromotionalOfferDetailsItem}
     * @memberof LeadsContactV2Item
     */
    promotionalOfferDetails?: PromotionalOfferDetailsItem;
    /**
     * 
     * @type {SharePhoneNumberConsentItem}
     * @memberof LeadsContactV2Item
     */
    sharePhoneNumberConsent?: SharePhoneNumberConsentItem;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof LeadsContactV2Item
     */
    subscriptionLevel?: PopStoreExtendedSubscriptionLevelEnumItem;
    /**
     * follow date for a FOLLOWER, capture date for a LEAD, and equal to createdAt on both. The result is sorted on the document create time, which is written in the same operation and so within milliseconds of this.
     * @type {string}
     * @memberof LeadsContactV2Item
     */
    joinDate?: string;
}


/**
 * 
 * @export
 * @interface LeadsContactV2PageRows
 */
export interface LeadsContactV2PageRows {
    /**
     * 
     * @type {Array<LeadsContactV2Item>}
     * @memberof LeadsContactV2PageRows
     */
    rows: Array<LeadsContactV2Item>;
}
/**
 * 
 * @export
 * @interface LeadsOfferConsentItem
 */
export interface LeadsOfferConsentItem {
    /**
     * 
     * @type {boolean}
     * @memberof LeadsOfferConsentItem
     */
    offerConsent: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeadsOfferConsentItem
     */
    offerConsentTimestamp?: string;
}
/**
 * 
 * @export
 * @interface LeadsSharePhoneConsentItem
 */
export interface LeadsSharePhoneConsentItem {
    /**
     * 
     * @type {boolean}
     * @memberof LeadsSharePhoneConsentItem
     */
    phoneConsent: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeadsSharePhoneConsentItem
     */
    phoneConsentTimestamp?: string;
}

/**
 * 
 * @export
 */
export const LeadsSourceTypeEnumItem = {
    RealEstateListing: 'REAL_ESTATE_LISTING',
    DigitalProduct: 'DIGITAL_PRODUCT',
    LeadForm: 'LEAD_FORM',
    Calendar: 'CALENDAR',
    LinkButton: 'LINK_BUTTON',
    SimpleLead: 'SIMPLE_LEAD'
} as const;
export type LeadsSourceTypeEnumItem = typeof LeadsSourceTypeEnumItem[keyof typeof LeadsSourceTypeEnumItem];

/**
 * 
 * @export
 * @interface LinkProductToCollectionRequest
 */
export interface LinkProductToCollectionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkProductToCollectionRequest
     */
    listingIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof LinkProductToCollectionRequest
     */
    reorder?: boolean;
}
/**
 * 
 * @export
 * @interface ListingDerivedFromTipToLiveStreamDto
 */
export interface ListingDerivedFromTipToLiveStreamDto {
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToLiveStreamDto
     */
    to: ListingDerivedFromTipToLiveStreamDtoToEnum;
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToLiveStreamDto
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToLiveStreamDto
     */
    liveStreamId: string;
}


/**
 * @export
 */
export const ListingDerivedFromTipToLiveStreamDtoToEnum = {
    LiveStream: 'LIVE_STREAM'
} as const;
export type ListingDerivedFromTipToLiveStreamDtoToEnum = typeof ListingDerivedFromTipToLiveStreamDtoToEnum[keyof typeof ListingDerivedFromTipToLiveStreamDtoToEnum];

/**
 * 
 * @export
 * @interface ListingDerivedFromTipToPostDto
 */
export interface ListingDerivedFromTipToPostDto {
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToPostDto
     */
    to: ListingDerivedFromTipToPostDtoToEnum;
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToPostDto
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToPostDto
     */
    postId: string;
}


/**
 * @export
 */
export const ListingDerivedFromTipToPostDtoToEnum = {
    Post: 'POST'
} as const;
export type ListingDerivedFromTipToPostDtoToEnum = typeof ListingDerivedFromTipToPostDtoToEnum[keyof typeof ListingDerivedFromTipToPostDtoToEnum];

/**
 * 
 * @export
 * @interface ListingDerivedFromTipToSellerDto
 */
export interface ListingDerivedFromTipToSellerDto {
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToSellerDto
     */
    to: ListingDerivedFromTipToSellerDtoToEnum;
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToSellerDto
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToSellerDto
     */
    tippingGoalId?: string;
}


/**
 * @export
 */
export const ListingDerivedFromTipToSellerDtoToEnum = {
    Seller: 'SELLER'
} as const;
export type ListingDerivedFromTipToSellerDtoToEnum = typeof ListingDerivedFromTipToSellerDtoToEnum[keyof typeof ListingDerivedFromTipToSellerDtoToEnum];

/**
 * 
 * @export
 * @interface ListingDropshipDetailsItem
 */
export interface ListingDropshipDetailsItem {
    /**
     * 
     * @type {number}
     * @memberof ListingDropshipDetailsItem
     */
    partnerId: number;
    /**
     * 
     * @type {string}
     * @memberof ListingDropshipDetailsItem
     */
    partnerName: string;
    /**
     * 
     * @type {number}
     * @memberof ListingDropshipDetailsItem
     */
    supplierId: number;
    /**
     * 
     * @type {string}
     * @memberof ListingDropshipDetailsItem
     */
    supplierName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListingDropshipDetailsItem
     */
    hasActiveAllocation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListingDropshipDetailsItem
     */
    allocationStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ListingDropshipDetailsItem
     */
    allocationEndDate?: string;
}
/**
 * 
 * @export
 * @interface ListingDto
 */
export interface ListingDto {
    /**
     * token pack id when type is TokenPack
     * @type {string}
     * @memberof ListingDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ListingDto
     */
    type: ListingDtoTypeEnum;
}


/**
 * @export
 */
export const ListingDtoTypeEnum = {
    TokenPack: 'TOKEN_PACK'
} as const;
export type ListingDtoTypeEnum = typeof ListingDtoTypeEnum[keyof typeof ListingDtoTypeEnum];

/**
 * 
 * @export
 * @interface ListingMeetingDto
 */
export interface ListingMeetingDto {
    /**
     * 
     * @type {string}
     * @memberof ListingMeetingDto
     */
    startDate: string;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingDto
     */
    durationInSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof ListingMeetingDto
     */
    timeZone?: string;
    /**
     * 
     * @type {MeetingRepeatFrequencyEnumItem}
     * @memberof ListingMeetingDto
     */
    repeatFrequency?: MeetingRepeatFrequencyEnumItem;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingDto
     */
    repeatCount?: number;
}


/**
 * 
 * @export
 * @interface ListingMeetingItem
 */
export interface ListingMeetingItem {
    /**
     * 
     * @type {string}
     * @memberof ListingMeetingItem
     */
    startDate: string;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingItem
     */
    durationInSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof ListingMeetingItem
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof ListingMeetingItem
     */
    timeZone?: string;
    /**
     * 
     * @type {MeetingRepeatFrequencyEnumItem}
     * @memberof ListingMeetingItem
     */
    repeatFrequency?: MeetingRepeatFrequencyEnumItem;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingItem
     */
    repeatCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListingMeetingItem
     */
    availableDates?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingItem
     */
    startTime?: number;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingItem
     */
    endTime?: number;
}


/**
 * 
 * @export
 * @interface ListingProductCategoryItem
 */
export interface ListingProductCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof ListingProductCategoryItem
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ListingProductCategoryItem
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ListingProductCategoryItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListingProductCategoryItem
     */
    slug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListingProductCategoryItem
     */
    isRoot: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListingProductCategoryItem
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListingProductCategoryItem
     */
    custom: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListingProductCategoryItem
     */
    digital?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ListingProductCategoryItem
     */
    sort: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListingProductCategoryItem
     */
    googleProductCategoryIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ListingProductCategoryItem
     */
    id: string;
}
/**
 * 
 * @export
 * @interface ListingRatingType
 */
export interface ListingRatingType {
    /**
     * 
     * @type {{ [key: string]: number | null; }}
     * @memberof ListingRatingType
     */
    details?: { [key: string]: number | null; };
}
/**
 * 
 * @export
 * @interface LiveStreamAuction
 */
export interface LiveStreamAuction {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuction
     */
    liveStreamId: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuction
     */
    auctionId: string;
}
/**
 * 
 * @export
 * @interface LiveStreamAuctionItem
 */
export interface LiveStreamAuctionItem {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionItem
     */
    liveStreamId: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionItem
     */
    auctionId: string;
}
/**
 * 
 * @export
 * @interface LiveStreamAuctionSendItemItem
 */
export interface LiveStreamAuctionSendItemItem {
    /**
     * 
     * @type {ProfileItem}
     * @memberof LiveStreamAuctionSendItemItem
     */
    fromUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    fromUserId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof LiveStreamAuctionSendItemItem
     */
    toUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof LiveStreamAuctionSendItemItem
     */
    listing: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    variantId?: string;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamAuctionSendItemItem
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    status: LiveStreamAuctionSendItemItemStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamAuctionSendItemItem
     */
    needShippingFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamAuctionSendItemItem
     */
    quantity: number;
    /**
     * 
     * @type {LiveStreamAuction}
     * @memberof LiveStreamAuctionSendItemItem
     */
    liveStreamAuction: LiveStreamAuction;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    type: LiveStreamAuctionSendItemItemTypeEnum;
}


/**
 * @export
 */
export const LiveStreamAuctionSendItemItemStatusEnum = {
    Processing: 'PROCESSING',
    Canceled: 'CANCELED',
    Confirmed: 'CONFIRMED',
    Rejected: ' REJECTED'
} as const;
export type LiveStreamAuctionSendItemItemStatusEnum = typeof LiveStreamAuctionSendItemItemStatusEnum[keyof typeof LiveStreamAuctionSendItemItemStatusEnum];

/**
 * @export
 */
export const LiveStreamAuctionSendItemItemTypeEnum = {
    LiveStreamAuction: 'liveStreamAuction'
} as const;
export type LiveStreamAuctionSendItemItemTypeEnum = typeof LiveStreamAuctionSendItemItemTypeEnum[keyof typeof LiveStreamAuctionSendItemItemTypeEnum];

/**
 * 
 * @export
 * @interface LiveStreamSendItemSourceSource
 */
export interface LiveStreamSendItemSourceSource {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamSendItemSourceSource
     */
    type: LiveStreamSendItemSourceSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamSendItemSourceSource
     */
    liveStreamId: string;
}


/**
 * @export
 */
export const LiveStreamSendItemSourceSourceTypeEnum = {
    LiveStream: 'liveStream'
} as const;
export type LiveStreamSendItemSourceSourceTypeEnum = typeof LiveStreamSendItemSourceSourceTypeEnum[keyof typeof LiveStreamSendItemSourceSourceTypeEnum];

/**
 * 
 * @export
 * @interface LiveStreamSource
 */
export interface LiveStreamSource {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamSource
     */
    type: LiveStreamSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamSource
     */
    liveStreamId: string;
}


/**
 * @export
 */
export const LiveStreamSourceTypeEnum = {
    LiveStream: 'LIVE_STREAM'
} as const;
export type LiveStreamSourceTypeEnum = typeof LiveStreamSourceTypeEnum[keyof typeof LiveStreamSourceTypeEnum];


/**
 * 
 * @export
 */
export const MeetingDurationEnumItem = {
    NUMBER_30: 30,
    NUMBER_60: 60,
    NUMBER_90: 90,
    NUMBER_120: 120
} as const;
export type MeetingDurationEnumItem = typeof MeetingDurationEnumItem[keyof typeof MeetingDurationEnumItem];


/**
 * 
 * @export
 */
export const MeetingRepeatFrequencyEnumItem = {
    OneTime: 'ONE_TIME',
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY',
    OnWeekdays: 'ON_WEEKDAYS'
} as const;
export type MeetingRepeatFrequencyEnumItem = typeof MeetingRepeatFrequencyEnumItem[keyof typeof MeetingRepeatFrequencyEnumItem];

/**
 * 
 * @export
 * @interface MeetingSlotItem
 */
export interface MeetingSlotItem {
    /**
     * 
     * @type {string}
     * @memberof MeetingSlotItem
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingSlotItem
     */
    endTime: string;
}
/**
 * 
 * @export
 * @interface MeetingTypeRequest
 */
export interface MeetingTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof MeetingTypeRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingTypeRequest
     */
    topic: string;
    /**
     * 
     * @type {MeetingDurationEnumItem}
     * @memberof MeetingTypeRequest
     */
    duration: MeetingDurationEnumItem;
    /**
     * 
     * @type {number}
     * @memberof MeetingTypeRequest
     */
    price: number;
}


/**
 * 
 * @export
 * @interface Metadata
 */
export interface Metadata {
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    updated_at: string;
}

/**
 * 
 * @export
 */
export const ModerationStatusEnumItem = {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    ReviewRequired: 'ReviewRequired'
} as const;
export type ModerationStatusEnumItem = typeof ModerationStatusEnumItem[keyof typeof ModerationStatusEnumItem];

/**
 * 
 * @export
 * @interface ModeratorProfileItem
 */
export interface ModeratorProfileItem {
    /**
     * 
     * @type {string}
     * @memberof ModeratorProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ModeratorProfileItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ModeratorProfileItem
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ModeratorProfileItem
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof ModeratorProfileItem
     */
    avatar?: string;
}
/**
 * 
 * @export
 * @interface MultiCurrencyOrderItem
 */
export interface MultiCurrencyOrderItem {
    /**
     * 
     * @type {string}
     * @memberof MultiCurrencyOrderItem
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    exchangeRate: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    shippingFeeAdjusted: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    totalPriceIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    totalPriceIncludeSlaveOrdersWithProductCoupon: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    totalRefundIncludeSlaveOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    refund?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    couponDiscountProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    couponDiscountShippingFeeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    bonus?: number;
    /**
     * 
     * @type {OrderChargeDistributionItem}
     * @memberof MultiCurrencyOrderItem
     */
    orderChargeDistribution?: OrderChargeDistributionItem;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof MultiCurrencyOrderItem
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {OrderItemPriceComponents}
     * @memberof MultiCurrencyOrderItem
     */
    priceComponents?: OrderItemPriceComponents;
}
/**
 * 
 * @export
 * @interface MyCouponDto
 */
export interface MyCouponDto {
    /**
     * redeemedCoupons/id
     * @type {string}
     * @memberof MyCouponDto
     */
    redeemedCouponId: string;
    /**
     * 
     * @type {string}
     * @memberof MyCouponDto
     */
    usedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof MyCouponDto
     */
    redeemedQuantity: number;
    /**
     * 
     * @type {string}
     * @memberof MyCouponDto
     */
    couponId: string;
    /**
     * 
     * @type {CouponItem}
     * @memberof MyCouponDto
     */
    coupon: CouponItem;
}
/**
 * 
 * @export
 * @interface MyMonthEarning
 */
export interface MyMonthEarning {
    /**
     * 
     * @type {number}
     * @memberof MyMonthEarning
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof MyMonthEarning
     */
    monthStartDate: string;
}
/**
 * 
 * @export
 * @interface MyPayout
 */
export interface MyPayout {
    /**
     * 
     * @type {number}
     * @memberof MyPayout
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof MyPayout
     */
    date: string;
}
/**
 * 
 * @export
 * @interface MyStoreListingItem
 */
export interface MyStoreListingItem {
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MyStoreListingItem
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {WearWithAiListingMediaItem}
     * @memberof MyStoreListingItem
     */
    defaultWearWithAiMedia?: WearWithAiListingMediaItem;
    /**
     * 
     * @type {Array<WearWithAiListingMediaItem>}
     * @memberof MyStoreListingItem
     */
    extraWearWithAiMedias?: Array<WearWithAiListingMediaItem>;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof MyStoreListingItem
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MyStoreListingItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    status?: MyStoreListingItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof MyStoreListingItem
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof MyStoreListingItem
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {CreateStoreListingRequestWeight}
     * @memberof MyStoreListingItem
     */
    weight?: CreateStoreListingRequestWeight;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof MyStoreListingItem
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof MyStoreListingItem
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof MyStoreListingItem
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof MyStoreListingItem
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof MyStoreListingItem
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    isLandingEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MyStoreListingItem
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    type?: MyStoreListingItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof MyStoreListingItem
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    moderationStatus?: MyStoreListingItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof MyStoreListingItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof MyStoreListingItem
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    isEligibleForWearMe?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    externalProductCtaText?: string;
    /**
     * 
     * @type {object}
     * @memberof MyStoreListingItem
     */
    extra?: object;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof MyStoreListingItem
     */
    metadata: Metadata;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    isLive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    externalId?: string;
    /**
     * 
     * @type {Relations}
     * @memberof MyStoreListingItem
     */
    relations?: Relations;
}


/**
 * @export
 */
export const MyStoreListingItemStatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;
export type MyStoreListingItemStatusEnum = typeof MyStoreListingItemStatusEnum[keyof typeof MyStoreListingItemStatusEnum];

/**
 * @export
 */
export const MyStoreListingItemTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type MyStoreListingItemTypeEnum = typeof MyStoreListingItemTypeEnum[keyof typeof MyStoreListingItemTypeEnum];

/**
 * @export
 */
export const MyStoreListingItemModerationStatusEnum = {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    ReviewRequired: 'ReviewRequired'
} as const;
export type MyStoreListingItemModerationStatusEnum = typeof MyStoreListingItemModerationStatusEnum[keyof typeof MyStoreListingItemModerationStatusEnum];

/**
 * 
 * @export
 * @interface MyStoreListingPageRows
 */
export interface MyStoreListingPageRows {
    /**
     * 
     * @type {Array<MyStoreListingItem>}
     * @memberof MyStoreListingPageRows
     */
    rows: Array<MyStoreListingItem>;
}
/**
 * 
 * @export
 * @interface MyStoreListingSearchResponse
 */
export interface MyStoreListingSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof MyStoreListingSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof MyStoreListingSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {MyStoreListingPageRows}
     * @memberof MyStoreListingSearchResponse
     */
    data: MyStoreListingPageRows;
}
/**
 * 
 * @export
 * @interface MySubscriptionDetails
 */
export interface MySubscriptionDetails {
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    id: string;
    /**
     * 
     * @type {Array<SubscriptionPlan>}
     * @memberof MySubscriptionDetails
     */
    plans: Array<SubscriptionPlan>;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    status: MySubscriptionDetailsStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    collectionMethod: string;
    /**
     * 
     * @type {number}
     * @memberof MySubscriptionDetails
     */
    discountedPrice: number;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    initialStartDate: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    currentPeriodStart: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    currentPeriodEnd: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    cancelledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    cancellationAppliedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    lastInvoiceId: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    defaultPaymentMethod: string;
    /**
     * 
     * @type {boolean}
     * @memberof MySubscriptionDetails
     */
    cancelAtPeriodEnd?: boolean;
    /**
     * 
     * @type {PaymentMethodAddress}
     * @memberof MySubscriptionDetails
     */
    address?: PaymentMethodAddress;
    /**
     * 
     * @type {CouponDetailItem}
     * @memberof MySubscriptionDetails
     */
    coupon?: CouponDetailItem;
    /**
     * 
     * @type {SubscriptionRetentionOfferItem}
     * @memberof MySubscriptionDetails
     */
    retentionOffer?: SubscriptionRetentionOfferItem;
    /**
     * 
     * @type {number}
     * @memberof MySubscriptionDetails
     */
    taxAmount: number;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    trialEnd?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MySubscriptionDetails
     */
    isOnPaidTrial?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MySubscriptionDetails
     */
    isOnFreeTrial?: boolean;
    /**
     * 
     * @type {SubscriptionInvoiceItem}
     * @memberof MySubscriptionDetails
     */
    invoices?: SubscriptionInvoiceItem;
    /**
     * 
     * @type {Array<SaasSubscriptionRefundItem>}
     * @memberof MySubscriptionDetails
     */
    refunds?: Array<SaasSubscriptionRefundItem>;
    /**
     * 
     * @type {SaasInvoicePaymentMethodDetailsItem}
     * @memberof MySubscriptionDetails
     */
    paymentMethodDetails?: SaasInvoicePaymentMethodDetailsItem;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    nextPaymentAttempt?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MySubscriptionDetails
     */
    isNoCreditCardTrial?: boolean;
}


/**
 * @export
 */
export const MySubscriptionDetailsStatusEnum = {
    Active: 'active',
    Canceled: 'canceled',
    Incomplete: 'incomplete',
    IncompleteExpired: 'incomplete_expired',
    Trialing: 'trialing',
    PastDue: 'past_due',
    Unpaid: 'unpaid',
    Paused: 'paused'
} as const;
export type MySubscriptionDetailsStatusEnum = typeof MySubscriptionDetailsStatusEnum[keyof typeof MySubscriptionDetailsStatusEnum];

/**
 * 
 * @export
 * @interface NormalSendItemItem
 */
export interface NormalSendItemItem {
    /**
     * 
     * @type {ProfileItem}
     * @memberof NormalSendItemItem
     */
    fromUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    fromUserId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof NormalSendItemItem
     */
    toUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof NormalSendItemItem
     */
    listing: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    variantId?: string;
    /**
     * 
     * @type {number}
     * @memberof NormalSendItemItem
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    status: NormalSendItemItemStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof NormalSendItemItem
     */
    needShippingFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof NormalSendItemItem
     */
    quantity: number;
    /**
     * 
     * @type {LiveStreamAuctionItem}
     * @memberof NormalSendItemItem
     */
    liveStreamAuction: LiveStreamAuctionItem;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    type: NormalSendItemItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    liveStreamId: string;
}


/**
 * @export
 */
export const NormalSendItemItemStatusEnum = {
    Processing: 'PROCESSING',
    Canceled: 'CANCELED',
    Confirmed: 'CONFIRMED',
    Rejected: ' REJECTED'
} as const;
export type NormalSendItemItemStatusEnum = typeof NormalSendItemItemStatusEnum[keyof typeof NormalSendItemItemStatusEnum];

/**
 * @export
 */
export const NormalSendItemItemTypeEnum = {
    Normal: 'normal'
} as const;
export type NormalSendItemItemTypeEnum = typeof NormalSendItemItemTypeEnum[keyof typeof NormalSendItemItemTypeEnum];

/**
 * 
 * @export
 * @interface OAuth2AuthRequest
 */
export interface OAuth2AuthRequest {
    /**
     * 
     * @type {string}
     * @memberof OAuth2AuthRequest
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2AuthRequest
     */
    redirectUri: string;
}
/**
 * 
 * @export
 * @interface OneTimeLoginCodeDto
 */
export interface OneTimeLoginCodeDto {
    /**
     * 
     * @type {string}
     * @memberof OneTimeLoginCodeDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof OneTimeLoginCodeDto
     */
    signature: string;
}
/**
 * 
 * @export
 * @interface OnlyApplyToListingsItem
 */
export interface OnlyApplyToListingsItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof OnlyApplyToListingsItem
     */
    listingIds: Array<string>;
}
/**
 * 
 * @export
 * @interface OnlyAssignToUserItem
 */
export interface OnlyAssignToUserItem {
    /**
     * 
     * @type {boolean}
     * @memberof OnlyAssignToUserItem
     */
    enabled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnlyAssignToUserItem
     */
    userIds: Array<string>;
}
/**
 * 
 * @export
 * @interface OrderCalendarEventItem
 */
export interface OrderCalendarEventItem {
    /**
     * 
     * @type {string}
     * @memberof OrderCalendarEventItem
     */
    eventId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderCalendarEventItem
     */
    calendarId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderCalendarEventItem
     */
    meetingUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderCalendarEventItem
     */
    rescheduleCount?: number;
}
/**
 * 
 * @export
 * @interface OrderChargeDistributionDropshipAmountsItem
 */
export interface OrderChargeDistributionDropshipAmountsItem {
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    costAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    soldAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    subtotalPaidByPopshop?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    subtotalPaidBySeller?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    managementFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    freeShippingDiscountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    shippingFeePaidByPopshop?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    shippingFeePaidBySeller?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    supplierWithdrawableAmount: number;
}
/**
 * 
 * @export
 * @interface OrderChargeDistributionItem
 */
export interface OrderChargeDistributionItem {
    /**
     * 
     * @type {CommissionFeeTypeEnumItem}
     * @memberof OrderChargeDistributionItem
     */
    commissionFeeType?: CommissionFeeTypeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    commissionFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    commissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    gatewayProcessingFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    gatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    sellerWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    salesTaxRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    couponSellerGotAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    bonus: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    couponDiscountProductAmount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderChargeDistributionItem
     */
    shippingFeePayer?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    popshopShippingFee?: number;
    /**
     * 
     * @type {OrderChargeDistributionDropshipAmountsItem}
     * @memberof OrderChargeDistributionItem
     */
    dropshipAmounts?: OrderChargeDistributionDropshipAmountsItem;
}


/**
 * 
 * @export
 * @interface OrderCompositionCancellationStatus
 */
export interface OrderCompositionCancellationStatus {
    /**
     * 
     * @type {boolean}
     * @memberof OrderCompositionCancellationStatus
     */
    allCancelled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderCompositionCancellationStatus
     */
    noneCancelled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderCompositionCancellationStatus
     */
    partiallyCancelled: boolean;
}
/**
 * 
 * @export
 * @interface OrderDetailWithRefundItem
 */
export interface OrderDetailWithRefundItem {
    /**
     * 
     * @type {OrderItemWithId}
     * @memberof OrderDetailWithRefundItem
     */
    order: OrderItemWithId;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDetailWithRefundItem
     */
    refundStatus: Array<OrderDetailWithRefundItemRefundStatusEnum>;
    /**
     * 
     * @type {number}
     * @memberof OrderDetailWithRefundItem
     */
    quantity: number;
}


/**
 * @export
 */
export const OrderDetailWithRefundItemRefundStatusEnum = {
    PartiallyRefunded: 'PartiallyRefunded',
    Refunded: 'Refunded',
    Canceled: 'Canceled'
} as const;
export type OrderDetailWithRefundItemRefundStatusEnum = typeof OrderDetailWithRefundItemRefundStatusEnum[keyof typeof OrderDetailWithRefundItemRefundStatusEnum];


/**
 * 
 * @export
 */
export const OrderEnumItem = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type OrderEnumItem = typeof OrderEnumItem[keyof typeof OrderEnumItem];

/**
 * 
 * @export
 * @interface OrderGiftPackageItem
 */
export interface OrderGiftPackageItem {
    /**
     * 
     * @type {boolean}
     * @memberof OrderGiftPackageItem
     */
    isGiftPackage: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderGiftPackageItem
     */
    giftMessage?: string;
}
/**
 * 
 * @export
 * @interface OrderGiftingItem
 */
export interface OrderGiftingItem {
    /**
     * 
     * @type {string}
     * @memberof OrderGiftingItem
     */
    recipientId: string;
    /**
     * 
     * @type {RecipientItem}
     * @memberof OrderGiftingItem
     */
    recipient: RecipientItem;
    /**
     * 
     * @type {string}
     * @memberof OrderGiftingItem
     */
    status: OrderGiftingItemStatusEnum;
}


/**
 * @export
 */
export const OrderGiftingItemStatusEnum = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED'
} as const;
export type OrderGiftingItemStatusEnum = typeof OrderGiftingItemStatusEnum[keyof typeof OrderGiftingItemStatusEnum];

/**
 * 
 * @export
 * @interface OrderGroupEventDto
 */
export interface OrderGroupEventDto {
    /**
     * 
     * @type {string}
     * @memberof OrderGroupEventDto
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof OrderGroupEventDto
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof OrderGroupEventDto
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof OrderGroupEventDto
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderGroupEventDto
     */
    groupEventId: string;
}
/**
 * 
 * @export
 * @interface OrderItemDropshipDetails
 */
export interface OrderItemDropshipDetails {
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemDropshipDetails
     */
    isDropship: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDropshipDetails
     */
    partnerId: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDropshipDetails
     */
    supplierId: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDropshipDetails
     */
    commentSoldProductId: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDropshipDetails
     */
    commentSoldVariantId: number;
}
/**
 * 
 * @export
 * @interface OrderItemPackageTemplate
 */
export interface OrderItemPackageTemplate {
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    type: OrderItemPackageTemplateTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemPackageTemplate
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    imageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPackageTemplate
     */
    shippingPrice: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    shippingCost: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    carrierId: string;
    /**
     * 
     * @type {ShippoCarrier}
     * @memberof OrderItemPackageTemplate
     */
    carrier: ShippoCarrier;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    parcelTemplateId: string;
    /**
     * 
     * @type {ShippoCarrierParcelTemplate}
     * @memberof OrderItemPackageTemplate
     */
    parcelTemplate: ShippoCarrierParcelTemplate;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPackageTemplate
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPackageTemplate
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPackageTemplate
     */
    depth: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    distanceUnit: OrderItemPackageTemplateDistanceUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPackageTemplate
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    massUnit: OrderItemPackageTemplateMassUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    signatureConfirmationId: string;
    /**
     * 
     * @type {ShippoCarrierSignatureConfirmation}
     * @memberof OrderItemPackageTemplate
     */
    signatureConfirmation: ShippoCarrierSignatureConfirmation;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    serviceLevelId: string;
    /**
     * 
     * @type {ShippoCarrierServiceLevel}
     * @memberof OrderItemPackageTemplate
     */
    serviceLevel: ShippoCarrierServiceLevel;
}


/**
 * @export
 */
export const OrderItemPackageTemplateTypeEnum = {
    Custom: 'CUSTOM',
    Preset: 'PRESET',
    Global: 'GLOBAL',
    SellerCustom: 'SELLER_CUSTOM',
    SellerArrangeMyOwn: 'SELLER_ARRANGE_MY_OWN'
} as const;
export type OrderItemPackageTemplateTypeEnum = typeof OrderItemPackageTemplateTypeEnum[keyof typeof OrderItemPackageTemplateTypeEnum];

/**
 * @export
 */
export const OrderItemPackageTemplateDistanceUnitEnum = {
    Cm: 'cm',
    In: 'in',
    Ft: 'ft',
    M: 'm',
    Mm: 'mm',
    Yd: 'yd'
} as const;
export type OrderItemPackageTemplateDistanceUnitEnum = typeof OrderItemPackageTemplateDistanceUnitEnum[keyof typeof OrderItemPackageTemplateDistanceUnitEnum];

/**
 * @export
 */
export const OrderItemPackageTemplateMassUnitEnum = {
    G: 'g',
    Kg: 'kg',
    Lb: 'lb',
    Oz: 'oz'
} as const;
export type OrderItemPackageTemplateMassUnitEnum = typeof OrderItemPackageTemplateMassUnitEnum[keyof typeof OrderItemPackageTemplateMassUnitEnum];

/**
 * 
 * @export
 * @interface OrderItemPresetShippingCost
 */
export interface OrderItemPresetShippingCost {
    /**
     * 
     * @type {string}
     * @memberof OrderItemPresetShippingCost
     */
    status: OrderItemPresetShippingCostStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPresetShippingCost
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPresetShippingCost
     */
    shippoShipmentId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPresetShippingCost
     */
    shippoRateId: string;
    /**
     * 
     * @type {ShippoRate}
     * @memberof OrderItemPresetShippingCost
     */
    shippoRate: ShippoRate;
}


/**
 * @export
 */
export const OrderItemPresetShippingCostStatusEnum = {
    Pending: 'pending',
    Failed: 'failed',
    Success: 'success'
} as const;
export type OrderItemPresetShippingCostStatusEnum = typeof OrderItemPresetShippingCostStatusEnum[keyof typeof OrderItemPresetShippingCostStatusEnum];

/**
 * 
 * @export
 * @interface OrderItemPriceComponents
 */
export interface OrderItemPriceComponents {
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemPriceComponents
     */
    shippingFeeTaxable: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    salesTaxRate: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    salesTaxRecipient?: OrderItemPriceComponentsSalesTaxRecipientEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    sellerGotWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    listingPrice: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    listingOriginPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    listingPriceSource?: OrderItemPriceComponentsListingPriceSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    listingQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {CommissionFeeTypeEnumItem}
     * @memberof OrderItemPriceComponents
     */
    commissionFeeType?: CommissionFeeTypeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    commissionFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    eventExtraCommissionFeeRate?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    baseCommissionFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    commissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    gatewayProcessingFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    gatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    shipmentDiscountedShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    shipmentOriginShippingFee: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    shipmentShippingMethod: OrderItemPriceComponentsShipmentShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    shipmentShippingFeePayer: OrderItemPriceComponentsShipmentShippingFeePayerEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    couponDiscountProductAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    couponDiscountShippingFeeAmount: number;
    /**
     * 
     * @type {Array<OrderItemPriceComponentsCouponItem>}
     * @memberof OrderItemPriceComponents
     */
    coupons?: Array<OrderItemPriceComponentsCouponItem>;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    paymentProvider: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    couponSellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    popshopShippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    popshopShippingFeeSource?: OrderItemPriceComponentsPopshopShippingFeeSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    sellerShippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    sellerShippingFeeSource?: OrderItemPriceComponentsSellerShippingFeeSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    referralGiftingDiscountSubtotal?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    referralGiftingDiscountShippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    referralGiftingDiscountSalesTaxAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    shippingIntegrationType?: OrderItemPriceComponentsShippingIntegrationTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemPriceComponents
     */
    useArrangeMyOwnShippingV2?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    shippingMarginRate?: number;
    /**
     * 
     * @type {RichShippingCostItem}
     * @memberof OrderItemPriceComponents
     */
    defaultShippingCost?: RichShippingCostItem;
    /**
     * 
     * @type {RichShippingCostItem}
     * @memberof OrderItemPriceComponents
     */
    userSelectedShippingCost?: RichShippingCostItem;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    shippingSurcharge?: number;
    /**
     * 
     * @type {DropshipAmountsItem}
     * @memberof OrderItemPriceComponents
     */
    dropshipAmounts?: DropshipAmountsItem;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    subtotal?: number;
}


/**
 * @export
 */
export const OrderItemPriceComponentsSalesTaxRecipientEnum = {
    Seller: 'seller',
    Popshop: 'popshop'
} as const;
export type OrderItemPriceComponentsSalesTaxRecipientEnum = typeof OrderItemPriceComponentsSalesTaxRecipientEnum[keyof typeof OrderItemPriceComponentsSalesTaxRecipientEnum];

/**
 * @export
 */
export const OrderItemPriceComponentsListingPriceSourceEnum = {
    Listing: 'LISTING',
    Variant: 'VARIANT'
} as const;
export type OrderItemPriceComponentsListingPriceSourceEnum = typeof OrderItemPriceComponentsListingPriceSourceEnum[keyof typeof OrderItemPriceComponentsListingPriceSourceEnum];

/**
 * @export
 */
export const OrderItemPriceComponentsShipmentShippingMethodEnum = {
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide',
    Pickup: 'pickup',
    DropshipSupplierProvide: 'dropshipSupplierProvide'
} as const;
export type OrderItemPriceComponentsShipmentShippingMethodEnum = typeof OrderItemPriceComponentsShipmentShippingMethodEnum[keyof typeof OrderItemPriceComponentsShipmentShippingMethodEnum];

/**
 * @export
 */
export const OrderItemPriceComponentsShipmentShippingFeePayerEnum = {
    Buyer: 'Buyer',
    Seller: 'Seller',
    Popshop: 'Popshop'
} as const;
export type OrderItemPriceComponentsShipmentShippingFeePayerEnum = typeof OrderItemPriceComponentsShipmentShippingFeePayerEnum[keyof typeof OrderItemPriceComponentsShipmentShippingFeePayerEnum];

/**
 * @export
 */
export const OrderItemPriceComponentsPopshopShippingFeeSourceEnum = {
    Default: 'DEFAULT',
    ReadonlyProfile: 'READONLY_PROFILE',
    ReadonlyProfileShippingPrice: 'READONLY_PROFILE_SHIPPING_PRICE',
    ShowEvent: 'SHOW_EVENT',
    Config: 'CONFIG',
    ShippoPlatform: 'SHIPPO_PLATFORM',
    PackageTemplate: 'PACKAGE_TEMPLATE'
} as const;
export type OrderItemPriceComponentsPopshopShippingFeeSourceEnum = typeof OrderItemPriceComponentsPopshopShippingFeeSourceEnum[keyof typeof OrderItemPriceComponentsPopshopShippingFeeSourceEnum];

/**
 * @export
 */
export const OrderItemPriceComponentsSellerShippingFeeSourceEnum = {
    Store: 'STORE',
    Listing: 'LISTING',
    PackageTemplate: 'PACKAGE_TEMPLATE'
} as const;
export type OrderItemPriceComponentsSellerShippingFeeSourceEnum = typeof OrderItemPriceComponentsSellerShippingFeeSourceEnum[keyof typeof OrderItemPriceComponentsSellerShippingFeeSourceEnum];

/**
 * @export
 */
export const OrderItemPriceComponentsShippingIntegrationTypeEnum = {
    Shippo: 'shippo',
    ShippoPlatform: 'shippo_platform'
} as const;
export type OrderItemPriceComponentsShippingIntegrationTypeEnum = typeof OrderItemPriceComponentsShippingIntegrationTypeEnum[keyof typeof OrderItemPriceComponentsShippingIntegrationTypeEnum];

/**
 * 
 * @export
 * @interface OrderItemPriceComponentsCouponItem
 */
export interface OrderItemPriceComponentsCouponItem {
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponentsCouponItem
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponentsCouponItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponentsCouponItem
     */
    discountedAmount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponentsCouponItem
     */
    discountPublisher: OrderItemPriceComponentsCouponItemDiscountPublisherEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponentsCouponItem
     */
    type: OrderItemPriceComponentsCouponItemTypeEnum;
}


/**
 * @export
 */
export const OrderItemPriceComponentsCouponItemDiscountPublisherEnum = {
    Popshop: 'popshop',
    Seller: 'seller'
} as const;
export type OrderItemPriceComponentsCouponItemDiscountPublisherEnum = typeof OrderItemPriceComponentsCouponItemDiscountPublisherEnum[keyof typeof OrderItemPriceComponentsCouponItemDiscountPublisherEnum];

/**
 * @export
 */
export const OrderItemPriceComponentsCouponItemTypeEnum = {
    DiscountPercent: 'discountPercent',
    DiscountAmount: 'discountAmount',
    FreeShipping: 'freeShipping'
} as const;
export type OrderItemPriceComponentsCouponItemTypeEnum = typeof OrderItemPriceComponentsCouponItemTypeEnum[keyof typeof OrderItemPriceComponentsCouponItemTypeEnum];

/**
 * 
 * @export
 * @interface OrderItemWithId
 */
export interface OrderItemWithId {
    /**
     * 
     * @type {CommentSoldOrderItem}
     * @memberof OrderItemWithId
     */
    commentSold?: CommentSoldOrderItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     * @deprecated
     */
    buyerName: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    shippingFeeAdjusted: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemWithId
     */
    braintreeShippingFeeRefunded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    buyerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof OrderItemWithId
     */
    buyer: OrderProfileItem;
    /**
     * 
     * @type {OrderGiftingItem}
     * @memberof OrderItemWithId
     */
    gifting?: OrderGiftingItem;
    /**
     * 
     * @type {OrderGiftPackageItem}
     * @memberof OrderItemWithId
     */
    giftPackage?: OrderGiftPackageItem;
    /**
     * 
     * @type {ShipmentItem}
     * @memberof OrderItemWithId
     */
    shipment?: ShipmentItem;
    /**
     * 
     * @type {PackingSlipItem}
     * @memberof OrderItemWithId
     */
    packingSlip?: PackingSlipItem;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    refund?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    userAgent?: string;
    /**
     * 
     * @type {OrderPaymentItem}
     * @memberof OrderItemWithId
     */
    orderPayment?: OrderPaymentItem;
    /**
     * 
     * @type {PaymentItem}
     * @memberof OrderItemWithId
     */
    payment?: PaymentItem;
    /**
     * 
     * @type {Array<RedeemedCouponItem>}
     * @memberof OrderItemWithId
     */
    coupons?: Array<RedeemedCouponItem>;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    couponDiscountProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    couponDiscountShippingFeeAmount?: number;
    /**
     * 
     * @type {SellerTrackingInfoItem}
     * @memberof OrderItemWithId
     */
    sellerTrackingInfo?: SellerTrackingInfoItem;
    /**
     * 
     * @type {Array<SellerTrackingInfoItem>}
     * @memberof OrderItemWithId
     */
    sellerTrackingInfoHistory?: Array<SellerTrackingInfoItem>;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    bonus?: number;
    /**
     * 
     * @type {AddressItem}
     * @memberof OrderItemWithId
     */
    shippingAddress: AddressItem;
    /**
     * 
     * @type {PickupAddressItem}
     * @memberof OrderItemWithId
     */
    pickupAddress?: PickupAddressItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof OrderItemWithId
     */
    listingSnapshot: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    sendItemId?: string;
    /**
     * 
     * @type {CreateOrderResponseSendItem}
     * @memberof OrderItemWithId
     */
    sendItem?: CreateOrderResponseSendItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    sellerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof OrderItemWithId
     */
    seller: OrderProfileItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    status: OrderItemWithIdStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    orderGroupStatus: OrderItemWithIdOrderGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    pickupStatus?: OrderItemWithIdPickupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    cancelStatus?: OrderItemWithIdCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    orderGroupCancelStatus?: OrderItemWithIdOrderGroupCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    orderRefundStatus?: OrderItemWithIdOrderRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    orderGroupRefundStatus?: OrderItemWithIdOrderGroupRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    shippingMethod: OrderItemWithIdShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    shippoOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    variantId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof OrderItemWithId
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {OrderShipmentGroupStatus}
     * @memberof OrderItemWithId
     */
    orderShipmentGroupStatus: OrderShipmentGroupStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof OrderItemWithId
     */
    shippingLabelStatus: ShippingLabelStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof OrderItemWithId
     */
    packingSlipStatus: ShippingLabelStatus;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    masterOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    planTimeOfShippingLabelGeneration?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    totalQuantitiesIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    totalPriceIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    totalPriceIncludeSlaveOrdersWithProductCoupon: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    totalRefundIncludeSlaveOrders?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemWithId
     */
    newCustomer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    firstPurchaseAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    updatedAt?: string;
    /**
     * 
     * @type {OrderCompositionCancellationStatus}
     * @memberof OrderItemWithId
     */
    orderCompositionCancellationStatus?: OrderCompositionCancellationStatus;
    /**
     * 
     * @type {OrderChargeDistributionItem}
     * @memberof OrderItemWithId
     */
    orderChargeDistribution?: OrderChargeDistributionItem;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemWithId
     */
    packed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    pickupNotifiedAt?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof OrderItemWithId
     */
    source?: OrderSource;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof OrderItemWithId
     */
    shipmentParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof OrderItemWithId
     */
    shipmentOriginalParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    shipmentOriginalParcelSource?: OrderItemWithIdShipmentOriginalParcelSourceEnum;
    /**
     * 
     * @type {OrderItemPriceComponents}
     * @memberof OrderItemWithId
     */
    priceComponents?: OrderItemPriceComponents;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof OrderItemWithId
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    packageTemplateId?: string;
    /**
     * 
     * @type {OrderItemPackageTemplate}
     * @memberof OrderItemWithId
     */
    packageTemplate?: OrderItemPackageTemplate;
    /**
     * 
     * @type {OrderItemPresetShippingCost}
     * @memberof OrderItemWithId
     */
    presetShippingCost?: OrderItemPresetShippingCost;
    /**
     * 
     * @type {OrderItemDropshipDetails}
     * @memberof OrderItemWithId
     */
    dropshipDetails?: OrderItemDropshipDetails;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    fundAvailableDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    fundAvailableDate2?: string;
    /**
     * 
     * @type {LabelShippingCost}
     * @memberof OrderItemWithId
     */
    labelShippingCost?: LabelShippingCost;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    totalRefundedSalesTax?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    paymentExpireAt?: string;
    /**
     * 
     * @type {MultiCurrencyOrderItem}
     * @memberof OrderItemWithId
     */
    buyerCurrencyOrderDetails?: MultiCurrencyOrderItem;
    /**
     * 
     * @type {OrderCalendarEventItem}
     * @memberof OrderItemWithId
     */
    calendarEvent?: OrderCalendarEventItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    id: string;
}


/**
 * @export
 */
export const OrderItemWithIdStatusEnum = {
    Created: 'created',
    Completed: 'completed',
    Canceled: 'canceled',
    PendingPayment: 'pendingPayment',
    ProcessingPayment: 'processingPayment',
    Closed: 'closed'
} as const;
export type OrderItemWithIdStatusEnum = typeof OrderItemWithIdStatusEnum[keyof typeof OrderItemWithIdStatusEnum];

/**
 * @export
 */
export const OrderItemWithIdOrderGroupStatusEnum = {
    Open: 'open',
    Processing: 'processing',
    Fulfilling: 'fulfilling',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type OrderItemWithIdOrderGroupStatusEnum = typeof OrderItemWithIdOrderGroupStatusEnum[keyof typeof OrderItemWithIdOrderGroupStatusEnum];

/**
 * @export
 */
export const OrderItemWithIdPickupStatusEnum = {
    Open: 'open',
    New: 'new',
    Processing: 'processing',
    Pending: 'pending',
    Packed: 'packed',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type OrderItemWithIdPickupStatusEnum = typeof OrderItemWithIdPickupStatusEnum[keyof typeof OrderItemWithIdPickupStatusEnum];

/**
 * @export
 */
export const OrderItemWithIdCancelStatusEnum = {
    SellerApplied: 'seller_applied',
    AdminApproved: 'admin_approved'
} as const;
export type OrderItemWithIdCancelStatusEnum = typeof OrderItemWithIdCancelStatusEnum[keyof typeof OrderItemWithIdCancelStatusEnum];

/**
 * @export
 */
export const OrderItemWithIdOrderGroupCancelStatusEnum = {
    PartialCanceled: 'PARTIAL_CANCELED',
    FullyCanceled: 'FULLY_CANCELED'
} as const;
export type OrderItemWithIdOrderGroupCancelStatusEnum = typeof OrderItemWithIdOrderGroupCancelStatusEnum[keyof typeof OrderItemWithIdOrderGroupCancelStatusEnum];

/**
 * @export
 */
export const OrderItemWithIdOrderRefundStatusEnum = {
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED'
} as const;
export type OrderItemWithIdOrderRefundStatusEnum = typeof OrderItemWithIdOrderRefundStatusEnum[keyof typeof OrderItemWithIdOrderRefundStatusEnum];

/**
 * @export
 */
export const OrderItemWithIdOrderGroupRefundStatusEnum = {
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED'
} as const;
export type OrderItemWithIdOrderGroupRefundStatusEnum = typeof OrderItemWithIdOrderGroupRefundStatusEnum[keyof typeof OrderItemWithIdOrderGroupRefundStatusEnum];

/**
 * @export
 */
export const OrderItemWithIdShippingMethodEnum = {
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide',
    Pickup: 'pickup',
    DropshipSupplierProvide: 'dropshipSupplierProvide'
} as const;
export type OrderItemWithIdShippingMethodEnum = typeof OrderItemWithIdShippingMethodEnum[keyof typeof OrderItemWithIdShippingMethodEnum];

/**
 * @export
 */
export const OrderItemWithIdShipmentOriginalParcelSourceEnum = {
    Default: 'DEFAULT',
    ShowEvent: 'SHOW_EVENT'
} as const;
export type OrderItemWithIdShipmentOriginalParcelSourceEnum = typeof OrderItemWithIdShipmentOriginalParcelSourceEnum[keyof typeof OrderItemWithIdShipmentOriginalParcelSourceEnum];

/**
 * 
 * @export
 * @interface OrderMeetingSlotDto
 */
export interface OrderMeetingSlotDto {
    /**
     * 
     * @type {string}
     * @memberof OrderMeetingSlotDto
     */
    startTime: string;
    /**
     * 
     * @type {MeetingDurationEnumItem}
     * @memberof OrderMeetingSlotDto
     */
    duration: MeetingDurationEnumItem;
    /**
     * 
     * @type {string}
     * @memberof OrderMeetingSlotDto
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof OrderMeetingSlotDto
     */
    meetingTypeId: string;
}


/**
 * 
 * @export
 * @interface OrderPageRows
 */
export interface OrderPageRows {
    /**
     * 
     * @type {Array<RichOrderItem>}
     * @memberof OrderPageRows
     */
    rows: Array<RichOrderItem>;
}
/**
 * 
 * @export
 * @interface OrderPaymentItem
 */
export interface OrderPaymentItem {
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    braintreeId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    nonce?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    creditCardId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    paymentType: OrderPaymentItemPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    status: OrderPaymentItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    braintreeStatus?: string;
    /**
     * 
     * @type {BraintreeTransactionItem}
     * @memberof OrderPaymentItem
     */
    transaction?: BraintreeTransactionItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderPaymentItem
     * @deprecated
     */
    refundTransactions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    createdAt: string;
}


/**
 * @export
 */
export const OrderPaymentItemPaymentTypeEnum = {
    Credit: 'credit',
    Applepay: 'applepay',
    Empty: 'empty'
} as const;
export type OrderPaymentItemPaymentTypeEnum = typeof OrderPaymentItemPaymentTypeEnum[keyof typeof OrderPaymentItemPaymentTypeEnum];

/**
 * @export
 */
export const OrderPaymentItemStatusEnum = {
    Approved: 'approved',
    Rejected: 'rejected'
} as const;
export type OrderPaymentItemStatusEnum = typeof OrderPaymentItemStatusEnum[keyof typeof OrderPaymentItemStatusEnum];

/**
 * 
 * @export
 * @interface OrderProfileItem
 */
export interface OrderProfileItem {
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     * @deprecated
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OrderProfileItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    storeType?: OrderProfileItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof OrderProfileItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof OrderProfileItem
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {PopStoreCreatorBusinessTypeEnumItem}
     * @memberof OrderProfileItem
     */
    businessType?: PopStoreCreatorBusinessTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    email: string;
}


/**
 * @export
 */
export const OrderProfileItemStoreTypeEnum = {
    Business: 'Business',
    Creator: 'Creator',
    CommentChat: 'CommentChat',
    Vfs: 'VFS'
} as const;
export type OrderProfileItemStoreTypeEnum = typeof OrderProfileItemStoreTypeEnum[keyof typeof OrderProfileItemStoreTypeEnum];

/**
 * 
 * @export
 * @interface OrderRefund
 */
export interface OrderRefund {
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    createdAt: string;
    /**
     * 
     * @type {OrderRefundDetail}
     * @memberof OrderRefund
     */
    detail: OrderRefundDetail;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderRefund
     */
    types: Array<OrderRefundTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    updatedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefund
     */
    shouldDeductProcessingAmount?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefund
     */
    shouldRestock?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefund
     */
    shouldFullyRefund?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    reason?: string;
    /**
     * 
     * @type {DropshipSupplierItem}
     * @memberof OrderRefund
     */
    dropshipSupplier: DropshipSupplierItem;
}


/**
 * @export
 */
export const OrderRefundTypesEnum = {
    All: 'all',
    ShippingFee: 'shippingFee',
    Listing: 'listing',
    CustomAmount: 'customAmount',
    Cancel: 'cancel',
    CancelListing: 'cancelListing'
} as const;
export type OrderRefundTypesEnum = typeof OrderRefundTypesEnum[keyof typeof OrderRefundTypesEnum];

/**
 * 
 * @export
 * @interface OrderRefundDetail
 */
export interface OrderRefundDetail {
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    listingDiscountedSubTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    listingQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    subtotal: number;
    /**
     * 
     * @type {string}
     * @memberof OrderRefundDetail
     */
    processingFeePayer: OrderRefundDetailProcessingFeePayerEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    deductProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    shipmentDiscountedShippingFee: number;
}


/**
 * @export
 */
export const OrderRefundDetailProcessingFeePayerEnum = {
    Seller: 'SELLER',
    Popshop: 'POPSHOP'
} as const;
export type OrderRefundDetailProcessingFeePayerEnum = typeof OrderRefundDetailProcessingFeePayerEnum[keyof typeof OrderRefundDetailProcessingFeePayerEnum];

/**
 * 
 * @export
 * @interface OrderShipmentGroupStatus
 */
export interface OrderShipmentGroupStatus {
    /**
     * 
     * @type {boolean}
     * @memberof OrderShipmentGroupStatus
     */
    master: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderShipmentGroupStatus
     */
    slave: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderShipmentGroupStatus
     */
    customer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderShipmentGroupStatus
     */
    legacy: boolean;
}
/**
 * 
 * @export
 * @interface OrderShipmentParcel
 */
export interface OrderShipmentParcel {
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    distance_unit: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    height: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    length: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    mass_unit: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    weight: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    width: string;
}
/**
 * 
 * @export
 * @interface OrderSource
 */
export interface OrderSource {
    /**
     * 
     * @type {string}
     * @memberof OrderSource
     */
    type?: OrderSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderSource
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSource
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSource
     */
    storeId?: string;
}


/**
 * @export
 */
export const OrderSourceTypeEnum = {
    UpcomingShow: 'UPCOMING_SHOW',
    LiveStream: 'LIVE_STREAM',
    Store: 'STORE',
    TwoWayStream: 'TWO_WAY_STREAM',
    ReferralGifting: 'REFERRAL_GIFTING',
    SendItem: 'SEND_ITEM',
    TopProducts: 'TOP_PRODUCTS',
    Shop: 'SHOP',
    Replay: 'REPLAY',
    CommentChat: 'COMMENT_CHAT'
} as const;
export type OrderSourceTypeEnum = typeof OrderSourceTypeEnum[keyof typeof OrderSourceTypeEnum];

/**
 * 
 * @export
 * @interface OrderSummaryPriceAdjustmentItem
 */
export interface OrderSummaryPriceAdjustmentItem {
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    totalAdjustment: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    couponAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    shipmentDiscountedShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    returnedCommissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    returnGatewayProcessingFee: number;
}
/**
 * 
 * @export
 * @interface OrderSummaryPriceCustomerItem
 */
export interface OrderSummaryPriceCustomerItem {
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceCustomerItem
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceCustomerItem
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceCustomerItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceCustomerItem
     */
    couponDiscountAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceCustomerItem
     */
    totalAmount: number;
}
/**
 * 
 * @export
 * @interface OrderSummaryPriceIItemWithCurrency
 */
export interface OrderSummaryPriceIItemWithCurrency {
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    isLegacyOrder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    isLegacyRefund: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    isLegacyOrderDetail: boolean;
    /**
     * 
     * @type {OrderSummaryPriceCustomerItem}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    customer: OrderSummaryPriceCustomerItem;
    /**
     * 
     * @type {OrderSummaryPriceRefundItem}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    refund: OrderSummaryPriceRefundItem;
    /**
     * 
     * @type {OrderSummaryPriceRevenueItem}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    revenue: OrderSummaryPriceRevenueItem;
    /**
     * 
     * @type {string}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    currency: string;
}
/**
 * 
 * @export
 * @interface OrderSummaryPriceItem
 */
export interface OrderSummaryPriceItem {
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceItem
     */
    isLegacyOrder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceItem
     */
    isLegacyRefund: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceItem
     */
    isLegacyOrderDetail: boolean;
    /**
     * 
     * @type {OrderSummaryPriceCustomerItem}
     * @memberof OrderSummaryPriceItem
     */
    customer: OrderSummaryPriceCustomerItem;
    /**
     * 
     * @type {OrderSummaryPriceRefundItem}
     * @memberof OrderSummaryPriceItem
     */
    refund: OrderSummaryPriceRefundItem;
    /**
     * 
     * @type {OrderSummaryPriceRevenueItem}
     * @memberof OrderSummaryPriceItem
     */
    revenue: OrderSummaryPriceRevenueItem;
}
/**
 * 
 * @export
 * @interface OrderSummaryPriceOriginalItem
 */
export interface OrderSummaryPriceOriginalItem {
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    shipmentDiscountedShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    commissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    gatewayProcessingFee: number;
}
/**
 * 
 * @export
 * @interface OrderSummaryPriceRefundItem
 */
export interface OrderSummaryPriceRefundItem {
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceRefundItem
     */
    subtotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceRefundItem
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceRefundItem
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceRefundItem
     */
    shipmentDiscountedShippingFee: number;
}
/**
 * 
 * @export
 * @interface OrderSummaryPriceRevenueItem
 */
export interface OrderSummaryPriceRevenueItem {
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceRevenueItem
     */
    subtotal: number;
    /**
     * 
     * @type {OrderSummaryPriceOriginalItem}
     * @memberof OrderSummaryPriceRevenueItem
     */
    original: OrderSummaryPriceOriginalItem;
    /**
     * 
     * @type {OrderSummaryPriceAdjustmentItem}
     * @memberof OrderSummaryPriceRevenueItem
     */
    adjustment: OrderSummaryPriceAdjustmentItem;
}
/**
 * 
 * @export
 * @interface OrdersDetailWithRefundResponse
 */
export interface OrdersDetailWithRefundResponse {
    /**
     * 
     * @type {string}
     * @memberof OrdersDetailWithRefundResponse
     */
    orderGroupRefundStatus: OrdersDetailWithRefundResponseOrderGroupRefundStatusEnum | null;
    /**
     * 
     * @type {Array<OrderDetailWithRefundItem>}
     * @memberof OrdersDetailWithRefundResponse
     */
    enrichOrders: Array<OrderDetailWithRefundItem>;
    /**
     * 
     * @type {OrderSummaryPriceItem}
     * @memberof OrdersDetailWithRefundResponse
     */
    summaryPrice: OrderSummaryPriceItem;
    /**
     * 
     * @type {OrderSummaryPriceIItemWithCurrency}
     * @memberof OrdersDetailWithRefundResponse
     */
    summaryPriceInCurrency?: OrderSummaryPriceIItemWithCurrency;
}


/**
 * @export
 */
export const OrdersDetailWithRefundResponseOrderGroupRefundStatusEnum = {
    PartiallyRefunded: 'PartiallyRefunded',
    Refunded: 'Refunded',
    Canceled: 'Canceled'
} as const;
export type OrdersDetailWithRefundResponseOrderGroupRefundStatusEnum = typeof OrdersDetailWithRefundResponseOrderGroupRefundStatusEnum[keyof typeof OrdersDetailWithRefundResponseOrderGroupRefundStatusEnum];

/**
 * 
 * @export
 * @interface OrdersSearchResponse
 */
export interface OrdersSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof OrdersSearchResponse
     */
    total: number;
    /**
     * 
     * @type {OrderPageRows}
     * @memberof OrdersSearchResponse
     */
    data: OrderPageRows;
}
/**
 * 
 * @export
 * @interface Outfit
 */
export interface Outfit {
    /**
     * 
     * @type {string}
     * @memberof Outfit
     */
    skinLevel: string;
    /**
     * 
     * @type {string}
     * @memberof Outfit
     */
    avatarType: string;
    /**
     * 
     * @type {string}
     * @memberof Outfit
     */
    outfitId: string;
    /**
     * 
     * @type {string}
     * @memberof Outfit
     */
    outfitName: string;
    /**
     * 
     * @type {string}
     * @memberof Outfit
     */
    outfitThumbnail: string;
    /**
     * 
     * @type {string}
     * @memberof Outfit
     */
    outfitThumbnailCdnUrl: string;
}
/**
 * 
 * @export
 * @interface OutfitV2
 */
export interface OutfitV2 {
    /**
     * 
     * @type {string}
     * @memberof OutfitV2
     */
    avatarType: string;
    /**
     * 
     * @type {string}
     * @memberof OutfitV2
     */
    outfitId: string;
    /**
     * 
     * @type {string}
     * @memberof OutfitV2
     */
    outfitName: string;
    /**
     * 
     * @type {string}
     * @memberof OutfitV2
     */
    outfitThumbnail: string;
}
/**
 * 
 * @export
 * @interface PackingSlipItem
 */
export interface PackingSlipItem {
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItem
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItem
     */
    expires: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItem
     */
    slipUrl: string;
}
/**
 * 
 * @export
 * @interface PaidTrialTax
 */
export interface PaidTrialTax {
    /**
     * 
     * @type {number}
     * @memberof PaidTrialTax
     */
    totalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaidTrialTax
     */
    taxAmount: number;
}
/**
 * 
 * @export
 * @interface PatchLeadFormRequest
 */
export interface PatchLeadFormRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchLeadFormRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchLeadFormRequest
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchLeadFormRequest
     */
    active?: boolean;
    /**
     * 
     * @type {Array<CreateLeadFormRequestQuestionsInner>}
     * @memberof PatchLeadFormRequest
     */
    questions?: Array<CreateLeadFormRequestQuestionsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchLeadFormRequest
     */
    showQuestionsInSequence?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchLeadFormRequest
     */
    autoQualify?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchLeadFormRequest
     */
    minIdealAnswersRequired?: number;
    /**
     * 
     * @type {LeadFormActionOnQualifiedEnumItem}
     * @memberof PatchLeadFormRequest
     */
    actionOnQualified?: LeadFormActionOnQualifiedEnumItem;
    /**
     * 
     * @type {LeadFormActionOnUnqualifiedEnumItem}
     * @memberof PatchLeadFormRequest
     */
    actionOnUnqualified?: LeadFormActionOnUnqualifiedEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PatchLeadFormRequest
     */
    redirectLink?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchLeadFormRequest
     */
    politeMessageTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchLeadFormRequest
     */
    politeMessageHtml?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchLeadFormRequest
     */
    politeMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchLeadFormRequest
     */
    differentLink?: string;
    /**
     * 
     * @type {Array<LeadFormTriggerActionDto>}
     * @memberof PatchLeadFormRequest
     */
    triggerActions?: Array<LeadFormTriggerActionDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchLeadFormRequest
     */
    updateMask: Array<PatchLeadFormRequestUpdateMaskEnum>;
}


/**
 * @export
 */
export const PatchLeadFormRequestUpdateMaskEnum = {
    Title: 'title',
    Description: 'description',
    Active: 'active',
    Questions: 'questions',
    ShowQuestionsInSequence: 'showQuestionsInSequence',
    AutoQualify: 'autoQualify',
    MinIdealAnswersRequired: 'minIdealAnswersRequired',
    ActionOnQualified: 'actionOnQualified',
    ActionOnUnqualified: 'actionOnUnqualified',
    RedirectLink: 'redirectLink',
    PoliteMessageTitle: 'politeMessageTitle',
    PoliteMessageHtml: 'politeMessageHtml',
    PoliteMessage: 'politeMessage',
    DifferentLink: 'differentLink',
    TriggerActions: 'triggerActions'
} as const;
export type PatchLeadFormRequestUpdateMaskEnum = typeof PatchLeadFormRequestUpdateMaskEnum[keyof typeof PatchLeadFormRequestUpdateMaskEnum];

/**
 * 
 * @export
 * @interface PatchSeriesElementRequest
 */
export interface PatchSeriesElementRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchSeriesElementRequest
     */
    pinned?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchSeriesElementRequest
     */
    updateMask: Array<PatchSeriesElementRequestUpdateMaskEnum>;
}


/**
 * @export
 */
export const PatchSeriesElementRequestUpdateMaskEnum = {
    Pinned: 'pinned'
} as const;
export type PatchSeriesElementRequestUpdateMaskEnum = typeof PatchSeriesElementRequestUpdateMaskEnum[keyof typeof PatchSeriesElementRequestUpdateMaskEnum];

/**
 * 
 * @export
 * @interface PatchStorePersonalLookRequest
 */
export interface PatchStorePersonalLookRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchStorePersonalLookRequest
     */
    isDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchStorePersonalLookRequest
     */
    name?: string;
    /**
     * at least default 1 face image aws s3 urls
     * @type {Array<string>}
     * @memberof PatchStorePersonalLookRequest
     */
    faceImageAwsS3Urls?: Array<string>;
    /**
     * 
     * @type {FaceImageAwsS3UrlsV2}
     * @memberof PatchStorePersonalLookRequest
     */
    faceImageAwsS3UrlsV2?: FaceImageAwsS3UrlsV2;
    /**
     * 
     * @type {BodyImageAwsS3UrlsV2}
     * @memberof PatchStorePersonalLookRequest
     */
    bodyImageAwsS3UrlsV2?: BodyImageAwsS3UrlsV2;
    /**
     * 
     * @type {BodyTypeEnumItem}
     * @memberof PatchStorePersonalLookRequest
     */
    bodyType?: BodyTypeEnumItem;
    /**
     * 
     * @type {SkinComplexionEnumItem}
     * @memberof PatchStorePersonalLookRequest
     */
    skinComplexion?: SkinComplexionEnumItem;
    /**
     * 
     * @type {EyeColorEnumItem}
     * @memberof PatchStorePersonalLookRequest
     */
    eyeColor?: EyeColorEnumItem;
    /**
     * 
     * @type {GenderEnumItem}
     * @memberof PatchStorePersonalLookRequest
     */
    gender?: GenderEnumItem;
    /**
     * 
     * @type {TattooImageAwsS3Urls}
     * @memberof PatchStorePersonalLookRequest
     */
    tattooImageAwsS3Urls?: TattooImageAwsS3Urls;
    /**
     * 
     * @type {boolean}
     * @memberof PatchStorePersonalLookRequest
     */
    brazilianButtLift?: boolean;
    /**
     * 
     * @type {BreastImplantsEnumItem}
     * @memberof PatchStorePersonalLookRequest
     */
    breastImplants?: BreastImplantsEnumItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStorePersonalLookRequest
     */
    updateMask: Array<PatchStorePersonalLookRequestUpdateMaskEnum>;
}


/**
 * @export
 */
export const PatchStorePersonalLookRequestUpdateMaskEnum = {
    IsDefault: 'isDefault',
    Name: 'name',
    FaceImageAwsS3Urls: 'faceImageAwsS3Urls',
    FaceImageAwsS3UrlsV2: 'faceImageAwsS3UrlsV2',
    BodyImageAwsS3UrlsV2: 'bodyImageAwsS3UrlsV2',
    BodyType: 'bodyType',
    SkinComplexion: 'skinComplexion',
    EyeColor: 'eyeColor',
    Gender: 'gender',
    TattooImageAwsS3Urls: 'tattooImageAwsS3Urls',
    BrazilianButtLift: 'brazilianButtLift',
    BreastImplants: 'breastImplants'
} as const;
export type PatchStorePersonalLookRequestUpdateMaskEnum = typeof PatchStorePersonalLookRequestUpdateMaskEnum[keyof typeof PatchStorePersonalLookRequestUpdateMaskEnum];

/**
 * 
 * @export
 * @interface PatchStoreV2Request
 */
export interface PatchStoreV2Request {
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    announcement?: string;
    /**
     * 
     * @type {EvergreenVideoItem}
     * @memberof PatchStoreV2Request
     */
    evergreenVideo?: EvergreenVideoItem;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    sellerPasscode?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchStoreV2Request
     */
    secondOfShippingLabelGeneration?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchStoreV2Request
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchStoreV2Request
     */
    adjustedPopshopShippingFee?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    defaultCoverImage?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreV2Request
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreV2Request
     */
    badges?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PatchStoreV2Request
     */
    salesTaxRate?: { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    storeType?: PatchStoreV2RequestStoreTypeEnum;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof PatchStoreV2Request
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreV2Request
     */
    defaultProductCategoryIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreV2Request
     */
    updateMask: Array<PatchStoreV2RequestUpdateMaskEnum>;
}


/**
 * @export
 */
export const PatchStoreV2RequestStoreTypeEnum = {
    Business: 'Business',
    Creator: 'Creator',
    CommentChat: 'CommentChat',
    Vfs: 'VFS'
} as const;
export type PatchStoreV2RequestStoreTypeEnum = typeof PatchStoreV2RequestStoreTypeEnum[keyof typeof PatchStoreV2RequestStoreTypeEnum];

/**
 * @export
 */
export const PatchStoreV2RequestUpdateMaskEnum = {
    Name: 'name',
    Bio: 'bio',
    Announcement: 'announcement',
    EvergreenVideo: 'evergreenVideo',
    ShortDescription: 'shortDescription',
    SellerPasscode: 'sellerPasscode',
    SecondOfShippingLabelGeneration: 'secondOfShippingLabelGeneration',
    ShippingFee: 'shippingFee',
    AdjustedPopshopShippingFee: 'adjustedPopshopShippingFee',
    DefaultCoverImage: 'defaultCoverImage',
    Tags: 'tags',
    Badges: 'badges',
    SalesTaxRate: 'salesTaxRate',
    StoreType: 'storeType',
    SocialAccounts: 'socialAccounts',
    DefaultProductCategoryIds: 'defaultProductCategoryIds'
} as const;
export type PatchStoreV2RequestUpdateMaskEnum = typeof PatchStoreV2RequestUpdateMaskEnum[keyof typeof PatchStoreV2RequestUpdateMaskEnum];

/**
 * 
 * @export
 * @interface PauseRequest
 */
export interface PauseRequest {
    /**
     * 
     * @type {string}
     * @memberof PauseRequest
     */
    streamPausedText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PauseRequest
     */
    manually?: boolean;
}
/**
 * 
 * @export
 * @interface PayToViewDto
 */
export interface PayToViewDto {
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewDto
     */
    price: number;
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewDto
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewDto
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof PayToViewDto
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PayToViewDto
     */
    discountEndDate?: string;
}
/**
 * 
 * @export
 * @interface PayToViewItem
 */
export interface PayToViewItem {
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewItem
     */
    price: number;
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof PayToViewItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PayToViewItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PayToViewItem
     */
    listingId?: string;
}
/**
 * 
 * @export
 * @interface PayToViewOnlyModeDto
 */
export interface PayToViewOnlyModeDto {
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewOnlyModeDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewOnlyModeDto
     */
    daysAfterPublished?: number;
}
/**
 * 
 * @export
 * @interface PayToViewOnlyModeItem
 */
export interface PayToViewOnlyModeItem {
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewOnlyModeItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewOnlyModeItem
     */
    daysAfterPublished?: number;
}
/**
 * 
 * @export
 * @interface PaymentAddressDto
 */
export interface PaymentAddressDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    postalCode: string;
}
/**
 * 
 * @export
 * @interface PaymentItem
 */
export interface PaymentItem {
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    buyerId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    intentId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    status: PaymentItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    paymentType: PaymentItemPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    captureGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    captureGroupStatus?: PaymentItemCaptureGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    stripeClientSecret?: string;
}


/**
 * @export
 */
export const PaymentItemStatusEnum = {
    Canceled: 'canceled',
    Processing: 'processing',
    RequiresAction: 'requires_action',
    RequiresCapture: 'requires_capture',
    RequiresConfirmation: 'requires_confirmation',
    RequiresPaymentMethod: 'requires_payment_method',
    Succeeded: 'succeeded'
} as const;
export type PaymentItemStatusEnum = typeof PaymentItemStatusEnum[keyof typeof PaymentItemStatusEnum];

/**
 * @export
 */
export const PaymentItemPaymentTypeEnum = {
    Credit: 'credit',
    Applepay: 'applepay',
    Empty: 'empty'
} as const;
export type PaymentItemPaymentTypeEnum = typeof PaymentItemPaymentTypeEnum[keyof typeof PaymentItemPaymentTypeEnum];

/**
 * @export
 */
export const PaymentItemCaptureGroupStatusEnum = {
    RequiresPayment: 'requiresPayment',
    RequiresCapture: 'requiresCapture',
    Captured: 'captured',
    Canceled: 'canceled',
    Failed: 'failed'
} as const;
export type PaymentItemCaptureGroupStatusEnum = typeof PaymentItemCaptureGroupStatusEnum[keyof typeof PaymentItemCaptureGroupStatusEnum];

/**
 * 
 * @export
 * @interface PaymentMethodAddress
 */
export interface PaymentMethodAddress {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodAddress
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodAddress
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodAddress
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodAddress
     */
    country?: string;
}
/**
 * 
 * @export
 * @interface PaymentMethodDetailItem
 */
export interface PaymentMethodDetailItem {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailItem
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailItem
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailItem
     */
    last4?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailItem
     */
    network?: string;
    /**
     * 
     * @type {PaymentMethodDetailWalletItem}
     * @memberof PaymentMethodDetailItem
     */
    wallet?: PaymentMethodDetailWalletItem;
}
/**
 * 
 * @export
 * @interface PaymentMethodDetailWalletItem
 */
export interface PaymentMethodDetailWalletItem {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailWalletItem
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailWalletItem
     */
    dynamicLast4?: string;
}
/**
 * 
 * @export
 * @interface PaymentMethodItem
 */
export interface PaymentMethodItem {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodItem
     */
    created: number;
    /**
     * 
     * @type {PaymentMethodItemCard}
     * @memberof PaymentMethodItem
     */
    card: PaymentMethodItemCard;
}
/**
 * 
 * @export
 * @interface PaymentMethodItemCard
 */
export interface PaymentMethodItemCard {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    brand: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    funding: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    last4: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    fingerprint?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    iin?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    issuer?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodItemCard
     */
    exp_month: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodItemCard
     */
    exp_year: number;
    /**
     * 
     * @type {CardThreeDSecureUsage}
     * @memberof PaymentMethodItemCard
     */
    three_d_secure_usage?: CardThreeDSecureUsage;
    /**
     * 
     * @type {CardWallet}
     * @memberof PaymentMethodItemCard
     */
    wallet?: CardWallet;
}
/**
 * 
 * @export
 * @interface PayoutBankItem
 */
export interface PayoutBankItem {
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    accountNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    routingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    accountType?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    zipcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    country?: string;
}
/**
 * 
 * @export
 * @interface PayoutPaypalItem
 */
export interface PayoutPaypalItem {
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalItem
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalItem
     */
    phone: string;
}
/**
 * 
 * @export
 * @interface PayoutVenmoItem
 */
export interface PayoutVenmoItem {
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoItem
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoItem
     */
    email: string;
}
/**
 * 
 * @export
 * @interface PersonalLookItem
 */
export interface PersonalLookItem {
    /**
     * 
     * @type {string}
     * @memberof PersonalLookItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalLookItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalLookItem
     */
    updatedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalLookItem
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof PersonalLookItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalLookItem
     */
    shopId: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalLookItem
     */
    creatorId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonalLookItem
     */
    faceImageAwsS3Urls: Array<string>;
    /**
     * 
     * @type {FaceImageAwsS3UrlsV2Item}
     * @memberof PersonalLookItem
     */
    faceImageAwsS3UrlsV2?: FaceImageAwsS3UrlsV2Item;
    /**
     * 
     * @type {BodyImageAwsS3UrlsV2Item}
     * @memberof PersonalLookItem
     */
    bodyImageAwsS3UrlsV2: BodyImageAwsS3UrlsV2Item;
    /**
     * 
     * @type {BodyTypeEnumItem}
     * @memberof PersonalLookItem
     */
    bodyType: BodyTypeEnumItem;
    /**
     * 
     * @type {SkinComplexionEnumItem}
     * @memberof PersonalLookItem
     */
    skinComplexion: SkinComplexionEnumItem;
    /**
     * 
     * @type {EyeColorEnumItem}
     * @memberof PersonalLookItem
     */
    eyeColor: EyeColorEnumItem;
    /**
     * 
     * @type {GenderEnumItem}
     * @memberof PersonalLookItem
     */
    gender: GenderEnumItem;
    /**
     * 
     * @type {TattooImageAwsS3UrlsItem}
     * @memberof PersonalLookItem
     */
    tattooImageAwsS3Urls?: TattooImageAwsS3UrlsItem;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalLookItem
     */
    brazilianButtLift?: boolean;
    /**
     * 
     * @type {BreastImplantsEnumItem}
     * @memberof PersonalLookItem
     */
    breastImplants?: BreastImplantsEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalLookItem
     */
    makeItMoreMe?: boolean;
    /**
     * 
     * @type {EthnicityEnumItem}
     * @memberof PersonalLookItem
     */
    ethnicity?: EthnicityEnumItem;
    /**
     * 
     * @type {HairColorEnumItem}
     * @memberof PersonalLookItem
     */
    hairColor?: HairColorEnumItem;
    /**
     * 
     * @type {HairLengthEnumItem}
     * @memberof PersonalLookItem
     */
    hairLength?: HairLengthEnumItem;
    /**
     * 
     * @type {HairStyleEnumItem}
     * @memberof PersonalLookItem
     */
    hairStyle?: HairStyleEnumItem;
    /**
     * 
     * @type {DressSizeEnumItem}
     * @memberof PersonalLookItem
     */
    dressSize?: DressSizeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof PersonalLookItem
     */
    height?: number;
    /**
     * 
     * @type {HeightUnitEnumItem}
     * @memberof PersonalLookItem
     */
    heightUnit?: HeightUnitEnumItem;
    /**
     * 
     * @type {number}
     * @memberof PersonalLookItem
     */
    bustSize?: number;
    /**
     * 
     * @type {BwhUnitEnumItem}
     * @memberof PersonalLookItem
     */
    bustUnit?: BwhUnitEnumItem;
    /**
     * 
     * @type {number}
     * @memberof PersonalLookItem
     */
    waistSize?: number;
    /**
     * 
     * @type {BreastImplantsEnumItem}
     * @memberof PersonalLookItem
     */
    waistUnit?: BreastImplantsEnumItem;
    /**
     * 
     * @type {number}
     * @memberof PersonalLookItem
     */
    hipSize?: number;
    /**
     * 
     * @type {BreastImplantsEnumItem}
     * @memberof PersonalLookItem
     */
    hipUnit?: BreastImplantsEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalLookItem
     */
    lipFillers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalLookItem
     */
    cheekboneFillers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalLookItem
     */
    chinFillers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalLookItem
     */
    definedAbs?: boolean;
}


/**
 * 
 * @export
 * @interface PersonalLookPageRows
 */
export interface PersonalLookPageRows {
    /**
     * 
     * @type {Array<PersonalLookItem>}
     * @memberof PersonalLookPageRows
     */
    rows: Array<PersonalLookItem>;
}
/**
 * 
 * @export
 * @interface PickupAddressDto
 */
export interface PickupAddressDto {
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    compareHash?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    addressId: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    pickupNote?: string;
}
/**
 * 
 * @export
 * @interface PickupAddressItem
 */
export interface PickupAddressItem {
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    compareHash?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    addressId: string;
}
/**
 * 
 * @export
 * @interface PlanFeatureDescriptionItem
 */
export interface PlanFeatureDescriptionItem {
    /**
     * 
     * @type {string}
     * @memberof PlanFeatureDescriptionItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PlanFeatureDescriptionItem
     */
    icon?: string;
}
/**
 * 
 * @export
 * @interface PlanFeatureListItem
 */
export interface PlanFeatureListItem {
    /**
     * 
     * @type {string}
     * @memberof PlanFeatureListItem
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanFeatureListItem
     */
    title: string;
    /**
     * 
     * @type {Array<PlanFeatureDescriptionItem>}
     * @memberof PlanFeatureListItem
     */
    description?: Array<PlanFeatureDescriptionItem>;
    /**
     * 
     * @type {boolean}
     * @memberof PlanFeatureListItem
     */
    pinned?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PlanFeatureListItem
     */
    tier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PlanFeatureListItem
     */
    utmRegintent?: string;
}

/**
 * 
 * @export
 */
export const PlatformEnumItem = {
    PopshopLive: 'popshop.live',
    PopStore: 'pop.store'
} as const;
export type PlatformEnumItem = typeof PlatformEnumItem[keyof typeof PlatformEnumItem];

/**
 * 
 * @export
 * @interface PollPageRows
 */
export interface PollPageRows {
    /**
     * 
     * @type {Array<PollSearchItem>}
     * @memberof PollPageRows
     */
    rows: Array<PollSearchItem>;
}
/**
 * 
 * @export
 * @interface PollSearchItem
 */
export interface PollSearchItem {
    /**
     * 
     * @type {string}
     * @memberof PollSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PollSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {PollTypeEnumItem}
     * @memberof PollSearchItem
     */
    type: PollTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PollSearchItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PollSearchItem
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof PollSearchItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PollSearchItem
     */
    dueAt: string;
    /**
     * 
     * @type {object}
     * @memberof PollSearchItem
     */
    endedAt?: object;
    /**
     * 
     * @type {boolean}
     * @memberof PollSearchItem
     */
    isAnonymousVotingAllowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PollSearchItem
     */
    shouldLockResponse: boolean;
    /**
     * 
     * @type {PollStatusEnumItem}
     * @memberof PollSearchItem
     */
    status: PollStatusEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof PollSearchItem
     */
    isMultiChoice: boolean;
    /**
     * 
     * @type {number}
     * @memberof PollSearchItem
     */
    voteCount: number;
    /**
     * 
     * @type {number}
     * @memberof PollSearchItem
     */
    voterCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof PollSearchItem
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof PollSearchItem
     */
    deletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PollSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof PollSearchItem
     */
    relations: Relations;
}


/**
 * 
 * @export
 * @interface PollSearchResponse
 */
export interface PollSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof PollSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof PollSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof PollSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {PollPageRows}
     * @memberof PollSearchResponse
     */
    data: PollPageRows;
}

/**
 * 
 * @export
 */
export const PollStatusEnumItem = {
    Active: 'active',
    Suspended: 'suspended',
    Ended: 'ended'
} as const;
export type PollStatusEnumItem = typeof PollStatusEnumItem[keyof typeof PollStatusEnumItem];


/**
 * 
 * @export
 */
export const PollTypeEnumItem = {
    Public: 'public',
    Blind: 'blind'
} as const;
export type PollTypeEnumItem = typeof PollTypeEnumItem[keyof typeof PollTypeEnumItem];

/**
 * 
 * @export
 * @interface PollVotePageRows
 */
export interface PollVotePageRows {
    /**
     * 
     * @type {Array<PollVoteSearchItem>}
     * @memberof PollVotePageRows
     */
    rows: Array<PollVoteSearchItem>;
}
/**
 * 
 * @export
 * @interface PollVoteSearchItem
 */
export interface PollVoteSearchItem {
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchItem
     */
    optionId: string;
    /**
     * 
     * @type {BasicProfileDto}
     * @memberof PollVoteSearchItem
     */
    profile?: BasicProfileDto;
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchItem
     */
    unifiedId: string;
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchItem
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchItem
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchItem
     */
    timeZone: string;
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchItem
     */
    ip: string;
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchItem
     */
    userAgent: string;
    /**
     * 
     * @type {number}
     * @memberof PollVoteSearchItem
     */
    age: number;
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof PollVoteSearchItem
     */
    relations: Relations;
}
/**
 * 
 * @export
 * @interface PollVoteSearchResponse
 */
export interface PollVoteSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof PollVoteSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof PollVoteSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof PollVoteSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {PollVotePageRows}
     * @memberof PollVoteSearchResponse
     */
    data: PollVotePageRows;
}

/**
 * 
 * @export
 */
export const PopStoreCreatorBusinessTypeEnumItem = {
    Realestate: 'realestate',
    Avatarme: 'avatarme',
    Generic: 'generic',
    Aiecho: 'aiecho',
    Creatorcoach: 'creatorcoach',
    Beautyfashionaffiliate: 'beautyfashionaffiliate'
} as const;
export type PopStoreCreatorBusinessTypeEnumItem = typeof PopStoreCreatorBusinessTypeEnumItem[keyof typeof PopStoreCreatorBusinessTypeEnumItem];


/**
 * 
 * @export
 */
export const PopStoreExtendedSubscriptionLevelEnumItem = {
    Follower: 'follower',
    Subscriber: 'subscriber',
    Fan: 'fan',
    Vip: 'vip'
} as const;
export type PopStoreExtendedSubscriptionLevelEnumItem = typeof PopStoreExtendedSubscriptionLevelEnumItem[keyof typeof PopStoreExtendedSubscriptionLevelEnumItem];


/**
 * 
 * @export
 */
export const PopStoreSubscriptionLevelEnumItem = {
    Subscriber: 'subscriber',
    Fan: 'fan',
    Vip: 'vip'
} as const;
export type PopStoreSubscriptionLevelEnumItem = typeof PopStoreSubscriptionLevelEnumItem[keyof typeof PopStoreSubscriptionLevelEnumItem];


/**
 * 
 * @export
 */
export const PopStoreUserAccessLevelEnumItem = {
    All: 'all',
    Subscriber: 'subscriber',
    Fan: 'fan',
    Vip: 'vip'
} as const;
export type PopStoreUserAccessLevelEnumItem = typeof PopStoreUserAccessLevelEnumItem[keyof typeof PopStoreUserAccessLevelEnumItem];

/**
 * 
 * @export
 * @interface Pose
 */
export interface Pose {
    /**
     * 
     * @type {number}
     * @memberof Pose
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Pose
     */
    thumbnail: string;
}
/**
 * 
 * @export
 * @interface PostCommentPageRows
 */
export interface PostCommentPageRows {
    /**
     * 
     * @type {Array<PostCommentSearchItem>}
     * @memberof PostCommentPageRows
     */
    rows: Array<PostCommentSearchItem>;
}
/**
 * 
 * @export
 * @interface PostCommentSearchItem
 */
export interface PostCommentSearchItem {
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {number}
     * @memberof PostCommentSearchItem
     */
    level: number;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    userId: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof PostCommentSearchItem
     */
    profile: BaseProfileItem;
    /**
     * 
     * @type {boolean}
     * @memberof PostCommentSearchItem
     */
    isFollower: boolean;
    /**
     * 
     * @type {PopStoreSubscriptionLevelEnumItem}
     * @memberof PostCommentSearchItem
     */
    subscriptionLevel?: PopStoreSubscriptionLevelEnumItem;
    /**
     * 
     * @type {number}
     * @memberof PostCommentSearchItem
     */
    likeCount: number;
    /**
     * 
     * @type {number}
     * @memberof PostCommentSearchItem
     */
    replyCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof PostCommentSearchItem
     */
    removed: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof PostCommentSearchItem
     */
    relations: Relations;
    /**
     * if the user liked the comment
     * @type {boolean}
     * @memberof PostCommentSearchItem
     */
    liked?: boolean;
}


/**
 * 
 * @export
 * @interface PostCommentSearchResponse
 */
export interface PostCommentSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof PostCommentSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof PostCommentSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {PostCommentPageRows}
     * @memberof PostCommentSearchResponse
     */
    data: PostCommentPageRows;
}

/**
 * 
 * @export
 */
export const PostContentTypeEnumItem = {
    RichText: 'RICH_TEXT',
    MediaGallery: 'MEDIA_GALLERY'
} as const;
export type PostContentTypeEnumItem = typeof PostContentTypeEnumItem[keyof typeof PostContentTypeEnumItem];

/**
 * 
 * @export
 * @interface PostMediaDimensionsDto
 */
export interface PostMediaDimensionsDto {
    /**
     * 
     * @type {number}
     * @memberof PostMediaDimensionsDto
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof PostMediaDimensionsDto
     */
    height: number;
}
/**
 * 
 * @export
 * @interface PostMediaDto
 */
export interface PostMediaDto {
    /**
     * 
     * @type {PostMediaTypeEnumItem}
     * @memberof PostMediaDto
     */
    type?: PostMediaTypeEnumItem;
    /**
     * 
     * @type {PostMediaOriginTypeEnumItem}
     * @memberof PostMediaDto
     */
    origin?: PostMediaOriginTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    processedUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    caption?: string;
    /**
     * 
     * @type {PostMediaMetadataDto}
     * @memberof PostMediaDto
     */
    metadata?: PostMediaMetadataDto;
}


/**
 * 
 * @export
 * @interface PostMediaItem
 */
export interface PostMediaItem {
    /**
     * 
     * @type {PostMediaTypeEnumItem}
     * @memberof PostMediaItem
     */
    type?: PostMediaTypeEnumItem;
    /**
     * 
     * @type {PostMediaOriginTypeEnumItem}
     * @memberof PostMediaItem
     */
    origin?: PostMediaOriginTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    processedUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    thumbnailVideoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    caption?: string;
    /**
     * 
     * @type {PostMediaMetadataDto}
     * @memberof PostMediaItem
     */
    metadata?: PostMediaMetadataDto;
    /**
     * 
     * @type {ContentModerationInfoItem}
     * @memberof PostMediaItem
     */
    moderation?: ContentModerationInfoItem;
}


/**
 * 
 * @export
 * @interface PostMediaMetadataDto
 */
export interface PostMediaMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof PostMediaMetadataDto
     */
    blurhash?: string;
    /**
     * 
     * @type {PostMediaDimensionsDto}
     * @memberof PostMediaMetadataDto
     */
    dimensions?: PostMediaDimensionsDto;
}

/**
 * 
 * @export
 */
export const PostMediaOriginTypeEnumItem = {
    UserUploaded: 'USER_UPLOADED',
    MediaGalleryObjectRef: 'MEDIA_GALLERY_OBJECT_REF',
    LiveReplayRef: 'LIVE_REPLAY_REF'
} as const;
export type PostMediaOriginTypeEnumItem = typeof PostMediaOriginTypeEnumItem[keyof typeof PostMediaOriginTypeEnumItem];


/**
 * 
 * @export
 */
export const PostMediaTypeEnumItem = {
    Image: 'IMAGE',
    Video: 'VIDEO',
    LiveReplay: 'LIVE_REPLAY'
} as const;
export type PostMediaTypeEnumItem = typeof PostMediaTypeEnumItem[keyof typeof PostMediaTypeEnumItem];

/**
 * 
 * @export
 * @interface PostPageRows
 */
export interface PostPageRows {
    /**
     * 
     * @type {Array<PostSearchItem>}
     * @memberof PostPageRows
     */
    rows: Array<PostSearchItem>;
}
/**
 * 
 * @export
 * @interface PostSearchItem
 */
export interface PostSearchItem {
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    cid: string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostSearchItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    permaLink?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostSearchItem
     */
    pinned?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    pinnedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostSearchItem
     */
    allowComments: boolean;
    /**
     * 
     * @type {PostStatusEnumItem}
     * @memberof PostSearchItem
     */
    status: PostStatusEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    scheduledReleaseTime?: string;
    /**
     * 
     * @type {PostVisibilityEnumItem}
     * @memberof PostSearchItem
     */
    visibility: PostVisibilityEnumItem;
    /**
     * 
     * @type {SubscribeToViewItem}
     * @memberof PostSearchItem
     */
    subscribeToView?: SubscribeToViewItem;
    /**
     * 
     * @type {PayToViewItem}
     * @memberof PostSearchItem
     */
    payToView?: PayToViewItem;
    /**
     * 
     * @type {PayToViewOnlyModeItem}
     * @memberof PostSearchItem
     */
    payToViewOnlyMode?: PayToViewOnlyModeItem;
    /**
     * 
     * @type {CrowdTippingToViewItem}
     * @memberof PostSearchItem
     */
    crowdTippingToView?: CrowdTippingToViewItem;
    /**
     * 
     * @type {TipToViewItem}
     * @memberof PostSearchItem
     */
    tipToView?: TipToViewItem;
    /**
     * 
     * @type {Array<TippingAmountItem>}
     * @memberof PostSearchItem
     */
    tippingAmounts?: Array<TippingAmountItem>;
    /**
     * 
     * @type {DmItem}
     * @memberof PostSearchItem
     */
    dm?: DmItem;
    /**
     * 
     * @type {PostContentTypeEnumItem}
     * @memberof PostSearchItem
     */
    postType: PostContentTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    textContent?: string;
    /**
     * 
     * @type {Array<PostMediaItem>}
     * @memberof PostSearchItem
     */
    medias?: Array<PostMediaItem>;
    /**
     * 
     * @type {number}
     * @memberof PostSearchItem
     */
    unrestrictedLeadingMediaCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchItem
     */
    commentCount: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchItem
     */
    likeCount: number;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    publishedAt?: string;
    /**
     * 
     * @type {ContentModerationInfoItem}
     * @memberof PostSearchItem
     */
    moderation?: ContentModerationInfoItem;
    /**
     * 
     * @type {ContentModerationInfoItem}
     * @memberof PostSearchItem
     */
    textContentModeration?: ContentModerationInfoItem;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof PostSearchItem
     */
    relations: Relations;
    /**
     * if the user liked the post
     * @type {boolean}
     * @memberof PostSearchItem
     */
    liked?: boolean;
    /**
     * true if the user does not have required access level to this post
     * @type {boolean}
     * @memberof PostSearchItem
     */
    restricted?: boolean;
    /**
     * for debug purpose
     * @type {string}
     * @memberof PostSearchItem
     */
    restrictionReason?: string;
    /**
     * if the user is following the creator of this post
     * @type {BaseProfileItem}
     * @memberof PostSearchItem
     */
    creatorProfile?: BaseProfileItem;
}


/**
 * 
 * @export
 * @interface PostSearchResponse
 */
export interface PostSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof PostSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof PostSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {PostPageRows}
     * @memberof PostSearchResponse
     */
    data: PostPageRows;
}

/**
 * 
 * @export
 */
export const PostStatusEnumItem = {
    Draft: 'DRAFT',
    Published: 'PUBLISHED',
    Scheduled: 'SCHEDULED'
} as const;
export type PostStatusEnumItem = typeof PostStatusEnumItem[keyof typeof PostStatusEnumItem];


/**
 * 
 * @export
 */
export const PostVisibilityEnumItem = {
    Public: 'PUBLIC',
    Restricted: 'RESTRICTED',
    Private: 'PRIVATE'
} as const;
export type PostVisibilityEnumItem = typeof PostVisibilityEnumItem[keyof typeof PostVisibilityEnumItem];

/**
 * 
 * @export
 * @interface PoundWithOunceWeightInfo
 */
export interface PoundWithOunceWeightInfo {
    /**
     * 
     * @type {string}
     * @memberof PoundWithOunceWeightInfo
     */
    type: PoundWithOunceWeightInfoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PoundWithOunceWeightInfo
     */
    lbValue: number;
    /**
     * 
     * @type {number}
     * @memberof PoundWithOunceWeightInfo
     */
    ozValue: number;
}


/**
 * @export
 */
export const PoundWithOunceWeightInfoTypeEnum = {
    PoundWithOunce: 'poundWithOunce'
} as const;
export type PoundWithOunceWeightInfoTypeEnum = typeof PoundWithOunceWeightInfoTypeEnum[keyof typeof PoundWithOunceWeightInfoTypeEnum];

/**
 * 
 * @export
 * @interface PreviewOrderAvailableCouponsDto
 */
export interface PreviewOrderAvailableCouponsDto {
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderAvailableCouponsDto
     */
    redeemedCouponId: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderAvailableCouponsDto
     */
    selectStatus: PreviewOrderAvailableCouponsDtoSelectStatusEnum;
    /**
     * 
     * @type {CouponItem}
     * @memberof PreviewOrderAvailableCouponsDto
     */
    coupon: CouponItem;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderAvailableCouponsDto
     */
    couponId: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderAvailableCouponsDto
     */
    reason?: string;
}


/**
 * @export
 */
export const PreviewOrderAvailableCouponsDtoSelectStatusEnum = {
    Selected: 'selected',
    Selectable: 'selectable',
    Unselectable: 'unselectable'
} as const;
export type PreviewOrderAvailableCouponsDtoSelectStatusEnum = typeof PreviewOrderAvailableCouponsDtoSelectStatusEnum[keyof typeof PreviewOrderAvailableCouponsDtoSelectStatusEnum];

/**
 * 
 * @export
 * @interface PreviewOrderDto
 */
export interface PreviewOrderDto {
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    stripePaymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    stripeApplePayNonce?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    listingId?: string;
    /**
     * listing info for virtual listings
     * @type {ListingDto}
     * @memberof PreviewOrderDto
     */
    listing?: ListingDto;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    sellerId: string;
    /**
     * The recipient of this gift order
     * @type {string}
     * @memberof PreviewOrderDto
     */
    recipientId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    sendItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    sentReferralGiftId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    variantId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    shippingMethod?: PreviewOrderDtoShippingMethodEnum;
    /**
     * Optional for gifting orders or digital products
     * @type {AddressDto}
     * @memberof PreviewOrderDto
     */
    shippingAddress?: AddressDto;
    /**
     * 
     * @type {PickupAddressDto}
     * @memberof PreviewOrderDto
     */
    pickupAddress?: PickupAddressDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof PreviewOrderDto
     */
    redeemedCouponIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderDto
     */
    quantity: number;
    /**
     * 
     * @type {PreviewOrderDtoSource}
     * @memberof PreviewOrderDto
     */
    source?: PreviewOrderDtoSource;
    /**
     * 
     * @type {PaymentAddressDto}
     * @memberof PreviewOrderDto
     */
    paymentBillingAddress?: PaymentAddressDto;
    /**
     * 
     * @type {TippingDto}
     * @memberof PreviewOrderDto
     */
    tipping?: TippingDto;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    fxQuoteId?: string;
    /**
     * 
     * @type {PreviewOrderDtoAvatarMe}
     * @memberof PreviewOrderDto
     */
    avatarMe?: PreviewOrderDtoAvatarMe;
    /**
     * 
     * @type {OrderMeetingSlotDto}
     * @memberof PreviewOrderDto
     */
    meeting?: OrderMeetingSlotDto;
    /**
     * 
     * @type {OrderGroupEventDto}
     * @memberof PreviewOrderDto
     */
    groupEvent?: OrderGroupEventDto;
}


/**
 * @export
 */
export const PreviewOrderDtoShippingMethodEnum = {
    DropshipSupplierProvide: 'dropshipSupplierProvide',
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide',
    Pickup: 'pickup'
} as const;
export type PreviewOrderDtoShippingMethodEnum = typeof PreviewOrderDtoShippingMethodEnum[keyof typeof PreviewOrderDtoShippingMethodEnum];

/**
 * @type PreviewOrderDtoAvatarMe
 * 
 * @export
 */
export type PreviewOrderDtoAvatarMe = AvatarMeGamifiedLipSyncVideoRequest | AvatarMeImageRequest | AvatarMePhotoshootRequest | AvatarMeStudioGamifiedLipSyncVideoRequest | AvatarMeStudioImageRequest | AvatarMeStudioPhotoshootRequest | AvatarMeStudioVideo10sRequest | AvatarMeStudioVideo5sRequest | AvatarMeStudioVideoPromptRequest | AvatarMeVideo10sRequest | AvatarMeVideo5sRequest | AvatarMeVideoFacePerfectRequest | AvatarMeVideoHdUpgradeRequest;
/**
 * @type PreviewOrderDtoSource
 * 
 * @export
 */
export type PreviewOrderDtoSource = CommentChatSource | LiveStreamSource | ReferralGiftingSource | ReplaySource | SendItemSource | ShopSource | StoreSource | TopProductsSource | TwoWayStreamSource | UpcomingShowSource;
/**
 * 
 * @export
 * @interface PreviewOrderResponse
 */
export interface PreviewOrderResponse {
    /**
     * 
     * @type {object}
     * @memberof PreviewOrderResponse
     */
    openboxCloseTime: object;
    /**
     * 
     * @type {DropshipAmountsItem}
     * @memberof PreviewOrderResponse
     */
    dropshipAmounts?: DropshipAmountsItem;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    salesTaxRate: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    couponDiscountShippingFeeAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    couponDiscountProductAmount: number;
    /**
     * 
     * @type {Array<PreviewOrderAvailableCouponsDto>}
     * @memberof PreviewOrderResponse
     */
    availableCoupons?: Array<PreviewOrderAvailableCouponsDto>;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    popshopShippingFeeSource?: PreviewOrderResponsePopshopShippingFeeSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    shipmentGroupStatus?: PreviewOrderResponseShipmentGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    shipmentShippingMethod: PreviewOrderResponseShipmentShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    masterOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    currency?: string;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    subtotal?: number;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    fxQuoteId?: string;
}


/**
 * @export
 */
export const PreviewOrderResponsePopshopShippingFeeSourceEnum = {
    ReadonlyProfile: 'READONLY_PROFILE',
    Default: 'DEFAULT',
    ShowEvent: 'SHOW_EVENT'
} as const;
export type PreviewOrderResponsePopshopShippingFeeSourceEnum = typeof PreviewOrderResponsePopshopShippingFeeSourceEnum[keyof typeof PreviewOrderResponsePopshopShippingFeeSourceEnum];

/**
 * @export
 */
export const PreviewOrderResponseShipmentGroupStatusEnum = {
    Customer: 'customer',
    Slave: 'slave',
    Master: 'master'
} as const;
export type PreviewOrderResponseShipmentGroupStatusEnum = typeof PreviewOrderResponseShipmentGroupStatusEnum[keyof typeof PreviewOrderResponseShipmentGroupStatusEnum];

/**
 * @export
 */
export const PreviewOrderResponseShipmentShippingMethodEnum = {
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide',
    Pickup: 'pickup',
    DropshipSupplierProvide: 'dropshipSupplierProvide'
} as const;
export type PreviewOrderResponseShipmentShippingMethodEnum = typeof PreviewOrderResponseShipmentShippingMethodEnum[keyof typeof PreviewOrderResponseShipmentShippingMethodEnum];

/**
 * 
 * @export
 * @interface PreviewTokenOrderDto
 */
export interface PreviewTokenOrderDto {
    /**
     * 
     * @type {string}
     * @memberof PreviewTokenOrderDto
     */
    sellerId: string;
    /**
     * 
     * @type {TokenListingDto}
     * @memberof PreviewTokenOrderDto
     */
    listing: TokenListingDto;
    /**
     * 
     * @type {number}
     * @memberof PreviewTokenOrderDto
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof PreviewTokenOrderDto
     */
    userAgent?: string;
}
/**
 * 
 * @export
 * @interface PreviewTokenOrderResponse
 */
export interface PreviewTokenOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof PreviewTokenOrderResponse
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTokenOrderResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTokenOrderResponse
     */
    subtotal: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTokenOrderResponse
     */
    listingSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTokenOrderResponse
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTokenOrderResponse
     */
    listingDiscountPercent?: number;
}
/**
 * 
 * @export
 * @interface ProductCategoriesPageRows
 */
export interface ProductCategoriesPageRows {
    /**
     * 
     * @type {Array<ProductCategoryItem>}
     * @memberof ProductCategoriesPageRows
     */
    rows: Array<ProductCategoryItem>;
}
/**
 * 
 * @export
 * @interface ProductCategoriesSearchResponse
 */
export interface ProductCategoriesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ProductCategoriesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ProductCategoriesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoriesSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {ProductCategoriesPageRows}
     * @memberof ProductCategoriesSearchResponse
     */
    data: ProductCategoriesPageRows;
}
/**
 * 
 * @export
 * @interface ProductCategoryItem
 */
export interface ProductCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    slug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCategoryItem
     */
    isRoot: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCategoryItem
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCategoryItem
     */
    custom: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCategoryItem
     */
    digital?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductCategoryItem
     */
    sort: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductCategoryItem
     */
    googleProductCategoryIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    updatedAt: string;
    /**
     * 
     * @type {Array<Array<BasicGoogleCategoryItem>>}
     * @memberof ProductCategoryItem
     */
    googleCategories?: Array<Array<BasicGoogleCategoryItem>>;
}
/**
 * 
 * @export
 * @interface ProductCollectionItem
 */
export interface ProductCollectionItem {
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    strategy: ProductCollectionItemStrategyEnum;
    /**
     * valid when strategy is BY_CATEGORY
     * @type {Array<string>}
     * @memberof ProductCollectionItem
     */
    productCategoryIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCollectionItem
     */
    archived: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductCollectionItem
     */
    sort: number;
    /**
     * 
     * @type {CollectionLayoutTypeEnumItem}
     * @memberof ProductCollectionItem
     */
    layoutType?: CollectionLayoutTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    id: string;
    /**
     * 
     * @type {Array<Array<BasicProductCategoryItem>>}
     * @memberof ProductCollectionItem
     */
    productCategories?: Array<Array<BasicProductCategoryItem>>;
}


/**
 * @export
 */
export const ProductCollectionItemStrategyEnum = {
    ByCategory: 'BY_CATEGORY',
    ManualSelection: 'MANUAL_SELECTION'
} as const;
export type ProductCollectionItemStrategyEnum = typeof ProductCollectionItemStrategyEnum[keyof typeof ProductCollectionItemStrategyEnum];

/**
 * 
 * @export
 * @interface ProductCollectionsPageRows
 */
export interface ProductCollectionsPageRows {
    /**
     * 
     * @type {Array<ProductCollectionItem>}
     * @memberof ProductCollectionsPageRows
     */
    rows: Array<ProductCollectionItem>;
}
/**
 * 
 * @export
 * @interface ProductCollectionsSearchResponse
 */
export interface ProductCollectionsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ProductCollectionsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ProductCollectionsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionsSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {ProductCollectionsPageRows}
     * @memberof ProductCollectionsSearchResponse
     */
    data: ProductCollectionsPageRows;
}
/**
 * 
 * @export
 * @interface ProductItem
 */
export interface ProductItem {
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductItem
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {WearWithAiListingMediaItem}
     * @memberof ProductItem
     */
    defaultWearWithAiMedia?: WearWithAiListingMediaItem;
    /**
     * 
     * @type {Array<WearWithAiListingMediaItem>}
     * @memberof ProductItem
     */
    extraWearWithAiMedias?: Array<WearWithAiListingMediaItem>;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof ProductItem
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    status?: ProductItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof ProductItem
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof ProductItem
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {CreateStoreListingRequestWeight}
     * @memberof ProductItem
     */
    weight?: CreateStoreListingRequestWeight;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof ProductItem
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof ProductItem
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof ProductItem
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductItem
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof ProductItem
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    isLandingEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductItem
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    type?: ProductItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof ProductItem
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    moderationStatus?: ProductItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof ProductItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof ProductItem
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    isEligibleForWearMe?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    externalProductCtaText?: string;
    /**
     * 
     * @type {object}
     * @memberof ProductItem
     */
    extra?: object;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    source?: ProductItemSourceEnum;
}


/**
 * @export
 */
export const ProductItemStatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;
export type ProductItemStatusEnum = typeof ProductItemStatusEnum[keyof typeof ProductItemStatusEnum];

/**
 * @export
 */
export const ProductItemTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type ProductItemTypeEnum = typeof ProductItemTypeEnum[keyof typeof ProductItemTypeEnum];

/**
 * @export
 */
export const ProductItemModerationStatusEnum = {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    ReviewRequired: 'ReviewRequired'
} as const;
export type ProductItemModerationStatusEnum = typeof ProductItemModerationStatusEnum[keyof typeof ProductItemModerationStatusEnum];

/**
 * @export
 */
export const ProductItemSourceEnum = {
    LiveStream: 'LiveStream',
    StoreFavorites: 'StoreFavorites'
} as const;
export type ProductItemSourceEnum = typeof ProductItemSourceEnum[keyof typeof ProductItemSourceEnum];

/**
 * 
 * @export
 * @interface ProfileAppsItem
 */
export interface ProfileAppsItem {
    /**
     * 
     * @type {boolean}
     * @memberof ProfileAppsItem
     */
    popStore?: boolean;
}
/**
 * 
 * @export
 * @interface ProfileBadges
 */
export interface ProfileBadges {
    /**
     * 
     * @type {boolean}
     * @memberof ProfileBadges
     */
    activeSeller?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileBadges
     */
    staff?: boolean;
}
/**
 * 
 * @export
 * @interface ProfileItem
 */
export interface ProfileItem {
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     * @deprecated
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProfileItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    storeType?: ProfileItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof ProfileItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof ProfileItem
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {PopStoreCreatorBusinessTypeEnumItem}
     * @memberof ProfileItem
     */
    businessType?: PopStoreCreatorBusinessTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    id: string;
}


/**
 * @export
 */
export const ProfileItemStoreTypeEnum = {
    Business: 'Business',
    Creator: 'Creator',
    CommentChat: 'CommentChat',
    Vfs: 'VFS'
} as const;
export type ProfileItemStoreTypeEnum = typeof ProfileItemStoreTypeEnum[keyof typeof ProfileItemStoreTypeEnum];


/**
 * 
 * @export
 */
export const ProfileUserTypeEnumItem = {
    Guest: 'guest',
    Normal: 'normal',
    Seller: 'seller',
    VerifiedSeller: 'verifiedSeller'
} as const;
export type ProfileUserTypeEnumItem = typeof ProfileUserTypeEnumItem[keyof typeof ProfileUserTypeEnumItem];

/**
 * 
 * @export
 * @interface ProfilesFollowerItem
 */
export interface ProfilesFollowerItem {
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     * @deprecated
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProfilesFollowerItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    storeType?: ProfilesFollowerItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof ProfilesFollowerItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof ProfilesFollowerItem
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {PopStoreCreatorBusinessTypeEnumItem}
     * @memberof ProfilesFollowerItem
     */
    businessType?: PopStoreCreatorBusinessTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof ProfilesFollowerItem
     */
    metadata: Metadata;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    email: string;
    /**
     * 
     * @type {SharePhoneNumberConsentDto}
     * @memberof ProfilesFollowerItem
     */
    sharePhoneNumberConsent?: SharePhoneNumberConsentDto;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    phoneNumber?: string;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof ProfilesFollowerItem
     */
    subscriptionLevel?: PopStoreExtendedSubscriptionLevelEnumItem;
}


/**
 * @export
 */
export const ProfilesFollowerItemStoreTypeEnum = {
    Business: 'Business',
    Creator: 'Creator',
    CommentChat: 'CommentChat',
    Vfs: 'VFS'
} as const;
export type ProfilesFollowerItemStoreTypeEnum = typeof ProfilesFollowerItemStoreTypeEnum[keyof typeof ProfilesFollowerItemStoreTypeEnum];

/**
 * 
 * @export
 * @interface ProfilesFollowerPageRows
 */
export interface ProfilesFollowerPageRows {
    /**
     * 
     * @type {Array<ProfilesFollowerItem>}
     * @memberof ProfilesFollowerPageRows
     */
    rows: Array<ProfilesFollowerItem>;
}
/**
 * 
 * @export
 * @interface ProfilesFollowersSearchResponse
 */
export interface ProfilesFollowersSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ProfilesFollowersSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ProfilesFollowersSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowersSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {ProfilesFollowerPageRows}
     * @memberof ProfilesFollowersSearchResponse
     */
    data: ProfilesFollowerPageRows;
}
/**
 * 
 * @export
 * @interface PromotionalOfferDetailsItem
 */
export interface PromotionalOfferDetailsItem {
    /**
     * 
     * @type {boolean}
     * @memberof PromotionalOfferDetailsItem
     */
    receivePromotionalOffers: boolean;
    /**
     * 
     * @type {string}
     * @memberof PromotionalOfferDetailsItem
     */
    receivePromotionalOffersToggledAt?: string;
}
/**
 * 
 * @export
 * @interface PublicCouponCampaignCriteriaDto
 */
export interface PublicCouponCampaignCriteriaDto {
    /**
     * raw snake_case marketing param name -> accepted values. Fields are ANDed, values within one field ORed, an absent field constrains nothing.
     * @type {{ [key: string]: Array<string>; }}
     * @memberof PublicCouponCampaignCriteriaDto
     */
    utmParams?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<PopStoreCreatorBusinessTypeEnumItem>}
     * @memberof PublicCouponCampaignCriteriaDto
     */
    businessTypes?: Array<PopStoreCreatorBusinessTypeEnumItem>;
    /**
     * 
     * @type {boolean}
     * @memberof PublicCouponCampaignCriteriaDto
     */
    firstSubscriptionOnly?: boolean;
}
/**
 * 
 * @export
 * @interface PublicCouponCampaignStageDto
 */
export interface PublicCouponCampaignStageDto {
    /**
     * 
     * @type {string}
     * @memberof PublicCouponCampaignStageDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof PublicCouponCampaignStageDto
     */
    name?: string;
    /**
     * the `saasSubscriptionCoupons` doc id to apply; absent on server-delivered stages (email, email_flow)
     * @type {string}
     * @memberof PublicCouponCampaignStageDto
     */
    couponId?: string;
    /**
     * 
     * @type {CouponCampaignTriggerDto}
     * @memberof PublicCouponCampaignStageDto
     */
    trigger: CouponCampaignTriggerDto;
    /**
     * 
     * @type {CouponCampaignReachDto}
     * @memberof PublicCouponCampaignStageDto
     */
    reach: CouponCampaignReachDto;
    /**
     * 
     * @type {number}
     * @memberof PublicCouponCampaignStageDto
     */
    sort: number;
    /**
     * 
     * @type {number}
     * @memberof PublicCouponCampaignStageDto
     */
    expiresInSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof PublicCouponCampaignStageDto
     */
    maxImpressions?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PublicCouponCampaignStageDto
     */
    meta?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface PublicSaasSubscriptionCouponCampaignItem
 */
export interface PublicSaasSubscriptionCouponCampaignItem {
    /**
     * 
     * @type {string}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    name: string;
    /**
     * 
     * @type {SaasSubscriptionCouponCampaignSceneEnumItem}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    scene: SaasSubscriptionCouponCampaignSceneEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    allowAnonymousUsers: boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    startsAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    endsAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    priority?: number;
    /**
     * returned rather than applied: per the campaign spec the client matches and runs the flow. `criteria.userIds` is applied server-side and never included here.
     * @type {PublicCouponCampaignCriteriaDto}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    criteria?: PublicCouponCampaignCriteriaDto;
    /**
     * 
     * @type {Array<PublicCouponCampaignStageDto>}
     * @memberof PublicSaasSubscriptionCouponCampaignItem
     */
    stages: Array<PublicCouponCampaignStageDto>;
}


/**
 * 
 * @export
 * @interface PublicSaasSubscriptionCouponCampaignPageRows
 */
export interface PublicSaasSubscriptionCouponCampaignPageRows {
    /**
     * 
     * @type {Array<PublicSaasSubscriptionCouponCampaignItem>}
     * @memberof PublicSaasSubscriptionCouponCampaignPageRows
     */
    rows: Array<PublicSaasSubscriptionCouponCampaignItem>;
}
/**
 * 
 * @export
 * @interface PurchasedAvatarMeMediaItem
 */
export interface PurchasedAvatarMeMediaItem {
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    buyerId: string;
    /**
     * 
     * @type {AvatarMeBuyerProfileItem}
     * @memberof PurchasedAvatarMeMediaItem
     */
    buyerProfile?: AvatarMeBuyerProfileItem;
    /**
     * 
     * @type {PurchasedAvatarMeMediaSourceTypeEnumItem}
     * @memberof PurchasedAvatarMeMediaItem
     */
    sourceType?: PurchasedAvatarMeMediaSourceTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    storeName: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    listingId?: string;
    /**
     * 
     * @type {PurchasedAvatarMeMediaItemRequest}
     * @memberof PurchasedAvatarMeMediaItem
     */
    request: PurchasedAvatarMeMediaItemRequest;
    /**
     * 
     * @type {AvatarMeProcessStatusEnumItem}
     * @memberof PurchasedAvatarMeMediaItem
     */
    status: AvatarMeProcessStatusEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    failedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    failureReason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchasedAvatarMeMediaItem
     */
    refunded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    refundedAt?: string;
    /**
     * the original watermark urls from commentsold
     * @type {Array<string>}
     * @memberof PurchasedAvatarMeMediaItem
     */
    watermarkUrls?: Array<string>;
    /**
     * the original cdn urls from commentsold
     * @type {Array<string>}
     * @memberof PurchasedAvatarMeMediaItem
     */
    cdnUrls?: Array<string>;
    /**
     * the original no watermark cdn urls from commentsold
     * @type {Array<string>}
     * @memberof PurchasedAvatarMeMediaItem
     */
    noWatermarkCdnUrls?: Array<string>;
    /**
     * the original url from commentsold
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    originalUrl?: string;
    /**
     * if type is IMAGE, it's a firestore storage url with query parameters(id={imageId}, source=avatarme) and blurhash
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    url?: string;
    /**
     * 
     * @type {WearWithAiItem}
     * @memberof PurchasedAvatarMeMediaItem
     */
    wearWithAi?: WearWithAiItem;
    /**
     * 
     * @type {string}
     * @memberof PurchasedAvatarMeMediaItem
     */
    checkedAtBySeller?: string;
}


/**
 * @type PurchasedAvatarMeMediaItemRequest
 * 
 * @export
 */
export type PurchasedAvatarMeMediaItemRequest = AvatarMeGamifiedLipSyncVideoRequestItem | AvatarMeGamifiedVideoRequestItem | AvatarMeImageRequestItem | AvatarMePhotoshootRequestItem | AvatarMeStudioFreeImageRequestItem | AvatarMeStudioGamifiedLipSyncVideoRequestItem | AvatarMeStudioImageRequestItem | AvatarMeStudioPhotoshootRequestItem | AvatarMeStudioVideo10sRequestItem | AvatarMeStudioVideo5sRequestItem | AvatarMeStudioVideoPromptRequestItem | AvatarMeStudioVideoRequestItem | AvatarMeStudioVideoXsRequestItem | AvatarMeVideo10sRequestItem | AvatarMeVideo5sRequestItem | AvatarMeVideoFacePerfectRequestItem | AvatarMeVideoHdUpgradeRequestItem | AvatarMeVideoRequestItem;
/**
 * 
 * @export
 * @interface PurchasedAvatarMeMediaPageRows
 */
export interface PurchasedAvatarMeMediaPageRows {
    /**
     * 
     * @type {Array<PurchasedAvatarMeMediaItem>}
     * @memberof PurchasedAvatarMeMediaPageRows
     */
    rows: Array<PurchasedAvatarMeMediaItem>;
}

/**
 * 
 * @export
 */
export const PurchasedAvatarMeMediaSourceTypeEnumItem = {
    Order: 'ORDER',
    TokenOrder: 'TOKEN_ORDER',
    VidCon2026: 'VID_CON_2026'
} as const;
export type PurchasedAvatarMeMediaSourceTypeEnumItem = typeof PurchasedAvatarMeMediaSourceTypeEnumItem[keyof typeof PurchasedAvatarMeMediaSourceTypeEnumItem];

/**
 * 
 * @export
 * @interface RecentRepliedProfileDto
 */
export interface RecentRepliedProfileDto {
    /**
     * 
     * @type {string}
     * @memberof RecentRepliedProfileDto
     */
    userId: string;
    /**
     * 
     * @type {BasicProfileDto}
     * @memberof RecentRepliedProfileDto
     */
    profile: BasicProfileDto;
}
/**
 * 
 * @export
 * @interface RecipientItem
 */
export interface RecipientItem {
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     * @deprecated
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RecipientItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    storeType?: RecipientItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof RecipientItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof RecipientItem
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {PopStoreCreatorBusinessTypeEnumItem}
     * @memberof RecipientItem
     */
    businessType?: PopStoreCreatorBusinessTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    nftImageUrl?: string;
}


/**
 * @export
 */
export const RecipientItemStoreTypeEnum = {
    Business: 'Business',
    Creator: 'Creator',
    CommentChat: 'CommentChat',
    Vfs: 'VFS'
} as const;
export type RecipientItemStoreTypeEnum = typeof RecipientItemStoreTypeEnum[keyof typeof RecipientItemStoreTypeEnum];

/**
 * 
 * @export
 * @interface RedeemCouponRequest
 */
export interface RedeemCouponRequest {
    /**
     * 
     * @type {string}
     * @memberof RedeemCouponRequest
     */
    sellerId?: string;
}
/**
 * 
 * @export
 * @interface RedeemedCouponItem
 */
export interface RedeemedCouponItem {
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    redeemedCouponId: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    couponId: string;
    /**
     * 
     * @type {CouponItem}
     * @memberof RedeemedCouponItem
     */
    coupon: CouponItem;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    buyerId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof RedeemedCouponItem
     */
    buyerProfile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    usedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemedCouponItem
     */
    used: boolean;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    targetSellerId?: string;
}
/**
 * 
 * @export
 * @interface ReferralGiftingSource
 */
export interface ReferralGiftingSource {
    /**
     * 
     * @type {string}
     * @memberof ReferralGiftingSource
     */
    type: ReferralGiftingSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReferralGiftingSource
     */
    sentReferralGiftId: string;
}


/**
 * @export
 */
export const ReferralGiftingSourceTypeEnum = {
    ReferralGifting: 'REFERRAL_GIFTING'
} as const;
export type ReferralGiftingSourceTypeEnum = typeof ReferralGiftingSourceTypeEnum[keyof typeof ReferralGiftingSourceTypeEnum];

/**
 * 
 * @export
 * @interface RefreshUserSubscriptionLevelRequest
 */
export interface RefreshUserSubscriptionLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof RefreshUserSubscriptionLevelRequest
     */
    creatorId: string;
}
/**
 * 
 * @export
 * @interface RefundOrderRequest
 */
export interface RefundOrderRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof RefundOrderRequest
     */
    refundTypes: Array<RefundOrderRequestRefundTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof RefundOrderRequest
     */
    reason?: string;
    /**
     * 
     * @type {number}
     * @memberof RefundOrderRequest
     */
    quantity?: number;
    /**
     * only admin can use
     * @type {string}
     * @memberof RefundOrderRequest
     */
    processingFeePayer?: RefundOrderRequestProcessingFeePayerEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RefundOrderRequest
     */
    shouldRestock: boolean;
}


/**
 * @export
 */
export const RefundOrderRequestRefundTypesEnum = {
    All: 'all',
    ShippingFee: 'shippingFee',
    Listing: 'listing',
    CancelListing: 'cancelListing',
    CustomAmount: 'customAmount'
} as const;
export type RefundOrderRequestRefundTypesEnum = typeof RefundOrderRequestRefundTypesEnum[keyof typeof RefundOrderRequestRefundTypesEnum];

/**
 * @export
 */
export const RefundOrderRequestProcessingFeePayerEnum = {
    Seller: 'SELLER',
    Popshop: 'POPSHOP'
} as const;
export type RefundOrderRequestProcessingFeePayerEnum = typeof RefundOrderRequestProcessingFeePayerEnum[keyof typeof RefundOrderRequestProcessingFeePayerEnum];

/**
 * 
 * @export
 * @interface Relations
 */
export interface Relations {
    /**
     * 
     * @type {string}
     * @memberof Relations
     */
    parentId: string;
}
/**
 * 
 * @export
 * @interface RenameStorePersonalLookRequest
 */
export interface RenameStorePersonalLookRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameStorePersonalLookRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface RephraseAvatarMeVideoPromptRequest
 */
export interface RephraseAvatarMeVideoPromptRequest {
    /**
     * 
     * @type {string}
     * @memberof RephraseAvatarMeVideoPromptRequest
     */
    imageProcessId: string;
    /**
     * 
     * @type {string}
     * @memberof RephraseAvatarMeVideoPromptRequest
     */
    prompt: string;
}
/**
 * 
 * @export
 * @interface RephraseAvatarMeVideoPromptResponse
 */
export interface RephraseAvatarMeVideoPromptResponse {
    /**
     * 
     * @type {string}
     * @memberof RephraseAvatarMeVideoPromptResponse
     */
    prompt: string;
}
/**
 * 
 * @export
 * @interface ReplaySource
 */
export interface ReplaySource {
    /**
     * 
     * @type {string}
     * @memberof ReplaySource
     */
    type: ReplaySourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReplaySource
     */
    liveStreamId: string;
}


/**
 * @export
 */
export const ReplaySourceTypeEnum = {
    Replay: 'REPLAY'
} as const;
export type ReplaySourceTypeEnum = typeof ReplaySourceTypeEnum[keyof typeof ReplaySourceTypeEnum];

/**
 * 
 * @export
 * @interface ReportLiveStreamRequest
 */
export interface ReportLiveStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportLiveStreamRequest
     */
    flag: string;
    /**
     * 
     * @type {string}
     * @memberof ReportLiveStreamRequest
     */
    additionalMsg?: string;
}

/**
 * 
 * @export
 */
export const ReportReasonEnumItem = {
    Spam: 'spam',
    Inappropriate: 'inappropriate',
    Aggressive: 'aggressive'
} as const;
export type ReportReasonEnumItem = typeof ReportReasonEnumItem[keyof typeof ReportReasonEnumItem];

/**
 * 
 * @export
 * @interface RescheduleMeetingOrderRequest
 */
export interface RescheduleMeetingOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof RescheduleMeetingOrderRequest
     */
    startDate: string;
    /**
     * 
     * @type {number}
     * @memberof RescheduleMeetingOrderRequest
     */
    durationInSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof RescheduleMeetingOrderRequest
     */
    reason?: string;
}
/**
 * 
 * @export
 * @interface ResumeLiveStreamRequest
 */
export interface ResumeLiveStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof ResumeLiveStreamRequest
     */
    device?: string;
}
/**
 * 
 * @export
 * @interface RetentionFeedbackBody
 */
export interface RetentionFeedbackBody {
    /**
     * 
     * @type {Array<object>}
     * @memberof RetentionFeedbackBody
     */
    answers: Array<object>;
    /**
     * 
     * @type {SaasSubscriptionRetentionOfferEnumItem}
     * @memberof RetentionFeedbackBody
     */
    retentionOffer: SaasSubscriptionRetentionOfferEnumItem;
}


/**
 * 
 * @export
 * @interface RetentionFreeMonthOffer
 */
export interface RetentionFreeMonthOffer {
    /**
     * Pass to the apply endpoint to take this offer
     * @type {string}
     * @memberof RetentionFreeMonthOffer
     */
    couponCode: string;
    /**
     * AI credits granted on top of the free invoice
     * @type {number}
     * @memberof RetentionFreeMonthOffer
     */
    bonusCredits: number;
}
/**
 * 
 * @export
 * @interface RetentionOfferPlanDetails
 */
export interface RetentionOfferPlanDetails {
    /**
     * 
     * @type {string}
     * @memberof RetentionOfferPlanDetails
     */
    planName: string;
    /**
     * 
     * @type {number}
     * @memberof RetentionOfferPlanDetails
     */
    originalPrice: number;
    /**
     * 
     * @type {number}
     * @memberof RetentionOfferPlanDetails
     */
    discountedPrice: number;
    /**
     * 
     * @type {number}
     * @memberof RetentionOfferPlanDetails
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof RetentionOfferPlanDetails
     */
    discountedAmount: number;
    /**
     * 
     * @type {SubscriptionPlanIntervalEnumItem}
     * @memberof RetentionOfferPlanDetails
     */
    interval: SubscriptionPlanIntervalEnumItem;
}


/**
 * 
 * @export
 * @interface RetentionOfferResponse
 */
export interface RetentionOfferResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RetentionOfferResponse
     */
    eligible: boolean;
    /**
     * 
     * @type {string}
     * @memberof RetentionOfferResponse
     */
    userType?: RetentionOfferResponseUserTypeEnum;
    /**
     * The discount offer coupon
     * @type {string}
     * @memberof RetentionOfferResponse
     */
    couponCode?: string;
    /**
     * 
     * @type {number}
     * @memberof RetentionOfferResponse
     */
    discountPercent?: number;
    /**
     * How many invoices the discount covers
     * @type {number}
     * @memberof RetentionOfferResponse
     */
    durationMonths?: number;
    /**
     * 
     * @type {RetentionOfferPlanDetails}
     * @memberof RetentionOfferResponse
     */
    plan?: RetentionOfferPlanDetails;
    /**
     * 
     * @type {string}
     * @memberof RetentionOfferResponse
     */
    offerExpiresAt?: string;
    /**
     * What the "too complicated" branch offers: a setup call for larger accounts, the setup video otherwise
     * @type {string}
     * @memberof RetentionOfferResponse
     */
    setupBranch?: RetentionOfferResponseSetupBranchEnum;
    /**
     * 
     * @type {RetentionFreeMonthOffer}
     * @memberof RetentionOfferResponse
     */
    freeMonth?: RetentionFreeMonthOffer;
}


/**
 * @export
 */
export const RetentionOfferResponseUserTypeEnum = {
    Paid: 'paid',
    Trial: 'trial'
} as const;
export type RetentionOfferResponseUserTypeEnum = typeof RetentionOfferResponseUserTypeEnum[keyof typeof RetentionOfferResponseUserTypeEnum];

/**
 * @export
 */
export const RetentionOfferResponseSetupBranchEnum = {
    Call: 'call',
    Video: 'video'
} as const;
export type RetentionOfferResponseSetupBranchEnum = typeof RetentionOfferResponseSetupBranchEnum[keyof typeof RetentionOfferResponseSetupBranchEnum];

/**
 * 
 * @export
 * @interface RetryPaymentRequest
 */
export interface RetryPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof RetryPaymentRequest
     */
    stripeConfirmationToken: string;
    /**
     * 
     * @type {string}
     * @memberof RetryPaymentRequest
     */
    returnUrl: string;
}
/**
 * 
 * @export
 * @interface RetryPaymentResponse
 */
export interface RetryPaymentResponse {
    /**
     * 
     * @type {CreateOrderResponse}
     * @memberof RetryPaymentResponse
     */
    order: CreateOrderResponse;
    /**
     * 
     * @type {object}
     * @memberof RetryPaymentResponse
     */
    nextAction?: object;
}
/**
 * 
 * @export
 * @interface RichOrderItem
 */
export interface RichOrderItem {
    /**
     * 
     * @type {CommentSoldOrderItem}
     * @memberof RichOrderItem
     */
    commentSold?: CommentSoldOrderItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     * @deprecated
     */
    buyerName: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    shippingFeeAdjusted: number;
    /**
     * 
     * @type {boolean}
     * @memberof RichOrderItem
     */
    braintreeShippingFeeRefunded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    buyerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof RichOrderItem
     */
    buyer: OrderProfileItem;
    /**
     * 
     * @type {OrderGiftingItem}
     * @memberof RichOrderItem
     */
    gifting?: OrderGiftingItem;
    /**
     * 
     * @type {OrderGiftPackageItem}
     * @memberof RichOrderItem
     */
    giftPackage?: OrderGiftPackageItem;
    /**
     * 
     * @type {ShipmentItem}
     * @memberof RichOrderItem
     */
    shipment?: ShipmentItem;
    /**
     * 
     * @type {PackingSlipItem}
     * @memberof RichOrderItem
     */
    packingSlip?: PackingSlipItem;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    refund?: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    userAgent?: string;
    /**
     * 
     * @type {OrderPaymentItem}
     * @memberof RichOrderItem
     */
    orderPayment?: OrderPaymentItem;
    /**
     * 
     * @type {PaymentItem}
     * @memberof RichOrderItem
     */
    payment?: PaymentItem;
    /**
     * 
     * @type {Array<RedeemedCouponItem>}
     * @memberof RichOrderItem
     */
    coupons?: Array<RedeemedCouponItem>;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    couponDiscountProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    couponDiscountShippingFeeAmount?: number;
    /**
     * 
     * @type {SellerTrackingInfoItem}
     * @memberof RichOrderItem
     */
    sellerTrackingInfo?: SellerTrackingInfoItem;
    /**
     * 
     * @type {Array<SellerTrackingInfoItem>}
     * @memberof RichOrderItem
     */
    sellerTrackingInfoHistory?: Array<SellerTrackingInfoItem>;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    bonus?: number;
    /**
     * 
     * @type {AddressItem}
     * @memberof RichOrderItem
     */
    shippingAddress: AddressItem;
    /**
     * 
     * @type {PickupAddressItem}
     * @memberof RichOrderItem
     */
    pickupAddress?: PickupAddressItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof RichOrderItem
     */
    listingSnapshot: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    sendItemId?: string;
    /**
     * 
     * @type {CreateOrderResponseSendItem}
     * @memberof RichOrderItem
     */
    sendItem?: CreateOrderResponseSendItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    sellerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof RichOrderItem
     */
    seller: OrderProfileItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    status: RichOrderItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    orderGroupStatus: RichOrderItemOrderGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    pickupStatus?: RichOrderItemPickupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    cancelStatus?: RichOrderItemCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    orderGroupCancelStatus?: RichOrderItemOrderGroupCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    orderRefundStatus?: RichOrderItemOrderRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    orderGroupRefundStatus?: RichOrderItemOrderGroupRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    shippingMethod: RichOrderItemShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    shippoOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    variantId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof RichOrderItem
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {OrderShipmentGroupStatus}
     * @memberof RichOrderItem
     */
    orderShipmentGroupStatus: OrderShipmentGroupStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof RichOrderItem
     */
    shippingLabelStatus: ShippingLabelStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof RichOrderItem
     */
    packingSlipStatus: ShippingLabelStatus;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    masterOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    planTimeOfShippingLabelGeneration?: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalQuantitiesIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalPriceIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalPriceIncludeSlaveOrdersWithProductCoupon: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalRefundIncludeSlaveOrders?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RichOrderItem
     */
    newCustomer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    firstPurchaseAt?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {OrderCompositionCancellationStatus}
     * @memberof RichOrderItem
     */
    orderCompositionCancellationStatus?: OrderCompositionCancellationStatus;
    /**
     * 
     * @type {OrderChargeDistributionItem}
     * @memberof RichOrderItem
     */
    orderChargeDistribution?: OrderChargeDistributionItem;
    /**
     * 
     * @type {boolean}
     * @memberof RichOrderItem
     */
    packed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    pickupNotifiedAt?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof RichOrderItem
     */
    source?: OrderSource;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof RichOrderItem
     */
    shipmentParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof RichOrderItem
     */
    shipmentOriginalParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    shipmentOriginalParcelSource?: RichOrderItemShipmentOriginalParcelSourceEnum;
    /**
     * 
     * @type {OrderItemPriceComponents}
     * @memberof RichOrderItem
     */
    priceComponents?: OrderItemPriceComponents;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof RichOrderItem
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    packageTemplateId?: string;
    /**
     * 
     * @type {OrderItemPackageTemplate}
     * @memberof RichOrderItem
     */
    packageTemplate?: OrderItemPackageTemplate;
    /**
     * 
     * @type {OrderItemPresetShippingCost}
     * @memberof RichOrderItem
     */
    presetShippingCost?: OrderItemPresetShippingCost;
    /**
     * 
     * @type {OrderItemDropshipDetails}
     * @memberof RichOrderItem
     */
    dropshipDetails?: OrderItemDropshipDetails;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    fundAvailableDate?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    fundAvailableDate2?: string;
    /**
     * 
     * @type {LabelShippingCost}
     * @memberof RichOrderItem
     */
    labelShippingCost?: LabelShippingCost;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalRefundedSalesTax?: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    paymentExpireAt?: string;
    /**
     * 
     * @type {MultiCurrencyOrderItem}
     * @memberof RichOrderItem
     */
    buyerCurrencyOrderDetails?: MultiCurrencyOrderItem;
    /**
     * 
     * @type {OrderCalendarEventItem}
     * @memberof RichOrderItem
     */
    calendarEvent?: OrderCalendarEventItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalSalesTaxAmountIncludeSlaveOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalSalesTaxAmountIncludeSlaveOrdersInCurrency?: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    type?: string;
}


/**
 * @export
 */
export const RichOrderItemStatusEnum = {
    Created: 'created',
    Completed: 'completed',
    Canceled: 'canceled',
    PendingPayment: 'pendingPayment',
    ProcessingPayment: 'processingPayment',
    Closed: 'closed'
} as const;
export type RichOrderItemStatusEnum = typeof RichOrderItemStatusEnum[keyof typeof RichOrderItemStatusEnum];

/**
 * @export
 */
export const RichOrderItemOrderGroupStatusEnum = {
    Open: 'open',
    Processing: 'processing',
    Fulfilling: 'fulfilling',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type RichOrderItemOrderGroupStatusEnum = typeof RichOrderItemOrderGroupStatusEnum[keyof typeof RichOrderItemOrderGroupStatusEnum];

/**
 * @export
 */
export const RichOrderItemPickupStatusEnum = {
    Open: 'open',
    New: 'new',
    Processing: 'processing',
    Pending: 'pending',
    Packed: 'packed',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;
export type RichOrderItemPickupStatusEnum = typeof RichOrderItemPickupStatusEnum[keyof typeof RichOrderItemPickupStatusEnum];

/**
 * @export
 */
export const RichOrderItemCancelStatusEnum = {
    SellerApplied: 'seller_applied',
    AdminApproved: 'admin_approved'
} as const;
export type RichOrderItemCancelStatusEnum = typeof RichOrderItemCancelStatusEnum[keyof typeof RichOrderItemCancelStatusEnum];

/**
 * @export
 */
export const RichOrderItemOrderGroupCancelStatusEnum = {
    PartialCanceled: 'PARTIAL_CANCELED',
    FullyCanceled: 'FULLY_CANCELED'
} as const;
export type RichOrderItemOrderGroupCancelStatusEnum = typeof RichOrderItemOrderGroupCancelStatusEnum[keyof typeof RichOrderItemOrderGroupCancelStatusEnum];

/**
 * @export
 */
export const RichOrderItemOrderRefundStatusEnum = {
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED'
} as const;
export type RichOrderItemOrderRefundStatusEnum = typeof RichOrderItemOrderRefundStatusEnum[keyof typeof RichOrderItemOrderRefundStatusEnum];

/**
 * @export
 */
export const RichOrderItemOrderGroupRefundStatusEnum = {
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED'
} as const;
export type RichOrderItemOrderGroupRefundStatusEnum = typeof RichOrderItemOrderGroupRefundStatusEnum[keyof typeof RichOrderItemOrderGroupRefundStatusEnum];

/**
 * @export
 */
export const RichOrderItemShippingMethodEnum = {
    SellerProvide: 'sellerProvide',
    PopshopProvide: 'popshopProvide',
    Pickup: 'pickup',
    DropshipSupplierProvide: 'dropshipSupplierProvide'
} as const;
export type RichOrderItemShippingMethodEnum = typeof RichOrderItemShippingMethodEnum[keyof typeof RichOrderItemShippingMethodEnum];

/**
 * @export
 */
export const RichOrderItemShipmentOriginalParcelSourceEnum = {
    Default: 'DEFAULT',
    ShowEvent: 'SHOW_EVENT'
} as const;
export type RichOrderItemShipmentOriginalParcelSourceEnum = typeof RichOrderItemShipmentOriginalParcelSourceEnum[keyof typeof RichOrderItemShipmentOriginalParcelSourceEnum];

/**
 * 
 * @export
 * @interface RichShippingCostItem
 */
export interface RichShippingCostItem {
    /**
     * 
     * @type {string}
     * @memberof RichShippingCostItem
     */
    status: RichShippingCostItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichShippingCostItem
     */
    message?: string;
    /**
     * available when status is success
     * @type {string}
     * @memberof RichShippingCostItem
     */
    shipmentId?: string;
    /**
     * available when status is success
     * @type {Array<ShippingRateItem>}
     * @memberof RichShippingCostItem
     */
    rates?: Array<ShippingRateItem>;
}


/**
 * @export
 */
export const RichShippingCostItemStatusEnum = {
    Pending: 'pending',
    Failed: 'failed',
    Success: 'success'
} as const;
export type RichShippingCostItemStatusEnum = typeof RichShippingCostItemStatusEnum[keyof typeof RichShippingCostItemStatusEnum];

/**
 * 
 * @export
 * @interface SaasInvoicePaymentMethodDetailsItem
 */
export interface SaasInvoicePaymentMethodDetailsItem {
    /**
     * 
     * @type {string}
     * @memberof SaasInvoicePaymentMethodDetailsItem
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasInvoicePaymentMethodDetailsItem
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasInvoicePaymentMethodDetailsItem
     */
    last4?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasInvoicePaymentMethodDetailsItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasInvoicePaymentMethodDetailsItem
     */
    network?: string;
    /**
     * 
     * @type {SaasInvoicePaymentMethodWalletItem}
     * @memberof SaasInvoicePaymentMethodDetailsItem
     */
    wallet?: SaasInvoicePaymentMethodWalletItem;
}
/**
 * 
 * @export
 * @interface SaasInvoicePaymentMethodWalletItem
 */
export interface SaasInvoicePaymentMethodWalletItem {
    /**
     * 
     * @type {string}
     * @memberof SaasInvoicePaymentMethodWalletItem
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasInvoicePaymentMethodWalletItem
     */
    dynamicLast4?: string;
}

/**
 * 
 * @export
 */
export const SaasSubscriptionBasePlanTypeEnumItem = {
    Beautify: 'BEAUTIFY',
    Community: 'COMMUNITY',
    Expert: 'EXPERT',
    CreatorPro: 'CREATOR PRO',
    Pro: 'PRO',
    RealEstateStarter: 'REAL ESTATE STARTER',
    RealEstatePro: 'REAL ESTATE PRO',
    RealEstateStar: 'REAL ESTATE STAR',
    ExpertCoachLaunch: 'EXPERT COACH LAUNCH',
    ExpertCoachPro: 'EXPERT COACH PRO',
    ExpertCoachAuthority: 'EXPERT COACH AUTHORITY',
    RealEstateAgent: 'REAL ESTATE AGENT',
    RealEstateProAgent: 'REAL ESTATE PRO AGENT',
    RealEstateTopProducer: 'REAL ESTATE TOP PRODUCER',
    BeautyLifestyleCreator: 'BEAUTY LIFESTYLE CREATOR',
    BeautyLifestylePro: 'BEAUTY LIFESTYLE PRO',
    BeautyLifestyleIcon: 'BEAUTY LIFESTYLE ICON',
    AiPdfCreator: 'AI PDF CREATOR',
    EchoMeAiAgent: 'ECHO-ME AI Agent',
    EchoMeFree: 'ECHO-ME FREE',
    EchoMeSolo: 'ECHO-ME SOLO',
    EchoMeSpark: 'ECHO-ME SPARK',
    EchoMeSurge: 'ECHO-ME SURGE'
} as const;
export type SaasSubscriptionBasePlanTypeEnumItem = typeof SaasSubscriptionBasePlanTypeEnumItem[keyof typeof SaasSubscriptionBasePlanTypeEnumItem];


/**
 * 
 * @export
 */
export const SaasSubscriptionCancelIntentEnumItem = {
    DowngradeToFree: 'downgrade_to_free',
    Cancel: 'cancel'
} as const;
export type SaasSubscriptionCancelIntentEnumItem = typeof SaasSubscriptionCancelIntentEnumItem[keyof typeof SaasSubscriptionCancelIntentEnumItem];


/**
 * `left` only — absent = any departure signal fires the stage
 * @export
 */
export const SaasSubscriptionCouponCampaignExitSignalEnumItem = {
    PageHidden: 'page_hidden',
    PageUnload: 'page_unload',
    SceneLeft: 'scene_left'
} as const;
export type SaasSubscriptionCouponCampaignExitSignalEnumItem = typeof SaasSubscriptionCouponCampaignExitSignalEnumItem[keyof typeof SaasSubscriptionCouponCampaignExitSignalEnumItem];


/**
 * 
 * @export
 */
export const SaasSubscriptionCouponCampaignReachMethodEnumItem = {
    Inline: 'inline',
    Popup: 'popup',
    Email: 'email',
    EmailFlow: 'email_flow'
} as const;
export type SaasSubscriptionCouponCampaignReachMethodEnumItem = typeof SaasSubscriptionCouponCampaignReachMethodEnumItem[keyof typeof SaasSubscriptionCouponCampaignReachMethodEnumItem];


/**
 * 
 * @export
 */
export const SaasSubscriptionCouponCampaignSceneEnumItem = {
    NewSubscription: 'new_subscription',
    UpgradeSubscription: 'upgrade_subscription'
} as const;
export type SaasSubscriptionCouponCampaignSceneEnumItem = typeof SaasSubscriptionCouponCampaignSceneEnumItem[keyof typeof SaasSubscriptionCouponCampaignSceneEnumItem];


/**
 * 
 * @export
 */
export const SaasSubscriptionCouponCampaignTriggerTypeEnumItem = {
    Landed: 'landed',
    Idled: 'idled',
    ActionTaken: 'action_taken',
    Left: 'left'
} as const;
export type SaasSubscriptionCouponCampaignTriggerTypeEnumItem = typeof SaasSubscriptionCouponCampaignTriggerTypeEnumItem[keyof typeof SaasSubscriptionCouponCampaignTriggerTypeEnumItem];


/**
 * 
 * @export
 */
export const SaasSubscriptionCouponFrequencyEnumItem = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type SaasSubscriptionCouponFrequencyEnumItem = typeof SaasSubscriptionCouponFrequencyEnumItem[keyof typeof SaasSubscriptionCouponFrequencyEnumItem];


/**
 * 
 * @export
 */
export const SaasSubscriptionCouponTypeEnumItem = {
    PercentOff: 'percent_off',
    AmountOff: 'amount_off',
    Trial: 'trial'
} as const;
export type SaasSubscriptionCouponTypeEnumItem = typeof SaasSubscriptionCouponTypeEnumItem[keyof typeof SaasSubscriptionCouponTypeEnumItem];

/**
 * 
 * @export
 * @interface SaasSubscriptionPromotionDetails
 */
export interface SaasSubscriptionPromotionDetails {
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionPromotionDetails
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionPromotionDetails
     */
    couponId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaasSubscriptionPromotionDetails
     */
    subscriptionPlanIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionPromotionDetails
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaasSubscriptionPromotionDetails
     */
    tags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SaasSubscriptionPromotionDetails
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaasSubscriptionPromotionDetails
     */
    isSceneDefault?: boolean;
    /**
     * 
     * @type {SaasSubscriptionSceneEnumItem}
     * @memberof SaasSubscriptionPromotionDetails
     */
    scene?: SaasSubscriptionSceneEnumItem;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionPromotionDetails
     */
    headerImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionPromotionDetails
     */
    headerContent?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionPromotionDetails
     */
    offerContent?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionPromotionDetails
     */
    sceneImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionPromotionDetails
     */
    cancelBtnText?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionPromotionDetails
     */
    confirmBtnText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SaasSubscriptionPromotionDetails
     */
    isDeleted?: boolean;
}


/**
 * 
 * @export
 * @interface SaasSubscriptionRefundItem
 */
export interface SaasSubscriptionRefundItem {
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionRefundItem
     */
    paymentIntentId: string;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionRefundItem
     */
    invoiceId?: string;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionRefundItem
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionRefundItem
     */
    appliedAt: string;
    /**
     * 
     * @type {number}
     * @memberof SaasSubscriptionRefundItem
     */
    refundedAmount: number;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionRefundItem
     */
    status: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionRefundItem
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof SaasSubscriptionRefundItem
     */
    failureReason?: string;
}

/**
 * 
 * @export
 */
export const SaasSubscriptionRetentionOfferEnumItem = {
    Discount: 'discount',
    FreeMonth: 'free_month'
} as const;
export type SaasSubscriptionRetentionOfferEnumItem = typeof SaasSubscriptionRetentionOfferEnumItem[keyof typeof SaasSubscriptionRetentionOfferEnumItem];


/**
 * 
 * @export
 */
export const SaasSubscriptionSceneEnumItem = {
    Checkout: 'checkout',
    Welcome: 'welcome',
    Winback: 'winback',
    AvatarMe: 'avatar_me',
    AdvancedStyle: 'advanced_style',
    CommentChat: 'comment_chat',
    DigitalDownloads: 'digital_downloads',
    Followers: 'followers',
    MeetingSlots: 'meeting_slots',
    AlternativeDomain: 'alternative_domain',
    IndependentDomain: 'independent_domain',
    CourseCreator: 'course_creator',
    SignUp: 'sign_up',
    RealEstate: 'real_estate'
} as const;
export type SaasSubscriptionSceneEnumItem = typeof SaasSubscriptionSceneEnumItem[keyof typeof SaasSubscriptionSceneEnumItem];


/**
 * 
 * @export
 */
export const SassSubscriptionCouponDurationTypeEnumItem = {
    Once: 'once',
    Repeating: 'repeating',
    Forever: 'forever'
} as const;
export type SassSubscriptionCouponDurationTypeEnumItem = typeof SassSubscriptionCouponDurationTypeEnumItem[keyof typeof SassSubscriptionCouponDurationTypeEnumItem];

/**
 * 
 * @export
 * @interface SaveAvailabilityRequest
 */
export interface SaveAvailabilityRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveAvailabilityRequest
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAvailabilityRequest
     */
    endTime?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAvailabilityRequest
     */
    timezone: string;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAvailabilityRequest
     */
    includeWeekends: boolean;
    /**
     * 
     * @type {Array<MeetingTypeRequest>}
     * @memberof SaveAvailabilityRequest
     */
    meetingTypes: Array<MeetingTypeRequest>;
    /**
     * 
     * @type {AdvanceNoticeRequest}
     * @memberof SaveAvailabilityRequest
     */
    advanceNotice: AdvanceNoticeRequest;
    /**
     * 
     * @type {SaveAvailabilityRequestFutureScheduleCondition}
     * @memberof SaveAvailabilityRequest
     */
    futureScheduleCondition: SaveAvailabilityRequestFutureScheduleCondition;
    /**
     * 
     * @type {Array<CustomScheduleRequest>}
     * @memberof SaveAvailabilityRequest
     */
    customSchedules?: Array<CustomScheduleRequest>;
}
/**
 * @type SaveAvailabilityRequestFutureScheduleCondition
 * 
 * @export
 */
export type SaveAvailabilityRequestFutureScheduleCondition = FutureScheduleConditionAnytimeRequest | FutureScheduleConditionDateRangeRequest | FutureScheduleConditionDaysRequest;
/**
 * 
 * @export
 * @interface SaveAvatarMeCustomLocationRequest
 */
export interface SaveAvatarMeCustomLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveAvatarMeCustomLocationRequest
     */
    personalLookId?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAvatarMeCustomLocationRequest
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAvatarMeCustomLocationRequest
     */
    label: string;
}
/**
 * 
 * @export
 * @interface SaveAvatarMeCustomVideoPromptRequest
 */
export interface SaveAvatarMeCustomVideoPromptRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveAvatarMeCustomVideoPromptRequest
     */
    personalLookId?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAvatarMeCustomVideoPromptRequest
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAvatarMeCustomVideoPromptRequest
     */
    label: string;
}
/**
 * 
 * @export
 * @interface SaveRetentionFeedbackResponse
 */
export interface SaveRetentionFeedbackResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SaveRetentionFeedbackResponse
     */
    success: boolean;
}

/**
 * 
 * @export
 * @interface ScrapeListingResponse
 */
export interface ScrapeListingResponse {
    /**
     * 
     * @type {string}
     * @memberof ScrapeListingResponse
     */
    source: ScrapeListingResponseSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ScrapeListingResponse
     */
    sourceUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapeListingResponse
     */
    scrapedAt: string;
    /**
     * 
     * @type {ScrapedListingItem}
     * @memberof ScrapeListingResponse
     */
    listing: ScrapedListingItem;
    /**
     * Non-fatal extraction issues — fields with missing data.
     * @type {Array<string>}
     * @memberof ScrapeListingResponse
     */
    warnings: Array<string>;
}


/**
 * @export
 */
export const ScrapeListingResponseSourceEnum = {
    Compass: 'compass',
    Zillow: 'zillow',
    Redfin: 'redfin'
} as const;
export type ScrapeListingResponseSourceEnum = typeof ScrapeListingResponseSourceEnum[keyof typeof ScrapeListingResponseSourceEnum];

/**
 * 
 * @export
 * @interface ScrapedAddressItem
 */
export interface ScrapedAddressItem {
    /**
     * 
     * @type {string}
     * @memberof ScrapedAddressItem
     */
    full?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedAddressItem
     */
    streetAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedAddressItem
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedAddressItem
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedAddressItem
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedAddressItem
     */
    country?: string;
}
/**
 * 
 * @export
 * @interface ScrapedAgentItem
 */
export interface ScrapedAgentItem {
    /**
     * 
     * @type {string}
     * @memberof ScrapedAgentItem
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedAgentItem
     */
    brokerage?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedAgentItem
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedAgentItem
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedAgentItem
     */
    photoUrl?: string;
}
/**
 * 
 * @export
 * @interface ScrapedDescriptionItem
 */
export interface ScrapedDescriptionItem {
    /**
     * 
     * @type {string}
     * @memberof ScrapedDescriptionItem
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedDescriptionItem
     */
    html?: string;
}
/**
 * 
 * @export
 * @interface ScrapedFeatureItem
 */
export interface ScrapedFeatureItem {
    /**
     * 
     * @type {string}
     * @memberof ScrapedFeatureItem
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedFeatureItem
     */
    category?: string;
}
/**
 * 
 * @export
 * @interface ScrapedImageItem
 */
export interface ScrapedImageItem {
    /**
     * 
     * @type {string}
     * @memberof ScrapedImageItem
     */
    url: string;
    /**
     * 
     * @type {number}
     * @memberof ScrapedImageItem
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof ScrapedImageItem
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof ScrapedImageItem
     */
    alt?: string;
}
/**
 * 
 * @export
 * @interface ScrapedListingItem
 */
export interface ScrapedListingItem {
    /**
     * 
     * @type {string}
     * @memberof ScrapedListingItem
     */
    propertyTitle?: string;
    /**
     * 
     * @type {number}
     * @memberof ScrapedListingItem
     */
    price?: number;
    /**
     * 
     * @type {ScrapedAddressItem}
     * @memberof ScrapedListingItem
     */
    address?: ScrapedAddressItem;
    /**
     * 
     * @type {ScrapedLocationItem}
     * @memberof ScrapedListingItem
     */
    location?: ScrapedLocationItem;
    /**
     * 
     * @type {number}
     * @memberof ScrapedListingItem
     */
    beds?: number;
    /**
     * 
     * @type {number}
     * @memberof ScrapedListingItem
     */
    baths?: number;
    /**
     * 
     * @type {number}
     * @memberof ScrapedListingItem
     */
    sqft?: number;
    /**
     * 
     * @type {number}
     * @memberof ScrapedListingItem
     */
    yearBuilt?: number;
    /**
     * 
     * @type {string}
     * @memberof ScrapedListingItem
     */
    propertyType?: string;
    /**
     * 
     * @type {ScrapedDescriptionItem}
     * @memberof ScrapedListingItem
     */
    description?: ScrapedDescriptionItem;
    /**
     * 
     * @type {Array<ScrapedImageItem>}
     * @memberof ScrapedListingItem
     */
    images: Array<ScrapedImageItem>;
    /**
     * 
     * @type {Array<ScrapedFeatureItem>}
     * @memberof ScrapedListingItem
     */
    features: Array<ScrapedFeatureItem>;
    /**
     * 
     * @type {Array<ScrapedOpenHouseItem>}
     * @memberof ScrapedListingItem
     */
    openHouses: Array<ScrapedOpenHouseItem>;
    /**
     * 
     * @type {ScrapedAgentItem}
     * @memberof ScrapedListingItem
     */
    agent?: ScrapedAgentItem;
}
/**
 * 
 * @export
 * @interface ScrapedLocationItem
 */
export interface ScrapedLocationItem {
    /**
     * 
     * @type {number}
     * @memberof ScrapedLocationItem
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof ScrapedLocationItem
     */
    lng: number;
}
/**
 * 
 * @export
 * @interface ScrapedOpenHouseItem
 */
export interface ScrapedOpenHouseItem {
    /**
     * 
     * @type {string}
     * @memberof ScrapedOpenHouseItem
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedOpenHouseItem
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedOpenHouseItem
     */
    endTime: string;
    /**
     * 
     * @type {string}
     * @memberof ScrapedOpenHouseItem
     */
    timezone?: string;
}
/**
 * 
 * @export
 * @interface SearchAccountsResponse
 */
export interface SearchAccountsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchAccountsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchAccountsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchAccountsResponse
     */
    cursor?: string;
    /**
     * 
     * @type {AccountsPageRows}
     * @memberof SearchAccountsResponse
     */
    data: AccountsPageRows;
}

/**
 * 
 * @export
 */
export const SearchCommunityChannelMemberSortByEnumItem = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt'
} as const;
export type SearchCommunityChannelMemberSortByEnumItem = typeof SearchCommunityChannelMemberSortByEnumItem[keyof typeof SearchCommunityChannelMemberSortByEnumItem];


/**
 * 
 * @export
 */
export const SearchCommunityChannelMessageSortByEnumItem = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    PinnedAt: 'pinnedAt'
} as const;
export type SearchCommunityChannelMessageSortByEnumItem = typeof SearchCommunityChannelMessageSortByEnumItem[keyof typeof SearchCommunityChannelMessageSortByEnumItem];


/**
 * 
 * @export
 */
export const SearchCommunityChannelSortByEnumItem = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    MemberCount: 'memberCount',
    MessageCount: 'messageCount'
} as const;
export type SearchCommunityChannelSortByEnumItem = typeof SearchCommunityChannelSortByEnumItem[keyof typeof SearchCommunityChannelSortByEnumItem];


/**
 * 
 * @export
 */
export const SearchGroupEventSortByEnumItem = {
    Id: 'id',
    CreatedAt: 'createdAt',
    StartDate: 'startDate'
} as const;
export type SearchGroupEventSortByEnumItem = typeof SearchGroupEventSortByEnumItem[keyof typeof SearchGroupEventSortByEnumItem];
/**
 * 
 * @export
 */
export const SearchLeadContactSortByEnumItem = {
    CreatedAt: 'createdAt'
} as const;
export type SearchLeadContactSortByEnumItem = typeof SearchLeadContactSortByEnumItem[keyof typeof SearchLeadContactSortByEnumItem];

/**
 * 
 * @export
 * @interface SearchLeadFormContactResponse
 */
export interface SearchLeadFormContactResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchLeadFormContactResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchLeadFormContactResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchLeadFormContactResponse
     */
    cursor?: string;
    /**
     * 
     * @type {LeadFormContactPageRows}
     * @memberof SearchLeadFormContactResponse
     */
    data: LeadFormContactPageRows;
}

/**
 * 
 * @export
 */
export const SearchLeadFormContactSortByEnumItem = {
    CreatedAt: 'createdAt'
} as const;
export type SearchLeadFormContactSortByEnumItem = typeof SearchLeadFormContactSortByEnumItem[keyof typeof SearchLeadFormContactSortByEnumItem];

/**
 * 
 * @export
 * @interface SearchLeadFormResponse
 */
export interface SearchLeadFormResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchLeadFormResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchLeadFormResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchLeadFormResponse
     */
    cursor?: string;
    /**
     * 
     * @type {LeadFormPageRows}
     * @memberof SearchLeadFormResponse
     */
    data: LeadFormPageRows;
}

/**
 * 
 * @export
 */
export const SearchLeadFormSortByEnumItem = {
    CreatedAt: 'createdAt'
} as const;
export type SearchLeadFormSortByEnumItem = typeof SearchLeadFormSortByEnumItem[keyof typeof SearchLeadFormSortByEnumItem];

/**
 * 
 * @export
 * @interface SearchLeadFormSubmissionResponse
 */
export interface SearchLeadFormSubmissionResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchLeadFormSubmissionResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchLeadFormSubmissionResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchLeadFormSubmissionResponse
     */
    cursor?: string;
    /**
     * 
     * @type {LeadFormSubmissionPageRows}
     * @memberof SearchLeadFormSubmissionResponse
     */
    data: LeadFormSubmissionPageRows;
}

/**
 * 
 * @export
 */
export const SearchLeadFormSubmissionSortByEnumItem = {
    CreatedAt: 'createdAt'
} as const;
export type SearchLeadFormSubmissionSortByEnumItem = typeof SearchLeadFormSubmissionSortByEnumItem[keyof typeof SearchLeadFormSubmissionSortByEnumItem];

/**
 * 
 * @export
 * @interface SearchLeadsContactsV2Response
 */
export interface SearchLeadsContactsV2Response {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchLeadsContactsV2Response
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchLeadsContactsV2Response
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchLeadsContactsV2Response
     */
    cursor?: string;
    /**
     * 
     * @type {LeadsContactV2PageRows}
     * @memberof SearchLeadsContactsV2Response
     */
    data: LeadsContactV2PageRows;
}
/**
 * 
 * @export
 * @interface SearchPersonalLookResponse
 */
export interface SearchPersonalLookResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchPersonalLookResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchPersonalLookResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchPersonalLookResponse
     */
    cursor?: string;
    /**
     * 
     * @type {PersonalLookPageRows}
     * @memberof SearchPersonalLookResponse
     */
    data: PersonalLookPageRows;
}

/**
 * 
 * @export
 */
export const SearchPersonalLookSortByEnumItem = {
    CreatedAt: 'createdAt'
} as const;
export type SearchPersonalLookSortByEnumItem = typeof SearchPersonalLookSortByEnumItem[keyof typeof SearchPersonalLookSortByEnumItem];


/**
 * 
 * @export
 */
export const SearchPollSortByEnumItem = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    VoteCount: 'voteCount',
    VoterCount: 'voterCount'
} as const;
export type SearchPollSortByEnumItem = typeof SearchPollSortByEnumItem[keyof typeof SearchPollSortByEnumItem];


/**
 * 
 * @export
 */
export const SearchPollVoteSortByEnumItem = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt'
} as const;
export type SearchPollVoteSortByEnumItem = typeof SearchPollVoteSortByEnumItem[keyof typeof SearchPollVoteSortByEnumItem];


/**
 * 
 * @export
 */
export const SearchPopStoreThemeTemplatePurposeEnumItem = {
    Manage: 'manage',
    Apply: 'apply'
} as const;
export type SearchPopStoreThemeTemplatePurposeEnumItem = typeof SearchPopStoreThemeTemplatePurposeEnumItem[keyof typeof SearchPopStoreThemeTemplatePurposeEnumItem];


/**
 * 
 * @export
 */
export const SearchPostCommentSortByEnumItem = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    LikeCount: 'likeCount',
    ReplyCount: 'replyCount'
} as const;
export type SearchPostCommentSortByEnumItem = typeof SearchPostCommentSortByEnumItem[keyof typeof SearchPostCommentSortByEnumItem];


/**
 * 
 * @export
 */
export const SearchPostSortByEnumItem = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    PublishedAt: 'publishedAt',
    Title: 'title',
    CommentCount: 'commentCount',
    LikeCount: 'likeCount'
} as const;
export type SearchPostSortByEnumItem = typeof SearchPostSortByEnumItem[keyof typeof SearchPostSortByEnumItem];

/**
 * 
 * @export
 * @interface SearchPublicSaasSubscriptionCouponCampaignResponse
 */
export interface SearchPublicSaasSubscriptionCouponCampaignResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchPublicSaasSubscriptionCouponCampaignResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchPublicSaasSubscriptionCouponCampaignResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchPublicSaasSubscriptionCouponCampaignResponse
     */
    cursor?: string;
    /**
     * 
     * @type {PublicSaasSubscriptionCouponCampaignPageRows}
     * @memberof SearchPublicSaasSubscriptionCouponCampaignResponse
     */
    data: PublicSaasSubscriptionCouponCampaignPageRows;
}
/**
 * 
 * @export
 * @interface SearchPurchasedAvatarMeMediaResponse
 */
export interface SearchPurchasedAvatarMeMediaResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchPurchasedAvatarMeMediaResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchPurchasedAvatarMeMediaResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchPurchasedAvatarMeMediaResponse
     */
    cursor?: string;
    /**
     * 
     * @type {PurchasedAvatarMeMediaPageRows}
     * @memberof SearchPurchasedAvatarMeMediaResponse
     */
    data: PurchasedAvatarMeMediaPageRows;
}

/**
 * 
 * @export
 */
export const SearchPurchasedAvatarMeMediaSortByEnumItem = {
    CreatedAt: 'createdAt'
} as const;
export type SearchPurchasedAvatarMeMediaSortByEnumItem = typeof SearchPurchasedAvatarMeMediaSortByEnumItem[keyof typeof SearchPurchasedAvatarMeMediaSortByEnumItem];

/**
 * 
 * @export
 * @interface SearchSellerCustomerOrdersFilters
 */
export interface SearchSellerCustomerOrdersFilters {
    /**
     * Narrow to a single buyer.
     * @type {string}
     * @memberof SearchSellerCustomerOrdersFilters
     */
    buyerId?: string;
    /**
     * Matches the start of the buyer's first name, last name, username, or the listing name, case-insensitively.
     * @type {string}
     * @memberof SearchSellerCustomerOrdersFilters
     */
    query?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSellerCustomerOrdersFilters
     */
    listingTypes?: Array<SearchSellerCustomerOrdersFiltersListingTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSellerCustomerOrdersFilters
     */
    priceCategories?: Array<SearchSellerCustomerOrdersFiltersPriceCategoriesEnum>;
    /**
     * 
     * @type {SellerCustomerOrdersPaidAmountFilter}
     * @memberof SearchSellerCustomerOrdersFilters
     */
    paidAmount?: SellerCustomerOrdersPaidAmountFilter;
    /**
     * 
     * @type {SellerCustomerOrdersDateRangeEnumItem}
     * @memberof SearchSellerCustomerOrdersFilters
     */
    dateRange?: SellerCustomerOrdersDateRangeEnumItem;
}


/**
 * @export
 */
export const SearchSellerCustomerOrdersFiltersListingTypesEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT',
    DerivedFromPost: 'DERIVED_FROM_POST',
    DerivedFromSeries: 'DERIVED_FROM_SERIES',
    DerivedFromTip: 'DERIVED_FROM_TIP'
} as const;
export type SearchSellerCustomerOrdersFiltersListingTypesEnum = typeof SearchSellerCustomerOrdersFiltersListingTypesEnum[keyof typeof SearchSellerCustomerOrdersFiltersListingTypesEnum];

/**
 * @export
 */
export const SearchSellerCustomerOrdersFiltersPriceCategoriesEnum = {
    Free: 'FREE',
    Discounted: 'DISCOUNTED',
    Original: 'ORIGINAL'
} as const;
export type SearchSellerCustomerOrdersFiltersPriceCategoriesEnum = typeof SearchSellerCustomerOrdersFiltersPriceCategoriesEnum[keyof typeof SearchSellerCustomerOrdersFiltersPriceCategoriesEnum];

/**
 * 
 * @export
 * @interface SearchSellerCustomerOrdersParams
 */
export interface SearchSellerCustomerOrdersParams {
    /**
     * Narrow to a single buyer.
     * @type {string}
     * @memberof SearchSellerCustomerOrdersParams
     */
    buyerId?: string;
    /**
     * Matches the start of the buyer's first name, last name, username, or the listing name, case-insensitively.
     * @type {string}
     * @memberof SearchSellerCustomerOrdersParams
     */
    query?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSellerCustomerOrdersParams
     */
    listingTypes?: Array<SearchSellerCustomerOrdersParamsListingTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSellerCustomerOrdersParams
     */
    priceCategories?: Array<SearchSellerCustomerOrdersParamsPriceCategoriesEnum>;
    /**
     * 
     * @type {SellerCustomerOrdersPaidAmountFilter}
     * @memberof SearchSellerCustomerOrdersParams
     */
    paidAmount?: SellerCustomerOrdersPaidAmountFilter;
    /**
     * 
     * @type {SellerCustomerOrdersDateRangeEnumItem}
     * @memberof SearchSellerCustomerOrdersParams
     */
    dateRange?: SellerCustomerOrdersDateRangeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerCustomerOrdersParams
     */
    pageNo: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerCustomerOrdersParams
     */
    pageSize: number;
    /**
     * 
     * @type {SellerCustomerOrdersSortByEnumItem}
     * @memberof SearchSellerCustomerOrdersParams
     */
    sortBy?: SellerCustomerOrdersSortByEnumItem;
    /**
     * 
     * @type {OrderEnumItem}
     * @memberof SearchSellerCustomerOrdersParams
     */
    order?: OrderEnumItem;
}


/**
 * @export
 */
export const SearchSellerCustomerOrdersParamsListingTypesEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT',
    DerivedFromPost: 'DERIVED_FROM_POST',
    DerivedFromSeries: 'DERIVED_FROM_SERIES',
    DerivedFromTip: 'DERIVED_FROM_TIP'
} as const;
export type SearchSellerCustomerOrdersParamsListingTypesEnum = typeof SearchSellerCustomerOrdersParamsListingTypesEnum[keyof typeof SearchSellerCustomerOrdersParamsListingTypesEnum];

/**
 * @export
 */
export const SearchSellerCustomerOrdersParamsPriceCategoriesEnum = {
    Free: 'FREE',
    Discounted: 'DISCOUNTED',
    Original: 'ORIGINAL'
} as const;
export type SearchSellerCustomerOrdersParamsPriceCategoriesEnum = typeof SearchSellerCustomerOrdersParamsPriceCategoriesEnum[keyof typeof SearchSellerCustomerOrdersParamsPriceCategoriesEnum];

/**
 * 
 * @export
 * @interface SearchSellerCustomerOrdersResponse
 */
export interface SearchSellerCustomerOrdersResponse {
    /**
     * 
     * @type {Array<SellerCustomerOrderItem>}
     * @memberof SearchSellerCustomerOrdersResponse
     */
    data: Array<SellerCustomerOrderItem>;
    /**
     * Matching orders, exact.
     * @type {number}
     * @memberof SearchSellerCustomerOrdersResponse
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchSellerCustomersParams
 */
export interface SearchSellerCustomersParams {
    /**
     * Matches the start of the buyer's username or first name, case-insensitively.
     * @type {string}
     * @memberof SearchSellerCustomersParams
     */
    query?: string;
    /**
     * Compares the spend of whichever date range is in effect.
     * @type {SellerCustomersPaidAmountFilter}
     * @memberof SearchSellerCustomersParams
     */
    paidAmount?: SellerCustomersPaidAmountFilter;
    /**
     * 
     * @type {SellerCustomersDateRangeEnumItem}
     * @memberof SearchSellerCustomersParams
     */
    dateRange?: SellerCustomersDateRangeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerCustomersParams
     */
    pageNo: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerCustomersParams
     */
    pageSize: number;
    /**
     * 
     * @type {SellerCustomersSortByEnumItem}
     * @memberof SearchSellerCustomersParams
     */
    sortBy?: SellerCustomersSortByEnumItem;
    /**
     * 
     * @type {OrderEnumItem}
     * @memberof SearchSellerCustomersParams
     */
    order?: OrderEnumItem;
}


/**
 * 
 * @export
 * @interface SearchSellerCustomersResponse
 */
export interface SearchSellerCustomersResponse {
    /**
     * 
     * @type {Array<SellerCustomerItem>}
     * @memberof SearchSellerCustomersResponse
     */
    data: Array<SellerCustomerItem>;
    /**
     * Distinct customers of this seller. Estimated above roughly 3000, so treat it as a page count rather than an accounting figure.
     * @type {number}
     * @memberof SearchSellerCustomersResponse
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchSellerLifeTimeStatsResponse
 */
export interface SearchSellerLifeTimeStatsResponse {
    /**
     * 
     * @type {AnlsSellerItem}
     * @memberof SearchSellerLifeTimeStatsResponse
     */
    data: AnlsSellerItem;
}

/**
 * 
 * @export
 */
export const SearchSeriesElementsSortByEnumItem = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Sort: 'sort'
} as const;
export type SearchSeriesElementsSortByEnumItem = typeof SearchSeriesElementsSortByEnumItem[keyof typeof SearchSeriesElementsSortByEnumItem];


/**
 * 
 * @export
 */
export const SearchTippingGoalSortByEnumItem = {
    Id: 'id',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    AchievedAt: 'achievedAt'
} as const;
export type SearchTippingGoalSortByEnumItem = typeof SearchTippingGoalSortByEnumItem[keyof typeof SearchTippingGoalSortByEnumItem];


/**
 * 
 * @export
 */
export const SearchTokenListingRequestTypeEnumItem = {
    TokenPack: 'TOKEN_PACK'
} as const;
export type SearchTokenListingRequestTypeEnumItem = typeof SearchTokenListingRequestTypeEnumItem[keyof typeof SearchTokenListingRequestTypeEnumItem];

/**
 * 
 * @export
 * @interface SearchTokenListingResponse
 */
export interface SearchTokenListingResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchTokenListingResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchTokenListingResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchTokenListingResponse
     */
    cursor?: string;
    /**
     * 
     * @type {TokenListingPageRows}
     * @memberof SearchTokenListingResponse
     */
    data: TokenListingPageRows;
}

/**
 * 
 * @export
 */
export const SearchTokenListingSortByEnumItem = {
    Sort: 'sort'
} as const;
export type SearchTokenListingSortByEnumItem = typeof SearchTokenListingSortByEnumItem[keyof typeof SearchTokenListingSortByEnumItem];

/**
 * 
 * @export
 * @interface SearchUpcomingShowItem
 */
export interface SearchUpcomingShowItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchUpcomingShowItem
     */
    badges: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    title: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof SearchUpcomingShowItem
     */
    user: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    originalCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    shareVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUpcomingShowItem
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    visibility?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    permission?: SearchUpcomingShowItemPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchUpcomingShowItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUpcomingShowItem
     */
    disableComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUpcomingShowItem
     */
    notificationSent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchUpcomingShowItem
     */
    historyLiveStreamIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    transcodeStatus?: SearchUpcomingShowItemTranscodeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    accessLevel?: SearchUpcomingShowItemAccessLevelEnum;
    /**
     * 
     * @type {ShowTippingItem}
     * @memberof SearchUpcomingShowItem
     */
    tipping?: ShowTippingItem;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SearchUpcomingShowItem
     */
    watchListCount?: number;
}


/**
 * @export
 */
export const SearchUpcomingShowItemPermissionEnum = {
    All: 'all',
    Follower: 'follower',
    Subscriber: 'subscriber',
    NoOne: 'no-one'
} as const;
export type SearchUpcomingShowItemPermissionEnum = typeof SearchUpcomingShowItemPermissionEnum[keyof typeof SearchUpcomingShowItemPermissionEnum];

/**
 * @export
 */
export const SearchUpcomingShowItemTranscodeStatusEnum = {
    Initial: 'initial',
    Processing: 'processing',
    TranscodeOriginal: 'transcode-original',
    TranscodeOriginalShare: 'transcode-original-share',
    RequestRetranscode: 'request-retranscode'
} as const;
export type SearchUpcomingShowItemTranscodeStatusEnum = typeof SearchUpcomingShowItemTranscodeStatusEnum[keyof typeof SearchUpcomingShowItemTranscodeStatusEnum];

/**
 * @export
 */
export const SearchUpcomingShowItemAccessLevelEnum = {
    All: 'all',
    Subscriber: 'subscriber',
    Fan: 'fan',
    Vip: 'vip'
} as const;
export type SearchUpcomingShowItemAccessLevelEnum = typeof SearchUpcomingShowItemAccessLevelEnum[keyof typeof SearchUpcomingShowItemAccessLevelEnum];

/**
 * 
 * @export
 * @interface SelectedLeadFormQuestionOptionItem
 */
export interface SelectedLeadFormQuestionOptionItem {
    /**
     * 
     * @type {string}
     * @memberof SelectedLeadFormQuestionOptionItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SelectedLeadFormQuestionOptionItem
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof SelectedLeadFormQuestionOptionItem
     */
    sort: number;
    /**
     * 
     * @type {boolean}
     * @memberof SelectedLeadFormQuestionOptionItem
     */
    ideal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SelectedLeadFormQuestionOptionItem
     */
    selected?: boolean;
}
/**
 * 
 * @export
 * @interface SellerBalanceResponse
 */
export interface SellerBalanceResponse {
    /**
     * 
     * @type {number}
     * @memberof SellerBalanceResponse
     */
    withdrawableBalance: number;
    /**
     * 
     * @type {number}
     * @memberof SellerBalanceResponse
     */
    withdrawablePendingBalance: number;
}
/**
 * 
 * @export
 * @interface SellerCustomerItem
 */
export interface SellerCustomerItem {
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerItem
     */
    username?: string;
    /**
     * First name and last initial joined by a space, empty when neither is known. The surname is stored in full only on the private profile, which is not a source for this endpoint.
     * @type {string}
     * @memberof SellerCustomerItem
     */
    fullName: string;
    /**
     * Name of the most recent product the user bought from this seller.
     * @type {string}
     * @memberof SellerCustomerItem
     */
    lastPurchasedListingName?: string;
    /**
     * Order line items bought from this seller. A checkout of three products counts as three.
     * @type {number}
     * @memberof SellerCustomerItem
     */
    orderCount: number;
    /**
     * What the buyer actually paid this seller, already net of refunds.
     * @type {number}
     * @memberof SellerCustomerItem
     */
    totalSpent: number;
}
/**
 * 
 * @export
 * @interface SellerCustomerOrderItem
 */
export interface SellerCustomerOrderItem {
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    buyerId?: string;
    /**
     * First and last name joined by a space.
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    buyerFullName: string;
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    buyerAvatar?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    buyerUsername?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    listingId?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    listingName?: string;
    /**
     * A derived listing reports what it was derived from, not `DERIVED`.
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    listingType?: string;
    /**
     * What the listing was asking when the order was placed, discounted where there was a discount. Not what the buyer paid.
     * @type {number}
     * @memberof SellerCustomerOrderItem
     */
    listingPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    orderStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof SellerCustomerOrderItem
     */
    buyerPaidAmount: number;
    /**
     * The payment intent id.
     * @type {string}
     * @memberof SellerCustomerOrderItem
     */
    paymentTransactionId?: string;
}

/**
 * 
 * @export
 */
export const SellerCustomerOrdersDateRangeEnumItem = {
    Last30Days: 'last30Days',
    Last60Days: 'last60Days',
    Last90Days: 'last90Days',
    Last12Months: 'last12Months',
    AllTime: 'allTime'
} as const;
export type SellerCustomerOrdersDateRangeEnumItem = typeof SellerCustomerOrdersDateRangeEnumItem[keyof typeof SellerCustomerOrdersDateRangeEnumItem];

/**
 * 
 * @export
 * @interface SellerCustomerOrdersPaidAmountFilter
 */
export interface SellerCustomerOrdersPaidAmountFilter {
    /**
     * 
     * @type {CustomerPaidAmountOperatorEnumItem}
     * @memberof SellerCustomerOrdersPaidAmountFilter
     */
    operator: CustomerPaidAmountOperatorEnumItem;
    /**
     * 
     * @type {number}
     * @memberof SellerCustomerOrdersPaidAmountFilter
     */
    value: number;
}



/**
 * 
 * @export
 */
export const SellerCustomerOrdersSortByEnumItem = {
    CreatedAt: 'createdAt',
    BuyerPaidAmount: 'buyerPaidAmount'
} as const;
export type SellerCustomerOrdersSortByEnumItem = typeof SellerCustomerOrdersSortByEnumItem[keyof typeof SellerCustomerOrdersSortByEnumItem];

/**
 * 
 * @export
 * @interface SellerCustomerOrdersSummaryResponse
 */
export interface SellerCustomerOrdersSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof SellerCustomerOrdersSummaryResponse
     */
    totalSpent: number;
    /**
     * The seller's net earnings.
     * @type {number}
     * @memberof SellerCustomerOrdersSummaryResponse
     */
    totalEarning: number;
    /**
     * 
     * @type {number}
     * @memberof SellerCustomerOrdersSummaryResponse
     */
    totalOrders: number;
    /**
     * 
     * @type {Array<SellerCustomerOrdersTypeBreakdownItem>}
     * @memberof SellerCustomerOrdersSummaryResponse
     */
    byListingType: Array<SellerCustomerOrdersTypeBreakdownItem>;
}
/**
 * 
 * @export
 * @interface SellerCustomerOrdersTypeBreakdownItem
 */
export interface SellerCustomerOrdersTypeBreakdownItem {
    /**
     * 
     * @type {string}
     * @memberof SellerCustomerOrdersTypeBreakdownItem
     */
    listingType: string;
    /**
     * 
     * @type {number}
     * @memberof SellerCustomerOrdersTypeBreakdownItem
     */
    totalSpent: number;
    /**
     * The seller's net earnings.
     * @type {number}
     * @memberof SellerCustomerOrdersTypeBreakdownItem
     */
    totalEarning: number;
    /**
     * 
     * @type {number}
     * @memberof SellerCustomerOrdersTypeBreakdownItem
     */
    totalOrders: number;
}
/**
 * 
 * @export
 * @interface SellerCustomerSummaryResponse
 */
export interface SellerCustomerSummaryResponse {
    /**
     * Distinct users who have ordered from this seller. Estimated above roughly 3000.
     * @type {number}
     * @memberof SellerCustomerSummaryResponse
     */
    totalCustomers: number;
    /**
     * Order line items. A checkout of three products counts as three. Exact.
     * @type {number}
     * @memberof SellerCustomerSummaryResponse
     */
    totalOrders: number;
    /**
     * What those buyers actually paid this seller, already net of refunds.
     * @type {number}
     * @memberof SellerCustomerSummaryResponse
     */
    totalSpent: number;
}

/**
 * 
 * @export
 */
export const SellerCustomersDateRangeEnumItem = {
    Last30Days: 'last30Days',
    Last60Days: 'last60Days',
    Last90Days: 'last90Days',
    Last12Months: 'last12Months',
    AllTime: 'allTime'
} as const;
export type SellerCustomersDateRangeEnumItem = typeof SellerCustomersDateRangeEnumItem[keyof typeof SellerCustomersDateRangeEnumItem];

/**
 * 
 * @export
 * @interface SellerCustomersFilterParams
 */
export interface SellerCustomersFilterParams {
    /**
     * Matches the start of the buyer's username or first name, case-insensitively.
     * @type {string}
     * @memberof SellerCustomersFilterParams
     */
    query?: string;
    /**
     * Compares the spend of whichever date range is in effect.
     * @type {SellerCustomersPaidAmountFilter}
     * @memberof SellerCustomersFilterParams
     */
    paidAmount?: SellerCustomersPaidAmountFilter;
    /**
     * 
     * @type {SellerCustomersDateRangeEnumItem}
     * @memberof SellerCustomersFilterParams
     */
    dateRange?: SellerCustomersDateRangeEnumItem;
}


/**
 * 
 * @export
 * @interface SellerCustomersPaidAmountFilter
 */
export interface SellerCustomersPaidAmountFilter {
    /**
     * 
     * @type {CustomerPaidAmountOperatorEnumItem}
     * @memberof SellerCustomersPaidAmountFilter
     */
    operator: CustomerPaidAmountOperatorEnumItem;
    /**
     * 
     * @type {number}
     * @memberof SellerCustomersPaidAmountFilter
     */
    value: number;
}



/**
 * 
 * @export
 */
export const SellerCustomersSortByEnumItem = {
    TotalSpent: 'totalSpent',
    OrderCount: 'orderCount',
    LastPurchasedAt: 'lastPurchasedAt'
} as const;
export type SellerCustomersSortByEnumItem = typeof SellerCustomersSortByEnumItem[keyof typeof SellerCustomersSortByEnumItem];

/**
 * 
 * @export
 * @interface SellerTrackingInfoItem
 */
export interface SellerTrackingInfoItem {
    /**
     * 
     * @type {string}
     * @memberof SellerTrackingInfoItem
     */
    trackingInfo: string;
    /**
     * 
     * @type {string}
     * @memberof SellerTrackingInfoItem
     */
    carrier?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerTrackingInfoItem
     */
    trackingURL?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerTrackingInfoItem
     */
    createdAt: string;
}
/**
 * 
 * @export
 * @interface SendChatMessage
 */
export interface SendChatMessage {
    /**
     * 
     * @type {number}
     * @memberof SendChatMessage
     */
    sessionType?: number;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    clientId: string;
    /**
     * 
     * @type {number}
     * @memberof SendChatMessage
     */
    type: number;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    ext: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    quoteMsg: string;
    /**
     * 
     * @type {object}
     * @memberof SendChatMessage
     */
    group?: object;
}
/**
 * 
 * @export
 * @interface SendCommentRequest
 */
export interface SendCommentRequest {
    /**
     * 
     * @type {SendCommentRequestComment}
     * @memberof SendCommentRequest
     */
    comment: SendCommentRequestComment;
}
/**
 * @type SendCommentRequestComment
 * 
 * @export
 */
export type SendCommentRequestComment = SendPlainCommentRequest | SendShareCommentRequest;
/**
 * 
 * @export
 * @interface SendItemSource
 */
export interface SendItemSource {
    /**
     * 
     * @type {string}
     * @memberof SendItemSource
     */
    type: SendItemSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SendItemSource
     */
    sendItemId: string;
    /**
     * 
     * @type {SendItemSourceSource}
     * @memberof SendItemSource
     */
    source: SendItemSourceSource;
}


/**
 * @export
 */
export const SendItemSourceTypeEnum = {
    SendItem: 'SEND_ITEM'
} as const;
export type SendItemSourceTypeEnum = typeof SendItemSourceTypeEnum[keyof typeof SendItemSourceTypeEnum];

/**
 * @type SendItemSourceSource
 * 
 * @export
 */
export type SendItemSourceSource = LiveStreamSendItemSourceSource | UpcomingShowSendItemSourceSource;
/**
 * 
 * @export
 * @interface SendPlainCommentRequest
 */
export interface SendPlainCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof SendPlainCommentRequest
     */
    type: SendPlainCommentRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SendPlainCommentRequest
     */
    content: string;
    /**
     * 
     * @type {Array<ChatMentionDto>}
     * @memberof SendPlainCommentRequest
     */
    mentions?: Array<ChatMentionDto>;
}


/**
 * @export
 */
export const SendPlainCommentRequestTypeEnum = {
    Comment: 'comment'
} as const;
export type SendPlainCommentRequestTypeEnum = typeof SendPlainCommentRequestTypeEnum[keyof typeof SendPlainCommentRequestTypeEnum];

/**
 * 
 * @export
 * @interface SendShareCommentRequest
 */
export interface SendShareCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof SendShareCommentRequest
     */
    type: SendShareCommentRequestTypeEnum;
}


/**
 * @export
 */
export const SendShareCommentRequestTypeEnum = {
    Share: 'share'
} as const;
export type SendShareCommentRequestTypeEnum = typeof SendShareCommentRequestTypeEnum[keyof typeof SendShareCommentRequestTypeEnum];


/**
 * 
 * @export
 */
export const SeriesChapterLabelFormatEnumItem = {
    Ch: 'CH',
    Chapter: 'CHAPTER'
} as const;
export type SeriesChapterLabelFormatEnumItem = typeof SeriesChapterLabelFormatEnumItem[keyof typeof SeriesChapterLabelFormatEnumItem];

/**
 * 
 * @export
 * @interface SeriesElementItemV2
 */
export interface SeriesElementItemV2 {
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    type: SeriesElementItemV2TypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SeriesElementItemV2
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    accessLevel?: SeriesElementItemV2AccessLevelEnum;
    /**
     * 
     * @type {SeriesPopClipElementItemV2}
     * @memberof SeriesElementItemV2
     */
    popClip?: SeriesPopClipElementItemV2;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    contentType?: SeriesElementItemV2ContentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesElementItemV2
     */
    pinned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesElementItemV2
     */
    startOfChapter?: boolean;
    /**
     * 
     * @type {Relations}
     * @memberof SeriesElementItemV2
     */
    relations?: Relations;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    seriesName?: string;
}


/**
 * @export
 */
export const SeriesElementItemV2TypeEnum = {
    PopClip: 'POP_CLIP'
} as const;
export type SeriesElementItemV2TypeEnum = typeof SeriesElementItemV2TypeEnum[keyof typeof SeriesElementItemV2TypeEnum];

/**
 * @export
 */
export const SeriesElementItemV2AccessLevelEnum = {
    All: 'all',
    Subscriber: 'subscriber',
    Fan: 'fan',
    Vip: 'vip'
} as const;
export type SeriesElementItemV2AccessLevelEnum = typeof SeriesElementItemV2AccessLevelEnum[keyof typeof SeriesElementItemV2AccessLevelEnum];

/**
 * @export
 */
export const SeriesElementItemV2ContentTypeEnum = {
    Feed: 'FEED',
    Episode: 'EPISODE',
    Teaser: 'TEASER',
    Promo: 'PROMO',
    Sponsored: 'SPONSORED'
} as const;
export type SeriesElementItemV2ContentTypeEnum = typeof SeriesElementItemV2ContentTypeEnum[keyof typeof SeriesElementItemV2ContentTypeEnum];


/**
 * 
 * @export
 */
export const SeriesElementModerationStatusEnumItem = {
    Accepted: 'accepted',
    Rejected: 'rejected',
    Pending: 'pending'
} as const;
export type SeriesElementModerationStatusEnumItem = typeof SeriesElementModerationStatusEnumItem[keyof typeof SeriesElementModerationStatusEnumItem];

/**
 * 
 * @export
 * @interface SeriesElementPageRowsV2
 */
export interface SeriesElementPageRowsV2 {
    /**
     * 
     * @type {Array<SeriesElementItemV2>}
     * @memberof SeriesElementPageRowsV2
     */
    rows: Array<SeriesElementItemV2>;
}
/**
 * 
 * @export
 * @interface SeriesElementSearchResponseV2
 */
export interface SeriesElementSearchResponseV2 {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SeriesElementSearchResponseV2
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SeriesElementSearchResponseV2
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementSearchResponseV2
     */
    cursor?: string;
    /**
     * 
     * @type {SeriesElementPageRowsV2}
     * @memberof SeriesElementSearchResponseV2
     */
    data: SeriesElementPageRowsV2;
}
/**
 * 
 * @export
 * @interface SeriesItem
 */
export interface SeriesItem {
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    slug: string;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesItem
     */
    archived: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeriesItem
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    elementSortingStrategy?: SeriesItemElementSortingStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    labelFormat?: SeriesItemLabelFormatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesItem
     */
    showLabel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesItem
     */
    hasChapter?: boolean;
    /**
     * 
     * @type {SeriesChapterLabelFormatEnumItem}
     * @memberof SeriesItem
     */
    chapterLabelFormat?: SeriesChapterLabelFormatEnumItem;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    mobileBannerImage?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    desktopBannerImage?: string;
    /**
     * 
     * @type {SeriesTypeEnumItem}
     * @memberof SeriesItem
     */
    type?: SeriesTypeEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesItem
     */
    standaloneSale?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeriesItem
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof SeriesItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {PopStoreUserAccessLevelEnumItem}
     * @memberof SeriesItem
     */
    accessLevel?: PopStoreUserAccessLevelEnumItem;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    listingId?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    id: string;
}


/**
 * @export
 */
export const SeriesItemElementSortingStrategyEnum = {
    MostRecentFirst: 'MOST_RECENT_FIRST',
    MostRecentLast: 'MOST_RECENT_LAST',
    Custom: 'CUSTOM'
} as const;
export type SeriesItemElementSortingStrategyEnum = typeof SeriesItemElementSortingStrategyEnum[keyof typeof SeriesItemElementSortingStrategyEnum];

/**
 * @export
 */
export const SeriesItemLabelFormatEnum = {
    Short: 'SHORT',
    Long: 'LONG'
} as const;
export type SeriesItemLabelFormatEnum = typeof SeriesItemLabelFormatEnum[keyof typeof SeriesItemLabelFormatEnum];

/**
 * 
 * @export
 * @interface SeriesPageRows
 */
export interface SeriesPageRows {
    /**
     * 
     * @type {Array<SeriesItem>}
     * @memberof SeriesPageRows
     */
    rows: Array<SeriesItem>;
}
/**
 * 
 * @export
 * @interface SeriesPopClipElementItemV2
 */
export interface SeriesPopClipElementItemV2 {
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    metaIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    cdnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    fileType: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    createdAt?: string;
    /**
     * 
     * @type {object}
     * @memberof SeriesPopClipElementItemV2
     */
    metaData: object;
}
/**
 * 
 * @export
 * @interface SeriesSearchResponse
 */
export interface SeriesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SeriesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SeriesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeriesSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {SeriesPageRows}
     * @memberof SeriesSearchResponse
     */
    data: SeriesPageRows;
}

/**
 * 
 * @export
 */
export const SeriesTypeEnumItem = {
    Default: 'DEFAULT',
    Course: 'COURSE',
    SubSeries: 'SUB_SERIES'
} as const;
export type SeriesTypeEnumItem = typeof SeriesTypeEnumItem[keyof typeof SeriesTypeEnumItem];

/**
 * 
 * @export
 * @interface ServiceLevelItem
 */
export interface ServiceLevelItem {
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelItem
     */
    terms: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelItem
     */
    token: string;
}
/**
 * 
 * @export
 * @interface SessionUnreadMessageCountItem
 */
export interface SessionUnreadMessageCountItem {
    /**
     * 
     * @type {number}
     * @memberof SessionUnreadMessageCountItem
     */
    sessionType: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUnreadMessageCountItem
     */
    unreadCount: number;
}
/**
 * 
 * @export
 * @interface SetDmMinimumSubscriptionLevelRequest
 */
export interface SetDmMinimumSubscriptionLevelRequest {
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof SetDmMinimumSubscriptionLevelRequest
     */
    dmMinimumSubscriptionLevel: PopStoreExtendedSubscriptionLevelEnumItem;
}


/**
 * 
 * @export
 * @interface SetUrlCodeDto
 */
export interface SetUrlCodeDto {
    /**
     * 
     * @type {string}
     * @memberof SetUrlCodeDto
     */
    urlCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof SetUrlCodeDto
     */
    useUrlCodeForUsername?: boolean;
}
/**
 * 
 * @export
 * @interface SharePhoneNumberConsentDto
 */
export interface SharePhoneNumberConsentDto {
    /**
     * 
     * @type {boolean}
     * @memberof SharePhoneNumberConsentDto
     */
    sharePhoneNumber: boolean;
    /**
     * 
     * @type {string}
     * @memberof SharePhoneNumberConsentDto
     */
    sharePhoneNumberTimestamp: string;
}
/**
 * 
 * @export
 * @interface SharePhoneNumberConsentItem
 */
export interface SharePhoneNumberConsentItem {
    /**
     * 
     * @type {boolean}
     * @memberof SharePhoneNumberConsentItem
     */
    sharePhoneNumber: boolean;
    /**
     * 
     * @type {string}
     * @memberof SharePhoneNumberConsentItem
     */
    sharePhoneNumberTimestamp?: string;
}
/**
 * 
 * @export
 * @interface ShipmentItem
 */
export interface ShipmentItem {
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    buyerId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    shippoTransactionId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    labelUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    trackingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    trackingStatus: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    trackingUrlProvider: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentItem
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    transaction: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    transactionStatus: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    updateAt: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    carrier?: ShipmentItemCarrierEnum;
}


/**
 * @export
 */
export const ShipmentItemCarrierEnum = {
    Shippo: 'SHIPPO',
    Usps: 'USPS',
    Ups: 'UPS',
    CanadaPost: 'CANADA_POST',
    DhlExpress: 'DHL_EXPRESS',
    DpdUk: 'DPD_UK',
    HermesUk: 'HERMES_UK'
} as const;
export type ShipmentItemCarrierEnum = typeof ShipmentItemCarrierEnum[keyof typeof ShipmentItemCarrierEnum];

/**
 * 
 * @export
 * @interface ShippingLabelStatus
 */
export interface ShippingLabelStatus {
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    disabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    noLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    generating: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    generated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    preGenerated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    failed: boolean;
}
/**
 * 
 * @export
 * @interface ShippingRateCostItem
 */
export interface ShippingRateCostItem {
    /**
     * 
     * @type {string}
     * @memberof ShippingRateCostItem
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingRateCostItem
     */
    base: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingRateCostItem
     */
    margin: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingRateCostItem
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ShippingRateItem
 */
export interface ShippingRateItem {
    /**
     * 
     * @type {string}
     * @memberof ShippingRateItem
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShippingRateItem
     */
    attributes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShippingRateItem
     */
    duration_terms: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingRateItem
     */
    estimated_days: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingRateItem
     */
    provider_image_75: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingRateItem
     */
    provider_image_200: string;
    /**
     * 
     * @type {ServiceLevelItem}
     * @memberof ShippingRateItem
     */
    servicelevel: ServiceLevelItem;
    /**
     * 
     * @type {ShippingRateCostItem}
     * @memberof ShippingRateItem
     */
    cost: ShippingRateCostItem;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingRateItem
     */
    test: boolean;
}
/**
 * 
 * @export
 * @interface ShippingSurchargeInfo
 */
export interface ShippingSurchargeInfo {
    /**
     * 
     * @type {number}
     * @memberof ShippingSurchargeInfo
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingSurchargeInfo
     */
    rule: ShippingSurchargeInfoRuleEnum;
}


/**
 * @export
 */
export const ShippingSurchargeInfoRuleEnum = {
    PerItem: 'PER_ITEM',
    PerOrderGroup: 'PER_ORDER_GROUP'
} as const;
export type ShippingSurchargeInfoRuleEnum = typeof ShippingSurchargeInfoRuleEnum[keyof typeof ShippingSurchargeInfoRuleEnum];

/**
 * 
 * @export
 * @interface ShippoCarrier
 */
export interface ShippoCarrier {
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrier
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrier
     */
    token: ShippoCarrierTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrier
     */
    name: ShippoCarrierNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrier
     */
    alias: string;
}


/**
 * @export
 */
export const ShippoCarrierTokenEnum = {
    Usps: 'usps'
} as const;
export type ShippoCarrierTokenEnum = typeof ShippoCarrierTokenEnum[keyof typeof ShippoCarrierTokenEnum];

/**
 * @export
 */
export const ShippoCarrierNameEnum = {
    Usps: 'USPS'
} as const;
export type ShippoCarrierNameEnum = typeof ShippoCarrierNameEnum[keyof typeof ShippoCarrierNameEnum];

/**
 * 
 * @export
 * @interface ShippoCarrierParcelTemplate
 */
export interface ShippoCarrierParcelTemplate {
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierParcelTemplate
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierParcelTemplate
     */
    type: ShippoCarrierParcelTemplateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierParcelTemplate
     */
    token: ShippoCarrierParcelTemplateTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierParcelTemplate
     */
    name: ShippoCarrierParcelTemplateNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierParcelTemplate
     */
    alias: string;
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierParcelTemplate
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierParcelTemplate
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierParcelTemplate
     */
    depth: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierParcelTemplate
     */
    distanceUnit: ShippoCarrierParcelTemplateDistanceUnitEnum;
}


/**
 * @export
 */
export const ShippoCarrierParcelTemplateTypeEnum = {
    Custom: 'CUSTOM',
    ShippoCarrierParcelTemplate: 'SHIPPO_CARRIER_PARCEL_TEMPLATE'
} as const;
export type ShippoCarrierParcelTemplateTypeEnum = typeof ShippoCarrierParcelTemplateTypeEnum[keyof typeof ShippoCarrierParcelTemplateTypeEnum];

/**
 * @export
 */
export const ShippoCarrierParcelTemplateTokenEnum = {
    UspsRegionalRateBoxB1: 'USPS_RegionalRateBoxB1',
    UspsRegionalRateBoxB2: 'USPS_RegionalRateBoxB2',
    UspsIrregularParcel: 'USPS_IrregularParcel',
    UspsCard: 'USPS_Card',
    UspsFlatRateCardboardEnvelope: 'USPS_FlatRateCardboardEnvelope',
    UspsFlatRateLegalEnvelope: 'USPS_FlatRateLegalEnvelope',
    UspsFlatRateEnvelope: 'USPS_FlatRateEnvelope',
    UspsFlatRateGiftCardEnvelope: 'USPS_FlatRateGiftCardEnvelope',
    UspsLargeVideoFlatRateBox: 'USPS_LargeVideoFlatRateBox',
    UspsLargeFlatRateBoardGameBox: 'USPS_LargeFlatRateBoardGameBox',
    UspsSmallFlatRateEnvelope: 'USPS_SmallFlatRateEnvelope',
    UspsSoftPack: 'USPS_SoftPack',
    UspsLargeFlatRateBox: 'USPS_LargeFlatRateBox',
    UspsMediumFlatRateBox1: 'USPS_MediumFlatRateBox1',
    UspsMediumFlatRateBox2: 'USPS_MediumFlatRateBox2',
    UspsSmallFlatRateBox: 'USPS_SmallFlatRateBox',
    UspsRegionalRateBoxA1: 'USPS_RegionalRateBoxA1',
    UspsRegionalRateBoxA2: 'USPS_RegionalRateBoxA2',
    UspsApoFlatRateBox: 'USPS_APOFlatRateBox',
    UspsFlatRateWindowEnvelope: 'USPS_FlatRateWindowEnvelope',
    UspsFlatRatePaddedEnvelope: 'USPS_FlatRatePaddedEnvelope'
} as const;
export type ShippoCarrierParcelTemplateTokenEnum = typeof ShippoCarrierParcelTemplateTokenEnum[keyof typeof ShippoCarrierParcelTemplateTokenEnum];

/**
 * @export
 */
export const ShippoCarrierParcelTemplateNameEnum = {
    Envelope: 'Envelope',
    Package: 'Package',
    RegionalRateBoxB1: 'Regional Rate Box B1',
    RegionalRateBoxB2: 'Regional Rate Box B2',
    IrregularParcel: 'Irregular Parcel',
    Card: 'Card',
    FlatRateCardboardEnvelope: 'Flat Rate Cardboard Envelope',
    FlatRateLegalEnvelope: 'Flat Rate Legal Envelope',
    FlatRateEnvelope: 'Flat Rate Envelope',
    FlatRateGiftCardEnvelope: 'Flat Rate Gift Card Envelope',
    FlatRateLargeVideoBoxIntlOnly: 'Flat Rate Large Video Box (Int\'l only)',
    LargeFlatRateBoardGameBox: 'Large Flat Rate Board Game Box',
    SmallFlatRateEnvelope: 'Small Flat Rate Envelope',
    SoftPackPaddedEnvelope: 'Soft Pack Padded Envelope',
    LargeFlatRateBox: 'Large Flat Rate Box',
    MediumFlatRateBox1: 'Medium Flat Rate Box 1',
    MediumFlatRateBox2: 'Medium Flat Rate Box 2',
    SmallFlatRateBox: 'Small Flat Rate Box',
    RegionalRateBoxA1: 'Regional Rate Box A1',
    RegionalRateBoxA2: 'Regional Rate Box A2',
    ApoFpoDpoLargeFlatRateBox: 'APO/FPO/DPO Large Flat Rate Box',
    FlatRateWindowEnvelope: 'Flat Rate Window Envelope',
    FlatRatePaddedEnvelope: 'Flat Rate Padded Envelope'
} as const;
export type ShippoCarrierParcelTemplateNameEnum = typeof ShippoCarrierParcelTemplateNameEnum[keyof typeof ShippoCarrierParcelTemplateNameEnum];

/**
 * @export
 */
export const ShippoCarrierParcelTemplateDistanceUnitEnum = {
    Cm: 'cm',
    In: 'in',
    Ft: 'ft',
    M: 'm',
    Mm: 'mm',
    Yd: 'yd'
} as const;
export type ShippoCarrierParcelTemplateDistanceUnitEnum = typeof ShippoCarrierParcelTemplateDistanceUnitEnum[keyof typeof ShippoCarrierParcelTemplateDistanceUnitEnum];

/**
 * 
 * @export
 * @interface ShippoCarrierServiceLevel
 */
export interface ShippoCarrierServiceLevel {
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierServiceLevel
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierServiceLevel
     */
    type: ShippoCarrierServiceLevelTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierServiceLevel
     */
    token: ShippoCarrierServiceLevelTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierServiceLevel
     */
    name: ShippoCarrierServiceLevelNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierServiceLevel
     */
    alias: string;
}


/**
 * @export
 */
export const ShippoCarrierServiceLevelTypeEnum = {
    ShippoRateAttribute: 'SHIPPO_RATE_ATTRIBUTE',
    ShippoCarrierServiceLevel: 'SHIPPO_CARRIER_SERVICE_LEVEL'
} as const;
export type ShippoCarrierServiceLevelTypeEnum = typeof ShippoCarrierServiceLevelTypeEnum[keyof typeof ShippoCarrierServiceLevelTypeEnum];

/**
 * @export
 */
export const ShippoCarrierServiceLevelTokenEnum = {
    Cheapest: 'CHEAPEST',
    Fastest: 'FASTEST',
    UspsGroundAdvantage: 'usps_ground_advantage',
    UspsPriority: 'usps_priority',
    UspsPriorityExpress: 'usps_priority_express'
} as const;
export type ShippoCarrierServiceLevelTokenEnum = typeof ShippoCarrierServiceLevelTokenEnum[keyof typeof ShippoCarrierServiceLevelTokenEnum];

/**
 * @export
 */
export const ShippoCarrierServiceLevelNameEnum = {
    Cheapest: 'CHEAPEST',
    Fastest: 'FASTEST',
    GroundAdvantage: 'Ground Advantage',
    PriorityMail: 'Priority Mail',
    PriorityMailExpress: 'Priority Mail Express'
} as const;
export type ShippoCarrierServiceLevelNameEnum = typeof ShippoCarrierServiceLevelNameEnum[keyof typeof ShippoCarrierServiceLevelNameEnum];

/**
 * 
 * @export
 * @interface ShippoCarrierSignatureConfirmation
 */
export interface ShippoCarrierSignatureConfirmation {
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierSignatureConfirmation
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierSignatureConfirmation
     */
    token: ShippoCarrierSignatureConfirmationTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierSignatureConfirmation
     */
    name: ShippoCarrierSignatureConfirmationNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierSignatureConfirmation
     */
    alias: string;
}


/**
 * @export
 */
export const ShippoCarrierSignatureConfirmationTokenEnum = {
    Standard: 'STANDARD',
    Adult: 'ADULT',
    Certified: 'CERTIFIED'
} as const;
export type ShippoCarrierSignatureConfirmationTokenEnum = typeof ShippoCarrierSignatureConfirmationTokenEnum[keyof typeof ShippoCarrierSignatureConfirmationTokenEnum];

/**
 * @export
 */
export const ShippoCarrierSignatureConfirmationNameEnum = {
    SignatureConfirmation: 'Signature Confirmation',
    AdultSignatureRequired: 'Adult Signature Required',
    CertifiedMail: 'Certified Mail'
} as const;
export type ShippoCarrierSignatureConfirmationNameEnum = typeof ShippoCarrierSignatureConfirmationNameEnum[keyof typeof ShippoCarrierSignatureConfirmationNameEnum];

/**
 * 
 * @export
 * @interface ShippoRate
 */
export interface ShippoRate {
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    object_created: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    object_updated: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    object_id: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    object_owner: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    shipment: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    amount_local: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    currency_local: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    provider_image_75: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    provider_image_200: string;
    /**
     * 
     * @type {ShippoServicelevel}
     * @memberof ShippoRate
     */
    servicelevel: ShippoServicelevel;
    /**
     * 
     * @type {number}
     * @memberof ShippoRate
     */
    estimated_days: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    duration_terms: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    carrier_account: string;
    /**
     * 
     * @type {object}
     * @memberof ShippoRate
     */
    arrives_by: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShippoRate
     */
    attributes: Array<ShippoRateAttributesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShippoRate
     */
    messages: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ShippoRate
     */
    test: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    zone: string;
}


/**
 * @export
 */
export const ShippoRateAttributesEnum = {
    Cheapest: 'CHEAPEST',
    Fastest: 'FASTEST',
    Bestvalue: 'BESTVALUE'
} as const;
export type ShippoRateAttributesEnum = typeof ShippoRateAttributesEnum[keyof typeof ShippoRateAttributesEnum];

/**
 * 
 * @export
 * @interface ShippoServicelevel
 */
export interface ShippoServicelevel {
    /**
     * 
     * @type {string}
     * @memberof ShippoServicelevel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoServicelevel
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoServicelevel
     */
    terms: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoServicelevel
     */
    extended_token: string;
    /**
     * 
     * @type {object}
     * @memberof ShippoServicelevel
     */
    parent_servicelevel: object;
}
/**
 * 
 * @export
 * @interface ShopSource
 */
export interface ShopSource {
    /**
     * 
     * @type {string}
     * @memberof ShopSource
     */
    type: ShopSourceTypeEnum;
}


/**
 * @export
 */
export const ShopSourceTypeEnum = {
    Shop: 'SHOP'
} as const;
export type ShopSourceTypeEnum = typeof ShopSourceTypeEnum[keyof typeof ShopSourceTypeEnum];

/**
 * 
 * @export
 * @interface ShopTokenResponse
 */
export interface ShopTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof ShopTokenResponse
     */
    token: string;
}
/**
 * 
 * @export
 * @interface ShowCustomizationItem
 */
export interface ShowCustomizationItem {
    /**
     * 
     * @type {string}
     * @memberof ShowCustomizationItem
     */
    primaryLightColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCustomizationItem
     */
    primaryDarkColor?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowCustomizationItem
     */
    lightingBoltImages?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShowCustomizationItem
     */
    lightingBoltButtonImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowCustomizationItem
     */
    disableLightingBoltForAll?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowCustomizationItem
     */
    tippingEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface ShowTippingItem
 */
export interface ShowTippingItem {
    /**
     * 
     * @type {boolean}
     * @memberof ShowTippingItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShowTippingItem
     */
    minAmount?: number;
}
/**
 * 
 * @export
 * @interface ShowTippingRequest
 */
export interface ShowTippingRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ShowTippingRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShowTippingRequest
     */
    minAmount?: number;
}
/**
 * 
 * @export
 * @interface SingleUnitWeightInfo
 */
export interface SingleUnitWeightInfo {
    /**
     * 
     * @type {string}
     * @memberof SingleUnitWeightInfo
     */
    type: SingleUnitWeightInfoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SingleUnitWeightInfo
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof SingleUnitWeightInfo
     */
    unit: SingleUnitWeightInfoUnitEnum;
}


/**
 * @export
 */
export const SingleUnitWeightInfoTypeEnum = {
    SingleUnit: 'singleUnit'
} as const;
export type SingleUnitWeightInfoTypeEnum = typeof SingleUnitWeightInfoTypeEnum[keyof typeof SingleUnitWeightInfoTypeEnum];

/**
 * @export
 */
export const SingleUnitWeightInfoUnitEnum = {
    G: 'g',
    Kg: 'kg',
    Lb: 'lb',
    Oz: 'oz'
} as const;
export type SingleUnitWeightInfoUnitEnum = typeof SingleUnitWeightInfoUnitEnum[keyof typeof SingleUnitWeightInfoUnitEnum];


/**
 * 
 * @export
 */
export const SkinComplexionEnumItem = {
    Pale: 'Pale',
    Fair: 'Fair',
    Olive: 'Olive',
    Dark: 'Dark'
} as const;
export type SkinComplexionEnumItem = typeof SkinComplexionEnumItem[keyof typeof SkinComplexionEnumItem];

/**
 * 
 * @export
 * @interface SocialAccountDto
 */
export interface SocialAccountDto {
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    instagramUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    youtubeUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    depopUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    ebayUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    facebookUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    tiktokUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    etsyUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    discordUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    lemon8Url?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    snapchatUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    twitterUrl?: string;
}
/**
 * 
 * @export
 * @interface SocialLinkRequest
 */
export interface SocialLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof SocialLinkRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLinkRequest
     */
    url: string;
    /**
     * 
     * @type {boolean}
     * @memberof SocialLinkRequest
     */
    hidden?: boolean;
}
/**
 * 
 * @export
 * @interface StoreControllerStoreListingVariant
 */
export interface StoreControllerStoreListingVariant {
    /**
     * 
     * @type {string}
     * @memberof StoreControllerStoreListingVariant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StoreControllerStoreListingVariant
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof StoreControllerStoreListingVariant
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof StoreControllerStoreListingVariant
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreControllerStoreListingVariant
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreControllerStoreListingVariant
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StoreControllerStoreListingVariant
     */
    hidden?: boolean;
    /**
     * 
     * @type {StoreListingVariantOriginalInfo}
     * @memberof StoreControllerStoreListingVariant
     */
    originalInfo?: StoreListingVariantOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof StoreControllerStoreListingVariant
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {CreateStoreListingRequestWeight}
     * @memberof StoreControllerStoreListingVariant
     */
    weight?: CreateStoreListingRequestWeight;
    /**
     * 
     * @type {string}
     * @memberof StoreControllerStoreListingVariant
     */
    externalCheckoutUrl?: string;
}
/**
 * 
 * @export
 * @interface StoreFrontItem
 */
export interface StoreFrontItem {
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    sellerPasscode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreFrontItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    createdAt: string;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof StoreFrontItem
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    agencyId?: string;
    /**
     * 
     * @type {AgencyItemWithId}
     * @memberof StoreFrontItem
     */
    agency?: AgencyItemWithId;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    passcode: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    lastLiveStreamDate?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItem
     */
    shippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItem
     */
    adjustedPopshopShippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    announcement?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof StoreFrontItem
     */
    salesTaxRate?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItem
     */
    secondOfShippingLabelGeneration: number;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof StoreFrontItem
     */
    upcomingShow?: BaseUpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {object}
     * @memberof StoreFrontItem
     */
    liveStream?: object;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {EvergreenVideoItem}
     * @memberof StoreFrontItem
     */
    evergreenVideo?: EvergreenVideoItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreFrontItem
     */
    badges?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    shortDescription?: string;
    /**
     * 
     * @type {ShowCustomizationItem}
     * @memberof StoreFrontItem
     */
    showCustomization?: ShowCustomizationItem;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    defaultCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    externalProductCtaText?: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof StoreFrontItem
     */
    profile: BaseProfileItem;
    /**
     * 
     * @type {StoreTypeEnumItem}
     * @memberof StoreFrontItem
     */
    storeType?: StoreTypeEnumItem;
}


/**
 * 
 * @export
 * @interface StoreItem
 */
export interface StoreItem {
    /**
     * 
     * @type {string}
     * @memberof StoreItem
     */
    name: string;
}
/**
 * 
 * @export
 * @interface StoreListingItem
 */
export interface StoreListingItem {
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItem
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {WearWithAiListingMediaItem}
     * @memberof StoreListingItem
     */
    defaultWearWithAiMedia?: WearWithAiListingMediaItem;
    /**
     * 
     * @type {Array<WearWithAiListingMediaItem>}
     * @memberof StoreListingItem
     */
    extraWearWithAiMedias?: Array<WearWithAiListingMediaItem>;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof StoreListingItem
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    status?: StoreListingItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof StoreListingItem
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof StoreListingItem
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {CreateStoreListingRequestWeight}
     * @memberof StoreListingItem
     */
    weight?: CreateStoreListingRequestWeight;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof StoreListingItem
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof StoreListingItem
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof StoreListingItem
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItem
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof StoreListingItem
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    isLandingEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItem
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    type?: StoreListingItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof StoreListingItem
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    moderationStatus?: StoreListingItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof StoreListingItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof StoreListingItem
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    isEligibleForWearMe?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    externalProductCtaText?: string;
    /**
     * 
     * @type {object}
     * @memberof StoreListingItem
     */
    extra?: object;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    id: string;
}


/**
 * @export
 */
export const StoreListingItemStatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;
export type StoreListingItemStatusEnum = typeof StoreListingItemStatusEnum[keyof typeof StoreListingItemStatusEnum];

/**
 * @export
 */
export const StoreListingItemTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type StoreListingItemTypeEnum = typeof StoreListingItemTypeEnum[keyof typeof StoreListingItemTypeEnum];

/**
 * @export
 */
export const StoreListingItemModerationStatusEnum = {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    ReviewRequired: 'ReviewRequired'
} as const;
export type StoreListingItemModerationStatusEnum = typeof StoreListingItemModerationStatusEnum[keyof typeof StoreListingItemModerationStatusEnum];

/**
 * 
 * @export
 * @interface StoreListingItemWithMetadata
 */
export interface StoreListingItemWithMetadata {
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItemWithMetadata
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {WearWithAiListingMediaItem}
     * @memberof StoreListingItemWithMetadata
     */
    defaultWearWithAiMedia?: WearWithAiListingMediaItem;
    /**
     * 
     * @type {Array<WearWithAiListingMediaItem>}
     * @memberof StoreListingItemWithMetadata
     */
    extraWearWithAiMedias?: Array<WearWithAiListingMediaItem>;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof StoreListingItemWithMetadata
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItemWithMetadata
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    status?: StoreListingItemWithMetadataStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof StoreListingItemWithMetadata
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof StoreListingItemWithMetadata
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {CreateStoreListingRequestWeight}
     * @memberof StoreListingItemWithMetadata
     */
    weight?: CreateStoreListingRequestWeight;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof StoreListingItemWithMetadata
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof StoreListingItemWithMetadata
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof StoreListingItemWithMetadata
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItemWithMetadata
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof StoreListingItemWithMetadata
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    isLandingEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItemWithMetadata
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    type?: StoreListingItemWithMetadataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof StoreListingItemWithMetadata
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    moderationStatus?: StoreListingItemWithMetadataModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof StoreListingItemWithMetadata
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof StoreListingItemWithMetadata
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    isEligibleForWearMe?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    externalProductCtaText?: string;
    /**
     * 
     * @type {object}
     * @memberof StoreListingItemWithMetadata
     */
    extra?: object;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof StoreListingItemWithMetadata
     */
    metadata: Metadata;
    /**
     * 
     * @type {Relations}
     * @memberof StoreListingItemWithMetadata
     */
    relations: Relations;
    /**
     * only available when searching top products
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    featured?: boolean;
}


/**
 * @export
 */
export const StoreListingItemWithMetadataStatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;
export type StoreListingItemWithMetadataStatusEnum = typeof StoreListingItemWithMetadataStatusEnum[keyof typeof StoreListingItemWithMetadataStatusEnum];

/**
 * @export
 */
export const StoreListingItemWithMetadataTypeEnum = {
    Physical: 'PHYSICAL',
    Digital: 'DIGITAL',
    External: 'EXTERNAL',
    Meeting: 'MEETING',
    Affiliate: 'AFFILIATE',
    Derived: 'DERIVED',
    AvatarMe: 'AVATAR_ME',
    TokenPack: 'TOKEN_PACK',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED',
    RealEstate: 'REAL_ESTATE',
    GroupEvent: 'GROUP_EVENT'
} as const;
export type StoreListingItemWithMetadataTypeEnum = typeof StoreListingItemWithMetadataTypeEnum[keyof typeof StoreListingItemWithMetadataTypeEnum];

/**
 * @export
 */
export const StoreListingItemWithMetadataModerationStatusEnum = {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    ReviewRequired: 'ReviewRequired'
} as const;
export type StoreListingItemWithMetadataModerationStatusEnum = typeof StoreListingItemWithMetadataModerationStatusEnum[keyof typeof StoreListingItemWithMetadataModerationStatusEnum];

/**
 * 
 * @export
 * @interface StoreListingOriginalInfo
 */
export interface StoreListingOriginalInfo {
    /**
     * 
     * @type {string}
     * @memberof StoreListingOriginalInfo
     */
    type: StoreListingOriginalInfoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingOriginalInfo
     */
    shopifyStoreId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingOriginalInfo
     */
    shopifyLocationId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingOriginalInfo
     */
    shopifyProductId?: string;
}


/**
 * @export
 */
export const StoreListingOriginalInfoTypeEnum = {
    Shopify: 'shopify'
} as const;
export type StoreListingOriginalInfoTypeEnum = typeof StoreListingOriginalInfoTypeEnum[keyof typeof StoreListingOriginalInfoTypeEnum];

/**
 * 
 * @export
 * @interface StoreListingPageRows
 */
export interface StoreListingPageRows {
    /**
     * 
     * @type {Array<StoreListingItemWithMetadata>}
     * @memberof StoreListingPageRows
     */
    rows: Array<StoreListingItemWithMetadata>;
}
/**
 * 
 * @export
 * @interface StoreListingSearchResponse
 */
export interface StoreListingSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof StoreListingSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof StoreListingSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreListingSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {StoreListingPageRows}
     * @memberof StoreListingSearchResponse
     */
    data: StoreListingPageRows;
}
/**
 * 
 * @export
 * @interface StoreListingVariant
 */
export interface StoreListingVariant {
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariant
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof StoreListingVariant
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariant
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreListingVariant
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreListingVariant
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingVariant
     */
    hidden?: boolean;
    /**
     * 
     * @type {StoreListingVariantOriginalInfo}
     * @memberof StoreListingVariant
     */
    originalInfo?: StoreListingVariantOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof StoreListingVariant
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {CreateStoreListingRequestWeight}
     * @memberof StoreListingVariant
     */
    weight?: CreateStoreListingRequestWeight;
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariant
     */
    externalCheckoutUrl?: string;
}
/**
 * 
 * @export
 * @interface StoreListingVariantOriginalInfo
 */
export interface StoreListingVariantOriginalInfo {
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariantOriginalInfo
     */
    type: StoreListingVariantOriginalInfoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariantOriginalInfo
     */
    shopifyVariantId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariantOriginalInfo
     */
    shopifyInventoryLevelId?: string;
}


/**
 * @export
 */
export const StoreListingVariantOriginalInfoTypeEnum = {
    Shopify: 'shopify'
} as const;
export type StoreListingVariantOriginalInfoTypeEnum = typeof StoreListingVariantOriginalInfoTypeEnum[keyof typeof StoreListingVariantOriginalInfoTypeEnum];

/**
 * 
 * @export
 * @interface StoreSource
 */
export interface StoreSource {
    /**
     * 
     * @type {string}
     * @memberof StoreSource
     */
    type: StoreSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreSource
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof StoreSource
     */
    liveStreamId?: string;
}


/**
 * @export
 */
export const StoreSourceTypeEnum = {
    Store: 'STORE'
} as const;
export type StoreSourceTypeEnum = typeof StoreSourceTypeEnum[keyof typeof StoreSourceTypeEnum];


/**
 * 
 * @export
 */
export const StoreTypeEnumItem = {
    Business: 'Business',
    Creator: 'Creator',
    CommentChat: 'CommentChat',
    Vfs: 'VFS'
} as const;
export type StoreTypeEnumItem = typeof StoreTypeEnumItem[keyof typeof StoreTypeEnumItem];

/**
 * 
 * @export
 * @interface StripePayoutMethodResponse
 */
export interface StripePayoutMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof StripePayoutMethodResponse
     */
    markedAccount: string;
    /**
     * 
     * @type {string}
     * @memberof StripePayoutMethodResponse
     */
    bankName: string;
}
/**
 * 
 * @export
 * @interface SubmitLeadFormRequest
 */
export interface SubmitLeadFormRequest {
    /**
     * 
     * @type {Array<LeadFormAnsweredQuestionDto>}
     * @memberof SubmitLeadFormRequest
     */
    answers: Array<LeadFormAnsweredQuestionDto>;
    /**
     * id of user if it is a signed user
     * @type {string}
     * @memberof SubmitLeadFormRequest
     * @deprecated
     */
    userId?: string;
    /**
     * contact info if it is an anonymous user
     * @type {LeadFormSubmissionContactDto}
     * @memberof SubmitLeadFormRequest
     */
    contact?: LeadFormSubmissionContactDto;
    /**
     * consent to be contacted
     * @type {boolean}
     * @memberof SubmitLeadFormRequest
     */
    consent?: boolean;
    /**
     * consent for marketing offer
     * @type {boolean}
     * @memberof SubmitLeadFormRequest
     */
    offerConsent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmitLeadFormRequest
     */
    recaptchaToken?: string;
    /**
     * contextual information about the submission, e.g. `pageUrl` — the page the visitor submitted from
     * @type {{ [key: string]: any; }}
     * @memberof SubmitLeadFormRequest
     */
    context?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface SubscribeToViewDto
 */
export interface SubscribeToViewDto {
    /**
     * 
     * @type {boolean}
     * @memberof SubscribeToViewDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof SubscribeToViewDto
     */
    level: PopStoreExtendedSubscriptionLevelEnumItem;
}


/**
 * 
 * @export
 * @interface SubscribeToViewItem
 */
export interface SubscribeToViewItem {
    /**
     * 
     * @type {boolean}
     * @memberof SubscribeToViewItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof SubscribeToViewItem
     */
    level: PopStoreExtendedSubscriptionLevelEnumItem;
}


/**
 * 
 * @export
 * @interface SubscriptionInvoiceItem
 */
export interface SubscriptionInvoiceItem {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoiceItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInvoiceItem
     */
    amountPaid: number;
    /**
     * Non-refundable credit add-on portion of the paid amount (price plus tax share). 0/absent = pure plan invoice; equal to amountPaid = pure credit-pack invoice. Refundable = amountPaid - creditAddonAmount.
     * @type {number}
     * @memberof SubscriptionInvoiceItem
     */
    creditAddonAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoiceItem
     */
    collectionMethod: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoiceItem
     */
    hostedInvoiceUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoiceItem
     */
    invoicePdf: string | null;
    /**
     * 
     * @type {object}
     * @memberof SubscriptionInvoiceItem
     */
    created: object;
    /**
     * 
     * @type {SubscriptionInvoiceStatusEnumItem}
     * @memberof SubscriptionInvoiceItem
     */
    status: SubscriptionInvoiceStatusEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionInvoiceItem
     */
    isRefunded: boolean;
    /**
     * 
     * @type {SaasInvoicePaymentMethodDetailsItem}
     * @memberof SubscriptionInvoiceItem
     */
    paymentMethodDetails?: SaasInvoicePaymentMethodDetailsItem;
}



/**
 * 
 * @export
 */
export const SubscriptionInvoiceStatusEnumItem = {
    Draft: 'draft',
    Open: 'open',
    Paid: 'paid',
    Void: 'void',
    Uncollectible: 'uncollectible'
} as const;
export type SubscriptionInvoiceStatusEnumItem = typeof SubscriptionInvoiceStatusEnumItem[keyof typeof SubscriptionInvoiceStatusEnumItem];

/**
 * 
 * @export
 * @interface SubscriptionLastChargeFailure
 */
export interface SubscriptionLastChargeFailure {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionLastChargeFailure
     */
    chargeId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionLastChargeFailure
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionLastChargeFailure
     */
    failedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionLastChargeFailure
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionLastChargeFailure
     */
    declineCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionLastChargeFailure
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionLastChargeFailure
     */
    errorType?: string;
}
/**
 * 
 * @export
 * @interface SubscriptionPaymentMethod
 */
export interface SubscriptionPaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentMethod
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentMethod
     */
    last4digits: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentMethod
     */
    expMonth: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentMethod
     */
    expYear: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentMethod
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentMethod
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPaymentMethod
     */
    isDefault: boolean;
    /**
     * 
     * @type {PaymentMethodAddress}
     * @memberof SubscriptionPaymentMethod
     */
    address: PaymentMethodAddress;
    /**
     * 
     * @type {SubscriptionPaymentMethodWalletItem}
     * @memberof SubscriptionPaymentMethod
     */
    wallet?: SubscriptionPaymentMethodWalletItem;
}
/**
 * 
 * @export
 * @interface SubscriptionPaymentMethodWalletItem
 */
export interface SubscriptionPaymentMethodWalletItem {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentMethodWalletItem
     */
    type: SubscriptionPaymentMethodWalletItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentMethodWalletItem
     */
    dynamicLast4?: string;
}


/**
 * @export
 */
export const SubscriptionPaymentMethodWalletItemTypeEnum = {
    AmexExpressCheckout: 'amex_express_checkout',
    ApplePay: 'apple_pay',
    GooglePay: 'google_pay',
    Link: 'link',
    Masterpass: 'masterpass',
    SamsungPay: 'samsung_pay',
    VisaCheckout: 'visa_checkout'
} as const;
export type SubscriptionPaymentMethodWalletItemTypeEnum = typeof SubscriptionPaymentMethodWalletItemTypeEnum[keyof typeof SubscriptionPaymentMethodWalletItemTypeEnum];

/**
 * 
 * @export
 * @interface SubscriptionPlan
 */
export interface SubscriptionPlan {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    priceId: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    productSlug: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    interval: SubscriptionPlanIntervalEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    planType: SubscriptionPlanPlanTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    intervalCount: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    description: string;
    /**
     * 
     * @type {Array<PlanFeatureListItem>}
     * @memberof SubscriptionPlan
     */
    featuresList?: Array<PlanFeatureListItem>;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    rawHtmlFeatures?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    commentChatContactCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    modelMePhotoCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    discountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    annualToMonthlyAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    originMonthlyAmount?: number;
    /**
     * 
     * @type {SaasSubscriptionBasePlanTypeEnumItem}
     * @memberof SubscriptionPlan
     */
    basePlanType?: SaasSubscriptionBasePlanTypeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    aiEchoMeCredit?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    trialPeriodDays?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    paidTrialAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    paidTrialPeriodDays?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    planLevel?: number;
    /**
     * 
     * @type {SubscriptionPricingTrackEnumItem}
     * @memberof SubscriptionPlan
     */
    pricingTrack?: SubscriptionPricingTrackEnumItem;
}


/**
 * @export
 */
export const SubscriptionPlanIntervalEnum = {
    Day: 'day',
    Month: 'month',
    Year: 'year'
} as const;
export type SubscriptionPlanIntervalEnum = typeof SubscriptionPlanIntervalEnum[keyof typeof SubscriptionPlanIntervalEnum];

/**
 * @export
 */
export const SubscriptionPlanPlanTypeEnum = {
    Plan: 'plan',
    CommentChatAddOn: 'commentChatAddOn',
    ModelMeAddOn: 'modelMeAddOn',
    TaxProduct: 'taxProduct',
    PopStoreAiEchoMeAddOn: 'popStoreAiEchoMeAddOn'
} as const;
export type SubscriptionPlanPlanTypeEnum = typeof SubscriptionPlanPlanTypeEnum[keyof typeof SubscriptionPlanPlanTypeEnum];


/**
 * 
 * @export
 */
export const SubscriptionPlanIntervalEnumItem = {
    Day: 'day',
    Month: 'month',
    Year: 'year'
} as const;
export type SubscriptionPlanIntervalEnumItem = typeof SubscriptionPlanIntervalEnumItem[keyof typeof SubscriptionPlanIntervalEnumItem];


/**
 * 
 * @export
 */
export const SubscriptionPricingTrackEnumItem = {
    BusinessCoach: 'business_coach'
} as const;
export type SubscriptionPricingTrackEnumItem = typeof SubscriptionPricingTrackEnumItem[keyof typeof SubscriptionPricingTrackEnumItem];

/**
 * 
 * @export
 * @interface SubscriptionRetentionOfferItem
 */
export interface SubscriptionRetentionOfferItem {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRetentionOfferItem
     */
    source: SubscriptionRetentionOfferItemSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRetentionOfferItem
     */
    kind: SubscriptionRetentionOfferItemKindEnum;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionRetentionOfferItem
     */
    percentOff: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionRetentionOfferItem
     */
    durationMonths: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRetentionOfferItem
     */
    status: SubscriptionRetentionOfferItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionRetentionOfferItem
     */
    currentMonth: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionRetentionOfferItem
     */
    monthsLeft: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRetentionOfferItem
     */
    startsAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRetentionOfferItem
     */
    appliedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRetentionOfferItem
     */
    endsAt?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionRetentionOfferItem
     */
    bonusCredits?: number;
}


/**
 * @export
 */
export const SubscriptionRetentionOfferItemSourceEnum = {
    Manual: 'manual',
    Retention: 'retention',
    PlanCoupon: 'plan_coupon',
    Campaign: 'campaign',
    WinBack: 'win_back'
} as const;
export type SubscriptionRetentionOfferItemSourceEnum = typeof SubscriptionRetentionOfferItemSourceEnum[keyof typeof SubscriptionRetentionOfferItemSourceEnum];

/**
 * @export
 */
export const SubscriptionRetentionOfferItemKindEnum = {
    Discount: 'discount',
    FreeMonth: 'free_month'
} as const;
export type SubscriptionRetentionOfferItemKindEnum = typeof SubscriptionRetentionOfferItemKindEnum[keyof typeof SubscriptionRetentionOfferItemKindEnum];

/**
 * @export
 */
export const SubscriptionRetentionOfferItemStatusEnum = {
    Scheduled: 'scheduled',
    Active: 'active',
    Ended: 'ended'
} as const;
export type SubscriptionRetentionOfferItemStatusEnum = typeof SubscriptionRetentionOfferItemStatusEnum[keyof typeof SubscriptionRetentionOfferItemStatusEnum];


/**
 * 
 * @export
 */
export const SubscriptionStatusEnumItem = {
    Active: 'active',
    Canceled: 'canceled',
    Incomplete: 'incomplete',
    IncompleteExpired: 'incomplete_expired',
    Trialing: 'trialing',
    PastDue: 'past_due',
    Unpaid: 'unpaid',
    Paused: 'paused'
} as const;
export type SubscriptionStatusEnumItem = typeof SubscriptionStatusEnumItem[keyof typeof SubscriptionStatusEnumItem];


/**
 * 
 * @export
 */
export const SurveyChoiceDisplayEnumItem = {
    Radio: 'RADIO',
    Dropdown: 'DROPDOWN',
    Pill: 'PILL',
    Scale: 'SCALE',
    Checkbox: 'CHECKBOX'
} as const;
export type SurveyChoiceDisplayEnumItem = typeof SurveyChoiceDisplayEnumItem[keyof typeof SurveyChoiceDisplayEnumItem];


/**
 * 
 * @export
 */
export const SurveyQuestionTypeEnumItem = {
    Choice: 'CHOICE',
    Text: 'TEXT'
} as const;
export type SurveyQuestionTypeEnumItem = typeof SurveyQuestionTypeEnumItem[keyof typeof SurveyQuestionTypeEnumItem];


/**
 * The save screen to open when this option is chosen; absent means none
 * @export
 */
export const SurveyRetentionModalEnumItem = {
    Setup: 'setup',
    Price: 'price',
    ProductFix: 'product_fix'
} as const;
export type SurveyRetentionModalEnumItem = typeof SurveyRetentionModalEnumItem[keyof typeof SurveyRetentionModalEnumItem];

/**
 * 
 * @export
 * @interface SurveyVisibilityRuleResponse
 */
export interface SurveyVisibilityRuleResponse {
    /**
     * 
     * @type {string}
     * @memberof SurveyVisibilityRuleResponse
     */
    questionId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyVisibilityRuleResponse
     */
    optionIds: Array<string>;
}
/**
 * 
 * @export
 * @interface TattooImageAwsS3Urls
 */
export interface TattooImageAwsS3Urls {
    /**
     * aws s3 url for front
     * @type {string}
     * @memberof TattooImageAwsS3Urls
     */
    front: string;
    /**
     * aws s3 url for back
     * @type {string}
     * @memberof TattooImageAwsS3Urls
     */
    closeup: string;
}
/**
 * 
 * @export
 * @interface TattooImageAwsS3UrlsItem
 */
export interface TattooImageAwsS3UrlsItem {
    /**
     * 
     * @type {string}
     * @memberof TattooImageAwsS3UrlsItem
     */
    front: string;
    /**
     * 
     * @type {string}
     * @memberof TattooImageAwsS3UrlsItem
     */
    closeup: string;
}
/**
 * 
 * @export
 * @interface TaxCalculationAddress
 */
export interface TaxCalculationAddress {
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    zipCode: string;
}

/**
 * 
 * @export
 * @interface TipToViewDto
 */
export interface TipToViewDto {
    /**
     * 
     * @type {boolean}
     * @memberof TipToViewDto
     */
    enabled?: boolean;
}
/**
 * 
 * @export
 * @interface TipToViewItem
 */
export interface TipToViewItem {
    /**
     * 
     * @type {boolean}
     * @memberof TipToViewItem
     */
    enabled?: boolean;
}
/**
 * 
 * @export
 * @interface TippingAmountDto
 */
export interface TippingAmountDto {
    /**
     * 
     * @type {number}
     * @memberof TippingAmountDto
     */
    amount: number;
    /**
     * currently only USD is supported
     * @type {string}
     * @memberof TippingAmountDto
     */
    currency: string;
}
/**
 * 
 * @export
 * @interface TippingAmountItem
 */
export interface TippingAmountItem {
    /**
     * 
     * @type {number}
     * @memberof TippingAmountItem
     */
    amount: number;
    /**
     * currently only USD is supported
     * @type {string}
     * @memberof TippingAmountItem
     */
    currency: string;
}
/**
 * 
 * @export
 * @interface TippingDto
 */
export interface TippingDto {
    /**
     * 
     * @type {number}
     * @memberof TippingDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof TippingDto
     */
    currency: string;
    /**
     * 
     * @type {TippingDtoTo}
     * @memberof TippingDto
     */
    to: TippingDtoTo;
}
/**
 * @type TippingDtoTo
 * 
 * @export
 */
export type TippingDtoTo = ListingDerivedFromTipToLiveStreamDto | ListingDerivedFromTipToPostDto | ListingDerivedFromTipToSellerDto;
/**
 * 
 * @export
 * @interface TippingGoalPageRows
 */
export interface TippingGoalPageRows {
    /**
     * 
     * @type {Array<TippingGoalSearchItem>}
     * @memberof TippingGoalPageRows
     */
    rows: Array<TippingGoalSearchItem>;
}
/**
 * 
 * @export
 * @interface TippingGoalSearchItem
 */
export interface TippingGoalSearchItem {
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    buttonText: string;
    /**
     * 
     * @type {number}
     * @memberof TippingGoalSearchItem
     */
    minimumTipAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TippingGoalSearchItem
     */
    targetAmount: number;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    dueAt: string;
    /**
     * 
     * @type {number}
     * @memberof TippingGoalSearchItem
     */
    achievedAmount: number;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    achievedAt: string;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    canceledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    endedAt?: string;
    /**
     * 
     * @type {TippingGoalStatusEnumItem}
     * @memberof TippingGoalSearchItem
     */
    status: TippingGoalStatusEnumItem;
    /**
     * 
     * @type {number}
     * @memberof TippingGoalSearchItem
     */
    tippingCount: number;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof TippingGoalSearchItem
     */
    relations: Relations;
}


/**
 * 
 * @export
 * @interface TippingGoalSearchResponse
 */
export interface TippingGoalSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof TippingGoalSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof TippingGoalSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof TippingGoalSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {TippingGoalPageRows}
     * @memberof TippingGoalSearchResponse
     */
    data: TippingGoalPageRows;
}

/**
 * 
 * @export
 */
export const TippingGoalStatusEnumItem = {
    Active: 'active',
    Achieved: 'achieved',
    Ended: 'ended',
    Canceled: 'canceled'
} as const;
export type TippingGoalStatusEnumItem = typeof TippingGoalStatusEnumItem[keyof typeof TippingGoalStatusEnumItem];

/**
 * 
 * @export
 * @interface ToggleCommunityChannelMessageBookmarkRequest
 */
export interface ToggleCommunityChannelMessageBookmarkRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleCommunityChannelMessageBookmarkRequest
     */
    remove: boolean;
}
/**
 * 
 * @export
 * @interface ToggleCommunityChannelMessagePinRequest
 */
export interface ToggleCommunityChannelMessagePinRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleCommunityChannelMessagePinRequest
     */
    remove: boolean;
}
/**
 * 
 * @export
 * @interface ToggleCommunityChannelMessageReactionRequest
 */
export interface ToggleCommunityChannelMessageReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof ToggleCommunityChannelMessageReactionRequest
     */
    emoji: string;
    /**
     * 
     * @type {string}
     * @memberof ToggleCommunityChannelMessageReactionRequest
     */
    emojiCode: string;
    /**
     * 
     * @type {CommunityChannelMessagePredefinedReactionNameEnumItem}
     * @memberof ToggleCommunityChannelMessageReactionRequest
     */
    name?: CommunityChannelMessagePredefinedReactionNameEnumItem;
}


/**
 * 
 * @export
 * @interface ToggleHiddenPostRequest
 */
export interface ToggleHiddenPostRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleHiddenPostRequest
     */
    hidden: boolean;
}
/**
 * 
 * @export
 * @interface TokenCostItem
 */
export interface TokenCostItem {
    /**
     * 
     * @type {string}
     * @memberof TokenCostItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof TokenCostItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof TokenCostItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TokenCostItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TokenCostItem
     */
    provider: string;
    /**
     * 
     * @type {number}
     * @memberof TokenCostItem
     */
    maxDuration: number;
    /**
     * 
     * @type {string}
     * @memberof TokenCostItem
     */
    slug: string;
    /**
     * 
     * @type {number}
     * @memberof TokenCostItem
     */
    tokenCost: number;
    /**
     * 
     * @type {TokenCostTypeEnumItem}
     * @memberof TokenCostItem
     */
    tokenCostType?: TokenCostTypeEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof TokenCostItem
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof TokenCostItem
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof TokenCostItem
     */
    operatorId?: string;
    /**
     * 
     * @type {BasicProfileDto}
     * @memberof TokenCostItem
     */
    operator?: BasicProfileDto;
    /**
     * 
     * @type {number}
     * @memberof TokenCostItem
     */
    salePrice?: number;
    /**
     * 
     * @type {string}
     * @memberof TokenCostItem
     */
    saleStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenCostItem
     */
    saleEndDate?: string;
    /**
     * 
     * @type {TokenCostUnitEnumItem}
     * @memberof TokenCostItem
     */
    unit?: TokenCostUnitEnumItem;
}



/**
 * 
 * @export
 */
export const TokenCostTypeEnumItem = {
    AiPhoto: 'AI_PHOTO',
    AiVideo5S: 'AI_VIDEO_5S',
    AiVideo10S: 'AI_VIDEO_10S',
    AiVideo15S: 'AI_VIDEO_15S',
    AiVideoPerSecond: 'AI_VIDEO_PER_SECOND',
    AiVideo480PPerSecond: 'AI_VIDEO_480P_PER_SECOND',
    AiVideo720PPerSecond: 'AI_VIDEO_720P_PER_SECOND',
    AiVideo1080PPerSecond: 'AI_VIDEO_1080P_PER_SECOND',
    AiStoryboardPreview: 'AI_STORYBOARD_PREVIEW',
    AiVideoCustomMotion: 'AI_VIDEO_CUSTOM_MOTION',
    LipSyncAddon: 'LIP_SYNC_ADDON',
    PhotoShoot: 'PHOTO_SHOOT',
    FullyAutoPdf: 'FULLY_AUTO_PDF',
    AiAssistedPdf: 'AI_ASSISTED_PDF',
    EditPdf: 'EDIT_PDF',
    AiDmResponseCommentchat: 'AI_DM_RESPONSE_COMMENTCHAT',
    AiCommentResponseCommentchat: 'AI_COMMENT_RESPONSE_COMMENTCHAT',
    EchoCommentGeneration: 'ECHO_COMMENT_GENERATION',
    DmOfferAnalysis: 'DM_OFFER_ANALYSIS',
    AiCommentAnalysis: 'AI_COMMENT_ANALYSIS',
    AiPostAnalysis: 'AI_POST_ANALYSIS',
    AiCommentIntentOfferMatching: 'AI_COMMENT_INTENT_OFFER_MATCHING',
    AiTemplateCustomization: 'ai-template-customization',
    FollowerProfileScrape: 'FOLLOWER_PROFILE_SCRAPE',
    CollabPostCommentScrape: 'COLLAB_POST_COMMENT_SCRAPE',
    GrowthRxDiagnostic: 'GROWTH_RX_DIAGNOSTIC',
    GrowthRxScript: 'GROWTH_RX_SCRIPT',
    GrowthRxPrewarm: 'GROWTH_RX_PREWARM',
    GrowthRxPostScore: 'GROWTH_RX_POST_SCORE',
    VideoChapter: 'VIDEO_CHAPTER'
} as const;
export type TokenCostTypeEnumItem = typeof TokenCostTypeEnumItem[keyof typeof TokenCostTypeEnumItem];


/**
 * 
 * @export
 */
export const TokenCostUnitEnumItem = {
    Tokens: 'TOKENS',
    TokensPerSecond: 'TOKENS_PER_SECOND',
    TokensPerMinute: 'TOKENS_PER_MINUTE'
} as const;
export type TokenCostUnitEnumItem = typeof TokenCostUnitEnumItem[keyof typeof TokenCostUnitEnumItem];

/**
 * 
 * @export
 * @interface TokenListingDto
 */
export interface TokenListingDto {
    /**
     * 
     * @type {string}
     * @memberof TokenListingDto
     */
    id: string;
    /**
     * 
     * @type {TokenListingDtoTypeEnumItem}
     * @memberof TokenListingDto
     */
    type: TokenListingDtoTypeEnumItem;
    /**
     * 
     * @type {TokenListingDtoAvatarMe}
     * @memberof TokenListingDto
     */
    avatarMe?: TokenListingDtoAvatarMe;
    /**
     * 
     * @type {TokenListingDtoAiGeneratedPdf}
     * @memberof TokenListingDto
     */
    aiGeneratedPdf?: TokenListingDtoAiGeneratedPdf;
    /**
     * 
     * @type {TokenListingDtoEchoForCommentchat}
     * @memberof TokenListingDto
     */
    echoForCommentchat?: TokenListingDtoEchoForCommentchat;
    /**
     * Required when type is TOKEN_GATED and the token cost's unit is TOKENS_PER_SECOND: whole seconds, 5-60. The unit price is multiplied by it.
     * @type {number}
     * @memberof TokenListingDto
     */
    durationSeconds?: number;
}


/**
 * @type TokenListingDtoAiGeneratedPdf
 * 
 * @export
 */
export type TokenListingDtoAiGeneratedPdf = AiGeneratedPdfAiAssistedRequest | AiGeneratedPdfEditPdfRequest | AiGeneratedPdfFullyAutoRequest;
/**
 * @type TokenListingDtoAvatarMe
 * 
 * @export
 */
export type TokenListingDtoAvatarMe = AvatarMeStudioGamifiedLipSyncVideoRequest | AvatarMeStudioImageRequest | AvatarMeStudioPhotoshootRequest | AvatarMeStudioVideo10sRequest | AvatarMeStudioVideo5sRequest | AvatarMeStudioVideoPromptRequest | AvatarMeStudioVideoXsRequest;
/**
 * @type TokenListingDtoEchoForCommentchat
 * 
 * @export
 */
export type TokenListingDtoEchoForCommentchat = EchoForCommentchatAiCommentAnalysisRequest | EchoForCommentchatAiCommentIntentOfferMatchingRequest | EchoForCommentchatAiCommentResponseRequest | EchoForCommentchatAiDmResponseRequest | EchoForCommentchatAiPostAnalysisRequest | EchoForCommentchatCollabPostCommentScrapeRequest | EchoForCommentchatDmOfferAnalysisRequest | EchoForCommentchatEchoCommentGenerationRequest | EchoForCommentchatFollowerProfileScrapeRequest | EchoForCommentchatGrowthRxDiagnosticRequest | EchoForCommentchatGrowthRxPostScoreRequest | EchoForCommentchatGrowthRxScriptRequest;

/**
 * 
 * @export
 */
export const TokenListingDtoTypeEnumItem = {
    AvatarMe: 'AVATAR_ME',
    AiGeneratedPdf: 'AI_GENERATED_PDF',
    EchoForCommentchat: 'ECHO_FOR_COMMENTCHAT',
    TokenGated: 'TOKEN_GATED'
} as const;
export type TokenListingDtoTypeEnumItem = typeof TokenListingDtoTypeEnumItem[keyof typeof TokenListingDtoTypeEnumItem];

/**
 * 
 * @export
 * @interface TokenListingItem
 */
export interface TokenListingItem {
    /**
     * 
     * @type {string}
     * @memberof TokenListingItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TokenListingItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof TokenListingItem
     */
    updatedAt: string;
    /**
     * 
     * @type {TokenListingItemTypeEnumItem}
     * @memberof TokenListingItem
     */
    type: TokenListingItemTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof TokenListingItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof TokenListingItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof TokenListingItem
     */
    tokens: number;
    /**
     * 
     * @type {number}
     * @memberof TokenListingItem
     */
    bonusTokens?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TokenListingItem
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof TokenListingItem
     */
    sort: number;
}



/**
 * 
 * @export
 */
export const TokenListingItemTypeEnumItem = {
    TokenPack: 'TOKEN_PACK'
} as const;
export type TokenListingItemTypeEnumItem = typeof TokenListingItemTypeEnumItem[keyof typeof TokenListingItemTypeEnumItem];

/**
 * 
 * @export
 * @interface TokenListingPageRows
 */
export interface TokenListingPageRows {
    /**
     * 
     * @type {Array<TokenListingItem>}
     * @memberof TokenListingPageRows
     */
    rows: Array<TokenListingItem>;
}
/**
 * 
 * @export
 * @interface TokenResponse
 */
export interface TokenResponse {
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    channel: string;
}
/**
 * 
 * @export
 * @interface TokensResponse
 */
export interface TokensResponse {
    /**
     * 
     * @type {TokenResponse}
     * @memberof TokensResponse
     */
    rtc: TokenResponse;
    /**
     * 
     * @type {TokenResponse}
     * @memberof TokensResponse
     */
    rtmComments: TokenResponse;
    /**
     * 
     * @type {TokenResponse}
     * @memberof TokensResponse
     */
    rtmCommentUpvotes: TokenResponse;
    /**
     * 
     * @type {TokenResponse}
     * @memberof TokensResponse
     */
    rtmLightningBolts: TokenResponse;
}
/**
 * 
 * @export
 * @interface TopProductsSource
 */
export interface TopProductsSource {
    /**
     * 
     * @type {string}
     * @memberof TopProductsSource
     */
    type: TopProductsSourceTypeEnum;
}


/**
 * @export
 */
export const TopProductsSourceTypeEnum = {
    TopProducts: 'TOP_PRODUCTS'
} as const;
export type TopProductsSourceTypeEnum = typeof TopProductsSourceTypeEnum[keyof typeof TopProductsSourceTypeEnum];

/**
 * 
 * @export
 * @interface TrialAvailabilityCouponItem
 */
export interface TrialAvailabilityCouponItem {
    /**
     * 
     * @type {SaasSubscriptionCouponTypeEnumItem}
     * @memberof TrialAvailabilityCouponItem
     */
    type: SaasSubscriptionCouponTypeEnumItem;
    /**
     * 
     * @type {number}
     * @memberof TrialAvailabilityCouponItem
     */
    percentOff?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialAvailabilityCouponItem
     */
    amountOff?: number;
}


/**
 * 
 * @export
 * @interface TriggerSaasSubscriptionCouponCampaignStageRequest
 */
export interface TriggerSaasSubscriptionCouponCampaignStageRequest {
    /**
     * which departure signal the client observed, for the audit trail only; ignored for other trigger types
     * @type {SaasSubscriptionCouponCampaignExitSignalEnumItem}
     * @memberof TriggerSaasSubscriptionCouponCampaignStageRequest
     */
    signal?: SaasSubscriptionCouponCampaignExitSignalEnumItem;
}


/**
 * 
 * @export
 * @interface TwoWayStreamSource
 */
export interface TwoWayStreamSource {
    /**
     * 
     * @type {string}
     * @memberof TwoWayStreamSource
     */
    type: TwoWayStreamSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TwoWayStreamSource
     */
    liveStreamId: string;
}


/**
 * @export
 */
export const TwoWayStreamSourceTypeEnum = {
    TwoWayStream: 'TWO_WAY_STREAM'
} as const;
export type TwoWayStreamSourceTypeEnum = typeof TwoWayStreamSourceTypeEnum[keyof typeof TwoWayStreamSourceTypeEnum];

/**
 * 
 * @export
 * @interface UpcomingShowPageRows
 */
export interface UpcomingShowPageRows {
    /**
     * 
     * @type {Array<SearchUpcomingShowItem>}
     * @memberof UpcomingShowPageRows
     */
    rows: Array<SearchUpcomingShowItem>;
}
/**
 * 
 * @export
 * @interface UpcomingShowResponse
 */
export interface UpcomingShowResponse {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowResponse
     */
    badges: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    title: string;
    /**
     * 
     * @type {object}
     * @memberof UpcomingShowResponse
     */
    user: object;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    originalCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    shareVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowResponse
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    visibility?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    permission?: UpcomingShowResponsePermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowResponse
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowResponse
     */
    disableComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowResponse
     */
    notificationSent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    liveStreamId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowResponse
     */
    historyLiveStreamIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    transcodeStatus?: UpcomingShowResponseTranscodeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    accessLevel?: UpcomingShowResponseAccessLevelEnum;
}


/**
 * @export
 */
export const UpcomingShowResponsePermissionEnum = {
    All: 'all',
    Follower: 'follower',
    Subscriber: 'subscriber',
    NoOne: 'no-one'
} as const;
export type UpcomingShowResponsePermissionEnum = typeof UpcomingShowResponsePermissionEnum[keyof typeof UpcomingShowResponsePermissionEnum];

/**
 * @export
 */
export const UpcomingShowResponseTranscodeStatusEnum = {
    Initial: 'initial',
    Processing: 'processing',
    TranscodeOriginal: 'transcode-original',
    TranscodeOriginalShare: 'transcode-original-share',
    RequestRetranscode: 'request-retranscode'
} as const;
export type UpcomingShowResponseTranscodeStatusEnum = typeof UpcomingShowResponseTranscodeStatusEnum[keyof typeof UpcomingShowResponseTranscodeStatusEnum];

/**
 * @export
 */
export const UpcomingShowResponseAccessLevelEnum = {
    All: 'all',
    Subscriber: 'subscriber',
    Fan: 'fan',
    Vip: 'vip'
} as const;
export type UpcomingShowResponseAccessLevelEnum = typeof UpcomingShowResponseAccessLevelEnum[keyof typeof UpcomingShowResponseAccessLevelEnum];

/**
 * 
 * @export
 * @interface UpcomingShowSearchResponse
 */
export interface UpcomingShowSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof UpcomingShowSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof UpcomingShowSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {UpcomingShowPageRows}
     * @memberof UpcomingShowSearchResponse
     */
    data: UpcomingShowPageRows;
}
/**
 * 
 * @export
 * @interface UpcomingShowSendItemSourceSource
 */
export interface UpcomingShowSendItemSourceSource {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowSendItemSourceSource
     */
    type: UpcomingShowSendItemSourceSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowSendItemSourceSource
     */
    upcomingShowId: string;
}


/**
 * @export
 */
export const UpcomingShowSendItemSourceSourceTypeEnum = {
    UpcomingShow: 'upcomingShow'
} as const;
export type UpcomingShowSendItemSourceSourceTypeEnum = typeof UpcomingShowSendItemSourceSourceTypeEnum[keyof typeof UpcomingShowSendItemSourceSourceTypeEnum];

/**
 * 
 * @export
 * @interface UpcomingShowSource
 */
export interface UpcomingShowSource {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowSource
     */
    type: UpcomingShowSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowSource
     */
    upcomingShowId: string;
}


/**
 * @export
 */
export const UpcomingShowSourceTypeEnum = {
    UpcomingShow: 'UPCOMING_SHOW'
} as const;
export type UpcomingShowSourceTypeEnum = typeof UpcomingShowSourceTypeEnum[keyof typeof UpcomingShowSourceTypeEnum];

/**
 * 
 * @export
 * @interface UpdateCommunityChannelMemberRequest
 */
export interface UpdateCommunityChannelMemberRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCommunityChannelMemberRequest
     */
    lastReadAt?: string;
    /**
     * 
     * @type {CommunityMemberPresenceStatusEnumItem}
     * @memberof UpdateCommunityChannelMemberRequest
     */
    presenceStatus?: CommunityMemberPresenceStatusEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCommunityChannelMemberRequest
     */
    muted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCommunityChannelMemberRequest
     */
    subscribedToUpdatesOfCreator?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCommunityChannelMemberRequest
     */
    subscribedToMentions?: boolean;
}


/**
 * 
 * @export
 * @interface UpdateCommunityChannelRequest
 */
export interface UpdateCommunityChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCommunityChannelRequest
     */
    icon: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCommunityChannelRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCommunityChannelRequest
     */
    description?: string;
    /**
     * 
     * @type {CommunityChannelVisibilityEnumItem}
     * @memberof UpdateCommunityChannelRequest
     */
    visibility: CommunityChannelVisibilityEnumItem;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof UpdateCommunityChannelRequest
     */
    minimumSubscriptionLevel: PopStoreExtendedSubscriptionLevelEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCommunityChannelRequest
     */
    isBroadcastChannel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCommunityChannelRequest
     */
    applySubscriptionLevelToNewMembersOnly: boolean;
}


/**
 * 
 * @export
 * @interface UpdateGroupEventRequest
 */
export interface UpdateGroupEventRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEventRequest
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEventRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEventRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEventRequest
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEventRequest
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEventRequest
     */
    endDate: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateGroupEventRequest
     */
    inviteeLimit: number;
    /**
     * 
     * @type {GroupEventLocationTypeEnumItem}
     * @memberof UpdateGroupEventRequest
     */
    locationType: GroupEventLocationTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupEventRequest
     */
    address?: string;
}


/**
 * 
 * @export
 * @interface UpdateMyUpcomingShowDto
 */
export interface UpdateMyUpcomingShowDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMyUpcomingShowDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyUpcomingShowDto
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyUpcomingShowDto
     */
    permission?: UpdateMyUpcomingShowDtoPermissionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMyUpcomingShowDto
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyUpcomingShowDto
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyUpcomingShowDto
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyUpcomingShowDto
     */
    accessLevel?: UpdateMyUpcomingShowDtoAccessLevelEnum;
    /**
     * 
     * @type {ShowTippingRequest}
     * @memberof UpdateMyUpcomingShowDto
     */
    tipping?: ShowTippingRequest;
}


/**
 * @export
 */
export const UpdateMyUpcomingShowDtoPermissionEnum = {
    All: 'all',
    Follower: 'follower',
    Subscriber: 'subscriber',
    NoOne: 'no-one'
} as const;
export type UpdateMyUpcomingShowDtoPermissionEnum = typeof UpdateMyUpcomingShowDtoPermissionEnum[keyof typeof UpdateMyUpcomingShowDtoPermissionEnum];

/**
 * @export
 */
export const UpdateMyUpcomingShowDtoAccessLevelEnum = {
    All: 'all',
    Subscriber: 'subscriber',
    Fan: 'fan',
    Vip: 'vip'
} as const;
export type UpdateMyUpcomingShowDtoAccessLevelEnum = typeof UpdateMyUpcomingShowDtoAccessLevelEnum[keyof typeof UpdateMyUpcomingShowDtoAccessLevelEnum];

/**
 * 
 * @export
 * @interface UpdateOptionRequest
 */
export interface UpdateOptionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOptionRequest
     */
    optionId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOptionRequest
     */
    title: string;
}
/**
 * 
 * @export
 * @interface UpdatePollRequest
 */
export interface UpdatePollRequest {
    /**
     * 
     * @type {PollTypeEnumItem}
     * @memberof UpdatePollRequest
     */
    type: PollTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof UpdatePollRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePollRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePollRequest
     */
    dueAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePollRequest
     */
    isAnonymousVotingAllowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePollRequest
     */
    isMultiChoice: boolean;
    /**
     * 
     * @type {Array<UpdateOptionRequest>}
     * @memberof UpdatePollRequest
     */
    options: Array<UpdateOptionRequest>;
}


/**
 * 
 * @export
 * @interface UpdatePostRequest
 */
export interface UpdatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePostRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePostRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePostRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePostRequest
     */
    allowComments: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePostRequest
     */
    saveAsDraft?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdatePostRequest
     */
    scheduledReleaseTime?: string;
    /**
     * 
     * @type {PayToViewOnlyModeDto}
     * @memberof UpdatePostRequest
     */
    payToViewOnlyMode?: PayToViewOnlyModeDto;
    /**
     * 
     * @type {SubscribeToViewDto}
     * @memberof UpdatePostRequest
     */
    subscribeToView?: SubscribeToViewDto;
    /**
     * 
     * @type {PayToViewDto}
     * @memberof UpdatePostRequest
     */
    payToView?: PayToViewDto;
    /**
     * 
     * @type {CrowdTippingToViewDto}
     * @memberof UpdatePostRequest
     */
    crowdTippingToView?: CrowdTippingToViewDto;
    /**
     * 
     * @type {TipToViewDto}
     * @memberof UpdatePostRequest
     */
    tipToView?: TipToViewDto;
    /**
     * 
     * @type {Array<TippingAmountDto>}
     * @memberof UpdatePostRequest
     */
    tippingAmounts?: Array<TippingAmountDto>;
    /**
     * 
     * @type {DmDto}
     * @memberof UpdatePostRequest
     */
    dm?: DmDto;
    /**
     * 
     * @type {PostContentTypeEnumItem}
     * @memberof UpdatePostRequest
     */
    postType: PostContentTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof UpdatePostRequest
     */
    textContent?: string;
    /**
     * 
     * @type {Array<PostMediaDto>}
     * @memberof UpdatePostRequest
     */
    medias?: Array<PostMediaDto>;
    /**
     * 
     * @type {number}
     * @memberof UpdatePostRequest
     */
    unrestrictedLeadingMediaCount?: number;
}


/**
 * 
 * @export
 * @interface UpdateSubscriptionDefaultPaymentMethodRequest
 */
export interface UpdateSubscriptionDefaultPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionDefaultPaymentMethodRequest
     */
    paymentMethodId: string;
}
/**
 * 
 * @export
 * @interface UpdateSubscriptionRequest
 */
export interface UpdateSubscriptionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSubscriptionRequest
     */
    priceIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    couponCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    paymentMethodId?: string;
}
/**
 * 
 * @export
 * @interface UpdateTippingGoalRequest
 */
export interface UpdateTippingGoalRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTippingGoalRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTippingGoalRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTippingGoalRequest
     */
    buttonText: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTippingGoalRequest
     */
    minimumTipAmount: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTippingGoalRequest
     */
    targetAmount: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTippingGoalRequest
     */
    dueAt: string;
}
/**
 * 
 * @export
 * @interface UpdateUserParamsV2
 */
export interface UpdateUserParamsV2 {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    avatar?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserParamsV2
     */
    hideBadgeInProfile?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    timezone?: string;
    /**
     * 
     * @type {PopStoreCreatorBusinessTypeEnumItem}
     * @memberof UpdateUserParamsV2
     */
    businessType?: PopStoreCreatorBusinessTypeEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserParamsV2
     */
    overrideBusinessTypeRestrictions?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserParamsV2
     */
    updateMask: Array<UpdateUserParamsV2UpdateMaskEnum>;
}


/**
 * @export
 */
export const UpdateUserParamsV2UpdateMaskEnum = {
    FirstName: 'firstName',
    LastName: 'lastName',
    Username: 'username',
    Email: 'email',
    Bio: 'bio',
    Avatar: 'avatar',
    HideBadgeInProfile: 'hideBadgeInProfile',
    PopStoreDomain: 'popStoreDomain',
    Timezone: 'timezone',
    BusinessType: 'businessType'
} as const;
export type UpdateUserParamsV2UpdateMaskEnum = typeof UpdateUserParamsV2UpdateMaskEnum[keyof typeof UpdateUserParamsV2UpdateMaskEnum];


/**
 * 
 * @export
 */
export const UploadAvatarMeMediaPurposeEnumItem = {
    Outfit: 'outfit',
    Lipsync: 'lipsync',
    Prompt: 'prompt'
} as const;
export type UploadAvatarMeMediaPurposeEnumItem = typeof UploadAvatarMeMediaPurposeEnumItem[keyof typeof UploadAvatarMeMediaPurposeEnumItem];

/**
 * 
 * @export
 * @interface UploadedFileDto
 */
export interface UploadedFileDto {
    /**
     * 
     * @type {number}
     * @memberof UploadedFileDto
     */
    sizeInBytes: number;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileDto
     */
    mimeType: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileDto
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileDto
     */
    fileHandle: string;
}
/**
 * 
 * @export
 * @interface UploadedFileItem
 */
export interface UploadedFileItem {
    /**
     * 
     * @type {number}
     * @memberof UploadedFileItem
     */
    sizeInBytes: number;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileItem
     */
    mimeType: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileItem
     */
    fileHandle: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileItem
     */
    filename: string;
    /**
     * 
     * @type {ModerationStatusEnumItem}
     * @memberof UploadedFileItem
     */
    moderationStatus?: ModerationStatusEnumItem;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileItem
     */
    moderationReason?: string;
}


/**
 * 
 * @export
 * @interface ValidateFeedbackIDRequest
 */
export interface ValidateFeedbackIDRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateFeedbackIDRequest
     */
    feedbackId: string;
}
/**
 * 
 * @export
 * @interface ValidateFeedbackIDResponse
 */
export interface ValidateFeedbackIDResponse {
    /**
     * 
     * @type {string}
     * @memberof ValidateFeedbackIDResponse
     */
    customToken: string;
    /**
     * 
     * @type {ValidateFeedbackIDTopic}
     * @memberof ValidateFeedbackIDResponse
     */
    topic?: ValidateFeedbackIDTopic;
}
/**
 * 
 * @export
 * @interface ValidateFeedbackIDTopic
 */
export interface ValidateFeedbackIDTopic {
    /**
     * 
     * @type {string}
     * @memberof ValidateFeedbackIDTopic
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateFeedbackIDTopic
     */
    topic: string;
}
/**
 * 
 * @export
 * @interface ValidateSellerCodeResponse
 */
export interface ValidateSellerCodeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateSellerCodeResponse
     */
    unique: boolean;
}
/**
 * 
 * @export
 * @interface VideoResolution
 */
export interface VideoResolution {
    /**
     * 
     * @type {number}
     * @memberof VideoResolution
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof VideoResolution
     */
    height: number;
}
/**
 * 
 * @export
 * @interface VotePollRequest
 */
export interface VotePollRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof VotePollRequest
     */
    optionIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VotePollRequest
     */
    timeZone: string;
}
/**
 * 
 * @export
 * @interface WearWithAiDto
 */
export interface WearWithAiDto {
    /**
     * 
     * @type {string}
     * @memberof WearWithAiDto
     */
    listingId: string;
}
/**
 * 
 * @export
 * @interface WearWithAiItem
 */
export interface WearWithAiItem {
    /**
     * 
     * @type {string}
     * @memberof WearWithAiItem
     */
    listingId: string;
    /**
     * 
     * @type {boolean}
     * @memberof WearWithAiItem
     */
    visible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WearWithAiItem
     */
    favorite: boolean;
}
/**
 * 
 * @export
 * @interface WearWithAiListingMediaItem
 */
export interface WearWithAiListingMediaItem {
    /**
     * 
     * @type {WearWithAiListingMediaTypeEnumItem}
     * @memberof WearWithAiListingMediaItem
     */
    type: WearWithAiListingMediaTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof WearWithAiListingMediaItem
     */
    url: string;
}



/**
 * 
 * @export
 */
export const WearWithAiListingMediaTypeEnumItem = {
    Image: 'IMAGE',
    Video: 'VIDEO'
} as const;
export type WearWithAiListingMediaTypeEnumItem = typeof WearWithAiListingMediaTypeEnumItem[keyof typeof WearWithAiListingMediaTypeEnumItem];

/**
 * 
 * @export
 * @interface WithdrawTransactionItemWithId
 */
export interface WithdrawTransactionItemWithId {
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    userId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof WithdrawTransactionItemWithId
     */
    profile: ProfileItem;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionItemWithId
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionItemWithId
     */
    balance: number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    status: WithdrawTransactionItemWithIdStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    note?: string;
    /**
     * 
     * @type {PayoutBankItem}
     * @memberof WithdrawTransactionItemWithId
     */
    payoutMethodBank?: PayoutBankItem;
    /**
     * 
     * @type {PayoutVenmoItem}
     * @memberof WithdrawTransactionItemWithId
     */
    payoutMethodVenmo?: PayoutVenmoItem;
    /**
     * 
     * @type {PayoutPaypalItem}
     * @memberof WithdrawTransactionItemWithId
     */
    payoutMethodPaypal?: PayoutPaypalItem;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    updatedAt: string;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionItemWithId
     */
    withdrawableAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionItemWithId
     */
    withdrawableBalance?: number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    userAgent?: string;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionItemWithId
     */
    idNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WithdrawTransactionItemWithId
     */
    isPslPayPayment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    withdrawType?: WithdrawTransactionItemWithIdWithdrawTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    id: string;
}


/**
 * @export
 */
export const WithdrawTransactionItemWithIdStatusEnum = {
    Approved: 'approved',
    Rejected: 'rejected',
    Pending: 'pending'
} as const;
export type WithdrawTransactionItemWithIdStatusEnum = typeof WithdrawTransactionItemWithIdStatusEnum[keyof typeof WithdrawTransactionItemWithIdStatusEnum];

/**
 * @export
 */
export const WithdrawTransactionItemWithIdWithdrawTypeEnum = {
    PslPay: 'pslPay',
    Creator: 'creator'
} as const;
export type WithdrawTransactionItemWithIdWithdrawTypeEnum = typeof WithdrawTransactionItemWithIdWithdrawTypeEnum[keyof typeof WithdrawTransactionItemWithIdWithdrawTypeEnum];

/**
 * 
 * @export
 * @interface WithdrawTransactionResponse
 */
export interface WithdrawTransactionResponse {
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionResponse
     */
    userId: string;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    profile: object;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionResponse
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionResponse
     */
    balance: number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionResponse
     */
    note?: string;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    payoutMethodBank?: object;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    payoutMethodVenmo?: object;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    payoutMethodPaypal?: object;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    createdAt: object;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    updatedAt: object;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionResponse
     */
    withdrawableAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionResponse
     */
    withdrawableBalance?: number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionResponse
     */
    userAgent?: string;
}
/**
 * 
 * @export
 * @interface WithdrawTransactionsPageRows
 */
export interface WithdrawTransactionsPageRows {
    /**
     * 
     * @type {Array<WithdrawTransactionItemWithId>}
     * @memberof WithdrawTransactionsPageRows
     */
    rows: Array<WithdrawTransactionItemWithId>;
}
/**
 * 
 * @export
 * @interface WithdrawTransactionsSearchResponse
 */
export interface WithdrawTransactionsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof WithdrawTransactionsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof WithdrawTransactionsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionsSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {WithdrawTransactionsPageRows}
     * @memberof WithdrawTransactionsSearchResponse
     */
    data: WithdrawTransactionsPageRows;
}
